import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_chest_proto from './dcei_wildsky_chest_proto';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
import * as dcei_wildsky_card_proto from './dcei_wildsky_card_proto';
class MapEvent_LevelAccessKey {
  get descriptor() {
    return MapEvent_LevelAccessKey.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInventoryKeyId = false;
    this._inventoryKeyId = null;
    this._hasKeyRegenerateIntervalInSecs = false;
    this._keyRegenerateIntervalInSecs = null;
    this._hasKeyCap = false;
    this._keyCap = null;
    this._gemsCosts = [];
    this._hasGemsCostResetTimeInSecs = false;
    this._gemsCostResetTimeInSecs = null;
    this._hasKeysAmountPurPurchase = false;
    this._keysAmountPurPurchase = null;
    this._hasKeysAmountPerAd = false;
    this._keysAmountPerAd = null;
    this._hasMaxAdsPerDay = false;
    this._maxAdsPerDay = null;
  }
  isEmpty() {
    if (this._hasInventoryKeyId) return false;
    if (this._hasKeyRegenerateIntervalInSecs) return false;
    if (this._hasKeyCap) return false;
    if (this._gemsCosts.length > 0) return false;
    if (this._hasGemsCostResetTimeInSecs) return false;
    if (this._hasKeysAmountPurPurchase) return false;
    if (this._hasKeysAmountPerAd) return false;
    if (this._hasMaxAdsPerDay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LevelAccessKey) {
      return value;
    }
    return MapEvent_LevelAccessKey.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LevelAccessKey();
    if (json.inventoryKeyId != null) {
      result._hasInventoryKeyId = true;
      result._inventoryKeyId = JsonToString.fromJson(json.inventoryKeyId);
    }
    if (json.keyRegenerateIntervalInSecs != null) {
      result._hasKeyRegenerateIntervalInSecs = true;
      result._keyRegenerateIntervalInSecs = JsonToInt32.fromJson(json.keyRegenerateIntervalInSecs);
    }
    if (json.keyCap != null) {
      result._hasKeyCap = true;
      result._keyCap = JsonToInt32.fromJson(json.keyCap);
    }
    result._gemsCosts = JsonToList(json.gemsCosts, JsonToInt32);
    if (json.gemsCostResetTimeInSecs != null) {
      result._hasGemsCostResetTimeInSecs = true;
      result._gemsCostResetTimeInSecs = JsonToInt32.fromJson(json.gemsCostResetTimeInSecs);
    }
    if (json.keysAmountPurPurchase != null) {
      result._hasKeysAmountPurPurchase = true;
      result._keysAmountPurPurchase = JsonToInt32.fromJson(json.keysAmountPurPurchase);
    }
    if (json.keysAmountPerAd != null) {
      result._hasKeysAmountPerAd = true;
      result._keysAmountPerAd = JsonToInt32.fromJson(json.keysAmountPerAd);
    }
    if (json.maxAdsPerDay != null) {
      result._hasMaxAdsPerDay = true;
      result._maxAdsPerDay = JsonToInt32.fromJson(json.maxAdsPerDay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInventoryKeyId) {
      result.inventoryKeyId = JsonToString.toJson(this._inventoryKeyId);
    }
    if (this._hasKeyRegenerateIntervalInSecs) {
      result.keyRegenerateIntervalInSecs = JsonToInt32.toJson(this._keyRegenerateIntervalInSecs);
    }
    if (this._hasKeyCap) {
      result.keyCap = JsonToInt32.toJson(this._keyCap);
    }
    if (this._gemsCosts.length > 0) {
      result.gemsCosts = ArrayToJson(this._gemsCosts, JsonToInt32);
    }
    if (this._hasGemsCostResetTimeInSecs) {
      result.gemsCostResetTimeInSecs = JsonToInt32.toJson(this._gemsCostResetTimeInSecs);
    }
    if (this._hasKeysAmountPurPurchase) {
      result.keysAmountPurPurchase = JsonToInt32.toJson(this._keysAmountPurPurchase);
    }
    if (this._hasKeysAmountPerAd) {
      result.keysAmountPerAd = JsonToInt32.toJson(this._keysAmountPerAd);
    }
    if (this._hasMaxAdsPerDay) {
      result.maxAdsPerDay = JsonToInt32.toJson(this._maxAdsPerDay);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get inventoryKeyId() {
    return this._hasInventoryKeyId ? this._inventoryKeyId : JsonToString.default;
  }
  get hasInventoryKeyId() {
    return this._hasInventoryKeyId;
  }
  setInventoryKeyId(path, value) {
    return {type: 'SET', path: path.concat(['inventoryKeyId']), value};
  }
  deleteInventoryKeyId(path) {
    return {type: 'DELETE', path: path.concat(['inventoryKeyId'])};
  }
  /**
   * @returns {number}
   */
  get keyRegenerateIntervalInSecs() {
    return this._hasKeyRegenerateIntervalInSecs ? this._keyRegenerateIntervalInSecs : JsonToInt32.default;
  }
  get hasKeyRegenerateIntervalInSecs() {
    return this._hasKeyRegenerateIntervalInSecs;
  }
  setKeyRegenerateIntervalInSecs(path, value) {
    return {type: 'SET', path: path.concat(['keyRegenerateIntervalInSecs']), value};
  }
  deleteKeyRegenerateIntervalInSecs(path) {
    return {type: 'DELETE', path: path.concat(['keyRegenerateIntervalInSecs'])};
  }
  /**
   * @returns {number}
   */
  get keyCap() {
    return this._hasKeyCap ? this._keyCap : JsonToInt32.default;
  }
  get hasKeyCap() {
    return this._hasKeyCap;
  }
  setKeyCap(path, value) {
    return {type: 'SET', path: path.concat(['keyCap']), value};
  }
  deleteKeyCap(path) {
    return {type: 'DELETE', path: path.concat(['keyCap'])};
  }
  /**
   * @returns {number[]}
   */
  get gemsCosts() {
    return this._gemsCosts;
  }
  addGemsCosts(path, value) {
    return {type: 'ADD', path: path.concat(['gemsCosts']), value};
  }
  setGemsCosts(path, value) {
    return {type: 'SET', path: path.concat(['gemsCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGemsCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gemsCosts', key]), value};
  }
  deleteGemsCosts(path) {
    return {type: 'DELETE', path: path.concat(['gemsCosts'])};
  }
  deleteGemsCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gemsCosts', key])};
  }
  /**
   * @returns {number}
   */
  get gemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs ? this._gemsCostResetTimeInSecs : JsonToInt32.default;
  }
  get hasGemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs;
  }
  setGemsCostResetTimeInSecs(path, value) {
    return {type: 'SET', path: path.concat(['gemsCostResetTimeInSecs']), value};
  }
  deleteGemsCostResetTimeInSecs(path) {
    return {type: 'DELETE', path: path.concat(['gemsCostResetTimeInSecs'])};
  }
  /**
   * @returns {number}
   */
  get keysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase ? this._keysAmountPurPurchase : JsonToInt32.default;
  }
  get hasKeysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase;
  }
  setKeysAmountPurPurchase(path, value) {
    return {type: 'SET', path: path.concat(['keysAmountPurPurchase']), value};
  }
  deleteKeysAmountPurPurchase(path) {
    return {type: 'DELETE', path: path.concat(['keysAmountPurPurchase'])};
  }
  /**
   * @returns {number}
   */
  get keysAmountPerAd() {
    return this._hasKeysAmountPerAd ? this._keysAmountPerAd : JsonToInt32.default;
  }
  get hasKeysAmountPerAd() {
    return this._hasKeysAmountPerAd;
  }
  setKeysAmountPerAd(path, value) {
    return {type: 'SET', path: path.concat(['keysAmountPerAd']), value};
  }
  deleteKeysAmountPerAd(path) {
    return {type: 'DELETE', path: path.concat(['keysAmountPerAd'])};
  }
  /**
   * @returns {number}
   */
  get maxAdsPerDay() {
    return this._hasMaxAdsPerDay ? this._maxAdsPerDay : JsonToInt32.default;
  }
  get hasMaxAdsPerDay() {
    return this._hasMaxAdsPerDay;
  }
  setMaxAdsPerDay(path, value) {
    return {type: 'SET', path: path.concat(['maxAdsPerDay']), value};
  }
  deleteMaxAdsPerDay(path) {
    return {type: 'DELETE', path: path.concat(['maxAdsPerDay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "inventoryKeyId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasInventoryKeyId = true;
              copy._inventoryKeyId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInventoryKeyId) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasInventoryKeyId = false;
              copy._inventoryKeyId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyRegenerateIntervalInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeyRegenerateIntervalInSecs = true;
              copy._keyRegenerateIntervalInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyRegenerateIntervalInSecs) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeyRegenerateIntervalInSecs = false;
              copy._keyRegenerateIntervalInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeyCap = true;
              copy._keyCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyCap) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeyCap = false;
              copy._keyCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemsCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._gemsCosts = [];        for (let i of value) {
                copy._gemsCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gemsCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._gemsCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.slice();
              copy._gemsCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.slice(0, path[1]).concat(copy._gemsCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          const oldValue = this._gemsCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LevelAccessKey(this);
          copy._gemsCosts = copy._gemsCosts.slice();
          copy._gemsCosts[key] = newValue;
          return copy;
        }
      }
      case "gemsCostResetTimeInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasGemsCostResetTimeInSecs = true;
              copy._gemsCostResetTimeInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemsCostResetTimeInSecs) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasGemsCostResetTimeInSecs = false;
              copy._gemsCostResetTimeInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keysAmountPurPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeysAmountPurPurchase = true;
              copy._keysAmountPurPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeysAmountPurPurchase) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeysAmountPurPurchase = false;
              copy._keysAmountPurPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keysAmountPerAd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeysAmountPerAd = true;
              copy._keysAmountPerAd = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeysAmountPerAd) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasKeysAmountPerAd = false;
              copy._keysAmountPerAd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxAdsPerDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasMaxAdsPerDay = true;
              copy._maxAdsPerDay = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxAdsPerDay) {
                return this;
              }
              const copy = new MapEvent_LevelAccessKey(this);
              copy._hasMaxAdsPerDay = false;
              copy._maxAdsPerDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LevelAccessKey} other
   * @returns {MapEvent_LevelAccessKey}
   */
  merge(other) {
    const copy = new MapEvent_LevelAccessKey(this);
    if (other._hasInventoryKeyId) {
      copy._hasInventoryKeyId = true;
      copy._inventoryKeyId = other._inventoryKeyId;
    }
    if (other._hasKeyRegenerateIntervalInSecs) {
      copy._hasKeyRegenerateIntervalInSecs = true;
      copy._keyRegenerateIntervalInSecs = other._keyRegenerateIntervalInSecs;
    }
    if (other._hasKeyCap) {
      copy._hasKeyCap = true;
      copy._keyCap = other._keyCap;
    }
    copy._gemsCosts = this._gemsCosts.concat(other._gemsCosts);
    if (other._hasGemsCostResetTimeInSecs) {
      copy._hasGemsCostResetTimeInSecs = true;
      copy._gemsCostResetTimeInSecs = other._gemsCostResetTimeInSecs;
    }
    if (other._hasKeysAmountPurPurchase) {
      copy._hasKeysAmountPurPurchase = true;
      copy._keysAmountPurPurchase = other._keysAmountPurPurchase;
    }
    if (other._hasKeysAmountPerAd) {
      copy._hasKeysAmountPerAd = true;
      copy._keysAmountPerAd = other._keysAmountPerAd;
    }
    if (other._hasMaxAdsPerDay) {
      copy._hasMaxAdsPerDay = true;
      copy._maxAdsPerDay = other._maxAdsPerDay;
    }
    return copy;
  }
}
MapEvent_LevelAccessKey.default = new MapEvent_LevelAccessKey();
class MapEvent_LevelAccessKey_Builder {
  constructor(value) {
    this._value = new MapEvent_LevelAccessKey(value);
  }
  build() {
    return new MapEvent_LevelAccessKey(this._value);
  }
  setInventoryKeyId(value) {
    this._value._hasInventoryKeyId = true;
    this._value._inventoryKeyId = value;
    return this;
  }
  deleteInventoryKeyId() {
    this._value._hasInventoryKeyId = false;
    this._value._inventoryKeyId = null;
    return this;
  }
  setKeyRegenerateIntervalInSecs(value) {
    this._value._hasKeyRegenerateIntervalInSecs = true;
    this._value._keyRegenerateIntervalInSecs = value;
    return this;
  }
  deleteKeyRegenerateIntervalInSecs() {
    this._value._hasKeyRegenerateIntervalInSecs = false;
    this._value._keyRegenerateIntervalInSecs = null;
    return this;
  }
  setKeyCap(value) {
    this._value._hasKeyCap = true;
    this._value._keyCap = value;
    return this;
  }
  deleteKeyCap() {
    this._value._hasKeyCap = false;
    this._value._keyCap = null;
    return this;
  }
  addAllGemsCosts(values) {
    this._value._gemsCosts = this._value._gemsCosts.concat(values);
    return this;
  }
  addGemsCosts(value) {
    this._value._gemsCosts = this._value._gemsCosts.concat([value]);
    return this;
  }
  setGemsCosts(index, value) {
    this._value._gemsCosts = this._value._gemsCosts.concat();
    this._value._gemsCosts[index] = value;
    return this;
  }
  clearGemsCosts() {
    this._value._gemsCosts = [];
    return this;
  }
  setGemsCostResetTimeInSecs(value) {
    this._value._hasGemsCostResetTimeInSecs = true;
    this._value._gemsCostResetTimeInSecs = value;
    return this;
  }
  deleteGemsCostResetTimeInSecs() {
    this._value._hasGemsCostResetTimeInSecs = false;
    this._value._gemsCostResetTimeInSecs = null;
    return this;
  }
  setKeysAmountPurPurchase(value) {
    this._value._hasKeysAmountPurPurchase = true;
    this._value._keysAmountPurPurchase = value;
    return this;
  }
  deleteKeysAmountPurPurchase() {
    this._value._hasKeysAmountPurPurchase = false;
    this._value._keysAmountPurPurchase = null;
    return this;
  }
  setKeysAmountPerAd(value) {
    this._value._hasKeysAmountPerAd = true;
    this._value._keysAmountPerAd = value;
    return this;
  }
  deleteKeysAmountPerAd() {
    this._value._hasKeysAmountPerAd = false;
    this._value._keysAmountPerAd = null;
    return this;
  }
  setMaxAdsPerDay(value) {
    this._value._hasMaxAdsPerDay = true;
    this._value._maxAdsPerDay = value;
    return this;
  }
  deleteMaxAdsPerDay() {
    this._value._hasMaxAdsPerDay = false;
    this._value._maxAdsPerDay = null;
    return this;
  }
}
MapEvent_LevelAccessKey.Builder = MapEvent_LevelAccessKey_Builder;
class MapEvent_LevelAccessKey_WithParent {
  /**
   * @param {MapEvent_LevelAccessKey} value
   * @param {MapEvent_LevelAccessKey_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LevelAccessKey.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInventoryKeyId() {
    if (this._cachedHasInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedHasInventoryKeyId = true;
      } else {
        this._cachedHasInventoryKeyId = this._parent ? this._parent.hasInventoryKeyId : false;
      }
    }
    return this._cachedHasInventoryKeyId;
  }
  get inventoryKeyId() {
    if (this._cachedInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedInventoryKeyId = this._value.inventoryKeyId;
      } else {
        this._cachedInventoryKeyId = this._parent ? this._parent.inventoryKeyId : this._value.inventoryKeyId;
      }
    }
    return this._cachedInventoryKeyId;
  }
  get hasKeyRegenerateIntervalInSecs() {
    if (this._cachedHasKeyRegenerateIntervalInSecs === undefined) {
      if (this._value.hasKeyRegenerateIntervalInSecs) {
        this._cachedHasKeyRegenerateIntervalInSecs = true;
      } else {
        this._cachedHasKeyRegenerateIntervalInSecs = this._parent ? this._parent.hasKeyRegenerateIntervalInSecs : false;
      }
    }
    return this._cachedHasKeyRegenerateIntervalInSecs;
  }
  get keyRegenerateIntervalInSecs() {
    if (this._cachedKeyRegenerateIntervalInSecs === undefined) {
      if (this._value.hasKeyRegenerateIntervalInSecs) {
        this._cachedKeyRegenerateIntervalInSecs = this._value.keyRegenerateIntervalInSecs;
      } else {
        this._cachedKeyRegenerateIntervalInSecs = this._parent ? this._parent.keyRegenerateIntervalInSecs : this._value.keyRegenerateIntervalInSecs;
      }
    }
    return this._cachedKeyRegenerateIntervalInSecs;
  }
  get hasKeyCap() {
    if (this._cachedHasKeyCap === undefined) {
      if (this._value.hasKeyCap) {
        this._cachedHasKeyCap = true;
      } else {
        this._cachedHasKeyCap = this._parent ? this._parent.hasKeyCap : false;
      }
    }
    return this._cachedHasKeyCap;
  }
  get keyCap() {
    if (this._cachedKeyCap === undefined) {
      if (this._value.hasKeyCap) {
        this._cachedKeyCap = this._value.keyCap;
      } else {
        this._cachedKeyCap = this._parent ? this._parent.keyCap : this._value.keyCap;
      }
    }
    return this._cachedKeyCap;
  }
  get selfGemsCosts() {
    return this._value.gemsCosts;
  }
  get inherentGemsCosts() {
    if (!this._inherentGemsCosts) {
      this._inherentGemsCosts = this._parent ? this._parent.gemsCosts : [];
    }
    return this._inherentGemsCosts;
  }
  get gemsCosts() {
    if (!this._allGemsCosts) {
      this._allGemsCosts = this._parent ? this._parent.gemsCosts.concat(this.selfGemsCosts) : this.selfGemsCosts;
    }
    return this._allGemsCosts;
  }
  get hasGemsCostResetTimeInSecs() {
    if (this._cachedHasGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedHasGemsCostResetTimeInSecs = true;
      } else {
        this._cachedHasGemsCostResetTimeInSecs = this._parent ? this._parent.hasGemsCostResetTimeInSecs : false;
      }
    }
    return this._cachedHasGemsCostResetTimeInSecs;
  }
  get gemsCostResetTimeInSecs() {
    if (this._cachedGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedGemsCostResetTimeInSecs = this._value.gemsCostResetTimeInSecs;
      } else {
        this._cachedGemsCostResetTimeInSecs = this._parent ? this._parent.gemsCostResetTimeInSecs : this._value.gemsCostResetTimeInSecs;
      }
    }
    return this._cachedGemsCostResetTimeInSecs;
  }
  get hasKeysAmountPurPurchase() {
    if (this._cachedHasKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedHasKeysAmountPurPurchase = true;
      } else {
        this._cachedHasKeysAmountPurPurchase = this._parent ? this._parent.hasKeysAmountPurPurchase : false;
      }
    }
    return this._cachedHasKeysAmountPurPurchase;
  }
  get keysAmountPurPurchase() {
    if (this._cachedKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedKeysAmountPurPurchase = this._value.keysAmountPurPurchase;
      } else {
        this._cachedKeysAmountPurPurchase = this._parent ? this._parent.keysAmountPurPurchase : this._value.keysAmountPurPurchase;
      }
    }
    return this._cachedKeysAmountPurPurchase;
  }
  get hasKeysAmountPerAd() {
    if (this._cachedHasKeysAmountPerAd === undefined) {
      if (this._value.hasKeysAmountPerAd) {
        this._cachedHasKeysAmountPerAd = true;
      } else {
        this._cachedHasKeysAmountPerAd = this._parent ? this._parent.hasKeysAmountPerAd : false;
      }
    }
    return this._cachedHasKeysAmountPerAd;
  }
  get keysAmountPerAd() {
    if (this._cachedKeysAmountPerAd === undefined) {
      if (this._value.hasKeysAmountPerAd) {
        this._cachedKeysAmountPerAd = this._value.keysAmountPerAd;
      } else {
        this._cachedKeysAmountPerAd = this._parent ? this._parent.keysAmountPerAd : this._value.keysAmountPerAd;
      }
    }
    return this._cachedKeysAmountPerAd;
  }
  get hasMaxAdsPerDay() {
    if (this._cachedHasMaxAdsPerDay === undefined) {
      if (this._value.hasMaxAdsPerDay) {
        this._cachedHasMaxAdsPerDay = true;
      } else {
        this._cachedHasMaxAdsPerDay = this._parent ? this._parent.hasMaxAdsPerDay : false;
      }
    }
    return this._cachedHasMaxAdsPerDay;
  }
  get maxAdsPerDay() {
    if (this._cachedMaxAdsPerDay === undefined) {
      if (this._value.hasMaxAdsPerDay) {
        this._cachedMaxAdsPerDay = this._value.maxAdsPerDay;
      } else {
        this._cachedMaxAdsPerDay = this._parent ? this._parent.maxAdsPerDay : this._value.maxAdsPerDay;
      }
    }
    return this._cachedMaxAdsPerDay;
  }
  update(current, parent) {
    const result = new MapEvent_LevelAccessKey_WithParent(current, parent);
    return result;
  }
}
MapEvent_LevelAccessKey_WithParent.default = new MapEvent_LevelAccessKey_WithParent(MapEvent_LevelAccessKey.default, null);
MapEvent_LevelAccessKey.WithParent = MapEvent_LevelAccessKey_WithParent;
class MapEvent_LevelAccessKey_Descriptor {
  get inventoryKeyId() {
    if (!this._inventoryKeyId) {
      this._inventoryKeyId = {
        name: "inventoryKeyId",
        Name: "InventoryKeyId",
        number: 1,
        protoType: 9,
        protoName: "inventory_key_id",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._inventoryKeyId;
  }
  get keyRegenerateIntervalInSecs() {
    if (!this._keyRegenerateIntervalInSecs) {
      this._keyRegenerateIntervalInSecs = {
        name: "keyRegenerateIntervalInSecs",
        Name: "KeyRegenerateIntervalInSecs",
        number: 2,
        protoType: 5,
        protoName: "key_regenerate_interval_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyRegenerateIntervalInSecs;
  }
  get keyCap() {
    if (!this._keyCap) {
      this._keyCap = {
        name: "keyCap",
        Name: "KeyCap",
        number: 3,
        protoType: 5,
        protoName: "key_cap",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyCap;
  }
  get gemsCosts() {
    if (!this._gemsCosts) {
      this._gemsCosts = {
        name: "gemsCosts",
        Name: "GemsCosts",
        number: 4,
        protoType: 5,
        protoName: "gems_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCosts;
  }
  get gemsCostResetTimeInSecs() {
    if (!this._gemsCostResetTimeInSecs) {
      this._gemsCostResetTimeInSecs = {
        name: "gemsCostResetTimeInSecs",
        Name: "GemsCostResetTimeInSecs",
        number: 5,
        protoType: 5,
        protoName: "gems_cost_reset_time_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCostResetTimeInSecs;
  }
  get keysAmountPurPurchase() {
    if (!this._keysAmountPurPurchase) {
      this._keysAmountPurPurchase = {
        name: "keysAmountPurPurchase",
        Name: "KeysAmountPurPurchase",
        number: 6,
        protoType: 5,
        protoName: "keys_amount_pur_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keysAmountPurPurchase;
  }
  get keysAmountPerAd() {
    if (!this._keysAmountPerAd) {
      this._keysAmountPerAd = {
        name: "keysAmountPerAd",
        Name: "KeysAmountPerAd",
        number: 7,
        protoType: 5,
        protoName: "keys_amount_per_ad",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keysAmountPerAd;
  }
  get maxAdsPerDay() {
    if (!this._maxAdsPerDay) {
      this._maxAdsPerDay = {
        name: "maxAdsPerDay",
        Name: "MaxAdsPerDay",
        number: 8,
        protoType: 5,
        protoName: "max_ads_per_day",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxAdsPerDay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.inventoryKeyId,
        this.keyRegenerateIntervalInSecs,
        this.keyCap,
        this.gemsCosts,
        this.gemsCostResetTimeInSecs,
        this.keysAmountPurPurchase,
        this.keysAmountPerAd,
        this.maxAdsPerDay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInventoryKeyId",
        Name: "DummyOneofForInventoryKeyId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyRegenerateIntervalInSecs",
        Name: "DummyOneofForKeyRegenerateIntervalInSecs",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyCap",
        Name: "DummyOneofForKeyCap",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemsCostResetTimeInSecs",
        Name: "DummyOneofForGemsCostResetTimeInSecs",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeysAmountPurPurchase",
        Name: "DummyOneofForKeysAmountPurPurchase",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeysAmountPerAd",
        Name: "DummyOneofForKeysAmountPerAd",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxAdsPerDay",
        Name: "DummyOneofForMaxAdsPerDay",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LevelAccessKey.descriptor = new MapEvent_LevelAccessKey_Descriptor();
class MapEvent_EventMilestonePath_Milestone {
  get descriptor() {
    return MapEvent_EventMilestonePath_Milestone.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasRequiredEventPoints = false;
    this._requiredEventPoints = null;
    this._hasSilverRewardItemKey = false;
    this._silverRewardItemKey = null;
    this._hasSilverRewardItemAmount = false;
    this._silverRewardItemAmount = null;
    this._hasGoldRewardItemKey = false;
    this._goldRewardItemKey = null;
    this._hasGoldRewardItemAmount = false;
    this._goldRewardItemAmount = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasRequiredEventPoints) return false;
    if (this._hasSilverRewardItemKey) return false;
    if (this._hasSilverRewardItemAmount) return false;
    if (this._hasGoldRewardItemKey) return false;
    if (this._hasGoldRewardItemAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventMilestonePath_Milestone) {
      return value;
    }
    return MapEvent_EventMilestonePath_Milestone.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventMilestonePath_Milestone();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.requiredEventPoints != null) {
      result._hasRequiredEventPoints = true;
      result._requiredEventPoints = JsonToInt32.fromJson(json.requiredEventPoints);
    }
    if (json.silverRewardItemKey != null) {
      result._hasSilverRewardItemKey = true;
      result._silverRewardItemKey = JsonToString.fromJson(json.silverRewardItemKey);
    }
    if (json.silverRewardItemAmount != null) {
      result._hasSilverRewardItemAmount = true;
      result._silverRewardItemAmount = JsonToInt32.fromJson(json.silverRewardItemAmount);
    }
    if (json.goldRewardItemKey != null) {
      result._hasGoldRewardItemKey = true;
      result._goldRewardItemKey = JsonToString.fromJson(json.goldRewardItemKey);
    }
    if (json.goldRewardItemAmount != null) {
      result._hasGoldRewardItemAmount = true;
      result._goldRewardItemAmount = JsonToInt32.fromJson(json.goldRewardItemAmount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasRequiredEventPoints) {
      result.requiredEventPoints = JsonToInt32.toJson(this._requiredEventPoints);
    }
    if (this._hasSilverRewardItemKey) {
      result.silverRewardItemKey = JsonToString.toJson(this._silverRewardItemKey);
    }
    if (this._hasSilverRewardItemAmount) {
      result.silverRewardItemAmount = JsonToInt32.toJson(this._silverRewardItemAmount);
    }
    if (this._hasGoldRewardItemKey) {
      result.goldRewardItemKey = JsonToString.toJson(this._goldRewardItemKey);
    }
    if (this._hasGoldRewardItemAmount) {
      result.goldRewardItemAmount = JsonToInt32.toJson(this._goldRewardItemAmount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get requiredEventPoints() {
    return this._hasRequiredEventPoints ? this._requiredEventPoints : JsonToInt32.default;
  }
  get hasRequiredEventPoints() {
    return this._hasRequiredEventPoints;
  }
  setRequiredEventPoints(path, value) {
    return {type: 'SET', path: path.concat(['requiredEventPoints']), value};
  }
  deleteRequiredEventPoints(path) {
    return {type: 'DELETE', path: path.concat(['requiredEventPoints'])};
  }
  /**
   * @returns {string}
   */
  get silverRewardItemKey() {
    return this._hasSilverRewardItemKey ? this._silverRewardItemKey : JsonToString.default;
  }
  get hasSilverRewardItemKey() {
    return this._hasSilverRewardItemKey;
  }
  setSilverRewardItemKey(path, value) {
    return {type: 'SET', path: path.concat(['silverRewardItemKey']), value};
  }
  deleteSilverRewardItemKey(path) {
    return {type: 'DELETE', path: path.concat(['silverRewardItemKey'])};
  }
  /**
   * @returns {number}
   */
  get silverRewardItemAmount() {
    return this._hasSilverRewardItemAmount ? this._silverRewardItemAmount : JsonToInt32.default;
  }
  get hasSilverRewardItemAmount() {
    return this._hasSilverRewardItemAmount;
  }
  setSilverRewardItemAmount(path, value) {
    return {type: 'SET', path: path.concat(['silverRewardItemAmount']), value};
  }
  deleteSilverRewardItemAmount(path) {
    return {type: 'DELETE', path: path.concat(['silverRewardItemAmount'])};
  }
  /**
   * @returns {string}
   */
  get goldRewardItemKey() {
    return this._hasGoldRewardItemKey ? this._goldRewardItemKey : JsonToString.default;
  }
  get hasGoldRewardItemKey() {
    return this._hasGoldRewardItemKey;
  }
  setGoldRewardItemKey(path, value) {
    return {type: 'SET', path: path.concat(['goldRewardItemKey']), value};
  }
  deleteGoldRewardItemKey(path) {
    return {type: 'DELETE', path: path.concat(['goldRewardItemKey'])};
  }
  /**
   * @returns {number}
   */
  get goldRewardItemAmount() {
    return this._hasGoldRewardItemAmount ? this._goldRewardItemAmount : JsonToInt32.default;
  }
  get hasGoldRewardItemAmount() {
    return this._hasGoldRewardItemAmount;
  }
  setGoldRewardItemAmount(path, value) {
    return {type: 'SET', path: path.concat(['goldRewardItemAmount']), value};
  }
  deleteGoldRewardItemAmount(path) {
    return {type: 'DELETE', path: path.concat(['goldRewardItemAmount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "requiredEventPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasRequiredEventPoints = true;
              copy._requiredEventPoints = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRequiredEventPoints) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasRequiredEventPoints = false;
              copy._requiredEventPoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverRewardItemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasSilverRewardItemKey = true;
              copy._silverRewardItemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSilverRewardItemKey) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasSilverRewardItemKey = false;
              copy._silverRewardItemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverRewardItemAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasSilverRewardItemAmount = true;
              copy._silverRewardItemAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSilverRewardItemAmount) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasSilverRewardItemAmount = false;
              copy._silverRewardItemAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldRewardItemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasGoldRewardItemKey = true;
              copy._goldRewardItemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldRewardItemKey) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasGoldRewardItemKey = false;
              copy._goldRewardItemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldRewardItemAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasGoldRewardItemAmount = true;
              copy._goldRewardItemAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldRewardItemAmount) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath_Milestone(this);
              copy._hasGoldRewardItemAmount = false;
              copy._goldRewardItemAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventMilestonePath_Milestone} other
   * @returns {MapEvent_EventMilestonePath_Milestone}
   */
  merge(other) {
    const copy = new MapEvent_EventMilestonePath_Milestone(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasRequiredEventPoints) {
      copy._hasRequiredEventPoints = true;
      copy._requiredEventPoints = other._requiredEventPoints;
    }
    if (other._hasSilverRewardItemKey) {
      copy._hasSilverRewardItemKey = true;
      copy._silverRewardItemKey = other._silverRewardItemKey;
    }
    if (other._hasSilverRewardItemAmount) {
      copy._hasSilverRewardItemAmount = true;
      copy._silverRewardItemAmount = other._silverRewardItemAmount;
    }
    if (other._hasGoldRewardItemKey) {
      copy._hasGoldRewardItemKey = true;
      copy._goldRewardItemKey = other._goldRewardItemKey;
    }
    if (other._hasGoldRewardItemAmount) {
      copy._hasGoldRewardItemAmount = true;
      copy._goldRewardItemAmount = other._goldRewardItemAmount;
    }
    return copy;
  }
}
MapEvent_EventMilestonePath_Milestone.default = new MapEvent_EventMilestonePath_Milestone();
class MapEvent_EventMilestonePath_Milestone_Builder {
  constructor(value) {
    this._value = new MapEvent_EventMilestonePath_Milestone(value);
  }
  build() {
    return new MapEvent_EventMilestonePath_Milestone(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setRequiredEventPoints(value) {
    this._value._hasRequiredEventPoints = true;
    this._value._requiredEventPoints = value;
    return this;
  }
  deleteRequiredEventPoints() {
    this._value._hasRequiredEventPoints = false;
    this._value._requiredEventPoints = null;
    return this;
  }
  setSilverRewardItemKey(value) {
    this._value._hasSilverRewardItemKey = true;
    this._value._silverRewardItemKey = value;
    return this;
  }
  deleteSilverRewardItemKey() {
    this._value._hasSilverRewardItemKey = false;
    this._value._silverRewardItemKey = null;
    return this;
  }
  setSilverRewardItemAmount(value) {
    this._value._hasSilverRewardItemAmount = true;
    this._value._silverRewardItemAmount = value;
    return this;
  }
  deleteSilverRewardItemAmount() {
    this._value._hasSilverRewardItemAmount = false;
    this._value._silverRewardItemAmount = null;
    return this;
  }
  setGoldRewardItemKey(value) {
    this._value._hasGoldRewardItemKey = true;
    this._value._goldRewardItemKey = value;
    return this;
  }
  deleteGoldRewardItemKey() {
    this._value._hasGoldRewardItemKey = false;
    this._value._goldRewardItemKey = null;
    return this;
  }
  setGoldRewardItemAmount(value) {
    this._value._hasGoldRewardItemAmount = true;
    this._value._goldRewardItemAmount = value;
    return this;
  }
  deleteGoldRewardItemAmount() {
    this._value._hasGoldRewardItemAmount = false;
    this._value._goldRewardItemAmount = null;
    return this;
  }
}
MapEvent_EventMilestonePath_Milestone.Builder = MapEvent_EventMilestonePath_Milestone_Builder;
class MapEvent_EventMilestonePath_Milestone_WithParent {
  /**
   * @param {MapEvent_EventMilestonePath_Milestone} value
   * @param {MapEvent_EventMilestonePath_Milestone_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventMilestonePath_Milestone.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasRequiredEventPoints() {
    if (this._cachedHasRequiredEventPoints === undefined) {
      if (this._value.hasRequiredEventPoints) {
        this._cachedHasRequiredEventPoints = true;
      } else {
        this._cachedHasRequiredEventPoints = this._parent ? this._parent.hasRequiredEventPoints : false;
      }
    }
    return this._cachedHasRequiredEventPoints;
  }
  get requiredEventPoints() {
    if (this._cachedRequiredEventPoints === undefined) {
      if (this._value.hasRequiredEventPoints) {
        this._cachedRequiredEventPoints = this._value.requiredEventPoints;
      } else {
        this._cachedRequiredEventPoints = this._parent ? this._parent.requiredEventPoints : this._value.requiredEventPoints;
      }
    }
    return this._cachedRequiredEventPoints;
  }
  get hasSilverRewardItemKey() {
    if (this._cachedHasSilverRewardItemKey === undefined) {
      if (this._value.hasSilverRewardItemKey) {
        this._cachedHasSilverRewardItemKey = true;
      } else {
        this._cachedHasSilverRewardItemKey = this._parent ? this._parent.hasSilverRewardItemKey : false;
      }
    }
    return this._cachedHasSilverRewardItemKey;
  }
  get silverRewardItemKey() {
    if (this._cachedSilverRewardItemKey === undefined) {
      if (this._value.hasSilverRewardItemKey) {
        this._cachedSilverRewardItemKey = this._value.silverRewardItemKey;
      } else {
        this._cachedSilverRewardItemKey = this._parent ? this._parent.silverRewardItemKey : this._value.silverRewardItemKey;
      }
    }
    return this._cachedSilverRewardItemKey;
  }
  get hasSilverRewardItemAmount() {
    if (this._cachedHasSilverRewardItemAmount === undefined) {
      if (this._value.hasSilverRewardItemAmount) {
        this._cachedHasSilverRewardItemAmount = true;
      } else {
        this._cachedHasSilverRewardItemAmount = this._parent ? this._parent.hasSilverRewardItemAmount : false;
      }
    }
    return this._cachedHasSilverRewardItemAmount;
  }
  get silverRewardItemAmount() {
    if (this._cachedSilverRewardItemAmount === undefined) {
      if (this._value.hasSilverRewardItemAmount) {
        this._cachedSilverRewardItemAmount = this._value.silverRewardItemAmount;
      } else {
        this._cachedSilverRewardItemAmount = this._parent ? this._parent.silverRewardItemAmount : this._value.silverRewardItemAmount;
      }
    }
    return this._cachedSilverRewardItemAmount;
  }
  get hasGoldRewardItemKey() {
    if (this._cachedHasGoldRewardItemKey === undefined) {
      if (this._value.hasGoldRewardItemKey) {
        this._cachedHasGoldRewardItemKey = true;
      } else {
        this._cachedHasGoldRewardItemKey = this._parent ? this._parent.hasGoldRewardItemKey : false;
      }
    }
    return this._cachedHasGoldRewardItemKey;
  }
  get goldRewardItemKey() {
    if (this._cachedGoldRewardItemKey === undefined) {
      if (this._value.hasGoldRewardItemKey) {
        this._cachedGoldRewardItemKey = this._value.goldRewardItemKey;
      } else {
        this._cachedGoldRewardItemKey = this._parent ? this._parent.goldRewardItemKey : this._value.goldRewardItemKey;
      }
    }
    return this._cachedGoldRewardItemKey;
  }
  get hasGoldRewardItemAmount() {
    if (this._cachedHasGoldRewardItemAmount === undefined) {
      if (this._value.hasGoldRewardItemAmount) {
        this._cachedHasGoldRewardItemAmount = true;
      } else {
        this._cachedHasGoldRewardItemAmount = this._parent ? this._parent.hasGoldRewardItemAmount : false;
      }
    }
    return this._cachedHasGoldRewardItemAmount;
  }
  get goldRewardItemAmount() {
    if (this._cachedGoldRewardItemAmount === undefined) {
      if (this._value.hasGoldRewardItemAmount) {
        this._cachedGoldRewardItemAmount = this._value.goldRewardItemAmount;
      } else {
        this._cachedGoldRewardItemAmount = this._parent ? this._parent.goldRewardItemAmount : this._value.goldRewardItemAmount;
      }
    }
    return this._cachedGoldRewardItemAmount;
  }
  update(current, parent) {
    const result = new MapEvent_EventMilestonePath_Milestone_WithParent(current, parent);
    return result;
  }
}
MapEvent_EventMilestonePath_Milestone_WithParent.default = new MapEvent_EventMilestonePath_Milestone_WithParent(MapEvent_EventMilestonePath_Milestone.default, null);
MapEvent_EventMilestonePath_Milestone.WithParent = MapEvent_EventMilestonePath_Milestone_WithParent;
class MapEvent_EventMilestonePath_Milestone_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get requiredEventPoints() {
    if (!this._requiredEventPoints) {
      this._requiredEventPoints = {
        name: "requiredEventPoints",
        Name: "RequiredEventPoints",
        number: 2,
        protoType: 5,
        protoName: "required_event_points",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredEventPoints;
  }
  get silverRewardItemKey() {
    if (!this._silverRewardItemKey) {
      this._silverRewardItemKey = {
        name: "silverRewardItemKey",
        Name: "SilverRewardItemKey",
        number: 3,
        protoType: 9,
        protoName: "silver_reward_item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverRewardItemKey;
  }
  get silverRewardItemAmount() {
    if (!this._silverRewardItemAmount) {
      this._silverRewardItemAmount = {
        name: "silverRewardItemAmount",
        Name: "SilverRewardItemAmount",
        number: 4,
        protoType: 5,
        protoName: "silver_reward_item_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverRewardItemAmount;
  }
  get goldRewardItemKey() {
    if (!this._goldRewardItemKey) {
      this._goldRewardItemKey = {
        name: "goldRewardItemKey",
        Name: "GoldRewardItemKey",
        number: 5,
        protoType: 9,
        protoName: "gold_reward_item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldRewardItemKey;
  }
  get goldRewardItemAmount() {
    if (!this._goldRewardItemAmount) {
      this._goldRewardItemAmount = {
        name: "goldRewardItemAmount",
        Name: "GoldRewardItemAmount",
        number: 6,
        protoType: 5,
        protoName: "gold_reward_item_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldRewardItemAmount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.requiredEventPoints,
        this.silverRewardItemKey,
        this.silverRewardItemAmount,
        this.goldRewardItemKey,
        this.goldRewardItemAmount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRequiredEventPoints",
        Name: "DummyOneofForRequiredEventPoints",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSilverRewardItemKey",
        Name: "DummyOneofForSilverRewardItemKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSilverRewardItemAmount",
        Name: "DummyOneofForSilverRewardItemAmount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldRewardItemKey",
        Name: "DummyOneofForGoldRewardItemKey",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldRewardItemAmount",
        Name: "DummyOneofForGoldRewardItemAmount",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventMilestonePath_Milestone.descriptor = new MapEvent_EventMilestonePath_Milestone_Descriptor();
class MapEvent_EventMilestonePath {
  get descriptor() {
    return MapEvent_EventMilestonePath.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBuyPointsStartMilestoneIndex = false;
    this._buyPointsStartMilestoneIndex = null;
    this._hasPointsToGemsRates = false;
    this._pointsToGemsRates = null;
    this._milestones = [];
  }
  isEmpty() {
    if (this._hasBuyPointsStartMilestoneIndex) return false;
    if (this._hasPointsToGemsRates) return false;
    if (this._milestones.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventMilestonePath) {
      return value;
    }
    return MapEvent_EventMilestonePath.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventMilestonePath();
    if (json.buyPointsStartMilestoneIndex != null) {
      result._hasBuyPointsStartMilestoneIndex = true;
      result._buyPointsStartMilestoneIndex = JsonToInt32.fromJson(json.buyPointsStartMilestoneIndex);
    }
    if (json.pointsToGemsRates != null) {
      result._hasPointsToGemsRates = true;
      result._pointsToGemsRates = JsonToDouble.fromJson(json.pointsToGemsRates);
    }
    result._milestones = JsonToList(json.milestones, MapEvent_EventMilestonePath_Milestone);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBuyPointsStartMilestoneIndex) {
      result.buyPointsStartMilestoneIndex = JsonToInt32.toJson(this._buyPointsStartMilestoneIndex);
    }
    if (this._hasPointsToGemsRates) {
      result.pointsToGemsRates = JsonToDouble.toJson(this._pointsToGemsRates);
    }
    if (this._milestones.length > 0) {
      result.milestones = ArrayToJson(this._milestones, MapEvent_EventMilestonePath_Milestone);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get buyPointsStartMilestoneIndex() {
    return this._hasBuyPointsStartMilestoneIndex ? this._buyPointsStartMilestoneIndex : JsonToInt32.default;
  }
  get hasBuyPointsStartMilestoneIndex() {
    return this._hasBuyPointsStartMilestoneIndex;
  }
  setBuyPointsStartMilestoneIndex(path, value) {
    return {type: 'SET', path: path.concat(['buyPointsStartMilestoneIndex']), value};
  }
  deleteBuyPointsStartMilestoneIndex(path) {
    return {type: 'DELETE', path: path.concat(['buyPointsStartMilestoneIndex'])};
  }
  /**
   * @returns {number}
   */
  get pointsToGemsRates() {
    return this._hasPointsToGemsRates ? this._pointsToGemsRates : JsonToDouble.default;
  }
  get hasPointsToGemsRates() {
    return this._hasPointsToGemsRates;
  }
  setPointsToGemsRates(path, value) {
    return {type: 'SET', path: path.concat(['pointsToGemsRates']), value};
  }
  deletePointsToGemsRates(path) {
    return {type: 'DELETE', path: path.concat(['pointsToGemsRates'])};
  }
  /**
   * @returns {MapEvent_EventMilestonePath_Milestone[]}
   */
  get milestones() {
    return this._milestones;
  }
  addMilestones(path, value) {
    return {type: 'ADD', path: path.concat(['milestones']), value: value.toJson()};
  }
  setMilestones(path, value) {
    return {type: 'SET', path: path.concat(['milestones']), value: ArrayToJson(value, MapEvent_EventMilestonePath_Milestone)};
  }
  setMilestonesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['milestones', key]), value: value.toJson()};
  }
  deleteMilestones(path) {
    return {type: 'DELETE', path: path.concat(['milestones'])};
  }
  deleteMilestonesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['milestones', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "buyPointsStartMilestoneIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._hasBuyPointsStartMilestoneIndex = true;
              copy._buyPointsStartMilestoneIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBuyPointsStartMilestoneIndex) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath(this);
              copy._hasBuyPointsStartMilestoneIndex = false;
              copy._buyPointsStartMilestoneIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "pointsToGemsRates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._hasPointsToGemsRates = true;
              copy._pointsToGemsRates = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPointsToGemsRates) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath(this);
              copy._hasPointsToGemsRates = false;
              copy._pointsToGemsRates = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "milestones": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._milestones = [];        for (let i of value) {
                copy._milestones.push(MapEvent_EventMilestonePath_Milestone.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._milestones = copy._milestones.concat([MapEvent_EventMilestonePath_Milestone.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._milestones.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventMilestonePath(this);
              copy._milestones = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._milestones.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._milestones = copy._milestones.slice();
              copy._milestones[path[1]] = MapEvent_EventMilestonePath_Milestone.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventMilestonePath(this);
              copy._milestones = copy._milestones.slice(0, path[1]).concat(copy._milestones.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._milestones.length) {
            return this;
          }
          const oldValue = this._milestones[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventMilestonePath(this);
          copy._milestones = copy._milestones.slice();
          copy._milestones[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventMilestonePath} other
   * @returns {MapEvent_EventMilestonePath}
   */
  merge(other) {
    const copy = new MapEvent_EventMilestonePath(this);
    if (other._hasBuyPointsStartMilestoneIndex) {
      copy._hasBuyPointsStartMilestoneIndex = true;
      copy._buyPointsStartMilestoneIndex = other._buyPointsStartMilestoneIndex;
    }
    if (other._hasPointsToGemsRates) {
      copy._hasPointsToGemsRates = true;
      copy._pointsToGemsRates = other._pointsToGemsRates;
    }
    copy._milestones = this._milestones.concat(other._milestones);
    return copy;
  }
}
MapEvent_EventMilestonePath.default = new MapEvent_EventMilestonePath();
MapEvent_EventMilestonePath.Milestone = MapEvent_EventMilestonePath_Milestone;
class MapEvent_EventMilestonePath_Builder {
  constructor(value) {
    this._value = new MapEvent_EventMilestonePath(value);
  }
  build() {
    return new MapEvent_EventMilestonePath(this._value);
  }
  setBuyPointsStartMilestoneIndex(value) {
    this._value._hasBuyPointsStartMilestoneIndex = true;
    this._value._buyPointsStartMilestoneIndex = value;
    return this;
  }
  deleteBuyPointsStartMilestoneIndex() {
    this._value._hasBuyPointsStartMilestoneIndex = false;
    this._value._buyPointsStartMilestoneIndex = null;
    return this;
  }
  setPointsToGemsRates(value) {
    this._value._hasPointsToGemsRates = true;
    this._value._pointsToGemsRates = value;
    return this;
  }
  deletePointsToGemsRates() {
    this._value._hasPointsToGemsRates = false;
    this._value._pointsToGemsRates = null;
    return this;
  }
  addAllMilestones(values) {
    this._value._milestones = this._value._milestones.concat(values);
    return this;
  }
  addMilestones(value) {
    this._value._milestones = this._value._milestones.concat([value]);
    return this;
  }
  setMilestones(index, value) {
    this._value._milestones = this._value._milestones.concat();
    this._value._milestones[index] = value;
    return this;
  }
  clearMilestones() {
    this._value._milestones = [];
    return this;
  }
}
MapEvent_EventMilestonePath.Builder = MapEvent_EventMilestonePath_Builder;
class MapEvent_EventMilestonePath_WithParent {
  /**
   * @param {MapEvent_EventMilestonePath} value
   * @param {MapEvent_EventMilestonePath_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventMilestonePath.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBuyPointsStartMilestoneIndex() {
    if (this._cachedHasBuyPointsStartMilestoneIndex === undefined) {
      if (this._value.hasBuyPointsStartMilestoneIndex) {
        this._cachedHasBuyPointsStartMilestoneIndex = true;
      } else {
        this._cachedHasBuyPointsStartMilestoneIndex = this._parent ? this._parent.hasBuyPointsStartMilestoneIndex : false;
      }
    }
    return this._cachedHasBuyPointsStartMilestoneIndex;
  }
  get buyPointsStartMilestoneIndex() {
    if (this._cachedBuyPointsStartMilestoneIndex === undefined) {
      if (this._value.hasBuyPointsStartMilestoneIndex) {
        this._cachedBuyPointsStartMilestoneIndex = this._value.buyPointsStartMilestoneIndex;
      } else {
        this._cachedBuyPointsStartMilestoneIndex = this._parent ? this._parent.buyPointsStartMilestoneIndex : this._value.buyPointsStartMilestoneIndex;
      }
    }
    return this._cachedBuyPointsStartMilestoneIndex;
  }
  get hasPointsToGemsRates() {
    if (this._cachedHasPointsToGemsRates === undefined) {
      if (this._value.hasPointsToGemsRates) {
        this._cachedHasPointsToGemsRates = true;
      } else {
        this._cachedHasPointsToGemsRates = this._parent ? this._parent.hasPointsToGemsRates : false;
      }
    }
    return this._cachedHasPointsToGemsRates;
  }
  get pointsToGemsRates() {
    if (this._cachedPointsToGemsRates === undefined) {
      if (this._value.hasPointsToGemsRates) {
        this._cachedPointsToGemsRates = this._value.pointsToGemsRates;
      } else {
        this._cachedPointsToGemsRates = this._parent ? this._parent.pointsToGemsRates : this._value.pointsToGemsRates;
      }
    }
    return this._cachedPointsToGemsRates;
  }
  get selfMilestones() {
    if (!this._selfMilestones) {
      this._selfMilestones = [];
      for (let i of this._value.milestones) {
        this._selfMilestones.push(new MapEvent_EventMilestonePath_Milestone.WithParent(i, null));
      }
    }
    return this._selfMilestones;
  }
  get inherentMilestones() {
    if (!this._inherentMilestones) {
      this._inherentMilestones = this._parent ? this._parent.milestones : [];
    }
    return this._inherentMilestones;
  }
  get milestones() {
    if (!this._allMilestones) {
      this._allMilestones = this._parent ? this._parent.milestones.concat(this.selfMilestones) : this.selfMilestones;
    }
    return this._allMilestones;
  }
  update(current, parent) {
    const result = new MapEvent_EventMilestonePath_WithParent(current, parent);
    if (this._selfMilestones) {
      if (this._value.milestones === current.milestones) {
        result._selfMilestones = this._selfMilestones;
      } else {
        result._selfMilestones = [];
        for (let i = 0; i < current.milestones.length; i++) {
          const oldValue = this._value.milestones[i];
          if (oldValue) {
            const oldCache = this._selfMilestones[i];
            if (oldValue === current.milestones[i]) {
              result._selfMilestones[i] = oldCache;
            } else {
              result._selfMilestones[i] = oldCache.update(current.milestones[i], null);
            }
          } else {
            result._selfMilestones[i] = new MapEvent_EventMilestonePath_Milestone.WithParent(current.milestones[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventMilestonePath_WithParent.default = new MapEvent_EventMilestonePath_WithParent(MapEvent_EventMilestonePath.default, null);
MapEvent_EventMilestonePath.WithParent = MapEvent_EventMilestonePath_WithParent;
class MapEvent_EventMilestonePath_Descriptor {
  get buyPointsStartMilestoneIndex() {
    if (!this._buyPointsStartMilestoneIndex) {
      this._buyPointsStartMilestoneIndex = {
        name: "buyPointsStartMilestoneIndex",
        Name: "BuyPointsStartMilestoneIndex",
        number: 3,
        protoType: 5,
        protoName: "buy_points_start_milestone_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._buyPointsStartMilestoneIndex;
  }
  get pointsToGemsRates() {
    if (!this._pointsToGemsRates) {
      this._pointsToGemsRates = {
        name: "pointsToGemsRates",
        Name: "PointsToGemsRates",
        number: 4,
        protoType: 1,
        protoName: "points_to_gems_rates",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pointsToGemsRates;
  }
  get milestones() {
    if (!this._milestones) {
      this._milestones = {
        name: "milestones",
        Name: "Milestones",
        number: 2,
        protoType: 11,
        protoName: "milestones",
        type: MapEvent_EventMilestonePath_Milestone,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._milestones;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.buyPointsStartMilestoneIndex,
        this.pointsToGemsRates,
        this.milestones,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBuyPointsStartMilestoneIndex",
        Name: "DummyOneofForBuyPointsStartMilestoneIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPointsToGemsRates",
        Name: "DummyOneofForPointsToGemsRates",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventMilestonePath.descriptor = new MapEvent_EventMilestonePath_Descriptor();
class MapEvent_EventLevel_LevelReward {
  get descriptor() {
    return MapEvent_EventLevel_LevelReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventLevel_LevelReward) {
      return value;
    }
    return MapEvent_EventLevel_LevelReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventLevel_LevelReward();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelReward(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelReward(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelReward(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelReward(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventLevel_LevelReward} other
   * @returns {MapEvent_EventLevel_LevelReward}
   */
  merge(other) {
    const copy = new MapEvent_EventLevel_LevelReward(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
MapEvent_EventLevel_LevelReward.default = new MapEvent_EventLevel_LevelReward();
class MapEvent_EventLevel_LevelReward_Builder {
  constructor(value) {
    this._value = new MapEvent_EventLevel_LevelReward(value);
  }
  build() {
    return new MapEvent_EventLevel_LevelReward(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
MapEvent_EventLevel_LevelReward.Builder = MapEvent_EventLevel_LevelReward_Builder;
class MapEvent_EventLevel_LevelReward_WithParent {
  /**
   * @param {MapEvent_EventLevel_LevelReward} value
   * @param {MapEvent_EventLevel_LevelReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventLevel_LevelReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new MapEvent_EventLevel_LevelReward_WithParent(current, parent);
    return result;
  }
}
MapEvent_EventLevel_LevelReward_WithParent.default = new MapEvent_EventLevel_LevelReward_WithParent(MapEvent_EventLevel_LevelReward.default, null);
MapEvent_EventLevel_LevelReward.WithParent = MapEvent_EventLevel_LevelReward_WithParent;
class MapEvent_EventLevel_LevelReward_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventLevel_LevelReward.descriptor = new MapEvent_EventLevel_LevelReward_Descriptor();
class MapEvent_EventLevel_LevelInfo {
  get descriptor() {
    return MapEvent_EventLevel_LevelInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasSilverStarQuestKey = false;
    this._silverStarQuestKey = null;
    this._hasGoldStarQuestKey = false;
    this._goldStarQuestKey = null;
    this._hasDifficulty = false;
    this._difficulty = null;
    this._silverStarReward = [];
    this._goldStarReward = [];
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasSilverStarQuestKey) return false;
    if (this._hasGoldStarQuestKey) return false;
    if (this._hasDifficulty) return false;
    if (this._silverStarReward.length > 0) return false;
    if (this._goldStarReward.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventLevel_LevelInfo) {
      return value;
    }
    return MapEvent_EventLevel_LevelInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventLevel_LevelInfo();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.silverStarQuestKey != null) {
      result._hasSilverStarQuestKey = true;
      result._silverStarQuestKey = JsonToString.fromJson(json.silverStarQuestKey);
    }
    if (json.goldStarQuestKey != null) {
      result._hasGoldStarQuestKey = true;
      result._goldStarQuestKey = JsonToString.fromJson(json.goldStarQuestKey);
    }
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    result._silverStarReward = JsonToList(json.silverStarReward, MapEvent_EventLevel_LevelReward);
    result._goldStarReward = JsonToList(json.goldStarReward, MapEvent_EventLevel_LevelReward);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasSilverStarQuestKey) {
      result.silverStarQuestKey = JsonToString.toJson(this._silverStarQuestKey);
    }
    if (this._hasGoldStarQuestKey) {
      result.goldStarQuestKey = JsonToString.toJson(this._goldStarQuestKey);
    }
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._silverStarReward.length > 0) {
      result.silverStarReward = ArrayToJson(this._silverStarReward, MapEvent_EventLevel_LevelReward);
    }
    if (this._goldStarReward.length > 0) {
      result.goldStarReward = ArrayToJson(this._goldStarReward, MapEvent_EventLevel_LevelReward);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {string}
   */
  get silverStarQuestKey() {
    return this._hasSilverStarQuestKey ? this._silverStarQuestKey : JsonToString.default;
  }
  get hasSilverStarQuestKey() {
    return this._hasSilverStarQuestKey;
  }
  setSilverStarQuestKey(path, value) {
    return {type: 'SET', path: path.concat(['silverStarQuestKey']), value};
  }
  deleteSilverStarQuestKey(path) {
    return {type: 'DELETE', path: path.concat(['silverStarQuestKey'])};
  }
  /**
   * @returns {string}
   */
  get goldStarQuestKey() {
    return this._hasGoldStarQuestKey ? this._goldStarQuestKey : JsonToString.default;
  }
  get hasGoldStarQuestKey() {
    return this._hasGoldStarQuestKey;
  }
  setGoldStarQuestKey(path, value) {
    return {type: 'SET', path: path.concat(['goldStarQuestKey']), value};
  }
  deleteGoldStarQuestKey(path) {
    return {type: 'DELETE', path: path.concat(['goldStarQuestKey'])};
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {MapEvent_EventLevel_LevelReward[]}
   */
  get silverStarReward() {
    return this._silverStarReward;
  }
  addSilverStarReward(path, value) {
    return {type: 'ADD', path: path.concat(['silverStarReward']), value: value.toJson()};
  }
  setSilverStarReward(path, value) {
    return {type: 'SET', path: path.concat(['silverStarReward']), value: ArrayToJson(value, MapEvent_EventLevel_LevelReward)};
  }
  setSilverStarRewardByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['silverStarReward', key]), value: value.toJson()};
  }
  deleteSilverStarReward(path) {
    return {type: 'DELETE', path: path.concat(['silverStarReward'])};
  }
  deleteSilverStarRewardByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['silverStarReward', key])};
  }
  /**
   * @returns {MapEvent_EventLevel_LevelReward[]}
   */
  get goldStarReward() {
    return this._goldStarReward;
  }
  addGoldStarReward(path, value) {
    return {type: 'ADD', path: path.concat(['goldStarReward']), value: value.toJson()};
  }
  setGoldStarReward(path, value) {
    return {type: 'SET', path: path.concat(['goldStarReward']), value: ArrayToJson(value, MapEvent_EventLevel_LevelReward)};
  }
  setGoldStarRewardByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldStarReward', key]), value: value.toJson()};
  }
  deleteGoldStarReward(path) {
    return {type: 'DELETE', path: path.concat(['goldStarReward'])};
  }
  deleteGoldStarRewardByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldStarReward', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverStarQuestKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasSilverStarQuestKey = true;
              copy._silverStarQuestKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSilverStarQuestKey) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasSilverStarQuestKey = false;
              copy._silverStarQuestKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldStarQuestKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasGoldStarQuestKey = true;
              copy._goldStarQuestKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldStarQuestKey) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasGoldStarQuestKey = false;
              copy._goldStarQuestKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverStarReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = [];        for (let i of value) {
                copy._silverStarReward.push(MapEvent_EventLevel_LevelReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.concat([MapEvent_EventLevel_LevelReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._silverStarReward.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._silverStarReward.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.slice();
              copy._silverStarReward[path[1]] = MapEvent_EventLevel_LevelReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.slice(0, path[1]).concat(copy._silverStarReward.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._silverStarReward.length) {
            return this;
          }
          const oldValue = this._silverStarReward[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel_LevelInfo(this);
          copy._silverStarReward = copy._silverStarReward.slice();
          copy._silverStarReward[key] = newValue;
          return copy;
        }
      }
      case "goldStarReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = [];        for (let i of value) {
                copy._goldStarReward.push(MapEvent_EventLevel_LevelReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.concat([MapEvent_EventLevel_LevelReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldStarReward.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldStarReward.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.slice();
              copy._goldStarReward[path[1]] = MapEvent_EventLevel_LevelReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.slice(0, path[1]).concat(copy._goldStarReward.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldStarReward.length) {
            return this;
          }
          const oldValue = this._goldStarReward[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel_LevelInfo(this);
          copy._goldStarReward = copy._goldStarReward.slice();
          copy._goldStarReward[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventLevel_LevelInfo} other
   * @returns {MapEvent_EventLevel_LevelInfo}
   */
  merge(other) {
    const copy = new MapEvent_EventLevel_LevelInfo(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasSilverStarQuestKey) {
      copy._hasSilverStarQuestKey = true;
      copy._silverStarQuestKey = other._silverStarQuestKey;
    }
    if (other._hasGoldStarQuestKey) {
      copy._hasGoldStarQuestKey = true;
      copy._goldStarQuestKey = other._goldStarQuestKey;
    }
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    copy._silverStarReward = this._silverStarReward.concat(other._silverStarReward);
    copy._goldStarReward = this._goldStarReward.concat(other._goldStarReward);
    return copy;
  }
}
MapEvent_EventLevel_LevelInfo.default = new MapEvent_EventLevel_LevelInfo();
class MapEvent_EventLevel_LevelInfo_Builder {
  constructor(value) {
    this._value = new MapEvent_EventLevel_LevelInfo(value);
  }
  build() {
    return new MapEvent_EventLevel_LevelInfo(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setSilverStarQuestKey(value) {
    this._value._hasSilverStarQuestKey = true;
    this._value._silverStarQuestKey = value;
    return this;
  }
  deleteSilverStarQuestKey() {
    this._value._hasSilverStarQuestKey = false;
    this._value._silverStarQuestKey = null;
    return this;
  }
  setGoldStarQuestKey(value) {
    this._value._hasGoldStarQuestKey = true;
    this._value._goldStarQuestKey = value;
    return this;
  }
  deleteGoldStarQuestKey() {
    this._value._hasGoldStarQuestKey = false;
    this._value._goldStarQuestKey = null;
    return this;
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  addAllSilverStarReward(values) {
    this._value._silverStarReward = this._value._silverStarReward.concat(values);
    return this;
  }
  addSilverStarReward(value) {
    this._value._silverStarReward = this._value._silverStarReward.concat([value]);
    return this;
  }
  setSilverStarReward(index, value) {
    this._value._silverStarReward = this._value._silverStarReward.concat();
    this._value._silverStarReward[index] = value;
    return this;
  }
  clearSilverStarReward() {
    this._value._silverStarReward = [];
    return this;
  }
  addAllGoldStarReward(values) {
    this._value._goldStarReward = this._value._goldStarReward.concat(values);
    return this;
  }
  addGoldStarReward(value) {
    this._value._goldStarReward = this._value._goldStarReward.concat([value]);
    return this;
  }
  setGoldStarReward(index, value) {
    this._value._goldStarReward = this._value._goldStarReward.concat();
    this._value._goldStarReward[index] = value;
    return this;
  }
  clearGoldStarReward() {
    this._value._goldStarReward = [];
    return this;
  }
}
MapEvent_EventLevel_LevelInfo.Builder = MapEvent_EventLevel_LevelInfo_Builder;
class MapEvent_EventLevel_LevelInfo_WithParent {
  /**
   * @param {MapEvent_EventLevel_LevelInfo} value
   * @param {MapEvent_EventLevel_LevelInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventLevel_LevelInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasSilverStarQuestKey() {
    if (this._cachedHasSilverStarQuestKey === undefined) {
      if (this._value.hasSilverStarQuestKey) {
        this._cachedHasSilverStarQuestKey = true;
      } else {
        this._cachedHasSilverStarQuestKey = this._parent ? this._parent.hasSilverStarQuestKey : false;
      }
    }
    return this._cachedHasSilverStarQuestKey;
  }
  get silverStarQuestKey() {
    if (this._cachedSilverStarQuestKey === undefined) {
      if (this._value.hasSilverStarQuestKey) {
        this._cachedSilverStarQuestKey = this._value.silverStarQuestKey;
      } else {
        this._cachedSilverStarQuestKey = this._parent ? this._parent.silverStarQuestKey : this._value.silverStarQuestKey;
      }
    }
    return this._cachedSilverStarQuestKey;
  }
  get hasGoldStarQuestKey() {
    if (this._cachedHasGoldStarQuestKey === undefined) {
      if (this._value.hasGoldStarQuestKey) {
        this._cachedHasGoldStarQuestKey = true;
      } else {
        this._cachedHasGoldStarQuestKey = this._parent ? this._parent.hasGoldStarQuestKey : false;
      }
    }
    return this._cachedHasGoldStarQuestKey;
  }
  get goldStarQuestKey() {
    if (this._cachedGoldStarQuestKey === undefined) {
      if (this._value.hasGoldStarQuestKey) {
        this._cachedGoldStarQuestKey = this._value.goldStarQuestKey;
      } else {
        this._cachedGoldStarQuestKey = this._parent ? this._parent.goldStarQuestKey : this._value.goldStarQuestKey;
      }
    }
    return this._cachedGoldStarQuestKey;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get selfSilverStarReward() {
    if (!this._selfSilverStarReward) {
      this._selfSilverStarReward = [];
      for (let i of this._value.silverStarReward) {
        this._selfSilverStarReward.push(new MapEvent_EventLevel_LevelReward.WithParent(i, null));
      }
    }
    return this._selfSilverStarReward;
  }
  get inherentSilverStarReward() {
    if (!this._inherentSilverStarReward) {
      this._inherentSilverStarReward = this._parent ? this._parent.silverStarReward : [];
    }
    return this._inherentSilverStarReward;
  }
  get silverStarReward() {
    if (!this._allSilverStarReward) {
      this._allSilverStarReward = this._parent ? this._parent.silverStarReward.concat(this.selfSilverStarReward) : this.selfSilverStarReward;
    }
    return this._allSilverStarReward;
  }
  get selfGoldStarReward() {
    if (!this._selfGoldStarReward) {
      this._selfGoldStarReward = [];
      for (let i of this._value.goldStarReward) {
        this._selfGoldStarReward.push(new MapEvent_EventLevel_LevelReward.WithParent(i, null));
      }
    }
    return this._selfGoldStarReward;
  }
  get inherentGoldStarReward() {
    if (!this._inherentGoldStarReward) {
      this._inherentGoldStarReward = this._parent ? this._parent.goldStarReward : [];
    }
    return this._inherentGoldStarReward;
  }
  get goldStarReward() {
    if (!this._allGoldStarReward) {
      this._allGoldStarReward = this._parent ? this._parent.goldStarReward.concat(this.selfGoldStarReward) : this.selfGoldStarReward;
    }
    return this._allGoldStarReward;
  }
  update(current, parent) {
    const result = new MapEvent_EventLevel_LevelInfo_WithParent(current, parent);
    if (this._selfSilverStarReward) {
      if (this._value.silverStarReward === current.silverStarReward) {
        result._selfSilverStarReward = this._selfSilverStarReward;
      } else {
        result._selfSilverStarReward = [];
        for (let i = 0; i < current.silverStarReward.length; i++) {
          const oldValue = this._value.silverStarReward[i];
          if (oldValue) {
            const oldCache = this._selfSilverStarReward[i];
            if (oldValue === current.silverStarReward[i]) {
              result._selfSilverStarReward[i] = oldCache;
            } else {
              result._selfSilverStarReward[i] = oldCache.update(current.silverStarReward[i], null);
            }
          } else {
            result._selfSilverStarReward[i] = new MapEvent_EventLevel_LevelReward.WithParent(current.silverStarReward[i], null);
          }
        }
      }
    }
    if (this._selfGoldStarReward) {
      if (this._value.goldStarReward === current.goldStarReward) {
        result._selfGoldStarReward = this._selfGoldStarReward;
      } else {
        result._selfGoldStarReward = [];
        for (let i = 0; i < current.goldStarReward.length; i++) {
          const oldValue = this._value.goldStarReward[i];
          if (oldValue) {
            const oldCache = this._selfGoldStarReward[i];
            if (oldValue === current.goldStarReward[i]) {
              result._selfGoldStarReward[i] = oldCache;
            } else {
              result._selfGoldStarReward[i] = oldCache.update(current.goldStarReward[i], null);
            }
          } else {
            result._selfGoldStarReward[i] = new MapEvent_EventLevel_LevelReward.WithParent(current.goldStarReward[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventLevel_LevelInfo_WithParent.default = new MapEvent_EventLevel_LevelInfo_WithParent(MapEvent_EventLevel_LevelInfo.default, null);
MapEvent_EventLevel_LevelInfo.WithParent = MapEvent_EventLevel_LevelInfo_WithParent;
class MapEvent_EventLevel_LevelInfo_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get silverStarQuestKey() {
    if (!this._silverStarQuestKey) {
      this._silverStarQuestKey = {
        name: "silverStarQuestKey",
        Name: "SilverStarQuestKey",
        number: 2,
        protoType: 9,
        protoName: "silver_star_quest_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverStarQuestKey;
  }
  get goldStarQuestKey() {
    if (!this._goldStarQuestKey) {
      this._goldStarQuestKey = {
        name: "goldStarQuestKey",
        Name: "GoldStarQuestKey",
        number: 3,
        protoType: 9,
        protoName: "gold_star_quest_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldStarQuestKey;
  }
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 5,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get silverStarReward() {
    if (!this._silverStarReward) {
      this._silverStarReward = {
        name: "silverStarReward",
        Name: "SilverStarReward",
        number: 6,
        protoType: 11,
        protoName: "silver_star_reward",
        type: MapEvent_EventLevel_LevelReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverStarReward;
  }
  get goldStarReward() {
    if (!this._goldStarReward) {
      this._goldStarReward = {
        name: "goldStarReward",
        Name: "GoldStarReward",
        number: 7,
        protoType: 11,
        protoName: "gold_star_reward",
        type: MapEvent_EventLevel_LevelReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldStarReward;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.silverStarQuestKey,
        this.goldStarQuestKey,
        this.difficulty,
        this.silverStarReward,
        this.goldStarReward,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSilverStarQuestKey",
        Name: "DummyOneofForSilverStarQuestKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldStarQuestKey",
        Name: "DummyOneofForGoldStarQuestKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventLevel_LevelInfo.descriptor = new MapEvent_EventLevel_LevelInfo_Descriptor();
class MapEvent_EventLevel_SoloLevel {
  get descriptor() {
    return MapEvent_EventLevel_SoloLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levels = [];
  }
  isEmpty() {
    if (this._levels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventLevel_SoloLevel) {
      return value;
    }
    return MapEvent_EventLevel_SoloLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventLevel_SoloLevel();
    result._levels = JsonToList(json.levels, MapEvent_EventLevel_LevelInfo);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, MapEvent_EventLevel_LevelInfo);
    }
    return result;
  }
  /**
   * @returns {MapEvent_EventLevel_LevelInfo[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, MapEvent_EventLevel_LevelInfo)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_SoloLevel(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(MapEvent_EventLevel_LevelInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.concat([MapEvent_EventLevel_LevelInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel_SoloLevel(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = MapEvent_EventLevel_LevelInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel_SoloLevel(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventLevel_SoloLevel} other
   * @returns {MapEvent_EventLevel_SoloLevel}
   */
  merge(other) {
    const copy = new MapEvent_EventLevel_SoloLevel(this);
    copy._levels = this._levels.concat(other._levels);
    return copy;
  }
}
MapEvent_EventLevel_SoloLevel.default = new MapEvent_EventLevel_SoloLevel();
class MapEvent_EventLevel_SoloLevel_Builder {
  constructor(value) {
    this._value = new MapEvent_EventLevel_SoloLevel(value);
  }
  build() {
    return new MapEvent_EventLevel_SoloLevel(this._value);
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
}
MapEvent_EventLevel_SoloLevel.Builder = MapEvent_EventLevel_SoloLevel_Builder;
class MapEvent_EventLevel_SoloLevel_WithParent {
  /**
   * @param {MapEvent_EventLevel_SoloLevel} value
   * @param {MapEvent_EventLevel_SoloLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventLevel_SoloLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new MapEvent_EventLevel_LevelInfo.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  update(current, parent) {
    const result = new MapEvent_EventLevel_SoloLevel_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new MapEvent_EventLevel_LevelInfo.WithParent(current.levels[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventLevel_SoloLevel_WithParent.default = new MapEvent_EventLevel_SoloLevel_WithParent(MapEvent_EventLevel_SoloLevel.default, null);
MapEvent_EventLevel_SoloLevel.WithParent = MapEvent_EventLevel_SoloLevel_WithParent;
class MapEvent_EventLevel_SoloLevel_Descriptor {
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 1,
        protoType: 11,
        protoName: "levels",
        type: MapEvent_EventLevel_LevelInfo,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_EventLevel_SoloLevel.descriptor = new MapEvent_EventLevel_SoloLevel_Descriptor();
class MapEvent_EventLevel {
  get descriptor() {
    return MapEvent_EventLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._mapKeys = [];
    this._mapLevels = [];
    this._soloLevels = [];
  }
  isEmpty() {
    if (this._mapKeys.length > 0) return false;
    if (this._mapLevels.length > 0) return false;
    if (this._soloLevels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventLevel) {
      return value;
    }
    return MapEvent_EventLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventLevel();
    result._mapKeys = JsonToList(json.mapKeys, JsonToString);
    result._mapLevels = JsonToList(json.mapLevels, MapEvent_EventLevel_LevelInfo);
    result._soloLevels = JsonToList(json.soloLevels, MapEvent_EventLevel_SoloLevel);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._mapKeys.length > 0) {
      result.mapKeys = ArrayToJson(this._mapKeys, JsonToString);
    }
    if (this._mapLevels.length > 0) {
      result.mapLevels = ArrayToJson(this._mapLevels, MapEvent_EventLevel_LevelInfo);
    }
    if (this._soloLevels.length > 0) {
      result.soloLevels = ArrayToJson(this._soloLevels, MapEvent_EventLevel_SoloLevel);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get mapKeys() {
    return this._mapKeys;
  }
  addMapKeys(path, value) {
    return {type: 'ADD', path: path.concat(['mapKeys']), value};
  }
  setMapKeys(path, value) {
    return {type: 'SET', path: path.concat(['mapKeys']), value: ArrayToJson(value, JsonToString)};
  }
  setMapKeysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapKeys', key]), value};
  }
  deleteMapKeys(path) {
    return {type: 'DELETE', path: path.concat(['mapKeys'])};
  }
  deleteMapKeysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapKeys', key])};
  }
  /**
   * @returns {MapEvent_EventLevel_LevelInfo[]}
   */
  get mapLevels() {
    return this._mapLevels;
  }
  addMapLevels(path, value) {
    return {type: 'ADD', path: path.concat(['mapLevels']), value: value.toJson()};
  }
  setMapLevels(path, value) {
    return {type: 'SET', path: path.concat(['mapLevels']), value: ArrayToJson(value, MapEvent_EventLevel_LevelInfo)};
  }
  setMapLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapLevels', key]), value: value.toJson()};
  }
  deleteMapLevels(path) {
    return {type: 'DELETE', path: path.concat(['mapLevels'])};
  }
  deleteMapLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapLevels', key])};
  }
  /**
   * @returns {MapEvent_EventLevel_SoloLevel[]}
   */
  get soloLevels() {
    return this._soloLevels;
  }
  addSoloLevels(path, value) {
    return {type: 'ADD', path: path.concat(['soloLevels']), value: value.toJson()};
  }
  setSoloLevels(path, value) {
    return {type: 'SET', path: path.concat(['soloLevels']), value: ArrayToJson(value, MapEvent_EventLevel_SoloLevel)};
  }
  setSoloLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['soloLevels', key]), value: value.toJson()};
  }
  deleteSoloLevels(path) {
    return {type: 'DELETE', path: path.concat(['soloLevels'])};
  }
  deleteSoloLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['soloLevels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapKeys = [];        for (let i of value) {
                copy._mapKeys.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapKeys = copy._mapKeys.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapKeys.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel(this);
              copy._mapKeys = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapKeys.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapKeys = copy._mapKeys.slice();
              copy._mapKeys[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapKeys = copy._mapKeys.slice(0, path[1]).concat(copy._mapKeys.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapKeys.length) {
            return this;
          }
          const oldValue = this._mapKeys[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel(this);
          copy._mapKeys = copy._mapKeys.slice();
          copy._mapKeys[key] = newValue;
          return copy;
        }
      }
      case "mapLevels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapLevels = [];        for (let i of value) {
                copy._mapLevels.push(MapEvent_EventLevel_LevelInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapLevels = copy._mapLevels.concat([MapEvent_EventLevel_LevelInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapLevels.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel(this);
              copy._mapLevels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapLevels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapLevels = copy._mapLevels.slice();
              copy._mapLevels[path[1]] = MapEvent_EventLevel_LevelInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel(this);
              copy._mapLevels = copy._mapLevels.slice(0, path[1]).concat(copy._mapLevels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapLevels.length) {
            return this;
          }
          const oldValue = this._mapLevels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel(this);
          copy._mapLevels = copy._mapLevels.slice();
          copy._mapLevels[key] = newValue;
          return copy;
        }
      }
      case "soloLevels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._soloLevels = [];        for (let i of value) {
                copy._soloLevels.push(MapEvent_EventLevel_SoloLevel.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.concat([MapEvent_EventLevel_SoloLevel.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._soloLevels.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventLevel(this);
              copy._soloLevels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._soloLevels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.slice();
              copy._soloLevels[path[1]] = MapEvent_EventLevel_SoloLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.slice(0, path[1]).concat(copy._soloLevels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._soloLevels.length) {
            return this;
          }
          const oldValue = this._soloLevels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventLevel(this);
          copy._soloLevels = copy._soloLevels.slice();
          copy._soloLevels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventLevel} other
   * @returns {MapEvent_EventLevel}
   */
  merge(other) {
    const copy = new MapEvent_EventLevel(this);
    copy._mapKeys = this._mapKeys.concat(other._mapKeys);
    copy._mapLevels = this._mapLevels.concat(other._mapLevels);
    copy._soloLevels = this._soloLevels.concat(other._soloLevels);
    return copy;
  }
}
MapEvent_EventLevel.default = new MapEvent_EventLevel();
MapEvent_EventLevel.LevelReward = MapEvent_EventLevel_LevelReward;
MapEvent_EventLevel.LevelInfo = MapEvent_EventLevel_LevelInfo;
MapEvent_EventLevel.SoloLevel = MapEvent_EventLevel_SoloLevel;
class MapEvent_EventLevel_Builder {
  constructor(value) {
    this._value = new MapEvent_EventLevel(value);
  }
  build() {
    return new MapEvent_EventLevel(this._value);
  }
  addAllMapKeys(values) {
    this._value._mapKeys = this._value._mapKeys.concat(values);
    return this;
  }
  addMapKeys(value) {
    this._value._mapKeys = this._value._mapKeys.concat([value]);
    return this;
  }
  setMapKeys(index, value) {
    this._value._mapKeys = this._value._mapKeys.concat();
    this._value._mapKeys[index] = value;
    return this;
  }
  clearMapKeys() {
    this._value._mapKeys = [];
    return this;
  }
  addAllMapLevels(values) {
    this._value._mapLevels = this._value._mapLevels.concat(values);
    return this;
  }
  addMapLevels(value) {
    this._value._mapLevels = this._value._mapLevels.concat([value]);
    return this;
  }
  setMapLevels(index, value) {
    this._value._mapLevels = this._value._mapLevels.concat();
    this._value._mapLevels[index] = value;
    return this;
  }
  clearMapLevels() {
    this._value._mapLevels = [];
    return this;
  }
  addAllSoloLevels(values) {
    this._value._soloLevels = this._value._soloLevels.concat(values);
    return this;
  }
  addSoloLevels(value) {
    this._value._soloLevels = this._value._soloLevels.concat([value]);
    return this;
  }
  setSoloLevels(index, value) {
    this._value._soloLevels = this._value._soloLevels.concat();
    this._value._soloLevels[index] = value;
    return this;
  }
  clearSoloLevels() {
    this._value._soloLevels = [];
    return this;
  }
}
MapEvent_EventLevel.Builder = MapEvent_EventLevel_Builder;
class MapEvent_EventLevel_WithParent {
  /**
   * @param {MapEvent_EventLevel} value
   * @param {MapEvent_EventLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMapKeys() {
    return this._value.mapKeys;
  }
  get inherentMapKeys() {
    if (!this._inherentMapKeys) {
      this._inherentMapKeys = this._parent ? this._parent.mapKeys : [];
    }
    return this._inherentMapKeys;
  }
  get mapKeys() {
    if (!this._allMapKeys) {
      this._allMapKeys = this._parent ? this._parent.mapKeys.concat(this.selfMapKeys) : this.selfMapKeys;
    }
    return this._allMapKeys;
  }
  get selfMapLevels() {
    if (!this._selfMapLevels) {
      this._selfMapLevels = [];
      for (let i of this._value.mapLevels) {
        this._selfMapLevels.push(new MapEvent_EventLevel_LevelInfo.WithParent(i, null));
      }
    }
    return this._selfMapLevels;
  }
  get inherentMapLevels() {
    if (!this._inherentMapLevels) {
      this._inherentMapLevels = this._parent ? this._parent.mapLevels : [];
    }
    return this._inherentMapLevels;
  }
  get mapLevels() {
    if (!this._allMapLevels) {
      this._allMapLevels = this._parent ? this._parent.mapLevels.concat(this.selfMapLevels) : this.selfMapLevels;
    }
    return this._allMapLevels;
  }
  get selfSoloLevels() {
    if (!this._selfSoloLevels) {
      this._selfSoloLevels = [];
      for (let i of this._value.soloLevels) {
        this._selfSoloLevels.push(new MapEvent_EventLevel_SoloLevel.WithParent(i, null));
      }
    }
    return this._selfSoloLevels;
  }
  get inherentSoloLevels() {
    if (!this._inherentSoloLevels) {
      this._inherentSoloLevels = this._parent ? this._parent.soloLevels : [];
    }
    return this._inherentSoloLevels;
  }
  get soloLevels() {
    if (!this._allSoloLevels) {
      this._allSoloLevels = this._parent ? this._parent.soloLevels.concat(this.selfSoloLevels) : this.selfSoloLevels;
    }
    return this._allSoloLevels;
  }
  update(current, parent) {
    const result = new MapEvent_EventLevel_WithParent(current, parent);
    if (this._selfMapLevels) {
      if (this._value.mapLevels === current.mapLevels) {
        result._selfMapLevels = this._selfMapLevels;
      } else {
        result._selfMapLevels = [];
        for (let i = 0; i < current.mapLevels.length; i++) {
          const oldValue = this._value.mapLevels[i];
          if (oldValue) {
            const oldCache = this._selfMapLevels[i];
            if (oldValue === current.mapLevels[i]) {
              result._selfMapLevels[i] = oldCache;
            } else {
              result._selfMapLevels[i] = oldCache.update(current.mapLevels[i], null);
            }
          } else {
            result._selfMapLevels[i] = new MapEvent_EventLevel_LevelInfo.WithParent(current.mapLevels[i], null);
          }
        }
      }
    }
    if (this._selfSoloLevels) {
      if (this._value.soloLevels === current.soloLevels) {
        result._selfSoloLevels = this._selfSoloLevels;
      } else {
        result._selfSoloLevels = [];
        for (let i = 0; i < current.soloLevels.length; i++) {
          const oldValue = this._value.soloLevels[i];
          if (oldValue) {
            const oldCache = this._selfSoloLevels[i];
            if (oldValue === current.soloLevels[i]) {
              result._selfSoloLevels[i] = oldCache;
            } else {
              result._selfSoloLevels[i] = oldCache.update(current.soloLevels[i], null);
            }
          } else {
            result._selfSoloLevels[i] = new MapEvent_EventLevel_SoloLevel.WithParent(current.soloLevels[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventLevel_WithParent.default = new MapEvent_EventLevel_WithParent(MapEvent_EventLevel.default, null);
MapEvent_EventLevel.WithParent = MapEvent_EventLevel_WithParent;
class MapEvent_EventLevel_Descriptor {
  get mapKeys() {
    if (!this._mapKeys) {
      this._mapKeys = {
        name: "mapKeys",
        Name: "MapKeys",
        number: 2,
        protoType: 9,
        protoName: "map_keys",
        type: JsonToString,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKeys;
  }
  get mapLevels() {
    if (!this._mapLevels) {
      this._mapLevels = {
        name: "mapLevels",
        Name: "MapLevels",
        number: 3,
        protoType: 11,
        protoName: "map_levels",
        type: MapEvent_EventLevel_LevelInfo,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapLevels;
  }
  get soloLevels() {
    if (!this._soloLevels) {
      this._soloLevels = {
        name: "soloLevels",
        Name: "SoloLevels",
        number: 4,
        protoType: 11,
        protoName: "solo_levels",
        type: MapEvent_EventLevel_SoloLevel,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soloLevels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKeys,
        this.mapLevels,
        this.soloLevels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_EventLevel.descriptor = new MapEvent_EventLevel_Descriptor();
class MapEvent_EventQuest_Quest {
  get descriptor() {
    return MapEvent_EventQuest_Quest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasAwardPointsAmount = false;
    this._awardPointsAmount = null;
    this._hasAwardTokenAmount = false;
    this._awardTokenAmount = null;
    this._hasAwardCoopKeyAmount = false;
    this._awardCoopKeyAmount = null;
    this._hasAwardBossKeyAmount = false;
    this._awardBossKeyAmount = null;
    this._hasCompletionTimesLimit = false;
    this._completionTimesLimit = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDisplayPoints = false;
    this._displayPoints = null;
    this._hasIcon = false;
    this._icon = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasAwardPointsAmount) return false;
    if (this._hasAwardTokenAmount) return false;
    if (this._hasAwardCoopKeyAmount) return false;
    if (this._hasAwardBossKeyAmount) return false;
    if (this._hasCompletionTimesLimit) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDisplayPoints) return false;
    if (this._hasIcon) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventQuest_Quest) {
      return value;
    }
    return MapEvent_EventQuest_Quest.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventQuest_Quest();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.awardPointsAmount != null) {
      result._hasAwardPointsAmount = true;
      result._awardPointsAmount = JsonToInt32.fromJson(json.awardPointsAmount);
    }
    if (json.awardTokenAmount != null) {
      result._hasAwardTokenAmount = true;
      result._awardTokenAmount = JsonToInt32.fromJson(json.awardTokenAmount);
    }
    if (json.awardCoopKeyAmount != null) {
      result._hasAwardCoopKeyAmount = true;
      result._awardCoopKeyAmount = JsonToInt32.fromJson(json.awardCoopKeyAmount);
    }
    if (json.awardBossKeyAmount != null) {
      result._hasAwardBossKeyAmount = true;
      result._awardBossKeyAmount = JsonToInt32.fromJson(json.awardBossKeyAmount);
    }
    if (json.completionTimesLimit != null) {
      result._hasCompletionTimesLimit = true;
      result._completionTimesLimit = JsonToInt32.fromJson(json.completionTimesLimit);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.displayPoints != null) {
      result._hasDisplayPoints = true;
      result._displayPoints = JsonToString.fromJson(json.displayPoints);
    }
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasAwardPointsAmount) {
      result.awardPointsAmount = JsonToInt32.toJson(this._awardPointsAmount);
    }
    if (this._hasAwardTokenAmount) {
      result.awardTokenAmount = JsonToInt32.toJson(this._awardTokenAmount);
    }
    if (this._hasAwardCoopKeyAmount) {
      result.awardCoopKeyAmount = JsonToInt32.toJson(this._awardCoopKeyAmount);
    }
    if (this._hasAwardBossKeyAmount) {
      result.awardBossKeyAmount = JsonToInt32.toJson(this._awardBossKeyAmount);
    }
    if (this._hasCompletionTimesLimit) {
      result.completionTimesLimit = JsonToInt32.toJson(this._completionTimesLimit);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDisplayPoints) {
      result.displayPoints = JsonToString.toJson(this._displayPoints);
    }
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get awardPointsAmount() {
    return this._hasAwardPointsAmount ? this._awardPointsAmount : JsonToInt32.default;
  }
  get hasAwardPointsAmount() {
    return this._hasAwardPointsAmount;
  }
  setAwardPointsAmount(path, value) {
    return {type: 'SET', path: path.concat(['awardPointsAmount']), value};
  }
  deleteAwardPointsAmount(path) {
    return {type: 'DELETE', path: path.concat(['awardPointsAmount'])};
  }
  /**
   * @returns {number}
   */
  get awardTokenAmount() {
    return this._hasAwardTokenAmount ? this._awardTokenAmount : JsonToInt32.default;
  }
  get hasAwardTokenAmount() {
    return this._hasAwardTokenAmount;
  }
  setAwardTokenAmount(path, value) {
    return {type: 'SET', path: path.concat(['awardTokenAmount']), value};
  }
  deleteAwardTokenAmount(path) {
    return {type: 'DELETE', path: path.concat(['awardTokenAmount'])};
  }
  /**
   * @returns {number}
   */
  get awardCoopKeyAmount() {
    return this._hasAwardCoopKeyAmount ? this._awardCoopKeyAmount : JsonToInt32.default;
  }
  get hasAwardCoopKeyAmount() {
    return this._hasAwardCoopKeyAmount;
  }
  setAwardCoopKeyAmount(path, value) {
    return {type: 'SET', path: path.concat(['awardCoopKeyAmount']), value};
  }
  deleteAwardCoopKeyAmount(path) {
    return {type: 'DELETE', path: path.concat(['awardCoopKeyAmount'])};
  }
  /**
   * @returns {number}
   */
  get awardBossKeyAmount() {
    return this._hasAwardBossKeyAmount ? this._awardBossKeyAmount : JsonToInt32.default;
  }
  get hasAwardBossKeyAmount() {
    return this._hasAwardBossKeyAmount;
  }
  setAwardBossKeyAmount(path, value) {
    return {type: 'SET', path: path.concat(['awardBossKeyAmount']), value};
  }
  deleteAwardBossKeyAmount(path) {
    return {type: 'DELETE', path: path.concat(['awardBossKeyAmount'])};
  }
  /**
   * @returns {number}
   */
  get completionTimesLimit() {
    return this._hasCompletionTimesLimit ? this._completionTimesLimit : JsonToInt32.default;
  }
  get hasCompletionTimesLimit() {
    return this._hasCompletionTimesLimit;
  }
  setCompletionTimesLimit(path, value) {
    return {type: 'SET', path: path.concat(['completionTimesLimit']), value};
  }
  deleteCompletionTimesLimit(path) {
    return {type: 'DELETE', path: path.concat(['completionTimesLimit'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get displayPoints() {
    return this._hasDisplayPoints ? this._displayPoints : JsonToString.default;
  }
  get hasDisplayPoints() {
    return this._hasDisplayPoints;
  }
  setDisplayPoints(path, value) {
    return {type: 'SET', path: path.concat(['displayPoints']), value};
  }
  deleteDisplayPoints(path) {
    return {type: 'DELETE', path: path.concat(['displayPoints'])};
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awardPointsAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardPointsAmount = true;
              copy._awardPointsAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwardPointsAmount) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardPointsAmount = false;
              copy._awardPointsAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awardTokenAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardTokenAmount = true;
              copy._awardTokenAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwardTokenAmount) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardTokenAmount = false;
              copy._awardTokenAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awardCoopKeyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardCoopKeyAmount = true;
              copy._awardCoopKeyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwardCoopKeyAmount) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardCoopKeyAmount = false;
              copy._awardCoopKeyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awardBossKeyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardBossKeyAmount = true;
              copy._awardBossKeyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwardBossKeyAmount) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasAwardBossKeyAmount = false;
              copy._awardBossKeyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "completionTimesLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasCompletionTimesLimit = true;
              copy._completionTimesLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompletionTimesLimit) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasCompletionTimesLimit = false;
              copy._completionTimesLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasDisplayPoints = true;
              copy._displayPoints = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayPoints) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasDisplayPoints = false;
              copy._displayPoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new MapEvent_EventQuest_Quest(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventQuest_Quest} other
   * @returns {MapEvent_EventQuest_Quest}
   */
  merge(other) {
    const copy = new MapEvent_EventQuest_Quest(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasAwardPointsAmount) {
      copy._hasAwardPointsAmount = true;
      copy._awardPointsAmount = other._awardPointsAmount;
    }
    if (other._hasAwardTokenAmount) {
      copy._hasAwardTokenAmount = true;
      copy._awardTokenAmount = other._awardTokenAmount;
    }
    if (other._hasAwardCoopKeyAmount) {
      copy._hasAwardCoopKeyAmount = true;
      copy._awardCoopKeyAmount = other._awardCoopKeyAmount;
    }
    if (other._hasAwardBossKeyAmount) {
      copy._hasAwardBossKeyAmount = true;
      copy._awardBossKeyAmount = other._awardBossKeyAmount;
    }
    if (other._hasCompletionTimesLimit) {
      copy._hasCompletionTimesLimit = true;
      copy._completionTimesLimit = other._completionTimesLimit;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDisplayPoints) {
      copy._hasDisplayPoints = true;
      copy._displayPoints = other._displayPoints;
    }
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    return copy;
  }
}
MapEvent_EventQuest_Quest.default = new MapEvent_EventQuest_Quest();
class MapEvent_EventQuest_Quest_Builder {
  constructor(value) {
    this._value = new MapEvent_EventQuest_Quest(value);
  }
  build() {
    return new MapEvent_EventQuest_Quest(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setAwardPointsAmount(value) {
    this._value._hasAwardPointsAmount = true;
    this._value._awardPointsAmount = value;
    return this;
  }
  deleteAwardPointsAmount() {
    this._value._hasAwardPointsAmount = false;
    this._value._awardPointsAmount = null;
    return this;
  }
  setAwardTokenAmount(value) {
    this._value._hasAwardTokenAmount = true;
    this._value._awardTokenAmount = value;
    return this;
  }
  deleteAwardTokenAmount() {
    this._value._hasAwardTokenAmount = false;
    this._value._awardTokenAmount = null;
    return this;
  }
  setAwardCoopKeyAmount(value) {
    this._value._hasAwardCoopKeyAmount = true;
    this._value._awardCoopKeyAmount = value;
    return this;
  }
  deleteAwardCoopKeyAmount() {
    this._value._hasAwardCoopKeyAmount = false;
    this._value._awardCoopKeyAmount = null;
    return this;
  }
  setAwardBossKeyAmount(value) {
    this._value._hasAwardBossKeyAmount = true;
    this._value._awardBossKeyAmount = value;
    return this;
  }
  deleteAwardBossKeyAmount() {
    this._value._hasAwardBossKeyAmount = false;
    this._value._awardBossKeyAmount = null;
    return this;
  }
  setCompletionTimesLimit(value) {
    this._value._hasCompletionTimesLimit = true;
    this._value._completionTimesLimit = value;
    return this;
  }
  deleteCompletionTimesLimit() {
    this._value._hasCompletionTimesLimit = false;
    this._value._completionTimesLimit = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDisplayPoints(value) {
    this._value._hasDisplayPoints = true;
    this._value._displayPoints = value;
    return this;
  }
  deleteDisplayPoints() {
    this._value._hasDisplayPoints = false;
    this._value._displayPoints = null;
    return this;
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
}
MapEvent_EventQuest_Quest.Builder = MapEvent_EventQuest_Quest_Builder;
class MapEvent_EventQuest_Quest_WithParent {
  /**
   * @param {MapEvent_EventQuest_Quest} value
   * @param {MapEvent_EventQuest_Quest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventQuest_Quest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasAwardPointsAmount() {
    if (this._cachedHasAwardPointsAmount === undefined) {
      if (this._value.hasAwardPointsAmount) {
        this._cachedHasAwardPointsAmount = true;
      } else {
        this._cachedHasAwardPointsAmount = this._parent ? this._parent.hasAwardPointsAmount : false;
      }
    }
    return this._cachedHasAwardPointsAmount;
  }
  get awardPointsAmount() {
    if (this._cachedAwardPointsAmount === undefined) {
      if (this._value.hasAwardPointsAmount) {
        this._cachedAwardPointsAmount = this._value.awardPointsAmount;
      } else {
        this._cachedAwardPointsAmount = this._parent ? this._parent.awardPointsAmount : this._value.awardPointsAmount;
      }
    }
    return this._cachedAwardPointsAmount;
  }
  get hasAwardTokenAmount() {
    if (this._cachedHasAwardTokenAmount === undefined) {
      if (this._value.hasAwardTokenAmount) {
        this._cachedHasAwardTokenAmount = true;
      } else {
        this._cachedHasAwardTokenAmount = this._parent ? this._parent.hasAwardTokenAmount : false;
      }
    }
    return this._cachedHasAwardTokenAmount;
  }
  get awardTokenAmount() {
    if (this._cachedAwardTokenAmount === undefined) {
      if (this._value.hasAwardTokenAmount) {
        this._cachedAwardTokenAmount = this._value.awardTokenAmount;
      } else {
        this._cachedAwardTokenAmount = this._parent ? this._parent.awardTokenAmount : this._value.awardTokenAmount;
      }
    }
    return this._cachedAwardTokenAmount;
  }
  get hasAwardCoopKeyAmount() {
    if (this._cachedHasAwardCoopKeyAmount === undefined) {
      if (this._value.hasAwardCoopKeyAmount) {
        this._cachedHasAwardCoopKeyAmount = true;
      } else {
        this._cachedHasAwardCoopKeyAmount = this._parent ? this._parent.hasAwardCoopKeyAmount : false;
      }
    }
    return this._cachedHasAwardCoopKeyAmount;
  }
  get awardCoopKeyAmount() {
    if (this._cachedAwardCoopKeyAmount === undefined) {
      if (this._value.hasAwardCoopKeyAmount) {
        this._cachedAwardCoopKeyAmount = this._value.awardCoopKeyAmount;
      } else {
        this._cachedAwardCoopKeyAmount = this._parent ? this._parent.awardCoopKeyAmount : this._value.awardCoopKeyAmount;
      }
    }
    return this._cachedAwardCoopKeyAmount;
  }
  get hasAwardBossKeyAmount() {
    if (this._cachedHasAwardBossKeyAmount === undefined) {
      if (this._value.hasAwardBossKeyAmount) {
        this._cachedHasAwardBossKeyAmount = true;
      } else {
        this._cachedHasAwardBossKeyAmount = this._parent ? this._parent.hasAwardBossKeyAmount : false;
      }
    }
    return this._cachedHasAwardBossKeyAmount;
  }
  get awardBossKeyAmount() {
    if (this._cachedAwardBossKeyAmount === undefined) {
      if (this._value.hasAwardBossKeyAmount) {
        this._cachedAwardBossKeyAmount = this._value.awardBossKeyAmount;
      } else {
        this._cachedAwardBossKeyAmount = this._parent ? this._parent.awardBossKeyAmount : this._value.awardBossKeyAmount;
      }
    }
    return this._cachedAwardBossKeyAmount;
  }
  get hasCompletionTimesLimit() {
    if (this._cachedHasCompletionTimesLimit === undefined) {
      if (this._value.hasCompletionTimesLimit) {
        this._cachedHasCompletionTimesLimit = true;
      } else {
        this._cachedHasCompletionTimesLimit = this._parent ? this._parent.hasCompletionTimesLimit : false;
      }
    }
    return this._cachedHasCompletionTimesLimit;
  }
  get completionTimesLimit() {
    if (this._cachedCompletionTimesLimit === undefined) {
      if (this._value.hasCompletionTimesLimit) {
        this._cachedCompletionTimesLimit = this._value.completionTimesLimit;
      } else {
        this._cachedCompletionTimesLimit = this._parent ? this._parent.completionTimesLimit : this._value.completionTimesLimit;
      }
    }
    return this._cachedCompletionTimesLimit;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDisplayPoints() {
    if (this._cachedHasDisplayPoints === undefined) {
      if (this._value.hasDisplayPoints) {
        this._cachedHasDisplayPoints = true;
      } else {
        this._cachedHasDisplayPoints = this._parent ? this._parent.hasDisplayPoints : false;
      }
    }
    return this._cachedHasDisplayPoints;
  }
  get displayPoints() {
    if (this._cachedDisplayPoints === undefined) {
      if (this._value.hasDisplayPoints) {
        this._cachedDisplayPoints = this._value.displayPoints;
      } else {
        this._cachedDisplayPoints = this._parent ? this._parent.displayPoints : this._value.displayPoints;
      }
    }
    return this._cachedDisplayPoints;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  update(current, parent) {
    const result = new MapEvent_EventQuest_Quest_WithParent(current, parent);
    return result;
  }
}
MapEvent_EventQuest_Quest_WithParent.default = new MapEvent_EventQuest_Quest_WithParent(MapEvent_EventQuest_Quest.default, null);
MapEvent_EventQuest_Quest.WithParent = MapEvent_EventQuest_Quest_WithParent;
class MapEvent_EventQuest_Quest_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get awardPointsAmount() {
    if (!this._awardPointsAmount) {
      this._awardPointsAmount = {
        name: "awardPointsAmount",
        Name: "AwardPointsAmount",
        number: 2,
        protoType: 5,
        protoName: "award_points_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awardPointsAmount;
  }
  get awardTokenAmount() {
    if (!this._awardTokenAmount) {
      this._awardTokenAmount = {
        name: "awardTokenAmount",
        Name: "AwardTokenAmount",
        number: 3,
        protoType: 5,
        protoName: "award_token_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awardTokenAmount;
  }
  get awardCoopKeyAmount() {
    if (!this._awardCoopKeyAmount) {
      this._awardCoopKeyAmount = {
        name: "awardCoopKeyAmount",
        Name: "AwardCoopKeyAmount",
        number: 8,
        protoType: 5,
        protoName: "award_coop_key_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awardCoopKeyAmount;
  }
  get awardBossKeyAmount() {
    if (!this._awardBossKeyAmount) {
      this._awardBossKeyAmount = {
        name: "awardBossKeyAmount",
        Name: "AwardBossKeyAmount",
        number: 9,
        protoType: 5,
        protoName: "award_boss_key_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awardBossKeyAmount;
  }
  get completionTimesLimit() {
    if (!this._completionTimesLimit) {
      this._completionTimesLimit = {
        name: "completionTimesLimit",
        Name: "CompletionTimesLimit",
        number: 4,
        protoType: 5,
        protoName: "completion_times_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._completionTimesLimit;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 5,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          hideInInspector: true,
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get displayPoints() {
    if (!this._displayPoints) {
      this._displayPoints = {
        name: "displayPoints",
        Name: "DisplayPoints",
        number: 6,
        protoType: 9,
        protoName: "display_points",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayPoints;
  }
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 7,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "MapQuestIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.awardPointsAmount,
        this.awardTokenAmount,
        this.awardCoopKeyAmount,
        this.awardBossKeyAmount,
        this.completionTimesLimit,
        this.displayName,
        this.displayPoints,
        this.icon,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwardPointsAmount",
        Name: "DummyOneofForAwardPointsAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwardTokenAmount",
        Name: "DummyOneofForAwardTokenAmount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwardCoopKeyAmount",
        Name: "DummyOneofForAwardCoopKeyAmount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwardBossKeyAmount",
        Name: "DummyOneofForAwardBossKeyAmount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCompletionTimesLimit",
        Name: "DummyOneofForCompletionTimesLimit",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayPoints",
        Name: "DummyOneofForDisplayPoints",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventQuest_Quest.descriptor = new MapEvent_EventQuest_Quest_Descriptor();
class MapEvent_EventQuest {
  get descriptor() {
    return MapEvent_EventQuest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLuaEntryPath = false;
    this._luaEntryPath = null;
    this._quests = [];
  }
  isEmpty() {
    if (this._hasLuaEntryPath) return false;
    if (this._quests.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventQuest) {
      return value;
    }
    return MapEvent_EventQuest.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventQuest();
    if (json.luaEntryPath != null) {
      result._hasLuaEntryPath = true;
      result._luaEntryPath = JsonToString.fromJson(json.luaEntryPath);
    }
    result._quests = JsonToList(json.quests, MapEvent_EventQuest_Quest);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLuaEntryPath) {
      result.luaEntryPath = JsonToString.toJson(this._luaEntryPath);
    }
    if (this._quests.length > 0) {
      result.quests = ArrayToJson(this._quests, MapEvent_EventQuest_Quest);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get luaEntryPath() {
    return this._hasLuaEntryPath ? this._luaEntryPath : JsonToString.default;
  }
  get hasLuaEntryPath() {
    return this._hasLuaEntryPath;
  }
  setLuaEntryPath(path, value) {
    return {type: 'SET', path: path.concat(['luaEntryPath']), value};
  }
  deleteLuaEntryPath(path) {
    return {type: 'DELETE', path: path.concat(['luaEntryPath'])};
  }
  /**
   * @returns {MapEvent_EventQuest_Quest[]}
   */
  get quests() {
    return this._quests;
  }
  addQuests(path, value) {
    return {type: 'ADD', path: path.concat(['quests']), value: value.toJson()};
  }
  setQuests(path, value) {
    return {type: 'SET', path: path.concat(['quests']), value: ArrayToJson(value, MapEvent_EventQuest_Quest)};
  }
  setQuestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['quests', key]), value: value.toJson()};
  }
  deleteQuests(path) {
    return {type: 'DELETE', path: path.concat(['quests'])};
  }
  deleteQuestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['quests', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "luaEntryPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest(this);
              copy._hasLuaEntryPath = true;
              copy._luaEntryPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLuaEntryPath) {
                return this;
              }
              const copy = new MapEvent_EventQuest(this);
              copy._hasLuaEntryPath = false;
              copy._luaEntryPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "quests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest(this);
              copy._quests = [];        for (let i of value) {
                copy._quests.push(MapEvent_EventQuest_Quest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventQuest(this);
              copy._quests = copy._quests.concat([MapEvent_EventQuest_Quest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._quests.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventQuest(this);
              copy._quests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._quests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventQuest(this);
              copy._quests = copy._quests.slice();
              copy._quests[path[1]] = MapEvent_EventQuest_Quest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventQuest(this);
              copy._quests = copy._quests.slice(0, path[1]).concat(copy._quests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._quests.length) {
            return this;
          }
          const oldValue = this._quests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventQuest(this);
          copy._quests = copy._quests.slice();
          copy._quests[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventQuest} other
   * @returns {MapEvent_EventQuest}
   */
  merge(other) {
    const copy = new MapEvent_EventQuest(this);
    if (other._hasLuaEntryPath) {
      copy._hasLuaEntryPath = true;
      copy._luaEntryPath = other._luaEntryPath;
    }
    copy._quests = this._quests.concat(other._quests);
    return copy;
  }
}
MapEvent_EventQuest.default = new MapEvent_EventQuest();
MapEvent_EventQuest.Quest = MapEvent_EventQuest_Quest;
class MapEvent_EventQuest_Builder {
  constructor(value) {
    this._value = new MapEvent_EventQuest(value);
  }
  build() {
    return new MapEvent_EventQuest(this._value);
  }
  setLuaEntryPath(value) {
    this._value._hasLuaEntryPath = true;
    this._value._luaEntryPath = value;
    return this;
  }
  deleteLuaEntryPath() {
    this._value._hasLuaEntryPath = false;
    this._value._luaEntryPath = null;
    return this;
  }
  addAllQuests(values) {
    this._value._quests = this._value._quests.concat(values);
    return this;
  }
  addQuests(value) {
    this._value._quests = this._value._quests.concat([value]);
    return this;
  }
  setQuests(index, value) {
    this._value._quests = this._value._quests.concat();
    this._value._quests[index] = value;
    return this;
  }
  clearQuests() {
    this._value._quests = [];
    return this;
  }
}
MapEvent_EventQuest.Builder = MapEvent_EventQuest_Builder;
class MapEvent_EventQuest_WithParent {
  /**
   * @param {MapEvent_EventQuest} value
   * @param {MapEvent_EventQuest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventQuest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLuaEntryPath() {
    if (this._cachedHasLuaEntryPath === undefined) {
      if (this._value.hasLuaEntryPath) {
        this._cachedHasLuaEntryPath = true;
      } else {
        this._cachedHasLuaEntryPath = this._parent ? this._parent.hasLuaEntryPath : false;
      }
    }
    return this._cachedHasLuaEntryPath;
  }
  get luaEntryPath() {
    if (this._cachedLuaEntryPath === undefined) {
      if (this._value.hasLuaEntryPath) {
        this._cachedLuaEntryPath = this._value.luaEntryPath;
      } else {
        this._cachedLuaEntryPath = this._parent ? this._parent.luaEntryPath : this._value.luaEntryPath;
      }
    }
    return this._cachedLuaEntryPath;
  }
  get selfQuests() {
    if (!this._selfQuests) {
      this._selfQuests = [];
      for (let i of this._value.quests) {
        this._selfQuests.push(new MapEvent_EventQuest_Quest.WithParent(i, null));
      }
    }
    return this._selfQuests;
  }
  get inherentQuests() {
    if (!this._inherentQuests) {
      this._inherentQuests = this._parent ? this._parent.quests : [];
    }
    return this._inherentQuests;
  }
  get quests() {
    if (!this._allQuests) {
      this._allQuests = this._parent ? this._parent.quests.concat(this.selfQuests) : this.selfQuests;
    }
    return this._allQuests;
  }
  update(current, parent) {
    const result = new MapEvent_EventQuest_WithParent(current, parent);
    if (this._selfQuests) {
      if (this._value.quests === current.quests) {
        result._selfQuests = this._selfQuests;
      } else {
        result._selfQuests = [];
        for (let i = 0; i < current.quests.length; i++) {
          const oldValue = this._value.quests[i];
          if (oldValue) {
            const oldCache = this._selfQuests[i];
            if (oldValue === current.quests[i]) {
              result._selfQuests[i] = oldCache;
            } else {
              result._selfQuests[i] = oldCache.update(current.quests[i], null);
            }
          } else {
            result._selfQuests[i] = new MapEvent_EventQuest_Quest.WithParent(current.quests[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventQuest_WithParent.default = new MapEvent_EventQuest_WithParent(MapEvent_EventQuest.default, null);
MapEvent_EventQuest.WithParent = MapEvent_EventQuest_WithParent;
class MapEvent_EventQuest_Descriptor {
  get luaEntryPath() {
    if (!this._luaEntryPath) {
      this._luaEntryPath = {
        name: "luaEntryPath",
        Name: "LuaEntryPath",
        number: 1,
        protoType: 9,
        protoName: "lua_entry_path",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._luaEntryPath;
  }
  get quests() {
    if (!this._quests) {
      this._quests = {
        name: "quests",
        Name: "Quests",
        number: 2,
        protoType: 11,
        protoName: "quests",
        type: MapEvent_EventQuest_Quest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._quests;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.luaEntryPath,
        this.quests,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLuaEntryPath",
        Name: "DummyOneofForLuaEntryPath",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventQuest.descriptor = new MapEvent_EventQuest_Descriptor();
class MapEvent_PossibleReward_PossibleRewardItem {
  get descriptor() {
    return MapEvent_PossibleReward_PossibleRewardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasItemAmountMin = false;
    this._itemAmountMin = null;
    this._hasItemAmountMax = false;
    this._itemAmountMax = null;
    this._hasChanceWeight = false;
    this._chanceWeight = null;
    this._hasDisplayText = false;
    this._displayText = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasItemAmountMin) return false;
    if (this._hasItemAmountMax) return false;
    if (this._hasChanceWeight) return false;
    if (this._hasDisplayText) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_PossibleReward_PossibleRewardItem) {
      return value;
    }
    return MapEvent_PossibleReward_PossibleRewardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_PossibleReward_PossibleRewardItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.itemAmountMin != null) {
      result._hasItemAmountMin = true;
      result._itemAmountMin = JsonToInt32.fromJson(json.itemAmountMin);
    }
    if (json.itemAmountMax != null) {
      result._hasItemAmountMax = true;
      result._itemAmountMax = JsonToInt32.fromJson(json.itemAmountMax);
    }
    if (json.chanceWeight != null) {
      result._hasChanceWeight = true;
      result._chanceWeight = JsonToDouble.fromJson(json.chanceWeight);
    }
    if (json.displayText != null) {
      result._hasDisplayText = true;
      result._displayText = JsonToString.fromJson(json.displayText);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasItemAmountMin) {
      result.itemAmountMin = JsonToInt32.toJson(this._itemAmountMin);
    }
    if (this._hasItemAmountMax) {
      result.itemAmountMax = JsonToInt32.toJson(this._itemAmountMax);
    }
    if (this._hasChanceWeight) {
      result.chanceWeight = JsonToDouble.toJson(this._chanceWeight);
    }
    if (this._hasDisplayText) {
      result.displayText = JsonToString.toJson(this._displayText);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get itemAmountMin() {
    return this._hasItemAmountMin ? this._itemAmountMin : JsonToInt32.default;
  }
  get hasItemAmountMin() {
    return this._hasItemAmountMin;
  }
  setItemAmountMin(path, value) {
    return {type: 'SET', path: path.concat(['itemAmountMin']), value};
  }
  deleteItemAmountMin(path) {
    return {type: 'DELETE', path: path.concat(['itemAmountMin'])};
  }
  /**
   * @returns {number}
   */
  get itemAmountMax() {
    return this._hasItemAmountMax ? this._itemAmountMax : JsonToInt32.default;
  }
  get hasItemAmountMax() {
    return this._hasItemAmountMax;
  }
  setItemAmountMax(path, value) {
    return {type: 'SET', path: path.concat(['itemAmountMax']), value};
  }
  deleteItemAmountMax(path) {
    return {type: 'DELETE', path: path.concat(['itemAmountMax'])};
  }
  /**
   * @returns {number}
   */
  get chanceWeight() {
    return this._hasChanceWeight ? this._chanceWeight : JsonToDouble.default;
  }
  get hasChanceWeight() {
    return this._hasChanceWeight;
  }
  setChanceWeight(path, value) {
    return {type: 'SET', path: path.concat(['chanceWeight']), value};
  }
  deleteChanceWeight(path) {
    return {type: 'DELETE', path: path.concat(['chanceWeight'])};
  }
  /**
   * @returns {string}
   */
  get displayText() {
    return this._hasDisplayText ? this._displayText : JsonToString.default;
  }
  get hasDisplayText() {
    return this._hasDisplayText;
  }
  setDisplayText(path, value) {
    return {type: 'SET', path: path.concat(['displayText']), value};
  }
  deleteDisplayText(path) {
    return {type: 'DELETE', path: path.concat(['displayText'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemAmountMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemAmountMin = true;
              copy._itemAmountMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAmountMin) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemAmountMin = false;
              copy._itemAmountMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemAmountMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemAmountMax = true;
              copy._itemAmountMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAmountMax) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasItemAmountMax = false;
              copy._itemAmountMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chanceWeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasChanceWeight = true;
              copy._chanceWeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChanceWeight) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasChanceWeight = false;
              copy._chanceWeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayText": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasDisplayText = true;
              copy._displayText = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayText) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
              copy._hasDisplayText = false;
              copy._displayText = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_PossibleReward_PossibleRewardItem} other
   * @returns {MapEvent_PossibleReward_PossibleRewardItem}
   */
  merge(other) {
    const copy = new MapEvent_PossibleReward_PossibleRewardItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasItemAmountMin) {
      copy._hasItemAmountMin = true;
      copy._itemAmountMin = other._itemAmountMin;
    }
    if (other._hasItemAmountMax) {
      copy._hasItemAmountMax = true;
      copy._itemAmountMax = other._itemAmountMax;
    }
    if (other._hasChanceWeight) {
      copy._hasChanceWeight = true;
      copy._chanceWeight = other._chanceWeight;
    }
    if (other._hasDisplayText) {
      copy._hasDisplayText = true;
      copy._displayText = other._displayText;
    }
    return copy;
  }
}
MapEvent_PossibleReward_PossibleRewardItem.default = new MapEvent_PossibleReward_PossibleRewardItem();
class MapEvent_PossibleReward_PossibleRewardItem_Builder {
  constructor(value) {
    this._value = new MapEvent_PossibleReward_PossibleRewardItem(value);
  }
  build() {
    return new MapEvent_PossibleReward_PossibleRewardItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setItemAmountMin(value) {
    this._value._hasItemAmountMin = true;
    this._value._itemAmountMin = value;
    return this;
  }
  deleteItemAmountMin() {
    this._value._hasItemAmountMin = false;
    this._value._itemAmountMin = null;
    return this;
  }
  setItemAmountMax(value) {
    this._value._hasItemAmountMax = true;
    this._value._itemAmountMax = value;
    return this;
  }
  deleteItemAmountMax() {
    this._value._hasItemAmountMax = false;
    this._value._itemAmountMax = null;
    return this;
  }
  setChanceWeight(value) {
    this._value._hasChanceWeight = true;
    this._value._chanceWeight = value;
    return this;
  }
  deleteChanceWeight() {
    this._value._hasChanceWeight = false;
    this._value._chanceWeight = null;
    return this;
  }
  setDisplayText(value) {
    this._value._hasDisplayText = true;
    this._value._displayText = value;
    return this;
  }
  deleteDisplayText() {
    this._value._hasDisplayText = false;
    this._value._displayText = null;
    return this;
  }
}
MapEvent_PossibleReward_PossibleRewardItem.Builder = MapEvent_PossibleReward_PossibleRewardItem_Builder;
class MapEvent_PossibleReward_PossibleRewardItem_WithParent {
  /**
   * @param {MapEvent_PossibleReward_PossibleRewardItem} value
   * @param {MapEvent_PossibleReward_PossibleRewardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_PossibleReward_PossibleRewardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasItemAmountMin() {
    if (this._cachedHasItemAmountMin === undefined) {
      if (this._value.hasItemAmountMin) {
        this._cachedHasItemAmountMin = true;
      } else {
        this._cachedHasItemAmountMin = this._parent ? this._parent.hasItemAmountMin : false;
      }
    }
    return this._cachedHasItemAmountMin;
  }
  get itemAmountMin() {
    if (this._cachedItemAmountMin === undefined) {
      if (this._value.hasItemAmountMin) {
        this._cachedItemAmountMin = this._value.itemAmountMin;
      } else {
        this._cachedItemAmountMin = this._parent ? this._parent.itemAmountMin : this._value.itemAmountMin;
      }
    }
    return this._cachedItemAmountMin;
  }
  get hasItemAmountMax() {
    if (this._cachedHasItemAmountMax === undefined) {
      if (this._value.hasItemAmountMax) {
        this._cachedHasItemAmountMax = true;
      } else {
        this._cachedHasItemAmountMax = this._parent ? this._parent.hasItemAmountMax : false;
      }
    }
    return this._cachedHasItemAmountMax;
  }
  get itemAmountMax() {
    if (this._cachedItemAmountMax === undefined) {
      if (this._value.hasItemAmountMax) {
        this._cachedItemAmountMax = this._value.itemAmountMax;
      } else {
        this._cachedItemAmountMax = this._parent ? this._parent.itemAmountMax : this._value.itemAmountMax;
      }
    }
    return this._cachedItemAmountMax;
  }
  get hasChanceWeight() {
    if (this._cachedHasChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedHasChanceWeight = true;
      } else {
        this._cachedHasChanceWeight = this._parent ? this._parent.hasChanceWeight : false;
      }
    }
    return this._cachedHasChanceWeight;
  }
  get chanceWeight() {
    if (this._cachedChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedChanceWeight = this._value.chanceWeight;
      } else {
        this._cachedChanceWeight = this._parent ? this._parent.chanceWeight : this._value.chanceWeight;
      }
    }
    return this._cachedChanceWeight;
  }
  get hasDisplayText() {
    if (this._cachedHasDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedHasDisplayText = true;
      } else {
        this._cachedHasDisplayText = this._parent ? this._parent.hasDisplayText : false;
      }
    }
    return this._cachedHasDisplayText;
  }
  get displayText() {
    if (this._cachedDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedDisplayText = this._value.displayText;
      } else {
        this._cachedDisplayText = this._parent ? this._parent.displayText : this._value.displayText;
      }
    }
    return this._cachedDisplayText;
  }
  update(current, parent) {
    const result = new MapEvent_PossibleReward_PossibleRewardItem_WithParent(current, parent);
    return result;
  }
}
MapEvent_PossibleReward_PossibleRewardItem_WithParent.default = new MapEvent_PossibleReward_PossibleRewardItem_WithParent(MapEvent_PossibleReward_PossibleRewardItem.default, null);
MapEvent_PossibleReward_PossibleRewardItem.WithParent = MapEvent_PossibleReward_PossibleRewardItem_WithParent;
class MapEvent_PossibleReward_PossibleRewardItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get itemAmountMin() {
    if (!this._itemAmountMin) {
      this._itemAmountMin = {
        name: "itemAmountMin",
        Name: "ItemAmountMin",
        number: 2,
        protoType: 5,
        protoName: "item_amount_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAmountMin;
  }
  get itemAmountMax() {
    if (!this._itemAmountMax) {
      this._itemAmountMax = {
        name: "itemAmountMax",
        Name: "ItemAmountMax",
        number: 3,
        protoType: 5,
        protoName: "item_amount_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAmountMax;
  }
  get chanceWeight() {
    if (!this._chanceWeight) {
      this._chanceWeight = {
        name: "chanceWeight",
        Name: "ChanceWeight",
        number: 4,
        protoType: 1,
        protoName: "chance_weight",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chanceWeight;
  }
  get displayText() {
    if (!this._displayText) {
      this._displayText = {
        name: "displayText",
        Name: "DisplayText",
        number: 5,
        protoType: 9,
        protoName: "display_text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayText;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.itemAmountMin,
        this.itemAmountMax,
        this.chanceWeight,
        this.displayText,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItemAmountMin",
        Name: "DummyOneofForItemAmountMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItemAmountMax",
        Name: "DummyOneofForItemAmountMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChanceWeight",
        Name: "DummyOneofForChanceWeight",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayText",
        Name: "DummyOneofForDisplayText",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_PossibleReward_PossibleRewardItem.descriptor = new MapEvent_PossibleReward_PossibleRewardItem_Descriptor();
class MapEvent_PossibleReward_PossibleRewardSlot {
  get descriptor() {
    return MapEvent_PossibleReward_PossibleRewardSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemCandidates = [];
  }
  isEmpty() {
    if (this._itemCandidates.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_PossibleReward_PossibleRewardSlot) {
      return value;
    }
    return MapEvent_PossibleReward_PossibleRewardSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_PossibleReward_PossibleRewardSlot();
    result._itemCandidates = JsonToList(json.itemCandidates, MapEvent_PossibleReward_PossibleRewardItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._itemCandidates.length > 0) {
      result.itemCandidates = ArrayToJson(this._itemCandidates, MapEvent_PossibleReward_PossibleRewardItem);
    }
    return result;
  }
  /**
   * @returns {MapEvent_PossibleReward_PossibleRewardItem[]}
   */
  get itemCandidates() {
    return this._itemCandidates;
  }
  addItemCandidates(path, value) {
    return {type: 'ADD', path: path.concat(['itemCandidates']), value: value.toJson()};
  }
  setItemCandidates(path, value) {
    return {type: 'SET', path: path.concat(['itemCandidates']), value: ArrayToJson(value, MapEvent_PossibleReward_PossibleRewardItem)};
  }
  setItemCandidatesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['itemCandidates', key]), value: value.toJson()};
  }
  deleteItemCandidates(path) {
    return {type: 'DELETE', path: path.concat(['itemCandidates'])};
  }
  deleteItemCandidatesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['itemCandidates', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemCandidates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
              copy._itemCandidates = [];        for (let i of value) {
                copy._itemCandidates.push(MapEvent_PossibleReward_PossibleRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.concat([MapEvent_PossibleReward_PossibleRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._itemCandidates.length === 0) {
                return this;
              }
              const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
              copy._itemCandidates = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice();
              copy._itemCandidates[path[1]] = MapEvent_PossibleReward_PossibleRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice(0, path[1]).concat(copy._itemCandidates.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          const oldValue = this._itemCandidates[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
          copy._itemCandidates = copy._itemCandidates.slice();
          copy._itemCandidates[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_PossibleReward_PossibleRewardSlot} other
   * @returns {MapEvent_PossibleReward_PossibleRewardSlot}
   */
  merge(other) {
    const copy = new MapEvent_PossibleReward_PossibleRewardSlot(this);
    copy._itemCandidates = this._itemCandidates.concat(other._itemCandidates);
    return copy;
  }
}
MapEvent_PossibleReward_PossibleRewardSlot.default = new MapEvent_PossibleReward_PossibleRewardSlot();
class MapEvent_PossibleReward_PossibleRewardSlot_Builder {
  constructor(value) {
    this._value = new MapEvent_PossibleReward_PossibleRewardSlot(value);
  }
  build() {
    return new MapEvent_PossibleReward_PossibleRewardSlot(this._value);
  }
  addAllItemCandidates(values) {
    this._value._itemCandidates = this._value._itemCandidates.concat(values);
    return this;
  }
  addItemCandidates(value) {
    this._value._itemCandidates = this._value._itemCandidates.concat([value]);
    return this;
  }
  setItemCandidates(index, value) {
    this._value._itemCandidates = this._value._itemCandidates.concat();
    this._value._itemCandidates[index] = value;
    return this;
  }
  clearItemCandidates() {
    this._value._itemCandidates = [];
    return this;
  }
}
MapEvent_PossibleReward_PossibleRewardSlot.Builder = MapEvent_PossibleReward_PossibleRewardSlot_Builder;
class MapEvent_PossibleReward_PossibleRewardSlot_WithParent {
  /**
   * @param {MapEvent_PossibleReward_PossibleRewardSlot} value
   * @param {MapEvent_PossibleReward_PossibleRewardSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_PossibleReward_PossibleRewardSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItemCandidates() {
    if (!this._selfItemCandidates) {
      this._selfItemCandidates = [];
      for (let i of this._value.itemCandidates) {
        this._selfItemCandidates.push(new MapEvent_PossibleReward_PossibleRewardItem.WithParent(i, null));
      }
    }
    return this._selfItemCandidates;
  }
  get inherentItemCandidates() {
    if (!this._inherentItemCandidates) {
      this._inherentItemCandidates = this._parent ? this._parent.itemCandidates : [];
    }
    return this._inherentItemCandidates;
  }
  get itemCandidates() {
    if (!this._allItemCandidates) {
      this._allItemCandidates = this._parent ? this._parent.itemCandidates.concat(this.selfItemCandidates) : this.selfItemCandidates;
    }
    return this._allItemCandidates;
  }
  update(current, parent) {
    const result = new MapEvent_PossibleReward_PossibleRewardSlot_WithParent(current, parent);
    if (this._selfItemCandidates) {
      if (this._value.itemCandidates === current.itemCandidates) {
        result._selfItemCandidates = this._selfItemCandidates;
      } else {
        result._selfItemCandidates = [];
        for (let i = 0; i < current.itemCandidates.length; i++) {
          const oldValue = this._value.itemCandidates[i];
          if (oldValue) {
            const oldCache = this._selfItemCandidates[i];
            if (oldValue === current.itemCandidates[i]) {
              result._selfItemCandidates[i] = oldCache;
            } else {
              result._selfItemCandidates[i] = oldCache.update(current.itemCandidates[i], null);
            }
          } else {
            result._selfItemCandidates[i] = new MapEvent_PossibleReward_PossibleRewardItem.WithParent(current.itemCandidates[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_PossibleReward_PossibleRewardSlot_WithParent.default = new MapEvent_PossibleReward_PossibleRewardSlot_WithParent(MapEvent_PossibleReward_PossibleRewardSlot.default, null);
MapEvent_PossibleReward_PossibleRewardSlot.WithParent = MapEvent_PossibleReward_PossibleRewardSlot_WithParent;
class MapEvent_PossibleReward_PossibleRewardSlot_Descriptor {
  get itemCandidates() {
    if (!this._itemCandidates) {
      this._itemCandidates = {
        name: "itemCandidates",
        Name: "ItemCandidates",
        number: 1,
        protoType: 11,
        protoName: "item_candidates",
        type: MapEvent_PossibleReward_PossibleRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemCandidates;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemCandidates,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_PossibleReward_PossibleRewardSlot.descriptor = new MapEvent_PossibleReward_PossibleRewardSlot_Descriptor();
class MapEvent_PossibleReward {
  get descriptor() {
    return MapEvent_PossibleReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._slots = [];
  }
  isEmpty() {
    if (this._slots.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_PossibleReward) {
      return value;
    }
    return MapEvent_PossibleReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_PossibleReward();
    result._slots = JsonToList(json.slots, MapEvent_PossibleReward_PossibleRewardSlot);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, MapEvent_PossibleReward_PossibleRewardSlot);
    }
    return result;
  }
  /**
   * @returns {MapEvent_PossibleReward_PossibleRewardSlot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, MapEvent_PossibleReward_PossibleRewardSlot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(MapEvent_PossibleReward_PossibleRewardSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_PossibleReward(this);
              copy._slots = copy._slots.concat([MapEvent_PossibleReward_PossibleRewardSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new MapEvent_PossibleReward(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PossibleReward(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = MapEvent_PossibleReward_PossibleRewardSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_PossibleReward(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_PossibleReward(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_PossibleReward} other
   * @returns {MapEvent_PossibleReward}
   */
  merge(other) {
    const copy = new MapEvent_PossibleReward(this);
    copy._slots = this._slots.concat(other._slots);
    return copy;
  }
}
MapEvent_PossibleReward.default = new MapEvent_PossibleReward();
MapEvent_PossibleReward.PossibleRewardItem = MapEvent_PossibleReward_PossibleRewardItem;
MapEvent_PossibleReward.PossibleRewardSlot = MapEvent_PossibleReward_PossibleRewardSlot;
class MapEvent_PossibleReward_Builder {
  constructor(value) {
    this._value = new MapEvent_PossibleReward(value);
  }
  build() {
    return new MapEvent_PossibleReward(this._value);
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
}
MapEvent_PossibleReward.Builder = MapEvent_PossibleReward_Builder;
class MapEvent_PossibleReward_WithParent {
  /**
   * @param {MapEvent_PossibleReward} value
   * @param {MapEvent_PossibleReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_PossibleReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new MapEvent_PossibleReward_PossibleRewardSlot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  update(current, parent) {
    const result = new MapEvent_PossibleReward_WithParent(current, parent);
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new MapEvent_PossibleReward_PossibleRewardSlot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_PossibleReward_WithParent.default = new MapEvent_PossibleReward_WithParent(MapEvent_PossibleReward.default, null);
MapEvent_PossibleReward.WithParent = MapEvent_PossibleReward_WithParent;
class MapEvent_PossibleReward_Descriptor {
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 1,
        protoType: 11,
        protoName: "slots",
        type: MapEvent_PossibleReward_PossibleRewardSlot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.slots,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_PossibleReward.descriptor = new MapEvent_PossibleReward_Descriptor();
class MapEvent_CoopRewardPattern {
  get descriptor() {
    return MapEvent_CoopRewardPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._discovererRewards = [];
    this._guaranteeRewards = [];
    this._hasPossibleReward = false;
    this._possibleReward = null;
    this._hasTryphyAmountPerParticipant = false;
    this._tryphyAmountPerParticipant = null;
    this._goldenPassRewards = [];
    this._mvpRewards = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._discovererRewards.length > 0) return false;
    if (this._guaranteeRewards.length > 0) return false;
    if (this._hasPossibleReward && !this._possibleReward.isEmpty()) return false;
    if (this._hasTryphyAmountPerParticipant) return false;
    if (this._goldenPassRewards.length > 0) return false;
    if (this._mvpRewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CoopRewardPattern) {
      return value;
    }
    return MapEvent_CoopRewardPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CoopRewardPattern();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._discovererRewards = JsonToList(json.discovererRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._guaranteeRewards = JsonToList(json.guaranteeRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    if (json.possibleReward != null) {
      result._hasPossibleReward = true;
      result._possibleReward = MapEvent_PossibleReward.fromJson(json.possibleReward);
    }
    if (json.tryphyAmountPerParticipant != null) {
      result._hasTryphyAmountPerParticipant = true;
      result._tryphyAmountPerParticipant = JsonToInt32.fromJson(json.tryphyAmountPerParticipant);
    }
    result._goldenPassRewards = JsonToList(json.goldenPassRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._mvpRewards = JsonToList(json.mvpRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._discovererRewards.length > 0) {
      result.discovererRewards = ArrayToJson(this._discovererRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._guaranteeRewards.length > 0) {
      result.guaranteeRewards = ArrayToJson(this._guaranteeRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._hasPossibleReward && !this._possibleReward.isEmpty()) {
      result.possibleReward = MapEvent_PossibleReward.toJson(this._possibleReward);
    }
    if (this._hasTryphyAmountPerParticipant) {
      result.tryphyAmountPerParticipant = JsonToInt32.toJson(this._tryphyAmountPerParticipant);
    }
    if (this._goldenPassRewards.length > 0) {
      result.goldenPassRewards = ArrayToJson(this._goldenPassRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._mvpRewards.length > 0) {
      result.mvpRewards = ArrayToJson(this._mvpRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get discovererRewards() {
    return this._discovererRewards;
  }
  addDiscovererRewards(path, value) {
    return {type: 'ADD', path: path.concat(['discovererRewards']), value: value.toJson()};
  }
  setDiscovererRewards(path, value) {
    return {type: 'SET', path: path.concat(['discovererRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setDiscovererRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['discovererRewards', key]), value: value.toJson()};
  }
  deleteDiscovererRewards(path) {
    return {type: 'DELETE', path: path.concat(['discovererRewards'])};
  }
  deleteDiscovererRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['discovererRewards', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get guaranteeRewards() {
    return this._guaranteeRewards;
  }
  addGuaranteeRewards(path, value) {
    return {type: 'ADD', path: path.concat(['guaranteeRewards']), value: value.toJson()};
  }
  setGuaranteeRewards(path, value) {
    return {type: 'SET', path: path.concat(['guaranteeRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setGuaranteeRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['guaranteeRewards', key]), value: value.toJson()};
  }
  deleteGuaranteeRewards(path) {
    return {type: 'DELETE', path: path.concat(['guaranteeRewards'])};
  }
  deleteGuaranteeRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['guaranteeRewards', key])};
  }
  /**
   * @returns {MapEvent_PossibleReward}
   */
  get possibleReward() {
    return this._hasPossibleReward ? this._possibleReward : MapEvent_PossibleReward.default;
  }
  get hasPossibleReward() {
    return this._hasPossibleReward;
  }
  setPossibleReward(path, value) {
    return {type: 'SET', path: path.concat(['possibleReward']), value: value.toJson()};
  }
  deletePossibleReward(path) {
    return {type: 'DELETE', path: path.concat(['possibleReward'])};
  }
  /**
   * @returns {number}
   */
  get tryphyAmountPerParticipant() {
    return this._hasTryphyAmountPerParticipant ? this._tryphyAmountPerParticipant : JsonToInt32.default;
  }
  get hasTryphyAmountPerParticipant() {
    return this._hasTryphyAmountPerParticipant;
  }
  setTryphyAmountPerParticipant(path, value) {
    return {type: 'SET', path: path.concat(['tryphyAmountPerParticipant']), value};
  }
  deleteTryphyAmountPerParticipant(path) {
    return {type: 'DELETE', path: path.concat(['tryphyAmountPerParticipant'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get goldenPassRewards() {
    return this._goldenPassRewards;
  }
  addGoldenPassRewards(path, value) {
    return {type: 'ADD', path: path.concat(['goldenPassRewards']), value: value.toJson()};
  }
  setGoldenPassRewards(path, value) {
    return {type: 'SET', path: path.concat(['goldenPassRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setGoldenPassRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldenPassRewards', key]), value: value.toJson()};
  }
  deleteGoldenPassRewards(path) {
    return {type: 'DELETE', path: path.concat(['goldenPassRewards'])};
  }
  deleteGoldenPassRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldenPassRewards', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get mvpRewards() {
    return this._mvpRewards;
  }
  addMvpRewards(path, value) {
    return {type: 'ADD', path: path.concat(['mvpRewards']), value: value.toJson()};
  }
  setMvpRewards(path, value) {
    return {type: 'SET', path: path.concat(['mvpRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setMvpRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mvpRewards', key]), value: value.toJson()};
  }
  deleteMvpRewards(path) {
    return {type: 'DELETE', path: path.concat(['mvpRewards'])};
  }
  deleteMvpRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mvpRewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "discovererRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._discovererRewards = [];        for (let i of value) {
                copy._discovererRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._discovererRewards = copy._discovererRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._discovererRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._discovererRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._discovererRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._discovererRewards = copy._discovererRewards.slice();
              copy._discovererRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._discovererRewards = copy._discovererRewards.slice(0, path[1]).concat(copy._discovererRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._discovererRewards.length) {
            return this;
          }
          const oldValue = this._discovererRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CoopRewardPattern(this);
          copy._discovererRewards = copy._discovererRewards.slice();
          copy._discovererRewards[key] = newValue;
          return copy;
        }
      }
      case "guaranteeRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._guaranteeRewards = [];        for (let i of value) {
                copy._guaranteeRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._guaranteeRewards = copy._guaranteeRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._guaranteeRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._guaranteeRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._guaranteeRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._guaranteeRewards = copy._guaranteeRewards.slice();
              copy._guaranteeRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._guaranteeRewards = copy._guaranteeRewards.slice(0, path[1]).concat(copy._guaranteeRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._guaranteeRewards.length) {
            return this;
          }
          const oldValue = this._guaranteeRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CoopRewardPattern(this);
          copy._guaranteeRewards = copy._guaranteeRewards.slice();
          copy._guaranteeRewards[key] = newValue;
          return copy;
        }
      }
      case "possibleReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasPossibleReward = true;
              copy._possibleReward = MapEvent_PossibleReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPossibleReward) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasPossibleReward = false;
              copy._possibleReward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPossibleReward) {
            const copy = new MapEvent_CoopRewardPattern(this);
            copy._hasPossibleReward = true;
            copy._possibleReward = MapEvent_PossibleReward.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._possibleReward.apply(type, path.slice(1), value);
          if (newValue === this._possibleReward) {
            return this;
          }
          const copy = new MapEvent_CoopRewardPattern(this);
          copy._possibleReward = copy._possibleReward.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tryphyAmountPerParticipant": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasTryphyAmountPerParticipant = true;
              copy._tryphyAmountPerParticipant = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTryphyAmountPerParticipant) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._hasTryphyAmountPerParticipant = false;
              copy._tryphyAmountPerParticipant = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldenPassRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._goldenPassRewards = [];        for (let i of value) {
                copy._goldenPassRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._goldenPassRewards = copy._goldenPassRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldenPassRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._goldenPassRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldenPassRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._goldenPassRewards = copy._goldenPassRewards.slice();
              copy._goldenPassRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._goldenPassRewards = copy._goldenPassRewards.slice(0, path[1]).concat(copy._goldenPassRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldenPassRewards.length) {
            return this;
          }
          const oldValue = this._goldenPassRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CoopRewardPattern(this);
          copy._goldenPassRewards = copy._goldenPassRewards.slice();
          copy._goldenPassRewards[key] = newValue;
          return copy;
        }
      }
      case "mvpRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._mvpRewards = [];        for (let i of value) {
                copy._mvpRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._mvpRewards = copy._mvpRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mvpRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._mvpRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mvpRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._mvpRewards = copy._mvpRewards.slice();
              copy._mvpRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CoopRewardPattern(this);
              copy._mvpRewards = copy._mvpRewards.slice(0, path[1]).concat(copy._mvpRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mvpRewards.length) {
            return this;
          }
          const oldValue = this._mvpRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CoopRewardPattern(this);
          copy._mvpRewards = copy._mvpRewards.slice();
          copy._mvpRewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CoopRewardPattern} other
   * @returns {MapEvent_CoopRewardPattern}
   */
  merge(other) {
    const copy = new MapEvent_CoopRewardPattern(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._discovererRewards = this._discovererRewards.concat(other._discovererRewards);
    copy._guaranteeRewards = this._guaranteeRewards.concat(other._guaranteeRewards);
    if (other._hasPossibleReward) {
      if (copy._hasPossibleReward) {
        copy._possibleReward = copy.possibleReward.merge(other.possibleReward);
      } else {
        copy._possibleReward = other._possibleReward;
      }
      copy._hasPossibleReward = true;
    }
    if (other._hasTryphyAmountPerParticipant) {
      copy._hasTryphyAmountPerParticipant = true;
      copy._tryphyAmountPerParticipant = other._tryphyAmountPerParticipant;
    }
    copy._goldenPassRewards = this._goldenPassRewards.concat(other._goldenPassRewards);
    copy._mvpRewards = this._mvpRewards.concat(other._mvpRewards);
    return copy;
  }
}
MapEvent_CoopRewardPattern.default = new MapEvent_CoopRewardPattern();
class MapEvent_CoopRewardPattern_Builder {
  constructor(value) {
    this._value = new MapEvent_CoopRewardPattern(value);
  }
  build() {
    return new MapEvent_CoopRewardPattern(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllDiscovererRewards(values) {
    this._value._discovererRewards = this._value._discovererRewards.concat(values);
    return this;
  }
  addDiscovererRewards(value) {
    this._value._discovererRewards = this._value._discovererRewards.concat([value]);
    return this;
  }
  setDiscovererRewards(index, value) {
    this._value._discovererRewards = this._value._discovererRewards.concat();
    this._value._discovererRewards[index] = value;
    return this;
  }
  clearDiscovererRewards() {
    this._value._discovererRewards = [];
    return this;
  }
  addAllGuaranteeRewards(values) {
    this._value._guaranteeRewards = this._value._guaranteeRewards.concat(values);
    return this;
  }
  addGuaranteeRewards(value) {
    this._value._guaranteeRewards = this._value._guaranteeRewards.concat([value]);
    return this;
  }
  setGuaranteeRewards(index, value) {
    this._value._guaranteeRewards = this._value._guaranteeRewards.concat();
    this._value._guaranteeRewards[index] = value;
    return this;
  }
  clearGuaranteeRewards() {
    this._value._guaranteeRewards = [];
    return this;
  }
  setPossibleReward(value) {
    this._value._hasPossibleReward = true;
    this._value._possibleReward = value;
    return this;
  }
  deletePossibleReward() {
    this._value._hasPossibleReward = false;
    this._value._possibleReward = null;
    return this;
  }
  setTryphyAmountPerParticipant(value) {
    this._value._hasTryphyAmountPerParticipant = true;
    this._value._tryphyAmountPerParticipant = value;
    return this;
  }
  deleteTryphyAmountPerParticipant() {
    this._value._hasTryphyAmountPerParticipant = false;
    this._value._tryphyAmountPerParticipant = null;
    return this;
  }
  addAllGoldenPassRewards(values) {
    this._value._goldenPassRewards = this._value._goldenPassRewards.concat(values);
    return this;
  }
  addGoldenPassRewards(value) {
    this._value._goldenPassRewards = this._value._goldenPassRewards.concat([value]);
    return this;
  }
  setGoldenPassRewards(index, value) {
    this._value._goldenPassRewards = this._value._goldenPassRewards.concat();
    this._value._goldenPassRewards[index] = value;
    return this;
  }
  clearGoldenPassRewards() {
    this._value._goldenPassRewards = [];
    return this;
  }
  addAllMvpRewards(values) {
    this._value._mvpRewards = this._value._mvpRewards.concat(values);
    return this;
  }
  addMvpRewards(value) {
    this._value._mvpRewards = this._value._mvpRewards.concat([value]);
    return this;
  }
  setMvpRewards(index, value) {
    this._value._mvpRewards = this._value._mvpRewards.concat();
    this._value._mvpRewards[index] = value;
    return this;
  }
  clearMvpRewards() {
    this._value._mvpRewards = [];
    return this;
  }
}
MapEvent_CoopRewardPattern.Builder = MapEvent_CoopRewardPattern_Builder;
class MapEvent_CoopRewardPattern_WithParent {
  /**
   * @param {MapEvent_CoopRewardPattern} value
   * @param {MapEvent_CoopRewardPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CoopRewardPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfDiscovererRewards() {
    if (!this._selfDiscovererRewards) {
      this._selfDiscovererRewards = [];
      for (let i of this._value.discovererRewards) {
        this._selfDiscovererRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfDiscovererRewards;
  }
  get inherentDiscovererRewards() {
    if (!this._inherentDiscovererRewards) {
      this._inherentDiscovererRewards = this._parent ? this._parent.discovererRewards : [];
    }
    return this._inherentDiscovererRewards;
  }
  get discovererRewards() {
    if (!this._allDiscovererRewards) {
      this._allDiscovererRewards = this._parent ? this._parent.discovererRewards.concat(this.selfDiscovererRewards) : this.selfDiscovererRewards;
    }
    return this._allDiscovererRewards;
  }
  get selfGuaranteeRewards() {
    if (!this._selfGuaranteeRewards) {
      this._selfGuaranteeRewards = [];
      for (let i of this._value.guaranteeRewards) {
        this._selfGuaranteeRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfGuaranteeRewards;
  }
  get inherentGuaranteeRewards() {
    if (!this._inherentGuaranteeRewards) {
      this._inherentGuaranteeRewards = this._parent ? this._parent.guaranteeRewards : [];
    }
    return this._inherentGuaranteeRewards;
  }
  get guaranteeRewards() {
    if (!this._allGuaranteeRewards) {
      this._allGuaranteeRewards = this._parent ? this._parent.guaranteeRewards.concat(this.selfGuaranteeRewards) : this.selfGuaranteeRewards;
    }
    return this._allGuaranteeRewards;
  }
  get hasPossibleReward() {
    if (this._cachedHasPossibleReward === undefined) {
      if (this._value.hasPossibleReward) {
        this._cachedHasPossibleReward = true;
      } else {
        this._cachedHasPossibleReward = this._parent ? this._parent.hasPossibleReward : false;
      }
    }
    return this._cachedHasPossibleReward;
  }
  get possibleReward() {
    if (!this._cachedPossibleReward) {
      if (this._value.hasPossibleReward) {
        this._cachedPossibleReward = new MapEvent_PossibleReward.WithParent(this._value.possibleReward, this._parent && this._parent.hasPossibleReward ? this._parent.possibleReward : null);
      } else {
        this._cachedPossibleReward = this._parent ? new MapEvent_PossibleReward.WithParent(MapEvent_PossibleReward.default, this._parent.possibleReward) : MapEvent_PossibleReward.WithParent.default;
      }
    }
    return this._cachedPossibleReward;
  }
  get hasTryphyAmountPerParticipant() {
    if (this._cachedHasTryphyAmountPerParticipant === undefined) {
      if (this._value.hasTryphyAmountPerParticipant) {
        this._cachedHasTryphyAmountPerParticipant = true;
      } else {
        this._cachedHasTryphyAmountPerParticipant = this._parent ? this._parent.hasTryphyAmountPerParticipant : false;
      }
    }
    return this._cachedHasTryphyAmountPerParticipant;
  }
  get tryphyAmountPerParticipant() {
    if (this._cachedTryphyAmountPerParticipant === undefined) {
      if (this._value.hasTryphyAmountPerParticipant) {
        this._cachedTryphyAmountPerParticipant = this._value.tryphyAmountPerParticipant;
      } else {
        this._cachedTryphyAmountPerParticipant = this._parent ? this._parent.tryphyAmountPerParticipant : this._value.tryphyAmountPerParticipant;
      }
    }
    return this._cachedTryphyAmountPerParticipant;
  }
  get selfGoldenPassRewards() {
    if (!this._selfGoldenPassRewards) {
      this._selfGoldenPassRewards = [];
      for (let i of this._value.goldenPassRewards) {
        this._selfGoldenPassRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfGoldenPassRewards;
  }
  get inherentGoldenPassRewards() {
    if (!this._inherentGoldenPassRewards) {
      this._inherentGoldenPassRewards = this._parent ? this._parent.goldenPassRewards : [];
    }
    return this._inherentGoldenPassRewards;
  }
  get goldenPassRewards() {
    if (!this._allGoldenPassRewards) {
      this._allGoldenPassRewards = this._parent ? this._parent.goldenPassRewards.concat(this.selfGoldenPassRewards) : this.selfGoldenPassRewards;
    }
    return this._allGoldenPassRewards;
  }
  get selfMvpRewards() {
    if (!this._selfMvpRewards) {
      this._selfMvpRewards = [];
      for (let i of this._value.mvpRewards) {
        this._selfMvpRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfMvpRewards;
  }
  get inherentMvpRewards() {
    if (!this._inherentMvpRewards) {
      this._inherentMvpRewards = this._parent ? this._parent.mvpRewards : [];
    }
    return this._inherentMvpRewards;
  }
  get mvpRewards() {
    if (!this._allMvpRewards) {
      this._allMvpRewards = this._parent ? this._parent.mvpRewards.concat(this.selfMvpRewards) : this.selfMvpRewards;
    }
    return this._allMvpRewards;
  }
  update(current, parent) {
    const result = new MapEvent_CoopRewardPattern_WithParent(current, parent);
    if (this._selfDiscovererRewards) {
      if (this._value.discovererRewards === current.discovererRewards) {
        result._selfDiscovererRewards = this._selfDiscovererRewards;
      } else {
        result._selfDiscovererRewards = [];
        for (let i = 0; i < current.discovererRewards.length; i++) {
          const oldValue = this._value.discovererRewards[i];
          if (oldValue) {
            const oldCache = this._selfDiscovererRewards[i];
            if (oldValue === current.discovererRewards[i]) {
              result._selfDiscovererRewards[i] = oldCache;
            } else {
              result._selfDiscovererRewards[i] = oldCache.update(current.discovererRewards[i], null);
            }
          } else {
            result._selfDiscovererRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.discovererRewards[i], null);
          }
        }
      }
    }
    if (this._selfGuaranteeRewards) {
      if (this._value.guaranteeRewards === current.guaranteeRewards) {
        result._selfGuaranteeRewards = this._selfGuaranteeRewards;
      } else {
        result._selfGuaranteeRewards = [];
        for (let i = 0; i < current.guaranteeRewards.length; i++) {
          const oldValue = this._value.guaranteeRewards[i];
          if (oldValue) {
            const oldCache = this._selfGuaranteeRewards[i];
            if (oldValue === current.guaranteeRewards[i]) {
              result._selfGuaranteeRewards[i] = oldCache;
            } else {
              result._selfGuaranteeRewards[i] = oldCache.update(current.guaranteeRewards[i], null);
            }
          } else {
            result._selfGuaranteeRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.guaranteeRewards[i], null);
          }
        }
      }
    }
    if (this._cachedPossibleReward && this._value.hasPossibleReward && current.hasPossibleReward) {
      if (this._value.possibleReward === current.possibleReward && this._parent === parent) {
        result._cachedPossibleReward = this._cachedPossibleReward;
      } else {
        result._cachedPossibleReward = this._cachedPossibleReward.update(current.possibleReward, parent && parent.hasPossibleReward ? parent.possibleReward : null);
      }
    }
    if (this._selfGoldenPassRewards) {
      if (this._value.goldenPassRewards === current.goldenPassRewards) {
        result._selfGoldenPassRewards = this._selfGoldenPassRewards;
      } else {
        result._selfGoldenPassRewards = [];
        for (let i = 0; i < current.goldenPassRewards.length; i++) {
          const oldValue = this._value.goldenPassRewards[i];
          if (oldValue) {
            const oldCache = this._selfGoldenPassRewards[i];
            if (oldValue === current.goldenPassRewards[i]) {
              result._selfGoldenPassRewards[i] = oldCache;
            } else {
              result._selfGoldenPassRewards[i] = oldCache.update(current.goldenPassRewards[i], null);
            }
          } else {
            result._selfGoldenPassRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.goldenPassRewards[i], null);
          }
        }
      }
    }
    if (this._selfMvpRewards) {
      if (this._value.mvpRewards === current.mvpRewards) {
        result._selfMvpRewards = this._selfMvpRewards;
      } else {
        result._selfMvpRewards = [];
        for (let i = 0; i < current.mvpRewards.length; i++) {
          const oldValue = this._value.mvpRewards[i];
          if (oldValue) {
            const oldCache = this._selfMvpRewards[i];
            if (oldValue === current.mvpRewards[i]) {
              result._selfMvpRewards[i] = oldCache;
            } else {
              result._selfMvpRewards[i] = oldCache.update(current.mvpRewards[i], null);
            }
          } else {
            result._selfMvpRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.mvpRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_CoopRewardPattern_WithParent.default = new MapEvent_CoopRewardPattern_WithParent(MapEvent_CoopRewardPattern.default, null);
MapEvent_CoopRewardPattern.WithParent = MapEvent_CoopRewardPattern_WithParent;
class MapEvent_CoopRewardPattern_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get discovererRewards() {
    if (!this._discovererRewards) {
      this._discovererRewards = {
        name: "discovererRewards",
        Name: "DiscovererRewards",
        number: 2,
        protoType: 11,
        protoName: "discoverer_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._discovererRewards;
  }
  get guaranteeRewards() {
    if (!this._guaranteeRewards) {
      this._guaranteeRewards = {
        name: "guaranteeRewards",
        Name: "GuaranteeRewards",
        number: 3,
        protoType: 11,
        protoName: "guarantee_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guaranteeRewards;
  }
  get possibleReward() {
    if (!this._possibleReward) {
      this._possibleReward = {
        name: "possibleReward",
        Name: "PossibleReward",
        number: 4,
        protoType: 11,
        protoName: "possible_reward",
        type: MapEvent_PossibleReward,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._possibleReward;
  }
  get tryphyAmountPerParticipant() {
    if (!this._tryphyAmountPerParticipant) {
      this._tryphyAmountPerParticipant = {
        name: "tryphyAmountPerParticipant",
        Name: "TryphyAmountPerParticipant",
        number: 5,
        protoType: 5,
        protoName: "tryphy_amount_per_participant",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tryphyAmountPerParticipant;
  }
  get goldenPassRewards() {
    if (!this._goldenPassRewards) {
      this._goldenPassRewards = {
        name: "goldenPassRewards",
        Name: "GoldenPassRewards",
        number: 6,
        protoType: 11,
        protoName: "golden_pass_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldenPassRewards;
  }
  get mvpRewards() {
    if (!this._mvpRewards) {
      this._mvpRewards = {
        name: "mvpRewards",
        Name: "MvpRewards",
        number: 7,
        protoType: 11,
        protoName: "mvp_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mvpRewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.discovererRewards,
        this.guaranteeRewards,
        this.possibleReward,
        this.tryphyAmountPerParticipant,
        this.goldenPassRewards,
        this.mvpRewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPossibleReward",
        Name: "DummyOneofForPossibleReward",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTryphyAmountPerParticipant",
        Name: "DummyOneofForTryphyAmountPerParticipant",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CoopRewardPattern.descriptor = new MapEvent_CoopRewardPattern_Descriptor();
class MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate {
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasCreepLevel = false;
    this._creepLevel = null;
    this._hasPrefixKey = false;
    this._prefixKey = null;
    this._hasDiscoverChance = false;
    this._discoverChance = null;
    this._hasRewardPatternKey = false;
    this._rewardPatternKey = null;
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasCreepLevel) return false;
    if (this._hasPrefixKey) return false;
    if (this._hasDiscoverChance) return false;
    if (this._hasRewardPatternKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate) {
      return value;
    }
    return MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    if (json.prefixKey != null) {
      result._hasPrefixKey = true;
      result._prefixKey = JsonToString.fromJson(json.prefixKey);
    }
    if (json.discoverChance != null) {
      result._hasDiscoverChance = true;
      result._discoverChance = JsonToDouble.fromJson(json.discoverChance);
    }
    if (json.rewardPatternKey != null) {
      result._hasRewardPatternKey = true;
      result._rewardPatternKey = JsonToString.fromJson(json.rewardPatternKey);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    if (this._hasPrefixKey) {
      result.prefixKey = JsonToString.toJson(this._prefixKey);
    }
    if (this._hasDiscoverChance) {
      result.discoverChance = JsonToDouble.toJson(this._discoverChance);
    }
    if (this._hasRewardPatternKey) {
      result.rewardPatternKey = JsonToString.toJson(this._rewardPatternKey);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  /**
   * @returns {string}
   */
  get prefixKey() {
    return this._hasPrefixKey ? this._prefixKey : JsonToString.default;
  }
  get hasPrefixKey() {
    return this._hasPrefixKey;
  }
  setPrefixKey(path, value) {
    return {type: 'SET', path: path.concat(['prefixKey']), value};
  }
  deletePrefixKey(path) {
    return {type: 'DELETE', path: path.concat(['prefixKey'])};
  }
  /**
   * @returns {number}
   */
  get discoverChance() {
    return this._hasDiscoverChance ? this._discoverChance : JsonToDouble.default;
  }
  get hasDiscoverChance() {
    return this._hasDiscoverChance;
  }
  setDiscoverChance(path, value) {
    return {type: 'SET', path: path.concat(['discoverChance']), value};
  }
  deleteDiscoverChance(path) {
    return {type: 'DELETE', path: path.concat(['discoverChance'])};
  }
  /**
   * @returns {string}
   */
  get rewardPatternKey() {
    return this._hasRewardPatternKey ? this._rewardPatternKey : JsonToString.default;
  }
  get hasRewardPatternKey() {
    return this._hasRewardPatternKey;
  }
  setRewardPatternKey(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatternKey']), value};
  }
  deleteRewardPatternKey(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatternKey'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "prefixKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasPrefixKey = true;
              copy._prefixKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefixKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasPrefixKey = false;
              copy._prefixKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "discoverChance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasDiscoverChance = true;
              copy._discoverChance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDiscoverChance) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasDiscoverChance = false;
              copy._discoverChance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardPatternKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasRewardPatternKey = true;
              copy._rewardPatternKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardPatternKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
              copy._hasRewardPatternKey = false;
              copy._rewardPatternKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate} other
   * @returns {MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    if (other._hasPrefixKey) {
      copy._hasPrefixKey = true;
      copy._prefixKey = other._prefixKey;
    }
    if (other._hasDiscoverChance) {
      copy._hasDiscoverChance = true;
      copy._discoverChance = other._discoverChance;
    }
    if (other._hasRewardPatternKey) {
      copy._hasRewardPatternKey = true;
      copy._rewardPatternKey = other._rewardPatternKey;
    }
    return copy;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.default = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate();
class MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(value);
  }
  build() {
    return new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
  setPrefixKey(value) {
    this._value._hasPrefixKey = true;
    this._value._prefixKey = value;
    return this;
  }
  deletePrefixKey() {
    this._value._hasPrefixKey = false;
    this._value._prefixKey = null;
    return this;
  }
  setDiscoverChance(value) {
    this._value._hasDiscoverChance = true;
    this._value._discoverChance = value;
    return this;
  }
  deleteDiscoverChance() {
    this._value._hasDiscoverChance = false;
    this._value._discoverChance = null;
    return this;
  }
  setRewardPatternKey(value) {
    this._value._hasRewardPatternKey = true;
    this._value._rewardPatternKey = value;
    return this;
  }
  deleteRewardPatternKey() {
    this._value._hasRewardPatternKey = false;
    this._value._rewardPatternKey = null;
    return this;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.Builder = MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_Builder;
class MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate} value
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  get hasPrefixKey() {
    if (this._cachedHasPrefixKey === undefined) {
      if (this._value.hasPrefixKey) {
        this._cachedHasPrefixKey = true;
      } else {
        this._cachedHasPrefixKey = this._parent ? this._parent.hasPrefixKey : false;
      }
    }
    return this._cachedHasPrefixKey;
  }
  get prefixKey() {
    if (this._cachedPrefixKey === undefined) {
      if (this._value.hasPrefixKey) {
        this._cachedPrefixKey = this._value.prefixKey;
      } else {
        this._cachedPrefixKey = this._parent ? this._parent.prefixKey : this._value.prefixKey;
      }
    }
    return this._cachedPrefixKey;
  }
  get hasDiscoverChance() {
    if (this._cachedHasDiscoverChance === undefined) {
      if (this._value.hasDiscoverChance) {
        this._cachedHasDiscoverChance = true;
      } else {
        this._cachedHasDiscoverChance = this._parent ? this._parent.hasDiscoverChance : false;
      }
    }
    return this._cachedHasDiscoverChance;
  }
  get discoverChance() {
    if (this._cachedDiscoverChance === undefined) {
      if (this._value.hasDiscoverChance) {
        this._cachedDiscoverChance = this._value.discoverChance;
      } else {
        this._cachedDiscoverChance = this._parent ? this._parent.discoverChance : this._value.discoverChance;
      }
    }
    return this._cachedDiscoverChance;
  }
  get hasRewardPatternKey() {
    if (this._cachedHasRewardPatternKey === undefined) {
      if (this._value.hasRewardPatternKey) {
        this._cachedHasRewardPatternKey = true;
      } else {
        this._cachedHasRewardPatternKey = this._parent ? this._parent.hasRewardPatternKey : false;
      }
    }
    return this._cachedHasRewardPatternKey;
  }
  get rewardPatternKey() {
    if (this._cachedRewardPatternKey === undefined) {
      if (this._value.hasRewardPatternKey) {
        this._cachedRewardPatternKey = this._value.rewardPatternKey;
      } else {
        this._cachedRewardPatternKey = this._parent ? this._parent.rewardPatternKey : this._value.rewardPatternKey;
      }
    }
    return this._cachedRewardPatternKey;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent(current, parent);
    return result;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent.default = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent(MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.default, null);
MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.WithParent = MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_WithParent;
class MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 2,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get prefixKey() {
    if (!this._prefixKey) {
      this._prefixKey = {
        name: "prefixKey",
        Name: "PrefixKey",
        number: 3,
        protoType: 9,
        protoName: "prefix_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapEventPrefixList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefixKey;
  }
  get discoverChance() {
    if (!this._discoverChance) {
      this._discoverChance = {
        name: "discoverChance",
        Name: "DiscoverChance",
        number: 4,
        protoType: 1,
        protoName: "discover_chance",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._discoverChance;
  }
  get rewardPatternKey() {
    if (!this._rewardPatternKey) {
      this._rewardPatternKey = {
        name: "rewardPatternKey",
        Name: "RewardPatternKey",
        number: 5,
        protoType: 9,
        protoName: "reward_pattern_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapEventCoopRewardPatternList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatternKey;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.creepLevel,
        this.prefixKey,
        this.discoverChance,
        this.rewardPatternKey,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrefixKey",
        Name: "DummyOneofForPrefixKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDiscoverChance",
        Name: "DummyOneofForDiscoverChance",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardPatternKey",
        Name: "DummyOneofForRewardPatternKey",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.descriptor = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate_Descriptor();
class MapEvent_LiveEventConfig_CoopLevelConfig {
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDifficulty = false;
    this._difficulty = null;
    this._hasEliteChanceIncrementPerReroll = false;
    this._eliteChanceIncrementPerReroll = null;
    this._hasEliteChanceIncrementPerRerollForDisplay = false;
    this._eliteChanceIncrementPerRerollForDisplay = null;
    this._hasInfernalChanceIncrementPerReroll = false;
    this._infernalChanceIncrementPerReroll = null;
    this._hasInfernalChanceIncrementPerRerollForDisplay = false;
    this._infernalChanceIncrementPerRerollForDisplay = null;
    this._hasQuickChanceIncrementPerReroll = false;
    this._quickChanceIncrementPerReroll = null;
    this._hasQuickChanceIncrementPerRerollForDisplay = false;
    this._quickChanceIncrementPerRerollForDisplay = null;
    this._mapCandidates = [];
    this._hasDurationInSeconds = false;
    this._durationInSeconds = null;
  }
  isEmpty() {
    if (this._hasDifficulty) return false;
    if (this._hasEliteChanceIncrementPerReroll) return false;
    if (this._hasEliteChanceIncrementPerRerollForDisplay) return false;
    if (this._hasInfernalChanceIncrementPerReroll) return false;
    if (this._hasInfernalChanceIncrementPerRerollForDisplay) return false;
    if (this._hasQuickChanceIncrementPerReroll) return false;
    if (this._hasQuickChanceIncrementPerRerollForDisplay) return false;
    if (this._mapCandidates.length > 0) return false;
    if (this._hasDurationInSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig_CoopLevelConfig) {
      return value;
    }
    return MapEvent_LiveEventConfig_CoopLevelConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig_CoopLevelConfig();
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    if (json.eliteChanceIncrementPerReroll != null) {
      result._hasEliteChanceIncrementPerReroll = true;
      result._eliteChanceIncrementPerReroll = JsonToDouble.fromJson(json.eliteChanceIncrementPerReroll);
    }
    if (json.eliteChanceIncrementPerRerollForDisplay != null) {
      result._hasEliteChanceIncrementPerRerollForDisplay = true;
      result._eliteChanceIncrementPerRerollForDisplay = JsonToDouble.fromJson(json.eliteChanceIncrementPerRerollForDisplay);
    }
    if (json.infernalChanceIncrementPerReroll != null) {
      result._hasInfernalChanceIncrementPerReroll = true;
      result._infernalChanceIncrementPerReroll = JsonToDouble.fromJson(json.infernalChanceIncrementPerReroll);
    }
    if (json.infernalChanceIncrementPerRerollForDisplay != null) {
      result._hasInfernalChanceIncrementPerRerollForDisplay = true;
      result._infernalChanceIncrementPerRerollForDisplay = JsonToDouble.fromJson(json.infernalChanceIncrementPerRerollForDisplay);
    }
    if (json.quickChanceIncrementPerReroll != null) {
      result._hasQuickChanceIncrementPerReroll = true;
      result._quickChanceIncrementPerReroll = JsonToDouble.fromJson(json.quickChanceIncrementPerReroll);
    }
    if (json.quickChanceIncrementPerRerollForDisplay != null) {
      result._hasQuickChanceIncrementPerRerollForDisplay = true;
      result._quickChanceIncrementPerRerollForDisplay = JsonToDouble.fromJson(json.quickChanceIncrementPerRerollForDisplay);
    }
    result._mapCandidates = JsonToList(json.mapCandidates, MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate);
    if (json.durationInSeconds != null) {
      result._hasDurationInSeconds = true;
      result._durationInSeconds = JsonToInt32.fromJson(json.durationInSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._hasEliteChanceIncrementPerReroll) {
      result.eliteChanceIncrementPerReroll = JsonToDouble.toJson(this._eliteChanceIncrementPerReroll);
    }
    if (this._hasEliteChanceIncrementPerRerollForDisplay) {
      result.eliteChanceIncrementPerRerollForDisplay = JsonToDouble.toJson(this._eliteChanceIncrementPerRerollForDisplay);
    }
    if (this._hasInfernalChanceIncrementPerReroll) {
      result.infernalChanceIncrementPerReroll = JsonToDouble.toJson(this._infernalChanceIncrementPerReroll);
    }
    if (this._hasInfernalChanceIncrementPerRerollForDisplay) {
      result.infernalChanceIncrementPerRerollForDisplay = JsonToDouble.toJson(this._infernalChanceIncrementPerRerollForDisplay);
    }
    if (this._hasQuickChanceIncrementPerReroll) {
      result.quickChanceIncrementPerReroll = JsonToDouble.toJson(this._quickChanceIncrementPerReroll);
    }
    if (this._hasQuickChanceIncrementPerRerollForDisplay) {
      result.quickChanceIncrementPerRerollForDisplay = JsonToDouble.toJson(this._quickChanceIncrementPerRerollForDisplay);
    }
    if (this._mapCandidates.length > 0) {
      result.mapCandidates = ArrayToJson(this._mapCandidates, MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate);
    }
    if (this._hasDurationInSeconds) {
      result.durationInSeconds = JsonToInt32.toJson(this._durationInSeconds);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {number}
   */
  get eliteChanceIncrementPerReroll() {
    return this._hasEliteChanceIncrementPerReroll ? this._eliteChanceIncrementPerReroll : JsonToDouble.default;
  }
  get hasEliteChanceIncrementPerReroll() {
    return this._hasEliteChanceIncrementPerReroll;
  }
  setEliteChanceIncrementPerReroll(path, value) {
    return {type: 'SET', path: path.concat(['eliteChanceIncrementPerReroll']), value};
  }
  deleteEliteChanceIncrementPerReroll(path) {
    return {type: 'DELETE', path: path.concat(['eliteChanceIncrementPerReroll'])};
  }
  /**
   * @returns {number}
   */
  get eliteChanceIncrementPerRerollForDisplay() {
    return this._hasEliteChanceIncrementPerRerollForDisplay ? this._eliteChanceIncrementPerRerollForDisplay : JsonToDouble.default;
  }
  get hasEliteChanceIncrementPerRerollForDisplay() {
    return this._hasEliteChanceIncrementPerRerollForDisplay;
  }
  setEliteChanceIncrementPerRerollForDisplay(path, value) {
    return {type: 'SET', path: path.concat(['eliteChanceIncrementPerRerollForDisplay']), value};
  }
  deleteEliteChanceIncrementPerRerollForDisplay(path) {
    return {type: 'DELETE', path: path.concat(['eliteChanceIncrementPerRerollForDisplay'])};
  }
  /**
   * @returns {number}
   */
  get infernalChanceIncrementPerReroll() {
    return this._hasInfernalChanceIncrementPerReroll ? this._infernalChanceIncrementPerReroll : JsonToDouble.default;
  }
  get hasInfernalChanceIncrementPerReroll() {
    return this._hasInfernalChanceIncrementPerReroll;
  }
  setInfernalChanceIncrementPerReroll(path, value) {
    return {type: 'SET', path: path.concat(['infernalChanceIncrementPerReroll']), value};
  }
  deleteInfernalChanceIncrementPerReroll(path) {
    return {type: 'DELETE', path: path.concat(['infernalChanceIncrementPerReroll'])};
  }
  /**
   * @returns {number}
   */
  get infernalChanceIncrementPerRerollForDisplay() {
    return this._hasInfernalChanceIncrementPerRerollForDisplay ? this._infernalChanceIncrementPerRerollForDisplay : JsonToDouble.default;
  }
  get hasInfernalChanceIncrementPerRerollForDisplay() {
    return this._hasInfernalChanceIncrementPerRerollForDisplay;
  }
  setInfernalChanceIncrementPerRerollForDisplay(path, value) {
    return {type: 'SET', path: path.concat(['infernalChanceIncrementPerRerollForDisplay']), value};
  }
  deleteInfernalChanceIncrementPerRerollForDisplay(path) {
    return {type: 'DELETE', path: path.concat(['infernalChanceIncrementPerRerollForDisplay'])};
  }
  /**
   * @returns {number}
   */
  get quickChanceIncrementPerReroll() {
    return this._hasQuickChanceIncrementPerReroll ? this._quickChanceIncrementPerReroll : JsonToDouble.default;
  }
  get hasQuickChanceIncrementPerReroll() {
    return this._hasQuickChanceIncrementPerReroll;
  }
  setQuickChanceIncrementPerReroll(path, value) {
    return {type: 'SET', path: path.concat(['quickChanceIncrementPerReroll']), value};
  }
  deleteQuickChanceIncrementPerReroll(path) {
    return {type: 'DELETE', path: path.concat(['quickChanceIncrementPerReroll'])};
  }
  /**
   * @returns {number}
   */
  get quickChanceIncrementPerRerollForDisplay() {
    return this._hasQuickChanceIncrementPerRerollForDisplay ? this._quickChanceIncrementPerRerollForDisplay : JsonToDouble.default;
  }
  get hasQuickChanceIncrementPerRerollForDisplay() {
    return this._hasQuickChanceIncrementPerRerollForDisplay;
  }
  setQuickChanceIncrementPerRerollForDisplay(path, value) {
    return {type: 'SET', path: path.concat(['quickChanceIncrementPerRerollForDisplay']), value};
  }
  deleteQuickChanceIncrementPerRerollForDisplay(path) {
    return {type: 'DELETE', path: path.concat(['quickChanceIncrementPerRerollForDisplay'])};
  }
  /**
   * @returns {MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate[]}
   */
  get mapCandidates() {
    return this._mapCandidates;
  }
  addMapCandidates(path, value) {
    return {type: 'ADD', path: path.concat(['mapCandidates']), value: value.toJson()};
  }
  setMapCandidates(path, value) {
    return {type: 'SET', path: path.concat(['mapCandidates']), value: ArrayToJson(value, MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate)};
  }
  setMapCandidatesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapCandidates', key]), value: value.toJson()};
  }
  deleteMapCandidates(path) {
    return {type: 'DELETE', path: path.concat(['mapCandidates'])};
  }
  deleteMapCandidatesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapCandidates', key])};
  }
  /**
   * @returns {number}
   */
  get durationInSeconds() {
    return this._hasDurationInSeconds ? this._durationInSeconds : JsonToInt32.default;
  }
  get hasDurationInSeconds() {
    return this._hasDurationInSeconds;
  }
  setDurationInSeconds(path, value) {
    return {type: 'SET', path: path.concat(['durationInSeconds']), value};
  }
  deleteDurationInSeconds(path) {
    return {type: 'DELETE', path: path.concat(['durationInSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eliteChanceIncrementPerReroll": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasEliteChanceIncrementPerReroll = true;
              copy._eliteChanceIncrementPerReroll = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEliteChanceIncrementPerReroll) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasEliteChanceIncrementPerReroll = false;
              copy._eliteChanceIncrementPerReroll = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eliteChanceIncrementPerRerollForDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasEliteChanceIncrementPerRerollForDisplay = true;
              copy._eliteChanceIncrementPerRerollForDisplay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEliteChanceIncrementPerRerollForDisplay) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasEliteChanceIncrementPerRerollForDisplay = false;
              copy._eliteChanceIncrementPerRerollForDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "infernalChanceIncrementPerReroll": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasInfernalChanceIncrementPerReroll = true;
              copy._infernalChanceIncrementPerReroll = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInfernalChanceIncrementPerReroll) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasInfernalChanceIncrementPerReroll = false;
              copy._infernalChanceIncrementPerReroll = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "infernalChanceIncrementPerRerollForDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasInfernalChanceIncrementPerRerollForDisplay = true;
              copy._infernalChanceIncrementPerRerollForDisplay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInfernalChanceIncrementPerRerollForDisplay) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasInfernalChanceIncrementPerRerollForDisplay = false;
              copy._infernalChanceIncrementPerRerollForDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "quickChanceIncrementPerReroll": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasQuickChanceIncrementPerReroll = true;
              copy._quickChanceIncrementPerReroll = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasQuickChanceIncrementPerReroll) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasQuickChanceIncrementPerReroll = false;
              copy._quickChanceIncrementPerReroll = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "quickChanceIncrementPerRerollForDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasQuickChanceIncrementPerRerollForDisplay = true;
              copy._quickChanceIncrementPerRerollForDisplay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasQuickChanceIncrementPerRerollForDisplay) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasQuickChanceIncrementPerRerollForDisplay = false;
              copy._quickChanceIncrementPerRerollForDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapCandidates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._mapCandidates = [];        for (let i of value) {
                copy._mapCandidates.push(MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.concat([MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapCandidates.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._mapCandidates = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapCandidates.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.slice();
              copy._mapCandidates[path[1]] = MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.slice(0, path[1]).concat(copy._mapCandidates.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapCandidates.length) {
            return this;
          }
          const oldValue = this._mapCandidates[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
          copy._mapCandidates = copy._mapCandidates.slice();
          copy._mapCandidates[key] = newValue;
          return copy;
        }
      }
      case "durationInSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasDurationInSeconds = true;
              copy._durationInSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationInSeconds) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
              copy._hasDurationInSeconds = false;
              copy._durationInSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig} other
   * @returns {MapEvent_LiveEventConfig_CoopLevelConfig}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig_CoopLevelConfig(this);
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    if (other._hasEliteChanceIncrementPerReroll) {
      copy._hasEliteChanceIncrementPerReroll = true;
      copy._eliteChanceIncrementPerReroll = other._eliteChanceIncrementPerReroll;
    }
    if (other._hasEliteChanceIncrementPerRerollForDisplay) {
      copy._hasEliteChanceIncrementPerRerollForDisplay = true;
      copy._eliteChanceIncrementPerRerollForDisplay = other._eliteChanceIncrementPerRerollForDisplay;
    }
    if (other._hasInfernalChanceIncrementPerReroll) {
      copy._hasInfernalChanceIncrementPerReroll = true;
      copy._infernalChanceIncrementPerReroll = other._infernalChanceIncrementPerReroll;
    }
    if (other._hasInfernalChanceIncrementPerRerollForDisplay) {
      copy._hasInfernalChanceIncrementPerRerollForDisplay = true;
      copy._infernalChanceIncrementPerRerollForDisplay = other._infernalChanceIncrementPerRerollForDisplay;
    }
    if (other._hasQuickChanceIncrementPerReroll) {
      copy._hasQuickChanceIncrementPerReroll = true;
      copy._quickChanceIncrementPerReroll = other._quickChanceIncrementPerReroll;
    }
    if (other._hasQuickChanceIncrementPerRerollForDisplay) {
      copy._hasQuickChanceIncrementPerRerollForDisplay = true;
      copy._quickChanceIncrementPerRerollForDisplay = other._quickChanceIncrementPerRerollForDisplay;
    }
    copy._mapCandidates = this._mapCandidates.concat(other._mapCandidates);
    if (other._hasDurationInSeconds) {
      copy._hasDurationInSeconds = true;
      copy._durationInSeconds = other._durationInSeconds;
    }
    return copy;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig.default = new MapEvent_LiveEventConfig_CoopLevelConfig();
MapEvent_LiveEventConfig_CoopLevelConfig.MapCandidate = MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate;
class MapEvent_LiveEventConfig_CoopLevelConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig_CoopLevelConfig(value);
  }
  build() {
    return new MapEvent_LiveEventConfig_CoopLevelConfig(this._value);
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  setEliteChanceIncrementPerReroll(value) {
    this._value._hasEliteChanceIncrementPerReroll = true;
    this._value._eliteChanceIncrementPerReroll = value;
    return this;
  }
  deleteEliteChanceIncrementPerReroll() {
    this._value._hasEliteChanceIncrementPerReroll = false;
    this._value._eliteChanceIncrementPerReroll = null;
    return this;
  }
  setEliteChanceIncrementPerRerollForDisplay(value) {
    this._value._hasEliteChanceIncrementPerRerollForDisplay = true;
    this._value._eliteChanceIncrementPerRerollForDisplay = value;
    return this;
  }
  deleteEliteChanceIncrementPerRerollForDisplay() {
    this._value._hasEliteChanceIncrementPerRerollForDisplay = false;
    this._value._eliteChanceIncrementPerRerollForDisplay = null;
    return this;
  }
  setInfernalChanceIncrementPerReroll(value) {
    this._value._hasInfernalChanceIncrementPerReroll = true;
    this._value._infernalChanceIncrementPerReroll = value;
    return this;
  }
  deleteInfernalChanceIncrementPerReroll() {
    this._value._hasInfernalChanceIncrementPerReroll = false;
    this._value._infernalChanceIncrementPerReroll = null;
    return this;
  }
  setInfernalChanceIncrementPerRerollForDisplay(value) {
    this._value._hasInfernalChanceIncrementPerRerollForDisplay = true;
    this._value._infernalChanceIncrementPerRerollForDisplay = value;
    return this;
  }
  deleteInfernalChanceIncrementPerRerollForDisplay() {
    this._value._hasInfernalChanceIncrementPerRerollForDisplay = false;
    this._value._infernalChanceIncrementPerRerollForDisplay = null;
    return this;
  }
  setQuickChanceIncrementPerReroll(value) {
    this._value._hasQuickChanceIncrementPerReroll = true;
    this._value._quickChanceIncrementPerReroll = value;
    return this;
  }
  deleteQuickChanceIncrementPerReroll() {
    this._value._hasQuickChanceIncrementPerReroll = false;
    this._value._quickChanceIncrementPerReroll = null;
    return this;
  }
  setQuickChanceIncrementPerRerollForDisplay(value) {
    this._value._hasQuickChanceIncrementPerRerollForDisplay = true;
    this._value._quickChanceIncrementPerRerollForDisplay = value;
    return this;
  }
  deleteQuickChanceIncrementPerRerollForDisplay() {
    this._value._hasQuickChanceIncrementPerRerollForDisplay = false;
    this._value._quickChanceIncrementPerRerollForDisplay = null;
    return this;
  }
  addAllMapCandidates(values) {
    this._value._mapCandidates = this._value._mapCandidates.concat(values);
    return this;
  }
  addMapCandidates(value) {
    this._value._mapCandidates = this._value._mapCandidates.concat([value]);
    return this;
  }
  setMapCandidates(index, value) {
    this._value._mapCandidates = this._value._mapCandidates.concat();
    this._value._mapCandidates[index] = value;
    return this;
  }
  clearMapCandidates() {
    this._value._mapCandidates = [];
    return this;
  }
  setDurationInSeconds(value) {
    this._value._hasDurationInSeconds = true;
    this._value._durationInSeconds = value;
    return this;
  }
  deleteDurationInSeconds() {
    this._value._hasDurationInSeconds = false;
    this._value._durationInSeconds = null;
    return this;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig.Builder = MapEvent_LiveEventConfig_CoopLevelConfig_Builder;
class MapEvent_LiveEventConfig_CoopLevelConfig_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig} value
   * @param {MapEvent_LiveEventConfig_CoopLevelConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get hasEliteChanceIncrementPerReroll() {
    if (this._cachedHasEliteChanceIncrementPerReroll === undefined) {
      if (this._value.hasEliteChanceIncrementPerReroll) {
        this._cachedHasEliteChanceIncrementPerReroll = true;
      } else {
        this._cachedHasEliteChanceIncrementPerReroll = this._parent ? this._parent.hasEliteChanceIncrementPerReroll : false;
      }
    }
    return this._cachedHasEliteChanceIncrementPerReroll;
  }
  get eliteChanceIncrementPerReroll() {
    if (this._cachedEliteChanceIncrementPerReroll === undefined) {
      if (this._value.hasEliteChanceIncrementPerReroll) {
        this._cachedEliteChanceIncrementPerReroll = this._value.eliteChanceIncrementPerReroll;
      } else {
        this._cachedEliteChanceIncrementPerReroll = this._parent ? this._parent.eliteChanceIncrementPerReroll : this._value.eliteChanceIncrementPerReroll;
      }
    }
    return this._cachedEliteChanceIncrementPerReroll;
  }
  get hasEliteChanceIncrementPerRerollForDisplay() {
    if (this._cachedHasEliteChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasEliteChanceIncrementPerRerollForDisplay) {
        this._cachedHasEliteChanceIncrementPerRerollForDisplay = true;
      } else {
        this._cachedHasEliteChanceIncrementPerRerollForDisplay = this._parent ? this._parent.hasEliteChanceIncrementPerRerollForDisplay : false;
      }
    }
    return this._cachedHasEliteChanceIncrementPerRerollForDisplay;
  }
  get eliteChanceIncrementPerRerollForDisplay() {
    if (this._cachedEliteChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasEliteChanceIncrementPerRerollForDisplay) {
        this._cachedEliteChanceIncrementPerRerollForDisplay = this._value.eliteChanceIncrementPerRerollForDisplay;
      } else {
        this._cachedEliteChanceIncrementPerRerollForDisplay = this._parent ? this._parent.eliteChanceIncrementPerRerollForDisplay : this._value.eliteChanceIncrementPerRerollForDisplay;
      }
    }
    return this._cachedEliteChanceIncrementPerRerollForDisplay;
  }
  get hasInfernalChanceIncrementPerReroll() {
    if (this._cachedHasInfernalChanceIncrementPerReroll === undefined) {
      if (this._value.hasInfernalChanceIncrementPerReroll) {
        this._cachedHasInfernalChanceIncrementPerReroll = true;
      } else {
        this._cachedHasInfernalChanceIncrementPerReroll = this._parent ? this._parent.hasInfernalChanceIncrementPerReroll : false;
      }
    }
    return this._cachedHasInfernalChanceIncrementPerReroll;
  }
  get infernalChanceIncrementPerReroll() {
    if (this._cachedInfernalChanceIncrementPerReroll === undefined) {
      if (this._value.hasInfernalChanceIncrementPerReroll) {
        this._cachedInfernalChanceIncrementPerReroll = this._value.infernalChanceIncrementPerReroll;
      } else {
        this._cachedInfernalChanceIncrementPerReroll = this._parent ? this._parent.infernalChanceIncrementPerReroll : this._value.infernalChanceIncrementPerReroll;
      }
    }
    return this._cachedInfernalChanceIncrementPerReroll;
  }
  get hasInfernalChanceIncrementPerRerollForDisplay() {
    if (this._cachedHasInfernalChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasInfernalChanceIncrementPerRerollForDisplay) {
        this._cachedHasInfernalChanceIncrementPerRerollForDisplay = true;
      } else {
        this._cachedHasInfernalChanceIncrementPerRerollForDisplay = this._parent ? this._parent.hasInfernalChanceIncrementPerRerollForDisplay : false;
      }
    }
    return this._cachedHasInfernalChanceIncrementPerRerollForDisplay;
  }
  get infernalChanceIncrementPerRerollForDisplay() {
    if (this._cachedInfernalChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasInfernalChanceIncrementPerRerollForDisplay) {
        this._cachedInfernalChanceIncrementPerRerollForDisplay = this._value.infernalChanceIncrementPerRerollForDisplay;
      } else {
        this._cachedInfernalChanceIncrementPerRerollForDisplay = this._parent ? this._parent.infernalChanceIncrementPerRerollForDisplay : this._value.infernalChanceIncrementPerRerollForDisplay;
      }
    }
    return this._cachedInfernalChanceIncrementPerRerollForDisplay;
  }
  get hasQuickChanceIncrementPerReroll() {
    if (this._cachedHasQuickChanceIncrementPerReroll === undefined) {
      if (this._value.hasQuickChanceIncrementPerReroll) {
        this._cachedHasQuickChanceIncrementPerReroll = true;
      } else {
        this._cachedHasQuickChanceIncrementPerReroll = this._parent ? this._parent.hasQuickChanceIncrementPerReroll : false;
      }
    }
    return this._cachedHasQuickChanceIncrementPerReroll;
  }
  get quickChanceIncrementPerReroll() {
    if (this._cachedQuickChanceIncrementPerReroll === undefined) {
      if (this._value.hasQuickChanceIncrementPerReroll) {
        this._cachedQuickChanceIncrementPerReroll = this._value.quickChanceIncrementPerReroll;
      } else {
        this._cachedQuickChanceIncrementPerReroll = this._parent ? this._parent.quickChanceIncrementPerReroll : this._value.quickChanceIncrementPerReroll;
      }
    }
    return this._cachedQuickChanceIncrementPerReroll;
  }
  get hasQuickChanceIncrementPerRerollForDisplay() {
    if (this._cachedHasQuickChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasQuickChanceIncrementPerRerollForDisplay) {
        this._cachedHasQuickChanceIncrementPerRerollForDisplay = true;
      } else {
        this._cachedHasQuickChanceIncrementPerRerollForDisplay = this._parent ? this._parent.hasQuickChanceIncrementPerRerollForDisplay : false;
      }
    }
    return this._cachedHasQuickChanceIncrementPerRerollForDisplay;
  }
  get quickChanceIncrementPerRerollForDisplay() {
    if (this._cachedQuickChanceIncrementPerRerollForDisplay === undefined) {
      if (this._value.hasQuickChanceIncrementPerRerollForDisplay) {
        this._cachedQuickChanceIncrementPerRerollForDisplay = this._value.quickChanceIncrementPerRerollForDisplay;
      } else {
        this._cachedQuickChanceIncrementPerRerollForDisplay = this._parent ? this._parent.quickChanceIncrementPerRerollForDisplay : this._value.quickChanceIncrementPerRerollForDisplay;
      }
    }
    return this._cachedQuickChanceIncrementPerRerollForDisplay;
  }
  get selfMapCandidates() {
    if (!this._selfMapCandidates) {
      this._selfMapCandidates = [];
      for (let i of this._value.mapCandidates) {
        this._selfMapCandidates.push(new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.WithParent(i, null));
      }
    }
    return this._selfMapCandidates;
  }
  get inherentMapCandidates() {
    if (!this._inherentMapCandidates) {
      this._inherentMapCandidates = this._parent ? this._parent.mapCandidates : [];
    }
    return this._inherentMapCandidates;
  }
  get mapCandidates() {
    if (!this._allMapCandidates) {
      this._allMapCandidates = this._parent ? this._parent.mapCandidates.concat(this.selfMapCandidates) : this.selfMapCandidates;
    }
    return this._allMapCandidates;
  }
  get hasDurationInSeconds() {
    if (this._cachedHasDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedHasDurationInSeconds = true;
      } else {
        this._cachedHasDurationInSeconds = this._parent ? this._parent.hasDurationInSeconds : false;
      }
    }
    return this._cachedHasDurationInSeconds;
  }
  get durationInSeconds() {
    if (this._cachedDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedDurationInSeconds = this._value.durationInSeconds;
      } else {
        this._cachedDurationInSeconds = this._parent ? this._parent.durationInSeconds : this._value.durationInSeconds;
      }
    }
    return this._cachedDurationInSeconds;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_CoopLevelConfig_WithParent(current, parent);
    if (this._selfMapCandidates) {
      if (this._value.mapCandidates === current.mapCandidates) {
        result._selfMapCandidates = this._selfMapCandidates;
      } else {
        result._selfMapCandidates = [];
        for (let i = 0; i < current.mapCandidates.length; i++) {
          const oldValue = this._value.mapCandidates[i];
          if (oldValue) {
            const oldCache = this._selfMapCandidates[i];
            if (oldValue === current.mapCandidates[i]) {
              result._selfMapCandidates[i] = oldCache;
            } else {
              result._selfMapCandidates[i] = oldCache.update(current.mapCandidates[i], null);
            }
          } else {
            result._selfMapCandidates[i] = new MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate.WithParent(current.mapCandidates[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig_WithParent.default = new MapEvent_LiveEventConfig_CoopLevelConfig_WithParent(MapEvent_LiveEventConfig_CoopLevelConfig.default, null);
MapEvent_LiveEventConfig_CoopLevelConfig.WithParent = MapEvent_LiveEventConfig_CoopLevelConfig_WithParent;
class MapEvent_LiveEventConfig_CoopLevelConfig_Descriptor {
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 1,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get eliteChanceIncrementPerReroll() {
    if (!this._eliteChanceIncrementPerReroll) {
      this._eliteChanceIncrementPerReroll = {
        name: "eliteChanceIncrementPerReroll",
        Name: "EliteChanceIncrementPerReroll",
        number: 7,
        protoType: 1,
        protoName: "elite_chance_increment_per_reroll",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eliteChanceIncrementPerReroll;
  }
  get eliteChanceIncrementPerRerollForDisplay() {
    if (!this._eliteChanceIncrementPerRerollForDisplay) {
      this._eliteChanceIncrementPerRerollForDisplay = {
        name: "eliteChanceIncrementPerRerollForDisplay",
        Name: "EliteChanceIncrementPerRerollForDisplay",
        number: 9,
        protoType: 1,
        protoName: "elite_chance_increment_per_reroll_for_display",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eliteChanceIncrementPerRerollForDisplay;
  }
  get infernalChanceIncrementPerReroll() {
    if (!this._infernalChanceIncrementPerReroll) {
      this._infernalChanceIncrementPerReroll = {
        name: "infernalChanceIncrementPerReroll",
        Name: "InfernalChanceIncrementPerReroll",
        number: 8,
        protoType: 1,
        protoName: "infernal_chance_increment_per_reroll",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._infernalChanceIncrementPerReroll;
  }
  get infernalChanceIncrementPerRerollForDisplay() {
    if (!this._infernalChanceIncrementPerRerollForDisplay) {
      this._infernalChanceIncrementPerRerollForDisplay = {
        name: "infernalChanceIncrementPerRerollForDisplay",
        Name: "InfernalChanceIncrementPerRerollForDisplay",
        number: 10,
        protoType: 1,
        protoName: "infernal_chance_increment_per_reroll_for_display",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._infernalChanceIncrementPerRerollForDisplay;
  }
  get quickChanceIncrementPerReroll() {
    if (!this._quickChanceIncrementPerReroll) {
      this._quickChanceIncrementPerReroll = {
        name: "quickChanceIncrementPerReroll",
        Name: "QuickChanceIncrementPerReroll",
        number: 11,
        protoType: 1,
        protoName: "quick_chance_increment_per_reroll",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._quickChanceIncrementPerReroll;
  }
  get quickChanceIncrementPerRerollForDisplay() {
    if (!this._quickChanceIncrementPerRerollForDisplay) {
      this._quickChanceIncrementPerRerollForDisplay = {
        name: "quickChanceIncrementPerRerollForDisplay",
        Name: "QuickChanceIncrementPerRerollForDisplay",
        number: 12,
        protoType: 1,
        protoName: "quick_chance_increment_per_reroll_for_display",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._quickChanceIncrementPerRerollForDisplay;
  }
  get mapCandidates() {
    if (!this._mapCandidates) {
      this._mapCandidates = {
        name: "mapCandidates",
        Name: "MapCandidates",
        number: 2,
        protoType: 11,
        protoName: "map_candidates",
        type: MapEvent_LiveEventConfig_CoopLevelConfig_MapCandidate,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapCandidates;
  }
  get durationInSeconds() {
    if (!this._durationInSeconds) {
      this._durationInSeconds = {
        name: "durationInSeconds",
        Name: "DurationInSeconds",
        number: 4,
        protoType: 5,
        protoName: "duration_in_seconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationInSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.difficulty,
        this.eliteChanceIncrementPerReroll,
        this.eliteChanceIncrementPerRerollForDisplay,
        this.infernalChanceIncrementPerReroll,
        this.infernalChanceIncrementPerRerollForDisplay,
        this.quickChanceIncrementPerReroll,
        this.quickChanceIncrementPerRerollForDisplay,
        this.mapCandidates,
        this.durationInSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEliteChanceIncrementPerReroll",
        Name: "DummyOneofForEliteChanceIncrementPerReroll",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEliteChanceIncrementPerRerollForDisplay",
        Name: "DummyOneofForEliteChanceIncrementPerRerollForDisplay",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInfernalChanceIncrementPerReroll",
        Name: "DummyOneofForInfernalChanceIncrementPerReroll",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInfernalChanceIncrementPerRerollForDisplay",
        Name: "DummyOneofForInfernalChanceIncrementPerRerollForDisplay",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForQuickChanceIncrementPerReroll",
        Name: "DummyOneofForQuickChanceIncrementPerReroll",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForQuickChanceIncrementPerRerollForDisplay",
        Name: "DummyOneofForQuickChanceIncrementPerRerollForDisplay",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDurationInSeconds",
        Name: "DummyOneofForDurationInSeconds",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig_CoopLevelConfig.descriptor = new MapEvent_LiveEventConfig_CoopLevelConfig_Descriptor();
class MapEvent_LiveEventConfig_LevelReward {
  get descriptor() {
    return MapEvent_LiveEventConfig_LevelReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig_LevelReward) {
      return value;
    }
    return MapEvent_LiveEventConfig_LevelReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig_LevelReward();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_LevelReward(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_LevelReward(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_LevelReward(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_LevelReward(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig_LevelReward} other
   * @returns {MapEvent_LiveEventConfig_LevelReward}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig_LevelReward(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
MapEvent_LiveEventConfig_LevelReward.default = new MapEvent_LiveEventConfig_LevelReward();
class MapEvent_LiveEventConfig_LevelReward_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig_LevelReward(value);
  }
  build() {
    return new MapEvent_LiveEventConfig_LevelReward(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
MapEvent_LiveEventConfig_LevelReward.Builder = MapEvent_LiveEventConfig_LevelReward_Builder;
class MapEvent_LiveEventConfig_LevelReward_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig_LevelReward} value
   * @param {MapEvent_LiveEventConfig_LevelReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig_LevelReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_LevelReward_WithParent(current, parent);
    return result;
  }
}
MapEvent_LiveEventConfig_LevelReward_WithParent.default = new MapEvent_LiveEventConfig_LevelReward_WithParent(MapEvent_LiveEventConfig_LevelReward.default, null);
MapEvent_LiveEventConfig_LevelReward.WithParent = MapEvent_LiveEventConfig_LevelReward_WithParent;
class MapEvent_LiveEventConfig_LevelReward_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig_LevelReward.descriptor = new MapEvent_LiveEventConfig_LevelReward_Descriptor();
class MapEvent_LiveEventConfig_CoopLevelAccessKey {
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelAccessKey.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInventoryKeyId = false;
    this._inventoryKeyId = null;
    this._hasUpfrontKeyAmount = false;
    this._upfrontKeyAmount = null;
    this._gemsCosts = [];
    this._goldCosts = [];
    this._hasGemsCostResetTimeInSecs = false;
    this._gemsCostResetTimeInSecs = null;
    this._hasKeysAmountPurPurchase = false;
    this._keysAmountPurPurchase = null;
  }
  isEmpty() {
    if (this._hasInventoryKeyId) return false;
    if (this._hasUpfrontKeyAmount) return false;
    if (this._gemsCosts.length > 0) return false;
    if (this._goldCosts.length > 0) return false;
    if (this._hasGemsCostResetTimeInSecs) return false;
    if (this._hasKeysAmountPurPurchase) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig_CoopLevelAccessKey) {
      return value;
    }
    return MapEvent_LiveEventConfig_CoopLevelAccessKey.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig_CoopLevelAccessKey();
    if (json.inventoryKeyId != null) {
      result._hasInventoryKeyId = true;
      result._inventoryKeyId = JsonToString.fromJson(json.inventoryKeyId);
    }
    if (json.upfrontKeyAmount != null) {
      result._hasUpfrontKeyAmount = true;
      result._upfrontKeyAmount = JsonToInt32.fromJson(json.upfrontKeyAmount);
    }
    result._gemsCosts = JsonToList(json.gemsCosts, JsonToInt32);
    result._goldCosts = JsonToList(json.goldCosts, JsonToInt32);
    if (json.gemsCostResetTimeInSecs != null) {
      result._hasGemsCostResetTimeInSecs = true;
      result._gemsCostResetTimeInSecs = JsonToInt32.fromJson(json.gemsCostResetTimeInSecs);
    }
    if (json.keysAmountPurPurchase != null) {
      result._hasKeysAmountPurPurchase = true;
      result._keysAmountPurPurchase = JsonToInt32.fromJson(json.keysAmountPurPurchase);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInventoryKeyId) {
      result.inventoryKeyId = JsonToString.toJson(this._inventoryKeyId);
    }
    if (this._hasUpfrontKeyAmount) {
      result.upfrontKeyAmount = JsonToInt32.toJson(this._upfrontKeyAmount);
    }
    if (this._gemsCosts.length > 0) {
      result.gemsCosts = ArrayToJson(this._gemsCosts, JsonToInt32);
    }
    if (this._goldCosts.length > 0) {
      result.goldCosts = ArrayToJson(this._goldCosts, JsonToInt32);
    }
    if (this._hasGemsCostResetTimeInSecs) {
      result.gemsCostResetTimeInSecs = JsonToInt32.toJson(this._gemsCostResetTimeInSecs);
    }
    if (this._hasKeysAmountPurPurchase) {
      result.keysAmountPurPurchase = JsonToInt32.toJson(this._keysAmountPurPurchase);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get inventoryKeyId() {
    return this._hasInventoryKeyId ? this._inventoryKeyId : JsonToString.default;
  }
  get hasInventoryKeyId() {
    return this._hasInventoryKeyId;
  }
  setInventoryKeyId(path, value) {
    return {type: 'SET', path: path.concat(['inventoryKeyId']), value};
  }
  deleteInventoryKeyId(path) {
    return {type: 'DELETE', path: path.concat(['inventoryKeyId'])};
  }
  /**
   * @returns {number}
   */
  get upfrontKeyAmount() {
    return this._hasUpfrontKeyAmount ? this._upfrontKeyAmount : JsonToInt32.default;
  }
  get hasUpfrontKeyAmount() {
    return this._hasUpfrontKeyAmount;
  }
  setUpfrontKeyAmount(path, value) {
    return {type: 'SET', path: path.concat(['upfrontKeyAmount']), value};
  }
  deleteUpfrontKeyAmount(path) {
    return {type: 'DELETE', path: path.concat(['upfrontKeyAmount'])};
  }
  /**
   * @returns {number[]}
   */
  get gemsCosts() {
    return this._gemsCosts;
  }
  addGemsCosts(path, value) {
    return {type: 'ADD', path: path.concat(['gemsCosts']), value};
  }
  setGemsCosts(path, value) {
    return {type: 'SET', path: path.concat(['gemsCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGemsCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gemsCosts', key]), value};
  }
  deleteGemsCosts(path) {
    return {type: 'DELETE', path: path.concat(['gemsCosts'])};
  }
  deleteGemsCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gemsCosts', key])};
  }
  /**
   * @returns {number[]}
   */
  get goldCosts() {
    return this._goldCosts;
  }
  addGoldCosts(path, value) {
    return {type: 'ADD', path: path.concat(['goldCosts']), value};
  }
  setGoldCosts(path, value) {
    return {type: 'SET', path: path.concat(['goldCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGoldCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldCosts', key]), value};
  }
  deleteGoldCosts(path) {
    return {type: 'DELETE', path: path.concat(['goldCosts'])};
  }
  deleteGoldCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldCosts', key])};
  }
  /**
   * @returns {number}
   */
  get gemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs ? this._gemsCostResetTimeInSecs : JsonToInt32.default;
  }
  get hasGemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs;
  }
  setGemsCostResetTimeInSecs(path, value) {
    return {type: 'SET', path: path.concat(['gemsCostResetTimeInSecs']), value};
  }
  deleteGemsCostResetTimeInSecs(path) {
    return {type: 'DELETE', path: path.concat(['gemsCostResetTimeInSecs'])};
  }
  /**
   * @returns {number}
   */
  get keysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase ? this._keysAmountPurPurchase : JsonToInt32.default;
  }
  get hasKeysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase;
  }
  setKeysAmountPurPurchase(path, value) {
    return {type: 'SET', path: path.concat(['keysAmountPurPurchase']), value};
  }
  deleteKeysAmountPurPurchase(path) {
    return {type: 'DELETE', path: path.concat(['keysAmountPurPurchase'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "inventoryKeyId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasInventoryKeyId = true;
              copy._inventoryKeyId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInventoryKeyId) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasInventoryKeyId = false;
              copy._inventoryKeyId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upfrontKeyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasUpfrontKeyAmount = true;
              copy._upfrontKeyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpfrontKeyAmount) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasUpfrontKeyAmount = false;
              copy._upfrontKeyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemsCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._gemsCosts = [];        for (let i of value) {
                copy._gemsCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gemsCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._gemsCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.slice();
              copy._gemsCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._gemsCosts = copy._gemsCosts.slice(0, path[1]).concat(copy._gemsCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          const oldValue = this._gemsCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
          copy._gemsCosts = copy._gemsCosts.slice();
          copy._gemsCosts[key] = newValue;
          return copy;
        }
      }
      case "goldCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._goldCosts = [];        for (let i of value) {
                copy._goldCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._goldCosts = copy._goldCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._goldCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._goldCosts = copy._goldCosts.slice();
              copy._goldCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._goldCosts = copy._goldCosts.slice(0, path[1]).concat(copy._goldCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldCosts.length) {
            return this;
          }
          const oldValue = this._goldCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
          copy._goldCosts = copy._goldCosts.slice();
          copy._goldCosts[key] = newValue;
          return copy;
        }
      }
      case "gemsCostResetTimeInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasGemsCostResetTimeInSecs = true;
              copy._gemsCostResetTimeInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemsCostResetTimeInSecs) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasGemsCostResetTimeInSecs = false;
              copy._gemsCostResetTimeInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keysAmountPurPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasKeysAmountPurPurchase = true;
              copy._keysAmountPurPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeysAmountPurPurchase) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
              copy._hasKeysAmountPurPurchase = false;
              copy._keysAmountPurPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelAccessKey} other
   * @returns {MapEvent_LiveEventConfig_CoopLevelAccessKey}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig_CoopLevelAccessKey(this);
    if (other._hasInventoryKeyId) {
      copy._hasInventoryKeyId = true;
      copy._inventoryKeyId = other._inventoryKeyId;
    }
    if (other._hasUpfrontKeyAmount) {
      copy._hasUpfrontKeyAmount = true;
      copy._upfrontKeyAmount = other._upfrontKeyAmount;
    }
    copy._gemsCosts = this._gemsCosts.concat(other._gemsCosts);
    copy._goldCosts = this._goldCosts.concat(other._goldCosts);
    if (other._hasGemsCostResetTimeInSecs) {
      copy._hasGemsCostResetTimeInSecs = true;
      copy._gemsCostResetTimeInSecs = other._gemsCostResetTimeInSecs;
    }
    if (other._hasKeysAmountPurPurchase) {
      copy._hasKeysAmountPurPurchase = true;
      copy._keysAmountPurPurchase = other._keysAmountPurPurchase;
    }
    return copy;
  }
}
MapEvent_LiveEventConfig_CoopLevelAccessKey.default = new MapEvent_LiveEventConfig_CoopLevelAccessKey();
class MapEvent_LiveEventConfig_CoopLevelAccessKey_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig_CoopLevelAccessKey(value);
  }
  build() {
    return new MapEvent_LiveEventConfig_CoopLevelAccessKey(this._value);
  }
  setInventoryKeyId(value) {
    this._value._hasInventoryKeyId = true;
    this._value._inventoryKeyId = value;
    return this;
  }
  deleteInventoryKeyId() {
    this._value._hasInventoryKeyId = false;
    this._value._inventoryKeyId = null;
    return this;
  }
  setUpfrontKeyAmount(value) {
    this._value._hasUpfrontKeyAmount = true;
    this._value._upfrontKeyAmount = value;
    return this;
  }
  deleteUpfrontKeyAmount() {
    this._value._hasUpfrontKeyAmount = false;
    this._value._upfrontKeyAmount = null;
    return this;
  }
  addAllGemsCosts(values) {
    this._value._gemsCosts = this._value._gemsCosts.concat(values);
    return this;
  }
  addGemsCosts(value) {
    this._value._gemsCosts = this._value._gemsCosts.concat([value]);
    return this;
  }
  setGemsCosts(index, value) {
    this._value._gemsCosts = this._value._gemsCosts.concat();
    this._value._gemsCosts[index] = value;
    return this;
  }
  clearGemsCosts() {
    this._value._gemsCosts = [];
    return this;
  }
  addAllGoldCosts(values) {
    this._value._goldCosts = this._value._goldCosts.concat(values);
    return this;
  }
  addGoldCosts(value) {
    this._value._goldCosts = this._value._goldCosts.concat([value]);
    return this;
  }
  setGoldCosts(index, value) {
    this._value._goldCosts = this._value._goldCosts.concat();
    this._value._goldCosts[index] = value;
    return this;
  }
  clearGoldCosts() {
    this._value._goldCosts = [];
    return this;
  }
  setGemsCostResetTimeInSecs(value) {
    this._value._hasGemsCostResetTimeInSecs = true;
    this._value._gemsCostResetTimeInSecs = value;
    return this;
  }
  deleteGemsCostResetTimeInSecs() {
    this._value._hasGemsCostResetTimeInSecs = false;
    this._value._gemsCostResetTimeInSecs = null;
    return this;
  }
  setKeysAmountPurPurchase(value) {
    this._value._hasKeysAmountPurPurchase = true;
    this._value._keysAmountPurPurchase = value;
    return this;
  }
  deleteKeysAmountPurPurchase() {
    this._value._hasKeysAmountPurPurchase = false;
    this._value._keysAmountPurPurchase = null;
    return this;
  }
}
MapEvent_LiveEventConfig_CoopLevelAccessKey.Builder = MapEvent_LiveEventConfig_CoopLevelAccessKey_Builder;
class MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig_CoopLevelAccessKey} value
   * @param {MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig_CoopLevelAccessKey.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInventoryKeyId() {
    if (this._cachedHasInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedHasInventoryKeyId = true;
      } else {
        this._cachedHasInventoryKeyId = this._parent ? this._parent.hasInventoryKeyId : false;
      }
    }
    return this._cachedHasInventoryKeyId;
  }
  get inventoryKeyId() {
    if (this._cachedInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedInventoryKeyId = this._value.inventoryKeyId;
      } else {
        this._cachedInventoryKeyId = this._parent ? this._parent.inventoryKeyId : this._value.inventoryKeyId;
      }
    }
    return this._cachedInventoryKeyId;
  }
  get hasUpfrontKeyAmount() {
    if (this._cachedHasUpfrontKeyAmount === undefined) {
      if (this._value.hasUpfrontKeyAmount) {
        this._cachedHasUpfrontKeyAmount = true;
      } else {
        this._cachedHasUpfrontKeyAmount = this._parent ? this._parent.hasUpfrontKeyAmount : false;
      }
    }
    return this._cachedHasUpfrontKeyAmount;
  }
  get upfrontKeyAmount() {
    if (this._cachedUpfrontKeyAmount === undefined) {
      if (this._value.hasUpfrontKeyAmount) {
        this._cachedUpfrontKeyAmount = this._value.upfrontKeyAmount;
      } else {
        this._cachedUpfrontKeyAmount = this._parent ? this._parent.upfrontKeyAmount : this._value.upfrontKeyAmount;
      }
    }
    return this._cachedUpfrontKeyAmount;
  }
  get selfGemsCosts() {
    return this._value.gemsCosts;
  }
  get inherentGemsCosts() {
    if (!this._inherentGemsCosts) {
      this._inherentGemsCosts = this._parent ? this._parent.gemsCosts : [];
    }
    return this._inherentGemsCosts;
  }
  get gemsCosts() {
    if (!this._allGemsCosts) {
      this._allGemsCosts = this._parent ? this._parent.gemsCosts.concat(this.selfGemsCosts) : this.selfGemsCosts;
    }
    return this._allGemsCosts;
  }
  get selfGoldCosts() {
    return this._value.goldCosts;
  }
  get inherentGoldCosts() {
    if (!this._inherentGoldCosts) {
      this._inherentGoldCosts = this._parent ? this._parent.goldCosts : [];
    }
    return this._inherentGoldCosts;
  }
  get goldCosts() {
    if (!this._allGoldCosts) {
      this._allGoldCosts = this._parent ? this._parent.goldCosts.concat(this.selfGoldCosts) : this.selfGoldCosts;
    }
    return this._allGoldCosts;
  }
  get hasGemsCostResetTimeInSecs() {
    if (this._cachedHasGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedHasGemsCostResetTimeInSecs = true;
      } else {
        this._cachedHasGemsCostResetTimeInSecs = this._parent ? this._parent.hasGemsCostResetTimeInSecs : false;
      }
    }
    return this._cachedHasGemsCostResetTimeInSecs;
  }
  get gemsCostResetTimeInSecs() {
    if (this._cachedGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedGemsCostResetTimeInSecs = this._value.gemsCostResetTimeInSecs;
      } else {
        this._cachedGemsCostResetTimeInSecs = this._parent ? this._parent.gemsCostResetTimeInSecs : this._value.gemsCostResetTimeInSecs;
      }
    }
    return this._cachedGemsCostResetTimeInSecs;
  }
  get hasKeysAmountPurPurchase() {
    if (this._cachedHasKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedHasKeysAmountPurPurchase = true;
      } else {
        this._cachedHasKeysAmountPurPurchase = this._parent ? this._parent.hasKeysAmountPurPurchase : false;
      }
    }
    return this._cachedHasKeysAmountPurPurchase;
  }
  get keysAmountPurPurchase() {
    if (this._cachedKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedKeysAmountPurPurchase = this._value.keysAmountPurPurchase;
      } else {
        this._cachedKeysAmountPurPurchase = this._parent ? this._parent.keysAmountPurPurchase : this._value.keysAmountPurPurchase;
      }
    }
    return this._cachedKeysAmountPurPurchase;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent(current, parent);
    return result;
  }
}
MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent.default = new MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent(MapEvent_LiveEventConfig_CoopLevelAccessKey.default, null);
MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent = MapEvent_LiveEventConfig_CoopLevelAccessKey_WithParent;
class MapEvent_LiveEventConfig_CoopLevelAccessKey_Descriptor {
  get inventoryKeyId() {
    if (!this._inventoryKeyId) {
      this._inventoryKeyId = {
        name: "inventoryKeyId",
        Name: "InventoryKeyId",
        number: 1,
        protoType: 9,
        protoName: "inventory_key_id",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._inventoryKeyId;
  }
  get upfrontKeyAmount() {
    if (!this._upfrontKeyAmount) {
      this._upfrontKeyAmount = {
        name: "upfrontKeyAmount",
        Name: "UpfrontKeyAmount",
        number: 7,
        protoType: 5,
        protoName: "upfront_key_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upfrontKeyAmount;
  }
  get gemsCosts() {
    if (!this._gemsCosts) {
      this._gemsCosts = {
        name: "gemsCosts",
        Name: "GemsCosts",
        number: 4,
        protoType: 5,
        protoName: "gems_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCosts;
  }
  get goldCosts() {
    if (!this._goldCosts) {
      this._goldCosts = {
        name: "goldCosts",
        Name: "GoldCosts",
        number: 8,
        protoType: 5,
        protoName: "gold_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldCosts;
  }
  get gemsCostResetTimeInSecs() {
    if (!this._gemsCostResetTimeInSecs) {
      this._gemsCostResetTimeInSecs = {
        name: "gemsCostResetTimeInSecs",
        Name: "GemsCostResetTimeInSecs",
        number: 5,
        protoType: 5,
        protoName: "gems_cost_reset_time_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCostResetTimeInSecs;
  }
  get keysAmountPurPurchase() {
    if (!this._keysAmountPurPurchase) {
      this._keysAmountPurPurchase = {
        name: "keysAmountPurPurchase",
        Name: "KeysAmountPurPurchase",
        number: 6,
        protoType: 5,
        protoName: "keys_amount_pur_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keysAmountPurPurchase;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.inventoryKeyId,
        this.upfrontKeyAmount,
        this.gemsCosts,
        this.goldCosts,
        this.gemsCostResetTimeInSecs,
        this.keysAmountPurPurchase,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInventoryKeyId",
        Name: "DummyOneofForInventoryKeyId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpfrontKeyAmount",
        Name: "DummyOneofForUpfrontKeyAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemsCostResetTimeInSecs",
        Name: "DummyOneofForGemsCostResetTimeInSecs",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeysAmountPurPurchase",
        Name: "DummyOneofForKeysAmountPurPurchase",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig_CoopLevelAccessKey.descriptor = new MapEvent_LiveEventConfig_CoopLevelAccessKey_Descriptor();
class MapEvent_LiveEventConfig_LevelRerollConfig {
  get descriptor() {
    return MapEvent_LiveEventConfig_LevelRerollConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._gemsCosts = [];
  }
  isEmpty() {
    if (this._gemsCosts.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig_LevelRerollConfig) {
      return value;
    }
    return MapEvent_LiveEventConfig_LevelRerollConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig_LevelRerollConfig();
    result._gemsCosts = JsonToList(json.gemsCosts, JsonToInt32);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._gemsCosts.length > 0) {
      result.gemsCosts = ArrayToJson(this._gemsCosts, JsonToInt32);
    }
    return result;
  }
  /**
   * @returns {number[]}
   */
  get gemsCosts() {
    return this._gemsCosts;
  }
  addGemsCosts(path, value) {
    return {type: 'ADD', path: path.concat(['gemsCosts']), value};
  }
  setGemsCosts(path, value) {
    return {type: 'SET', path: path.concat(['gemsCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGemsCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gemsCosts', key]), value};
  }
  deleteGemsCosts(path) {
    return {type: 'DELETE', path: path.concat(['gemsCosts'])};
  }
  deleteGemsCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gemsCosts', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "gemsCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
              copy._gemsCosts = [];        for (let i of value) {
                copy._gemsCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
              copy._gemsCosts = copy._gemsCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gemsCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
              copy._gemsCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
              copy._gemsCosts = copy._gemsCosts.slice();
              copy._gemsCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
              copy._gemsCosts = copy._gemsCosts.slice(0, path[1]).concat(copy._gemsCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          const oldValue = this._gemsCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
          copy._gemsCosts = copy._gemsCosts.slice();
          copy._gemsCosts[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig_LevelRerollConfig} other
   * @returns {MapEvent_LiveEventConfig_LevelRerollConfig}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig_LevelRerollConfig(this);
    copy._gemsCosts = this._gemsCosts.concat(other._gemsCosts);
    return copy;
  }
}
MapEvent_LiveEventConfig_LevelRerollConfig.default = new MapEvent_LiveEventConfig_LevelRerollConfig();
class MapEvent_LiveEventConfig_LevelRerollConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig_LevelRerollConfig(value);
  }
  build() {
    return new MapEvent_LiveEventConfig_LevelRerollConfig(this._value);
  }
  addAllGemsCosts(values) {
    this._value._gemsCosts = this._value._gemsCosts.concat(values);
    return this;
  }
  addGemsCosts(value) {
    this._value._gemsCosts = this._value._gemsCosts.concat([value]);
    return this;
  }
  setGemsCosts(index, value) {
    this._value._gemsCosts = this._value._gemsCosts.concat();
    this._value._gemsCosts[index] = value;
    return this;
  }
  clearGemsCosts() {
    this._value._gemsCosts = [];
    return this;
  }
}
MapEvent_LiveEventConfig_LevelRerollConfig.Builder = MapEvent_LiveEventConfig_LevelRerollConfig_Builder;
class MapEvent_LiveEventConfig_LevelRerollConfig_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig_LevelRerollConfig} value
   * @param {MapEvent_LiveEventConfig_LevelRerollConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig_LevelRerollConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGemsCosts() {
    return this._value.gemsCosts;
  }
  get inherentGemsCosts() {
    if (!this._inherentGemsCosts) {
      this._inherentGemsCosts = this._parent ? this._parent.gemsCosts : [];
    }
    return this._inherentGemsCosts;
  }
  get gemsCosts() {
    if (!this._allGemsCosts) {
      this._allGemsCosts = this._parent ? this._parent.gemsCosts.concat(this.selfGemsCosts) : this.selfGemsCosts;
    }
    return this._allGemsCosts;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_LevelRerollConfig_WithParent(current, parent);
    return result;
  }
}
MapEvent_LiveEventConfig_LevelRerollConfig_WithParent.default = new MapEvent_LiveEventConfig_LevelRerollConfig_WithParent(MapEvent_LiveEventConfig_LevelRerollConfig.default, null);
MapEvent_LiveEventConfig_LevelRerollConfig.WithParent = MapEvent_LiveEventConfig_LevelRerollConfig_WithParent;
class MapEvent_LiveEventConfig_LevelRerollConfig_Descriptor {
  get gemsCosts() {
    if (!this._gemsCosts) {
      this._gemsCosts = {
        name: "gemsCosts",
        Name: "GemsCosts",
        number: 1,
        protoType: 5,
        protoName: "gems_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCosts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.gemsCosts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig_LevelRerollConfig.descriptor = new MapEvent_LiveEventConfig_LevelRerollConfig_Descriptor();
class MapEvent_LiveEventConfig {
  get descriptor() {
    return MapEvent_LiveEventConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCoopLevelKey = false;
    this._coopLevelKey = null;
    this._hasCoopCoopKey = false;
    this._coopCoopKey = null;
    this._hasLevelRerollConfig = false;
    this._levelRerollConfig = null;
    this._coopRewardPatterns = [];
    this._coopLevelConfigs = [];
  }
  isEmpty() {
    if (this._hasCoopLevelKey && !this._coopLevelKey.isEmpty()) return false;
    if (this._hasCoopCoopKey && !this._coopCoopKey.isEmpty()) return false;
    if (this._hasLevelRerollConfig && !this._levelRerollConfig.isEmpty()) return false;
    if (this._coopRewardPatterns.length > 0) return false;
    if (this._coopLevelConfigs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_LiveEventConfig) {
      return value;
    }
    return MapEvent_LiveEventConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_LiveEventConfig();
    if (json.coopLevelKey != null) {
      result._hasCoopLevelKey = true;
      result._coopLevelKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.fromJson(json.coopLevelKey);
    }
    if (json.coopCoopKey != null) {
      result._hasCoopCoopKey = true;
      result._coopCoopKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.fromJson(json.coopCoopKey);
    }
    if (json.levelRerollConfig != null) {
      result._hasLevelRerollConfig = true;
      result._levelRerollConfig = MapEvent_LiveEventConfig_LevelRerollConfig.fromJson(json.levelRerollConfig);
    }
    result._coopRewardPatterns = JsonToList(json.coopRewardPatterns, MapEvent_CoopRewardPattern);
    result._coopLevelConfigs = JsonToList(json.coopLevelConfigs, MapEvent_LiveEventConfig_CoopLevelConfig);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCoopLevelKey && !this._coopLevelKey.isEmpty()) {
      result.coopLevelKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.toJson(this._coopLevelKey);
    }
    if (this._hasCoopCoopKey && !this._coopCoopKey.isEmpty()) {
      result.coopCoopKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.toJson(this._coopCoopKey);
    }
    if (this._hasLevelRerollConfig && !this._levelRerollConfig.isEmpty()) {
      result.levelRerollConfig = MapEvent_LiveEventConfig_LevelRerollConfig.toJson(this._levelRerollConfig);
    }
    if (this._coopRewardPatterns.length > 0) {
      result.coopRewardPatterns = ArrayToJson(this._coopRewardPatterns, MapEvent_CoopRewardPattern);
    }
    if (this._coopLevelConfigs.length > 0) {
      result.coopLevelConfigs = ArrayToJson(this._coopLevelConfigs, MapEvent_LiveEventConfig_CoopLevelConfig);
    }
    return result;
  }
  /**
   * @returns {MapEvent_LiveEventConfig_CoopLevelAccessKey}
   */
  get coopLevelKey() {
    return this._hasCoopLevelKey ? this._coopLevelKey : MapEvent_LiveEventConfig_CoopLevelAccessKey.default;
  }
  get hasCoopLevelKey() {
    return this._hasCoopLevelKey;
  }
  setCoopLevelKey(path, value) {
    return {type: 'SET', path: path.concat(['coopLevelKey']), value: value.toJson()};
  }
  deleteCoopLevelKey(path) {
    return {type: 'DELETE', path: path.concat(['coopLevelKey'])};
  }
  /**
   * @returns {MapEvent_LiveEventConfig_CoopLevelAccessKey}
   */
  get coopCoopKey() {
    return this._hasCoopCoopKey ? this._coopCoopKey : MapEvent_LiveEventConfig_CoopLevelAccessKey.default;
  }
  get hasCoopCoopKey() {
    return this._hasCoopCoopKey;
  }
  setCoopCoopKey(path, value) {
    return {type: 'SET', path: path.concat(['coopCoopKey']), value: value.toJson()};
  }
  deleteCoopCoopKey(path) {
    return {type: 'DELETE', path: path.concat(['coopCoopKey'])};
  }
  /**
   * @returns {MapEvent_LiveEventConfig_LevelRerollConfig}
   */
  get levelRerollConfig() {
    return this._hasLevelRerollConfig ? this._levelRerollConfig : MapEvent_LiveEventConfig_LevelRerollConfig.default;
  }
  get hasLevelRerollConfig() {
    return this._hasLevelRerollConfig;
  }
  setLevelRerollConfig(path, value) {
    return {type: 'SET', path: path.concat(['levelRerollConfig']), value: value.toJson()};
  }
  deleteLevelRerollConfig(path) {
    return {type: 'DELETE', path: path.concat(['levelRerollConfig'])};
  }
  /**
   * @returns {MapEvent_CoopRewardPattern[]}
   */
  get coopRewardPatterns() {
    return this._coopRewardPatterns;
  }
  addCoopRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['coopRewardPatterns']), value: value.toJson()};
  }
  setCoopRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['coopRewardPatterns']), value: ArrayToJson(value, MapEvent_CoopRewardPattern)};
  }
  setCoopRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['coopRewardPatterns', key]), value: value.toJson()};
  }
  deleteCoopRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['coopRewardPatterns'])};
  }
  deleteCoopRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['coopRewardPatterns', key])};
  }
  /**
   * @returns {MapEvent_LiveEventConfig_CoopLevelConfig[]}
   */
  get coopLevelConfigs() {
    return this._coopLevelConfigs;
  }
  addCoopLevelConfigs(path, value) {
    return {type: 'ADD', path: path.concat(['coopLevelConfigs']), value: value.toJson()};
  }
  setCoopLevelConfigs(path, value) {
    return {type: 'SET', path: path.concat(['coopLevelConfigs']), value: ArrayToJson(value, MapEvent_LiveEventConfig_CoopLevelConfig)};
  }
  setCoopLevelConfigsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['coopLevelConfigs', key]), value: value.toJson()};
  }
  deleteCoopLevelConfigs(path) {
    return {type: 'DELETE', path: path.concat(['coopLevelConfigs'])};
  }
  deleteCoopLevelConfigsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['coopLevelConfigs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "coopLevelKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasCoopLevelKey = true;
              copy._coopLevelKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCoopLevelKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasCoopLevelKey = false;
              copy._coopLevelKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCoopLevelKey) {
            const copy = new MapEvent_LiveEventConfig(this);
            copy._hasCoopLevelKey = true;
            copy._coopLevelKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._coopLevelKey.apply(type, path.slice(1), value);
          if (newValue === this._coopLevelKey) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig(this);
          copy._coopLevelKey = copy._coopLevelKey.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "coopCoopKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasCoopCoopKey = true;
              copy._coopCoopKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCoopCoopKey) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasCoopCoopKey = false;
              copy._coopCoopKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCoopCoopKey) {
            const copy = new MapEvent_LiveEventConfig(this);
            copy._hasCoopCoopKey = true;
            copy._coopCoopKey = MapEvent_LiveEventConfig_CoopLevelAccessKey.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._coopCoopKey.apply(type, path.slice(1), value);
          if (newValue === this._coopCoopKey) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig(this);
          copy._coopCoopKey = copy._coopCoopKey.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "levelRerollConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasLevelRerollConfig = true;
              copy._levelRerollConfig = MapEvent_LiveEventConfig_LevelRerollConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelRerollConfig) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig(this);
              copy._hasLevelRerollConfig = false;
              copy._levelRerollConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLevelRerollConfig) {
            const copy = new MapEvent_LiveEventConfig(this);
            copy._hasLevelRerollConfig = true;
            copy._levelRerollConfig = MapEvent_LiveEventConfig_LevelRerollConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._levelRerollConfig.apply(type, path.slice(1), value);
          if (newValue === this._levelRerollConfig) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig(this);
          copy._levelRerollConfig = copy._levelRerollConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "coopRewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopRewardPatterns = [];        for (let i of value) {
                copy._coopRewardPatterns.push(MapEvent_CoopRewardPattern.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopRewardPatterns = copy._coopRewardPatterns.concat([MapEvent_CoopRewardPattern.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._coopRewardPatterns.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopRewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._coopRewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopRewardPatterns = copy._coopRewardPatterns.slice();
              copy._coopRewardPatterns[path[1]] = MapEvent_CoopRewardPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopRewardPatterns = copy._coopRewardPatterns.slice(0, path[1]).concat(copy._coopRewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._coopRewardPatterns.length) {
            return this;
          }
          const oldValue = this._coopRewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig(this);
          copy._coopRewardPatterns = copy._coopRewardPatterns.slice();
          copy._coopRewardPatterns[key] = newValue;
          return copy;
        }
      }
      case "coopLevelConfigs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopLevelConfigs = [];        for (let i of value) {
                copy._coopLevelConfigs.push(MapEvent_LiveEventConfig_CoopLevelConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopLevelConfigs = copy._coopLevelConfigs.concat([MapEvent_LiveEventConfig_CoopLevelConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._coopLevelConfigs.length === 0) {
                return this;
              }
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopLevelConfigs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._coopLevelConfigs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopLevelConfigs = copy._coopLevelConfigs.slice();
              copy._coopLevelConfigs[path[1]] = MapEvent_LiveEventConfig_CoopLevelConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_LiveEventConfig(this);
              copy._coopLevelConfigs = copy._coopLevelConfigs.slice(0, path[1]).concat(copy._coopLevelConfigs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._coopLevelConfigs.length) {
            return this;
          }
          const oldValue = this._coopLevelConfigs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_LiveEventConfig(this);
          copy._coopLevelConfigs = copy._coopLevelConfigs.slice();
          copy._coopLevelConfigs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_LiveEventConfig} other
   * @returns {MapEvent_LiveEventConfig}
   */
  merge(other) {
    const copy = new MapEvent_LiveEventConfig(this);
    if (other._hasCoopLevelKey) {
      if (copy._hasCoopLevelKey) {
        copy._coopLevelKey = copy.coopLevelKey.merge(other.coopLevelKey);
      } else {
        copy._coopLevelKey = other._coopLevelKey;
      }
      copy._hasCoopLevelKey = true;
    }
    if (other._hasCoopCoopKey) {
      if (copy._hasCoopCoopKey) {
        copy._coopCoopKey = copy.coopCoopKey.merge(other.coopCoopKey);
      } else {
        copy._coopCoopKey = other._coopCoopKey;
      }
      copy._hasCoopCoopKey = true;
    }
    if (other._hasLevelRerollConfig) {
      if (copy._hasLevelRerollConfig) {
        copy._levelRerollConfig = copy.levelRerollConfig.merge(other.levelRerollConfig);
      } else {
        copy._levelRerollConfig = other._levelRerollConfig;
      }
      copy._hasLevelRerollConfig = true;
    }
    copy._coopRewardPatterns = this._coopRewardPatterns.concat(other._coopRewardPatterns);
    copy._coopLevelConfigs = this._coopLevelConfigs.concat(other._coopLevelConfigs);
    return copy;
  }
}
MapEvent_LiveEventConfig.default = new MapEvent_LiveEventConfig();
MapEvent_LiveEventConfig.CoopLevelConfig = MapEvent_LiveEventConfig_CoopLevelConfig;
MapEvent_LiveEventConfig.LevelReward = MapEvent_LiveEventConfig_LevelReward;
MapEvent_LiveEventConfig.CoopLevelAccessKey = MapEvent_LiveEventConfig_CoopLevelAccessKey;
MapEvent_LiveEventConfig.LevelRerollConfig = MapEvent_LiveEventConfig_LevelRerollConfig;
class MapEvent_LiveEventConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_LiveEventConfig(value);
  }
  build() {
    return new MapEvent_LiveEventConfig(this._value);
  }
  setCoopLevelKey(value) {
    this._value._hasCoopLevelKey = true;
    this._value._coopLevelKey = value;
    return this;
  }
  deleteCoopLevelKey() {
    this._value._hasCoopLevelKey = false;
    this._value._coopLevelKey = null;
    return this;
  }
  setCoopCoopKey(value) {
    this._value._hasCoopCoopKey = true;
    this._value._coopCoopKey = value;
    return this;
  }
  deleteCoopCoopKey() {
    this._value._hasCoopCoopKey = false;
    this._value._coopCoopKey = null;
    return this;
  }
  setLevelRerollConfig(value) {
    this._value._hasLevelRerollConfig = true;
    this._value._levelRerollConfig = value;
    return this;
  }
  deleteLevelRerollConfig() {
    this._value._hasLevelRerollConfig = false;
    this._value._levelRerollConfig = null;
    return this;
  }
  addAllCoopRewardPatterns(values) {
    this._value._coopRewardPatterns = this._value._coopRewardPatterns.concat(values);
    return this;
  }
  addCoopRewardPatterns(value) {
    this._value._coopRewardPatterns = this._value._coopRewardPatterns.concat([value]);
    return this;
  }
  setCoopRewardPatterns(index, value) {
    this._value._coopRewardPatterns = this._value._coopRewardPatterns.concat();
    this._value._coopRewardPatterns[index] = value;
    return this;
  }
  clearCoopRewardPatterns() {
    this._value._coopRewardPatterns = [];
    return this;
  }
  addAllCoopLevelConfigs(values) {
    this._value._coopLevelConfigs = this._value._coopLevelConfigs.concat(values);
    return this;
  }
  addCoopLevelConfigs(value) {
    this._value._coopLevelConfigs = this._value._coopLevelConfigs.concat([value]);
    return this;
  }
  setCoopLevelConfigs(index, value) {
    this._value._coopLevelConfigs = this._value._coopLevelConfigs.concat();
    this._value._coopLevelConfigs[index] = value;
    return this;
  }
  clearCoopLevelConfigs() {
    this._value._coopLevelConfigs = [];
    return this;
  }
}
MapEvent_LiveEventConfig.Builder = MapEvent_LiveEventConfig_Builder;
class MapEvent_LiveEventConfig_WithParent {
  /**
   * @param {MapEvent_LiveEventConfig} value
   * @param {MapEvent_LiveEventConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_LiveEventConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCoopLevelKey() {
    if (this._cachedHasCoopLevelKey === undefined) {
      if (this._value.hasCoopLevelKey) {
        this._cachedHasCoopLevelKey = true;
      } else {
        this._cachedHasCoopLevelKey = this._parent ? this._parent.hasCoopLevelKey : false;
      }
    }
    return this._cachedHasCoopLevelKey;
  }
  get coopLevelKey() {
    if (!this._cachedCoopLevelKey) {
      if (this._value.hasCoopLevelKey) {
        this._cachedCoopLevelKey = new MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent(this._value.coopLevelKey, this._parent && this._parent.hasCoopLevelKey ? this._parent.coopLevelKey : null);
      } else {
        this._cachedCoopLevelKey = this._parent ? new MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent(MapEvent_LiveEventConfig_CoopLevelAccessKey.default, this._parent.coopLevelKey) : MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent.default;
      }
    }
    return this._cachedCoopLevelKey;
  }
  get hasCoopCoopKey() {
    if (this._cachedHasCoopCoopKey === undefined) {
      if (this._value.hasCoopCoopKey) {
        this._cachedHasCoopCoopKey = true;
      } else {
        this._cachedHasCoopCoopKey = this._parent ? this._parent.hasCoopCoopKey : false;
      }
    }
    return this._cachedHasCoopCoopKey;
  }
  get coopCoopKey() {
    if (!this._cachedCoopCoopKey) {
      if (this._value.hasCoopCoopKey) {
        this._cachedCoopCoopKey = new MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent(this._value.coopCoopKey, this._parent && this._parent.hasCoopCoopKey ? this._parent.coopCoopKey : null);
      } else {
        this._cachedCoopCoopKey = this._parent ? new MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent(MapEvent_LiveEventConfig_CoopLevelAccessKey.default, this._parent.coopCoopKey) : MapEvent_LiveEventConfig_CoopLevelAccessKey.WithParent.default;
      }
    }
    return this._cachedCoopCoopKey;
  }
  get hasLevelRerollConfig() {
    if (this._cachedHasLevelRerollConfig === undefined) {
      if (this._value.hasLevelRerollConfig) {
        this._cachedHasLevelRerollConfig = true;
      } else {
        this._cachedHasLevelRerollConfig = this._parent ? this._parent.hasLevelRerollConfig : false;
      }
    }
    return this._cachedHasLevelRerollConfig;
  }
  get levelRerollConfig() {
    if (!this._cachedLevelRerollConfig) {
      if (this._value.hasLevelRerollConfig) {
        this._cachedLevelRerollConfig = new MapEvent_LiveEventConfig_LevelRerollConfig.WithParent(this._value.levelRerollConfig, this._parent && this._parent.hasLevelRerollConfig ? this._parent.levelRerollConfig : null);
      } else {
        this._cachedLevelRerollConfig = this._parent ? new MapEvent_LiveEventConfig_LevelRerollConfig.WithParent(MapEvent_LiveEventConfig_LevelRerollConfig.default, this._parent.levelRerollConfig) : MapEvent_LiveEventConfig_LevelRerollConfig.WithParent.default;
      }
    }
    return this._cachedLevelRerollConfig;
  }
  get selfCoopRewardPatterns() {
    if (!this._selfCoopRewardPatterns) {
      this._selfCoopRewardPatterns = [];
      for (let i of this._value.coopRewardPatterns) {
        this._selfCoopRewardPatterns.push(new MapEvent_CoopRewardPattern.WithParent(i, null));
      }
    }
    return this._selfCoopRewardPatterns;
  }
  get inherentCoopRewardPatterns() {
    if (!this._inherentCoopRewardPatterns) {
      this._inherentCoopRewardPatterns = this._parent ? this._parent.coopRewardPatterns : [];
    }
    return this._inherentCoopRewardPatterns;
  }
  get coopRewardPatterns() {
    if (!this._allCoopRewardPatterns) {
      this._allCoopRewardPatterns = this._parent ? this._parent.coopRewardPatterns.concat(this.selfCoopRewardPatterns) : this.selfCoopRewardPatterns;
    }
    return this._allCoopRewardPatterns;
  }
  get selfCoopLevelConfigs() {
    if (!this._selfCoopLevelConfigs) {
      this._selfCoopLevelConfigs = [];
      for (let i of this._value.coopLevelConfigs) {
        this._selfCoopLevelConfigs.push(new MapEvent_LiveEventConfig_CoopLevelConfig.WithParent(i, null));
      }
    }
    return this._selfCoopLevelConfigs;
  }
  get inherentCoopLevelConfigs() {
    if (!this._inherentCoopLevelConfigs) {
      this._inherentCoopLevelConfigs = this._parent ? this._parent.coopLevelConfigs : [];
    }
    return this._inherentCoopLevelConfigs;
  }
  get coopLevelConfigs() {
    if (!this._allCoopLevelConfigs) {
      this._allCoopLevelConfigs = this._parent ? this._parent.coopLevelConfigs.concat(this.selfCoopLevelConfigs) : this.selfCoopLevelConfigs;
    }
    return this._allCoopLevelConfigs;
  }
  update(current, parent) {
    const result = new MapEvent_LiveEventConfig_WithParent(current, parent);
    if (this._cachedCoopLevelKey && this._value.hasCoopLevelKey && current.hasCoopLevelKey) {
      if (this._value.coopLevelKey === current.coopLevelKey && this._parent === parent) {
        result._cachedCoopLevelKey = this._cachedCoopLevelKey;
      } else {
        result._cachedCoopLevelKey = this._cachedCoopLevelKey.update(current.coopLevelKey, parent && parent.hasCoopLevelKey ? parent.coopLevelKey : null);
      }
    }
    if (this._cachedCoopCoopKey && this._value.hasCoopCoopKey && current.hasCoopCoopKey) {
      if (this._value.coopCoopKey === current.coopCoopKey && this._parent === parent) {
        result._cachedCoopCoopKey = this._cachedCoopCoopKey;
      } else {
        result._cachedCoopCoopKey = this._cachedCoopCoopKey.update(current.coopCoopKey, parent && parent.hasCoopCoopKey ? parent.coopCoopKey : null);
      }
    }
    if (this._cachedLevelRerollConfig && this._value.hasLevelRerollConfig && current.hasLevelRerollConfig) {
      if (this._value.levelRerollConfig === current.levelRerollConfig && this._parent === parent) {
        result._cachedLevelRerollConfig = this._cachedLevelRerollConfig;
      } else {
        result._cachedLevelRerollConfig = this._cachedLevelRerollConfig.update(current.levelRerollConfig, parent && parent.hasLevelRerollConfig ? parent.levelRerollConfig : null);
      }
    }
    if (this._selfCoopRewardPatterns) {
      if (this._value.coopRewardPatterns === current.coopRewardPatterns) {
        result._selfCoopRewardPatterns = this._selfCoopRewardPatterns;
      } else {
        result._selfCoopRewardPatterns = [];
        for (let i = 0; i < current.coopRewardPatterns.length; i++) {
          const oldValue = this._value.coopRewardPatterns[i];
          if (oldValue) {
            const oldCache = this._selfCoopRewardPatterns[i];
            if (oldValue === current.coopRewardPatterns[i]) {
              result._selfCoopRewardPatterns[i] = oldCache;
            } else {
              result._selfCoopRewardPatterns[i] = oldCache.update(current.coopRewardPatterns[i], null);
            }
          } else {
            result._selfCoopRewardPatterns[i] = new MapEvent_CoopRewardPattern.WithParent(current.coopRewardPatterns[i], null);
          }
        }
      }
    }
    if (this._selfCoopLevelConfigs) {
      if (this._value.coopLevelConfigs === current.coopLevelConfigs) {
        result._selfCoopLevelConfigs = this._selfCoopLevelConfigs;
      } else {
        result._selfCoopLevelConfigs = [];
        for (let i = 0; i < current.coopLevelConfigs.length; i++) {
          const oldValue = this._value.coopLevelConfigs[i];
          if (oldValue) {
            const oldCache = this._selfCoopLevelConfigs[i];
            if (oldValue === current.coopLevelConfigs[i]) {
              result._selfCoopLevelConfigs[i] = oldCache;
            } else {
              result._selfCoopLevelConfigs[i] = oldCache.update(current.coopLevelConfigs[i], null);
            }
          } else {
            result._selfCoopLevelConfigs[i] = new MapEvent_LiveEventConfig_CoopLevelConfig.WithParent(current.coopLevelConfigs[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_LiveEventConfig_WithParent.default = new MapEvent_LiveEventConfig_WithParent(MapEvent_LiveEventConfig.default, null);
MapEvent_LiveEventConfig.WithParent = MapEvent_LiveEventConfig_WithParent;
class MapEvent_LiveEventConfig_Descriptor {
  get coopLevelKey() {
    if (!this._coopLevelKey) {
      this._coopLevelKey = {
        name: "coopLevelKey",
        Name: "CoopLevelKey",
        number: 1,
        protoType: 11,
        protoName: "coop_level_key",
        type: MapEvent_LiveEventConfig_CoopLevelAccessKey,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopLevelKey;
  }
  get coopCoopKey() {
    if (!this._coopCoopKey) {
      this._coopCoopKey = {
        name: "coopCoopKey",
        Name: "CoopCoopKey",
        number: 5,
        protoType: 11,
        protoName: "coop_coop_key",
        type: MapEvent_LiveEventConfig_CoopLevelAccessKey,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopCoopKey;
  }
  get levelRerollConfig() {
    if (!this._levelRerollConfig) {
      this._levelRerollConfig = {
        name: "levelRerollConfig",
        Name: "LevelRerollConfig",
        number: 4,
        protoType: 11,
        protoName: "level_reroll_config",
        type: MapEvent_LiveEventConfig_LevelRerollConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelRerollConfig;
  }
  get coopRewardPatterns() {
    if (!this._coopRewardPatterns) {
      this._coopRewardPatterns = {
        name: "coopRewardPatterns",
        Name: "CoopRewardPatterns",
        number: 3,
        protoType: 11,
        protoName: "coop_reward_patterns",
        type: MapEvent_CoopRewardPattern,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopRewardPatterns;
  }
  get coopLevelConfigs() {
    if (!this._coopLevelConfigs) {
      this._coopLevelConfigs = {
        name: "coopLevelConfigs",
        Name: "CoopLevelConfigs",
        number: 2,
        protoType: 11,
        protoName: "coop_level_configs",
        type: MapEvent_LiveEventConfig_CoopLevelConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopLevelConfigs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.coopLevelKey,
        this.coopCoopKey,
        this.levelRerollConfig,
        this.coopRewardPatterns,
        this.coopLevelConfigs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCoopLevelKey",
        Name: "DummyOneofForCoopLevelKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCoopCoopKey",
        Name: "DummyOneofForCoopCoopKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelRerollConfig",
        Name: "DummyOneofForLevelRerollConfig",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_LiveEventConfig.descriptor = new MapEvent_LiveEventConfig_Descriptor();
class MapEvent_EventGuildConfig_GuildRewardTier {
  get descriptor() {
    return MapEvent_EventGuildConfig_GuildRewardTier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRankFrom = false;
    this._rankFrom = null;
    this._hasRankTo = false;
    this._rankTo = null;
    this._hasDisplayTier = false;
    this._displayTier = null;
    this._hasDisplayTierRank = false;
    this._displayTierRank = null;
    this._hasChestIcon = false;
    this._chestIcon = null;
    this._rewards = [];
    this._guildLeaderRewards = [];
  }
  isEmpty() {
    if (this._hasRankFrom) return false;
    if (this._hasRankTo) return false;
    if (this._hasDisplayTier) return false;
    if (this._hasDisplayTierRank) return false;
    if (this._hasChestIcon) return false;
    if (this._rewards.length > 0) return false;
    if (this._guildLeaderRewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig_GuildRewardTier) {
      return value;
    }
    return MapEvent_EventGuildConfig_GuildRewardTier.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig_GuildRewardTier();
    if (json.rankFrom != null) {
      result._hasRankFrom = true;
      result._rankFrom = JsonToInt32.fromJson(json.rankFrom);
    }
    if (json.rankTo != null) {
      result._hasRankTo = true;
      result._rankTo = JsonToInt32.fromJson(json.rankTo);
    }
    if (json.displayTier != null) {
      result._hasDisplayTier = true;
      result._displayTier = JsonToString.fromJson(json.displayTier);
    }
    if (json.displayTierRank != null) {
      result._hasDisplayTierRank = true;
      result._displayTierRank = JsonToString.fromJson(json.displayTierRank);
    }
    if (json.chestIcon != null) {
      result._hasChestIcon = true;
      result._chestIcon = JsonToString.fromJson(json.chestIcon);
    }
    result._rewards = JsonToList(json.rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._guildLeaderRewards = JsonToList(json.guildLeaderRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRankFrom) {
      result.rankFrom = JsonToInt32.toJson(this._rankFrom);
    }
    if (this._hasRankTo) {
      result.rankTo = JsonToInt32.toJson(this._rankTo);
    }
    if (this._hasDisplayTier) {
      result.displayTier = JsonToString.toJson(this._displayTier);
    }
    if (this._hasDisplayTierRank) {
      result.displayTierRank = JsonToString.toJson(this._displayTierRank);
    }
    if (this._hasChestIcon) {
      result.chestIcon = JsonToString.toJson(this._chestIcon);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._guildLeaderRewards.length > 0) {
      result.guildLeaderRewards = ArrayToJson(this._guildLeaderRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get rankFrom() {
    return this._hasRankFrom ? this._rankFrom : JsonToInt32.default;
  }
  get hasRankFrom() {
    return this._hasRankFrom;
  }
  setRankFrom(path, value) {
    return {type: 'SET', path: path.concat(['rankFrom']), value};
  }
  deleteRankFrom(path) {
    return {type: 'DELETE', path: path.concat(['rankFrom'])};
  }
  /**
   * @returns {number}
   */
  get rankTo() {
    return this._hasRankTo ? this._rankTo : JsonToInt32.default;
  }
  get hasRankTo() {
    return this._hasRankTo;
  }
  setRankTo(path, value) {
    return {type: 'SET', path: path.concat(['rankTo']), value};
  }
  deleteRankTo(path) {
    return {type: 'DELETE', path: path.concat(['rankTo'])};
  }
  /**
   * @returns {string}
   */
  get displayTier() {
    return this._hasDisplayTier ? this._displayTier : JsonToString.default;
  }
  get hasDisplayTier() {
    return this._hasDisplayTier;
  }
  setDisplayTier(path, value) {
    return {type: 'SET', path: path.concat(['displayTier']), value};
  }
  deleteDisplayTier(path) {
    return {type: 'DELETE', path: path.concat(['displayTier'])};
  }
  /**
   * @returns {string}
   */
  get displayTierRank() {
    return this._hasDisplayTierRank ? this._displayTierRank : JsonToString.default;
  }
  get hasDisplayTierRank() {
    return this._hasDisplayTierRank;
  }
  setDisplayTierRank(path, value) {
    return {type: 'SET', path: path.concat(['displayTierRank']), value};
  }
  deleteDisplayTierRank(path) {
    return {type: 'DELETE', path: path.concat(['displayTierRank'])};
  }
  /**
   * @returns {string}
   */
  get chestIcon() {
    return this._hasChestIcon ? this._chestIcon : JsonToString.default;
  }
  get hasChestIcon() {
    return this._hasChestIcon;
  }
  setChestIcon(path, value) {
    return {type: 'SET', path: path.concat(['chestIcon']), value};
  }
  deleteChestIcon(path) {
    return {type: 'DELETE', path: path.concat(['chestIcon'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get guildLeaderRewards() {
    return this._guildLeaderRewards;
  }
  addGuildLeaderRewards(path, value) {
    return {type: 'ADD', path: path.concat(['guildLeaderRewards']), value: value.toJson()};
  }
  setGuildLeaderRewards(path, value) {
    return {type: 'SET', path: path.concat(['guildLeaderRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setGuildLeaderRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['guildLeaderRewards', key]), value: value.toJson()};
  }
  deleteGuildLeaderRewards(path) {
    return {type: 'DELETE', path: path.concat(['guildLeaderRewards'])};
  }
  deleteGuildLeaderRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['guildLeaderRewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rankFrom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasRankFrom = true;
              copy._rankFrom = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRankFrom) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasRankFrom = false;
              copy._rankFrom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rankTo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasRankTo = true;
              copy._rankTo = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRankTo) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasRankTo = false;
              copy._rankTo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayTier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasDisplayTier = true;
              copy._displayTier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayTier) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasDisplayTier = false;
              copy._displayTier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayTierRank": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasDisplayTierRank = true;
              copy._displayTierRank = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayTierRank) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasDisplayTierRank = false;
              copy._displayTierRank = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasChestIcon = true;
              copy._chestIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestIcon) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._hasChestIcon = false;
              copy._chestIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._rewards = copy._rewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      case "guildLeaderRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._guildLeaderRewards = [];        for (let i of value) {
                copy._guildLeaderRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._guildLeaderRewards = copy._guildLeaderRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._guildLeaderRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._guildLeaderRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._guildLeaderRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._guildLeaderRewards = copy._guildLeaderRewards.slice();
              copy._guildLeaderRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
              copy._guildLeaderRewards = copy._guildLeaderRewards.slice(0, path[1]).concat(copy._guildLeaderRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._guildLeaderRewards.length) {
            return this;
          }
          const oldValue = this._guildLeaderRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
          copy._guildLeaderRewards = copy._guildLeaderRewards.slice();
          copy._guildLeaderRewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig_GuildRewardTier} other
   * @returns {MapEvent_EventGuildConfig_GuildRewardTier}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig_GuildRewardTier(this);
    if (other._hasRankFrom) {
      copy._hasRankFrom = true;
      copy._rankFrom = other._rankFrom;
    }
    if (other._hasRankTo) {
      copy._hasRankTo = true;
      copy._rankTo = other._rankTo;
    }
    if (other._hasDisplayTier) {
      copy._hasDisplayTier = true;
      copy._displayTier = other._displayTier;
    }
    if (other._hasDisplayTierRank) {
      copy._hasDisplayTierRank = true;
      copy._displayTierRank = other._displayTierRank;
    }
    if (other._hasChestIcon) {
      copy._hasChestIcon = true;
      copy._chestIcon = other._chestIcon;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    copy._guildLeaderRewards = this._guildLeaderRewards.concat(other._guildLeaderRewards);
    return copy;
  }
}
MapEvent_EventGuildConfig_GuildRewardTier.default = new MapEvent_EventGuildConfig_GuildRewardTier();
class MapEvent_EventGuildConfig_GuildRewardTier_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig_GuildRewardTier(value);
  }
  build() {
    return new MapEvent_EventGuildConfig_GuildRewardTier(this._value);
  }
  setRankFrom(value) {
    this._value._hasRankFrom = true;
    this._value._rankFrom = value;
    return this;
  }
  deleteRankFrom() {
    this._value._hasRankFrom = false;
    this._value._rankFrom = null;
    return this;
  }
  setRankTo(value) {
    this._value._hasRankTo = true;
    this._value._rankTo = value;
    return this;
  }
  deleteRankTo() {
    this._value._hasRankTo = false;
    this._value._rankTo = null;
    return this;
  }
  setDisplayTier(value) {
    this._value._hasDisplayTier = true;
    this._value._displayTier = value;
    return this;
  }
  deleteDisplayTier() {
    this._value._hasDisplayTier = false;
    this._value._displayTier = null;
    return this;
  }
  setDisplayTierRank(value) {
    this._value._hasDisplayTierRank = true;
    this._value._displayTierRank = value;
    return this;
  }
  deleteDisplayTierRank() {
    this._value._hasDisplayTierRank = false;
    this._value._displayTierRank = null;
    return this;
  }
  setChestIcon(value) {
    this._value._hasChestIcon = true;
    this._value._chestIcon = value;
    return this;
  }
  deleteChestIcon() {
    this._value._hasChestIcon = false;
    this._value._chestIcon = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
  addAllGuildLeaderRewards(values) {
    this._value._guildLeaderRewards = this._value._guildLeaderRewards.concat(values);
    return this;
  }
  addGuildLeaderRewards(value) {
    this._value._guildLeaderRewards = this._value._guildLeaderRewards.concat([value]);
    return this;
  }
  setGuildLeaderRewards(index, value) {
    this._value._guildLeaderRewards = this._value._guildLeaderRewards.concat();
    this._value._guildLeaderRewards[index] = value;
    return this;
  }
  clearGuildLeaderRewards() {
    this._value._guildLeaderRewards = [];
    return this;
  }
}
MapEvent_EventGuildConfig_GuildRewardTier.Builder = MapEvent_EventGuildConfig_GuildRewardTier_Builder;
class MapEvent_EventGuildConfig_GuildRewardTier_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig_GuildRewardTier} value
   * @param {MapEvent_EventGuildConfig_GuildRewardTier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig_GuildRewardTier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRankFrom() {
    if (this._cachedHasRankFrom === undefined) {
      if (this._value.hasRankFrom) {
        this._cachedHasRankFrom = true;
      } else {
        this._cachedHasRankFrom = this._parent ? this._parent.hasRankFrom : false;
      }
    }
    return this._cachedHasRankFrom;
  }
  get rankFrom() {
    if (this._cachedRankFrom === undefined) {
      if (this._value.hasRankFrom) {
        this._cachedRankFrom = this._value.rankFrom;
      } else {
        this._cachedRankFrom = this._parent ? this._parent.rankFrom : this._value.rankFrom;
      }
    }
    return this._cachedRankFrom;
  }
  get hasRankTo() {
    if (this._cachedHasRankTo === undefined) {
      if (this._value.hasRankTo) {
        this._cachedHasRankTo = true;
      } else {
        this._cachedHasRankTo = this._parent ? this._parent.hasRankTo : false;
      }
    }
    return this._cachedHasRankTo;
  }
  get rankTo() {
    if (this._cachedRankTo === undefined) {
      if (this._value.hasRankTo) {
        this._cachedRankTo = this._value.rankTo;
      } else {
        this._cachedRankTo = this._parent ? this._parent.rankTo : this._value.rankTo;
      }
    }
    return this._cachedRankTo;
  }
  get hasDisplayTier() {
    if (this._cachedHasDisplayTier === undefined) {
      if (this._value.hasDisplayTier) {
        this._cachedHasDisplayTier = true;
      } else {
        this._cachedHasDisplayTier = this._parent ? this._parent.hasDisplayTier : false;
      }
    }
    return this._cachedHasDisplayTier;
  }
  get displayTier() {
    if (this._cachedDisplayTier === undefined) {
      if (this._value.hasDisplayTier) {
        this._cachedDisplayTier = this._value.displayTier;
      } else {
        this._cachedDisplayTier = this._parent ? this._parent.displayTier : this._value.displayTier;
      }
    }
    return this._cachedDisplayTier;
  }
  get hasDisplayTierRank() {
    if (this._cachedHasDisplayTierRank === undefined) {
      if (this._value.hasDisplayTierRank) {
        this._cachedHasDisplayTierRank = true;
      } else {
        this._cachedHasDisplayTierRank = this._parent ? this._parent.hasDisplayTierRank : false;
      }
    }
    return this._cachedHasDisplayTierRank;
  }
  get displayTierRank() {
    if (this._cachedDisplayTierRank === undefined) {
      if (this._value.hasDisplayTierRank) {
        this._cachedDisplayTierRank = this._value.displayTierRank;
      } else {
        this._cachedDisplayTierRank = this._parent ? this._parent.displayTierRank : this._value.displayTierRank;
      }
    }
    return this._cachedDisplayTierRank;
  }
  get hasChestIcon() {
    if (this._cachedHasChestIcon === undefined) {
      if (this._value.hasChestIcon) {
        this._cachedHasChestIcon = true;
      } else {
        this._cachedHasChestIcon = this._parent ? this._parent.hasChestIcon : false;
      }
    }
    return this._cachedHasChestIcon;
  }
  get chestIcon() {
    if (this._cachedChestIcon === undefined) {
      if (this._value.hasChestIcon) {
        this._cachedChestIcon = this._value.chestIcon;
      } else {
        this._cachedChestIcon = this._parent ? this._parent.chestIcon : this._value.chestIcon;
      }
    }
    return this._cachedChestIcon;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  get selfGuildLeaderRewards() {
    if (!this._selfGuildLeaderRewards) {
      this._selfGuildLeaderRewards = [];
      for (let i of this._value.guildLeaderRewards) {
        this._selfGuildLeaderRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfGuildLeaderRewards;
  }
  get inherentGuildLeaderRewards() {
    if (!this._inherentGuildLeaderRewards) {
      this._inherentGuildLeaderRewards = this._parent ? this._parent.guildLeaderRewards : [];
    }
    return this._inherentGuildLeaderRewards;
  }
  get guildLeaderRewards() {
    if (!this._allGuildLeaderRewards) {
      this._allGuildLeaderRewards = this._parent ? this._parent.guildLeaderRewards.concat(this.selfGuildLeaderRewards) : this.selfGuildLeaderRewards;
    }
    return this._allGuildLeaderRewards;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_GuildRewardTier_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    if (this._selfGuildLeaderRewards) {
      if (this._value.guildLeaderRewards === current.guildLeaderRewards) {
        result._selfGuildLeaderRewards = this._selfGuildLeaderRewards;
      } else {
        result._selfGuildLeaderRewards = [];
        for (let i = 0; i < current.guildLeaderRewards.length; i++) {
          const oldValue = this._value.guildLeaderRewards[i];
          if (oldValue) {
            const oldCache = this._selfGuildLeaderRewards[i];
            if (oldValue === current.guildLeaderRewards[i]) {
              result._selfGuildLeaderRewards[i] = oldCache;
            } else {
              result._selfGuildLeaderRewards[i] = oldCache.update(current.guildLeaderRewards[i], null);
            }
          } else {
            result._selfGuildLeaderRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.guildLeaderRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_GuildRewardTier_WithParent.default = new MapEvent_EventGuildConfig_GuildRewardTier_WithParent(MapEvent_EventGuildConfig_GuildRewardTier.default, null);
MapEvent_EventGuildConfig_GuildRewardTier.WithParent = MapEvent_EventGuildConfig_GuildRewardTier_WithParent;
class MapEvent_EventGuildConfig_GuildRewardTier_Descriptor {
  get rankFrom() {
    if (!this._rankFrom) {
      this._rankFrom = {
        name: "rankFrom",
        Name: "RankFrom",
        number: 1,
        protoType: 5,
        protoName: "rank_from",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankFrom;
  }
  get rankTo() {
    if (!this._rankTo) {
      this._rankTo = {
        name: "rankTo",
        Name: "RankTo",
        number: 2,
        protoType: 5,
        protoName: "rank_to",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankTo;
  }
  get displayTier() {
    if (!this._displayTier) {
      this._displayTier = {
        name: "displayTier",
        Name: "DisplayTier",
        number: 3,
        protoType: 9,
        protoName: "display_tier",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayTier;
  }
  get displayTierRank() {
    if (!this._displayTierRank) {
      this._displayTierRank = {
        name: "displayTierRank",
        Name: "DisplayTierRank",
        number: 4,
        protoType: 9,
        protoName: "display_tier_rank",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayTierRank;
  }
  get chestIcon() {
    if (!this._chestIcon) {
      this._chestIcon = {
        name: "chestIcon",
        Name: "ChestIcon",
        number: 6,
        protoType: 9,
        protoName: "chest_icon",
        type: JsonToString,
        options: {
          valueDropdown: "GuildChestIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestIcon;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 5,
        protoType: 11,
        protoName: "rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get guildLeaderRewards() {
    if (!this._guildLeaderRewards) {
      this._guildLeaderRewards = {
        name: "guildLeaderRewards",
        Name: "GuildLeaderRewards",
        number: 7,
        protoType: 11,
        protoName: "guild_leader_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildLeaderRewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rankFrom,
        this.rankTo,
        this.displayTier,
        this.displayTierRank,
        this.chestIcon,
        this.rewards,
        this.guildLeaderRewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRankFrom",
        Name: "DummyOneofForRankFrom",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRankTo",
        Name: "DummyOneofForRankTo",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayTier",
        Name: "DummyOneofForDisplayTier",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayTierRank",
        Name: "DummyOneofForDisplayTierRank",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestIcon",
        Name: "DummyOneofForChestIcon",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig_GuildRewardTier.descriptor = new MapEvent_EventGuildConfig_GuildRewardTier_Descriptor();
class MapEvent_EventGuildConfig_BossDamageRankRewardTire {
  get descriptor() {
    return MapEvent_EventGuildConfig_BossDamageRankRewardTire.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRankFrom = false;
    this._rankFrom = null;
    this._hasRankTo = false;
    this._rankTo = null;
    this._rewards = [];
  }
  isEmpty() {
    if (this._hasRankFrom) return false;
    if (this._hasRankTo) return false;
    if (this._rewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig_BossDamageRankRewardTire) {
      return value;
    }
    return MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig_BossDamageRankRewardTire();
    if (json.rankFrom != null) {
      result._hasRankFrom = true;
      result._rankFrom = JsonToInt32.fromJson(json.rankFrom);
    }
    if (json.rankTo != null) {
      result._hasRankTo = true;
      result._rankTo = JsonToInt32.fromJson(json.rankTo);
    }
    result._rewards = JsonToList(json.rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRankFrom) {
      result.rankFrom = JsonToInt32.toJson(this._rankFrom);
    }
    if (this._hasRankTo) {
      result.rankTo = JsonToInt32.toJson(this._rankTo);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get rankFrom() {
    return this._hasRankFrom ? this._rankFrom : JsonToInt32.default;
  }
  get hasRankFrom() {
    return this._hasRankFrom;
  }
  setRankFrom(path, value) {
    return {type: 'SET', path: path.concat(['rankFrom']), value};
  }
  deleteRankFrom(path) {
    return {type: 'DELETE', path: path.concat(['rankFrom'])};
  }
  /**
   * @returns {number}
   */
  get rankTo() {
    return this._hasRankTo ? this._rankTo : JsonToInt32.default;
  }
  get hasRankTo() {
    return this._hasRankTo;
  }
  setRankTo(path, value) {
    return {type: 'SET', path: path.concat(['rankTo']), value};
  }
  deleteRankTo(path) {
    return {type: 'DELETE', path: path.concat(['rankTo'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rankFrom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._hasRankFrom = true;
              copy._rankFrom = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRankFrom) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._hasRankFrom = false;
              copy._rankFrom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rankTo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._hasRankTo = true;
              copy._rankTo = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRankTo) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._hasRankTo = false;
              copy._rankTo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._rewards = copy._rewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig_BossDamageRankRewardTire} other
   * @returns {MapEvent_EventGuildConfig_BossDamageRankRewardTire}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this);
    if (other._hasRankFrom) {
      copy._hasRankFrom = true;
      copy._rankFrom = other._rankFrom;
    }
    if (other._hasRankTo) {
      copy._hasRankTo = true;
      copy._rankTo = other._rankTo;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    return copy;
  }
}
MapEvent_EventGuildConfig_BossDamageRankRewardTire.default = new MapEvent_EventGuildConfig_BossDamageRankRewardTire();
class MapEvent_EventGuildConfig_BossDamageRankRewardTire_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig_BossDamageRankRewardTire(value);
  }
  build() {
    return new MapEvent_EventGuildConfig_BossDamageRankRewardTire(this._value);
  }
  setRankFrom(value) {
    this._value._hasRankFrom = true;
    this._value._rankFrom = value;
    return this;
  }
  deleteRankFrom() {
    this._value._hasRankFrom = false;
    this._value._rankFrom = null;
    return this;
  }
  setRankTo(value) {
    this._value._hasRankTo = true;
    this._value._rankTo = value;
    return this;
  }
  deleteRankTo() {
    this._value._hasRankTo = false;
    this._value._rankTo = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
}
MapEvent_EventGuildConfig_BossDamageRankRewardTire.Builder = MapEvent_EventGuildConfig_BossDamageRankRewardTire_Builder;
class MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig_BossDamageRankRewardTire} value
   * @param {MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig_BossDamageRankRewardTire.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRankFrom() {
    if (this._cachedHasRankFrom === undefined) {
      if (this._value.hasRankFrom) {
        this._cachedHasRankFrom = true;
      } else {
        this._cachedHasRankFrom = this._parent ? this._parent.hasRankFrom : false;
      }
    }
    return this._cachedHasRankFrom;
  }
  get rankFrom() {
    if (this._cachedRankFrom === undefined) {
      if (this._value.hasRankFrom) {
        this._cachedRankFrom = this._value.rankFrom;
      } else {
        this._cachedRankFrom = this._parent ? this._parent.rankFrom : this._value.rankFrom;
      }
    }
    return this._cachedRankFrom;
  }
  get hasRankTo() {
    if (this._cachedHasRankTo === undefined) {
      if (this._value.hasRankTo) {
        this._cachedHasRankTo = true;
      } else {
        this._cachedHasRankTo = this._parent ? this._parent.hasRankTo : false;
      }
    }
    return this._cachedHasRankTo;
  }
  get rankTo() {
    if (this._cachedRankTo === undefined) {
      if (this._value.hasRankTo) {
        this._cachedRankTo = this._value.rankTo;
      } else {
        this._cachedRankTo = this._parent ? this._parent.rankTo : this._value.rankTo;
      }
    }
    return this._cachedRankTo;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent.default = new MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent(MapEvent_EventGuildConfig_BossDamageRankRewardTire.default, null);
MapEvent_EventGuildConfig_BossDamageRankRewardTire.WithParent = MapEvent_EventGuildConfig_BossDamageRankRewardTire_WithParent;
class MapEvent_EventGuildConfig_BossDamageRankRewardTire_Descriptor {
  get rankFrom() {
    if (!this._rankFrom) {
      this._rankFrom = {
        name: "rankFrom",
        Name: "RankFrom",
        number: 1,
        protoType: 5,
        protoName: "rank_from",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankFrom;
  }
  get rankTo() {
    if (!this._rankTo) {
      this._rankTo = {
        name: "rankTo",
        Name: "RankTo",
        number: 2,
        protoType: 5,
        protoName: "rank_to",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankTo;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 3,
        protoType: 11,
        protoName: "rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rankFrom,
        this.rankTo,
        this.rewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRankFrom",
        Name: "DummyOneofForRankFrom",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRankTo",
        Name: "DummyOneofForRankTo",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig_BossDamageRankRewardTire.descriptor = new MapEvent_EventGuildConfig_BossDamageRankRewardTire_Descriptor();
class MapEvent_EventGuildConfig_BossDamageRewardTire {
  get descriptor() {
    return MapEvent_EventGuildConfig_BossDamageRewardTire.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGuildRankFrom = false;
    this._guildRankFrom = null;
    this._hasGuildRankTo = false;
    this._guildRankTo = null;
    this._bossDamageRankRewards = [];
  }
  isEmpty() {
    if (this._hasGuildRankFrom) return false;
    if (this._hasGuildRankTo) return false;
    if (this._bossDamageRankRewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig_BossDamageRewardTire) {
      return value;
    }
    return MapEvent_EventGuildConfig_BossDamageRewardTire.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig_BossDamageRewardTire();
    if (json.guildRankFrom != null) {
      result._hasGuildRankFrom = true;
      result._guildRankFrom = JsonToInt32.fromJson(json.guildRankFrom);
    }
    if (json.guildRankTo != null) {
      result._hasGuildRankTo = true;
      result._guildRankTo = JsonToInt32.fromJson(json.guildRankTo);
    }
    result._bossDamageRankRewards = JsonToList(json.bossDamageRankRewards, MapEvent_EventGuildConfig_BossDamageRankRewardTire);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGuildRankFrom) {
      result.guildRankFrom = JsonToInt32.toJson(this._guildRankFrom);
    }
    if (this._hasGuildRankTo) {
      result.guildRankTo = JsonToInt32.toJson(this._guildRankTo);
    }
    if (this._bossDamageRankRewards.length > 0) {
      result.bossDamageRankRewards = ArrayToJson(this._bossDamageRankRewards, MapEvent_EventGuildConfig_BossDamageRankRewardTire);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get guildRankFrom() {
    return this._hasGuildRankFrom ? this._guildRankFrom : JsonToInt32.default;
  }
  get hasGuildRankFrom() {
    return this._hasGuildRankFrom;
  }
  setGuildRankFrom(path, value) {
    return {type: 'SET', path: path.concat(['guildRankFrom']), value};
  }
  deleteGuildRankFrom(path) {
    return {type: 'DELETE', path: path.concat(['guildRankFrom'])};
  }
  /**
   * @returns {number}
   */
  get guildRankTo() {
    return this._hasGuildRankTo ? this._guildRankTo : JsonToInt32.default;
  }
  get hasGuildRankTo() {
    return this._hasGuildRankTo;
  }
  setGuildRankTo(path, value) {
    return {type: 'SET', path: path.concat(['guildRankTo']), value};
  }
  deleteGuildRankTo(path) {
    return {type: 'DELETE', path: path.concat(['guildRankTo'])};
  }
  /**
   * @returns {MapEvent_EventGuildConfig_BossDamageRankRewardTire[]}
   */
  get bossDamageRankRewards() {
    return this._bossDamageRankRewards;
  }
  addBossDamageRankRewards(path, value) {
    return {type: 'ADD', path: path.concat(['bossDamageRankRewards']), value: value.toJson()};
  }
  setBossDamageRankRewards(path, value) {
    return {type: 'SET', path: path.concat(['bossDamageRankRewards']), value: ArrayToJson(value, MapEvent_EventGuildConfig_BossDamageRankRewardTire)};
  }
  setBossDamageRankRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bossDamageRankRewards', key]), value: value.toJson()};
  }
  deleteBossDamageRankRewards(path) {
    return {type: 'DELETE', path: path.concat(['bossDamageRankRewards'])};
  }
  deleteBossDamageRankRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bossDamageRankRewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "guildRankFrom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._hasGuildRankFrom = true;
              copy._guildRankFrom = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildRankFrom) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._hasGuildRankFrom = false;
              copy._guildRankFrom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildRankTo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._hasGuildRankTo = true;
              copy._guildRankTo = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildRankTo) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._hasGuildRankTo = false;
              copy._guildRankTo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bossDamageRankRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._bossDamageRankRewards = [];        for (let i of value) {
                copy._bossDamageRankRewards.push(MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.concat([MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bossDamageRankRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._bossDamageRankRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRankRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice();
              copy._bossDamageRankRewards[path[1]] = MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice(0, path[1]).concat(copy._bossDamageRankRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRankRewards.length) {
            return this;
          }
          const oldValue = this._bossDamageRankRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
          copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice();
          copy._bossDamageRankRewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig_BossDamageRewardTire} other
   * @returns {MapEvent_EventGuildConfig_BossDamageRewardTire}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig_BossDamageRewardTire(this);
    if (other._hasGuildRankFrom) {
      copy._hasGuildRankFrom = true;
      copy._guildRankFrom = other._guildRankFrom;
    }
    if (other._hasGuildRankTo) {
      copy._hasGuildRankTo = true;
      copy._guildRankTo = other._guildRankTo;
    }
    copy._bossDamageRankRewards = this._bossDamageRankRewards.concat(other._bossDamageRankRewards);
    return copy;
  }
}
MapEvent_EventGuildConfig_BossDamageRewardTire.default = new MapEvent_EventGuildConfig_BossDamageRewardTire();
class MapEvent_EventGuildConfig_BossDamageRewardTire_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig_BossDamageRewardTire(value);
  }
  build() {
    return new MapEvent_EventGuildConfig_BossDamageRewardTire(this._value);
  }
  setGuildRankFrom(value) {
    this._value._hasGuildRankFrom = true;
    this._value._guildRankFrom = value;
    return this;
  }
  deleteGuildRankFrom() {
    this._value._hasGuildRankFrom = false;
    this._value._guildRankFrom = null;
    return this;
  }
  setGuildRankTo(value) {
    this._value._hasGuildRankTo = true;
    this._value._guildRankTo = value;
    return this;
  }
  deleteGuildRankTo() {
    this._value._hasGuildRankTo = false;
    this._value._guildRankTo = null;
    return this;
  }
  addAllBossDamageRankRewards(values) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat(values);
    return this;
  }
  addBossDamageRankRewards(value) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat([value]);
    return this;
  }
  setBossDamageRankRewards(index, value) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat();
    this._value._bossDamageRankRewards[index] = value;
    return this;
  }
  clearBossDamageRankRewards() {
    this._value._bossDamageRankRewards = [];
    return this;
  }
}
MapEvent_EventGuildConfig_BossDamageRewardTire.Builder = MapEvent_EventGuildConfig_BossDamageRewardTire_Builder;
class MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig_BossDamageRewardTire} value
   * @param {MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig_BossDamageRewardTire.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGuildRankFrom() {
    if (this._cachedHasGuildRankFrom === undefined) {
      if (this._value.hasGuildRankFrom) {
        this._cachedHasGuildRankFrom = true;
      } else {
        this._cachedHasGuildRankFrom = this._parent ? this._parent.hasGuildRankFrom : false;
      }
    }
    return this._cachedHasGuildRankFrom;
  }
  get guildRankFrom() {
    if (this._cachedGuildRankFrom === undefined) {
      if (this._value.hasGuildRankFrom) {
        this._cachedGuildRankFrom = this._value.guildRankFrom;
      } else {
        this._cachedGuildRankFrom = this._parent ? this._parent.guildRankFrom : this._value.guildRankFrom;
      }
    }
    return this._cachedGuildRankFrom;
  }
  get hasGuildRankTo() {
    if (this._cachedHasGuildRankTo === undefined) {
      if (this._value.hasGuildRankTo) {
        this._cachedHasGuildRankTo = true;
      } else {
        this._cachedHasGuildRankTo = this._parent ? this._parent.hasGuildRankTo : false;
      }
    }
    return this._cachedHasGuildRankTo;
  }
  get guildRankTo() {
    if (this._cachedGuildRankTo === undefined) {
      if (this._value.hasGuildRankTo) {
        this._cachedGuildRankTo = this._value.guildRankTo;
      } else {
        this._cachedGuildRankTo = this._parent ? this._parent.guildRankTo : this._value.guildRankTo;
      }
    }
    return this._cachedGuildRankTo;
  }
  get selfBossDamageRankRewards() {
    if (!this._selfBossDamageRankRewards) {
      this._selfBossDamageRankRewards = [];
      for (let i of this._value.bossDamageRankRewards) {
        this._selfBossDamageRankRewards.push(new MapEvent_EventGuildConfig_BossDamageRankRewardTire.WithParent(i, null));
      }
    }
    return this._selfBossDamageRankRewards;
  }
  get inherentBossDamageRankRewards() {
    if (!this._inherentBossDamageRankRewards) {
      this._inherentBossDamageRankRewards = this._parent ? this._parent.bossDamageRankRewards : [];
    }
    return this._inherentBossDamageRankRewards;
  }
  get bossDamageRankRewards() {
    if (!this._allBossDamageRankRewards) {
      this._allBossDamageRankRewards = this._parent ? this._parent.bossDamageRankRewards.concat(this.selfBossDamageRankRewards) : this.selfBossDamageRankRewards;
    }
    return this._allBossDamageRankRewards;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent(current, parent);
    if (this._selfBossDamageRankRewards) {
      if (this._value.bossDamageRankRewards === current.bossDamageRankRewards) {
        result._selfBossDamageRankRewards = this._selfBossDamageRankRewards;
      } else {
        result._selfBossDamageRankRewards = [];
        for (let i = 0; i < current.bossDamageRankRewards.length; i++) {
          const oldValue = this._value.bossDamageRankRewards[i];
          if (oldValue) {
            const oldCache = this._selfBossDamageRankRewards[i];
            if (oldValue === current.bossDamageRankRewards[i]) {
              result._selfBossDamageRankRewards[i] = oldCache;
            } else {
              result._selfBossDamageRankRewards[i] = oldCache.update(current.bossDamageRankRewards[i], null);
            }
          } else {
            result._selfBossDamageRankRewards[i] = new MapEvent_EventGuildConfig_BossDamageRankRewardTire.WithParent(current.bossDamageRankRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent.default = new MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent(MapEvent_EventGuildConfig_BossDamageRewardTire.default, null);
MapEvent_EventGuildConfig_BossDamageRewardTire.WithParent = MapEvent_EventGuildConfig_BossDamageRewardTire_WithParent;
class MapEvent_EventGuildConfig_BossDamageRewardTire_Descriptor {
  get guildRankFrom() {
    if (!this._guildRankFrom) {
      this._guildRankFrom = {
        name: "guildRankFrom",
        Name: "GuildRankFrom",
        number: 1,
        protoType: 5,
        protoName: "guild_rank_from",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildRankFrom;
  }
  get guildRankTo() {
    if (!this._guildRankTo) {
      this._guildRankTo = {
        name: "guildRankTo",
        Name: "GuildRankTo",
        number: 2,
        protoType: 5,
        protoName: "guild_rank_to",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildRankTo;
  }
  get bossDamageRankRewards() {
    if (!this._bossDamageRankRewards) {
      this._bossDamageRankRewards = {
        name: "bossDamageRankRewards",
        Name: "BossDamageRankRewards",
        number: 3,
        protoType: 11,
        protoName: "boss_damage_rank_rewards",
        type: MapEvent_EventGuildConfig_BossDamageRankRewardTire,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossDamageRankRewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.guildRankFrom,
        this.guildRankTo,
        this.bossDamageRankRewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGuildRankFrom",
        Name: "DummyOneofForGuildRankFrom",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildRankTo",
        Name: "DummyOneofForGuildRankTo",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig_BossDamageRewardTire.descriptor = new MapEvent_EventGuildConfig_BossDamageRewardTire_Descriptor();
class MapEvent_EventGuildConfig_LeagueTier {
  get descriptor() {
    return MapEvent_EventGuildConfig_LeagueTier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rankRewardTiers = [];
    this._bossDamageRankRewards = [];
    this._bossDamageRewards = [];
    this._hasGroupSize = false;
    this._groupSize = null;
    this._hasPromotionCount = false;
    this._promotionCount = null;
    this._hasDemotionCount = false;
    this._demotionCount = null;
    this._hasDemotionIndex = false;
    this._demotionIndex = null;
    this._hasMaxGroupSize = false;
    this._maxGroupSize = null;
  }
  isEmpty() {
    if (this._rankRewardTiers.length > 0) return false;
    if (this._bossDamageRankRewards.length > 0) return false;
    if (this._bossDamageRewards.length > 0) return false;
    if (this._hasGroupSize) return false;
    if (this._hasPromotionCount) return false;
    if (this._hasDemotionCount) return false;
    if (this._hasDemotionIndex) return false;
    if (this._hasMaxGroupSize) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig_LeagueTier) {
      return value;
    }
    return MapEvent_EventGuildConfig_LeagueTier.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig_LeagueTier();
    result._rankRewardTiers = JsonToList(json.rankRewardTiers, MapEvent_EventGuildConfig_GuildRewardTier);
    result._bossDamageRankRewards = JsonToList(json.bossDamageRankRewards, MapEvent_EventGuildConfig_BossDamageRankRewardTire);
    result._bossDamageRewards = JsonToList(json.bossDamageRewards, MapEvent_EventGuildConfig_BossDamageRewardTire);
    if (json.groupSize != null) {
      result._hasGroupSize = true;
      result._groupSize = JsonToInt32.fromJson(json.groupSize);
    }
    if (json.promotionCount != null) {
      result._hasPromotionCount = true;
      result._promotionCount = JsonToInt32.fromJson(json.promotionCount);
    }
    if (json.demotionCount != null) {
      result._hasDemotionCount = true;
      result._demotionCount = JsonToInt32.fromJson(json.demotionCount);
    }
    if (json.demotionIndex != null) {
      result._hasDemotionIndex = true;
      result._demotionIndex = JsonToInt32.fromJson(json.demotionIndex);
    }
    if (json.maxGroupSize != null) {
      result._hasMaxGroupSize = true;
      result._maxGroupSize = JsonToInt32.fromJson(json.maxGroupSize);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rankRewardTiers.length > 0) {
      result.rankRewardTiers = ArrayToJson(this._rankRewardTiers, MapEvent_EventGuildConfig_GuildRewardTier);
    }
    if (this._bossDamageRankRewards.length > 0) {
      result.bossDamageRankRewards = ArrayToJson(this._bossDamageRankRewards, MapEvent_EventGuildConfig_BossDamageRankRewardTire);
    }
    if (this._bossDamageRewards.length > 0) {
      result.bossDamageRewards = ArrayToJson(this._bossDamageRewards, MapEvent_EventGuildConfig_BossDamageRewardTire);
    }
    if (this._hasGroupSize) {
      result.groupSize = JsonToInt32.toJson(this._groupSize);
    }
    if (this._hasPromotionCount) {
      result.promotionCount = JsonToInt32.toJson(this._promotionCount);
    }
    if (this._hasDemotionCount) {
      result.demotionCount = JsonToInt32.toJson(this._demotionCount);
    }
    if (this._hasDemotionIndex) {
      result.demotionIndex = JsonToInt32.toJson(this._demotionIndex);
    }
    if (this._hasMaxGroupSize) {
      result.maxGroupSize = JsonToInt32.toJson(this._maxGroupSize);
    }
    return result;
  }
  /**
   * @returns {MapEvent_EventGuildConfig_GuildRewardTier[]}
   */
  get rankRewardTiers() {
    return this._rankRewardTiers;
  }
  addRankRewardTiers(path, value) {
    return {type: 'ADD', path: path.concat(['rankRewardTiers']), value: value.toJson()};
  }
  setRankRewardTiers(path, value) {
    return {type: 'SET', path: path.concat(['rankRewardTiers']), value: ArrayToJson(value, MapEvent_EventGuildConfig_GuildRewardTier)};
  }
  setRankRewardTiersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rankRewardTiers', key]), value: value.toJson()};
  }
  deleteRankRewardTiers(path) {
    return {type: 'DELETE', path: path.concat(['rankRewardTiers'])};
  }
  deleteRankRewardTiersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rankRewardTiers', key])};
  }
  /**
   * @returns {MapEvent_EventGuildConfig_BossDamageRankRewardTire[]}
   */
  get bossDamageRankRewards() {
    return this._bossDamageRankRewards;
  }
  addBossDamageRankRewards(path, value) {
    return {type: 'ADD', path: path.concat(['bossDamageRankRewards']), value: value.toJson()};
  }
  setBossDamageRankRewards(path, value) {
    return {type: 'SET', path: path.concat(['bossDamageRankRewards']), value: ArrayToJson(value, MapEvent_EventGuildConfig_BossDamageRankRewardTire)};
  }
  setBossDamageRankRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bossDamageRankRewards', key]), value: value.toJson()};
  }
  deleteBossDamageRankRewards(path) {
    return {type: 'DELETE', path: path.concat(['bossDamageRankRewards'])};
  }
  deleteBossDamageRankRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bossDamageRankRewards', key])};
  }
  /**
   * @returns {MapEvent_EventGuildConfig_BossDamageRewardTire[]}
   */
  get bossDamageRewards() {
    return this._bossDamageRewards;
  }
  addBossDamageRewards(path, value) {
    return {type: 'ADD', path: path.concat(['bossDamageRewards']), value: value.toJson()};
  }
  setBossDamageRewards(path, value) {
    return {type: 'SET', path: path.concat(['bossDamageRewards']), value: ArrayToJson(value, MapEvent_EventGuildConfig_BossDamageRewardTire)};
  }
  setBossDamageRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bossDamageRewards', key]), value: value.toJson()};
  }
  deleteBossDamageRewards(path) {
    return {type: 'DELETE', path: path.concat(['bossDamageRewards'])};
  }
  deleteBossDamageRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bossDamageRewards', key])};
  }
  /**
   * @returns {number}
   */
  get groupSize() {
    return this._hasGroupSize ? this._groupSize : JsonToInt32.default;
  }
  get hasGroupSize() {
    return this._hasGroupSize;
  }
  setGroupSize(path, value) {
    return {type: 'SET', path: path.concat(['groupSize']), value};
  }
  deleteGroupSize(path) {
    return {type: 'DELETE', path: path.concat(['groupSize'])};
  }
  /**
   * @returns {number}
   */
  get promotionCount() {
    return this._hasPromotionCount ? this._promotionCount : JsonToInt32.default;
  }
  get hasPromotionCount() {
    return this._hasPromotionCount;
  }
  setPromotionCount(path, value) {
    return {type: 'SET', path: path.concat(['promotionCount']), value};
  }
  deletePromotionCount(path) {
    return {type: 'DELETE', path: path.concat(['promotionCount'])};
  }
  /**
   * @returns {number}
   */
  get demotionCount() {
    return this._hasDemotionCount ? this._demotionCount : JsonToInt32.default;
  }
  get hasDemotionCount() {
    return this._hasDemotionCount;
  }
  setDemotionCount(path, value) {
    return {type: 'SET', path: path.concat(['demotionCount']), value};
  }
  deleteDemotionCount(path) {
    return {type: 'DELETE', path: path.concat(['demotionCount'])};
  }
  /**
   * @returns {number}
   */
  get demotionIndex() {
    return this._hasDemotionIndex ? this._demotionIndex : JsonToInt32.default;
  }
  get hasDemotionIndex() {
    return this._hasDemotionIndex;
  }
  setDemotionIndex(path, value) {
    return {type: 'SET', path: path.concat(['demotionIndex']), value};
  }
  deleteDemotionIndex(path) {
    return {type: 'DELETE', path: path.concat(['demotionIndex'])};
  }
  /**
   * @returns {number}
   */
  get maxGroupSize() {
    return this._hasMaxGroupSize ? this._maxGroupSize : JsonToInt32.default;
  }
  get hasMaxGroupSize() {
    return this._hasMaxGroupSize;
  }
  setMaxGroupSize(path, value) {
    return {type: 'SET', path: path.concat(['maxGroupSize']), value};
  }
  deleteMaxGroupSize(path) {
    return {type: 'DELETE', path: path.concat(['maxGroupSize'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rankRewardTiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._rankRewardTiers = [];        for (let i of value) {
                copy._rankRewardTiers.push(MapEvent_EventGuildConfig_GuildRewardTier.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._rankRewardTiers = copy._rankRewardTiers.concat([MapEvent_EventGuildConfig_GuildRewardTier.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rankRewardTiers.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._rankRewardTiers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rankRewardTiers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._rankRewardTiers = copy._rankRewardTiers.slice();
              copy._rankRewardTiers[path[1]] = MapEvent_EventGuildConfig_GuildRewardTier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._rankRewardTiers = copy._rankRewardTiers.slice(0, path[1]).concat(copy._rankRewardTiers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rankRewardTiers.length) {
            return this;
          }
          const oldValue = this._rankRewardTiers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
          copy._rankRewardTiers = copy._rankRewardTiers.slice();
          copy._rankRewardTiers[key] = newValue;
          return copy;
        }
      }
      case "bossDamageRankRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRankRewards = [];        for (let i of value) {
                copy._bossDamageRankRewards.push(MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.concat([MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bossDamageRankRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRankRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRankRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice();
              copy._bossDamageRankRewards[path[1]] = MapEvent_EventGuildConfig_BossDamageRankRewardTire.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice(0, path[1]).concat(copy._bossDamageRankRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRankRewards.length) {
            return this;
          }
          const oldValue = this._bossDamageRankRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
          copy._bossDamageRankRewards = copy._bossDamageRankRewards.slice();
          copy._bossDamageRankRewards[key] = newValue;
          return copy;
        }
      }
      case "bossDamageRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRewards = [];        for (let i of value) {
                copy._bossDamageRewards.push(MapEvent_EventGuildConfig_BossDamageRewardTire.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRewards = copy._bossDamageRewards.concat([MapEvent_EventGuildConfig_BossDamageRewardTire.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bossDamageRewards.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRewards = copy._bossDamageRewards.slice();
              copy._bossDamageRewards[path[1]] = MapEvent_EventGuildConfig_BossDamageRewardTire.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._bossDamageRewards = copy._bossDamageRewards.slice(0, path[1]).concat(copy._bossDamageRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bossDamageRewards.length) {
            return this;
          }
          const oldValue = this._bossDamageRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
          copy._bossDamageRewards = copy._bossDamageRewards.slice();
          copy._bossDamageRewards[key] = newValue;
          return copy;
        }
      }
      case "groupSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasGroupSize = true;
              copy._groupSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupSize) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasGroupSize = false;
              copy._groupSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "promotionCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasPromotionCount = true;
              copy._promotionCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPromotionCount) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasPromotionCount = false;
              copy._promotionCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "demotionCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasDemotionCount = true;
              copy._demotionCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDemotionCount) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasDemotionCount = false;
              copy._demotionCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "demotionIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasDemotionIndex = true;
              copy._demotionIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDemotionIndex) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasDemotionIndex = false;
              copy._demotionIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxGroupSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasMaxGroupSize = true;
              copy._maxGroupSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxGroupSize) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
              copy._hasMaxGroupSize = false;
              copy._maxGroupSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig_LeagueTier} other
   * @returns {MapEvent_EventGuildConfig_LeagueTier}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig_LeagueTier(this);
    copy._rankRewardTiers = this._rankRewardTiers.concat(other._rankRewardTiers);
    copy._bossDamageRankRewards = this._bossDamageRankRewards.concat(other._bossDamageRankRewards);
    copy._bossDamageRewards = this._bossDamageRewards.concat(other._bossDamageRewards);
    if (other._hasGroupSize) {
      copy._hasGroupSize = true;
      copy._groupSize = other._groupSize;
    }
    if (other._hasPromotionCount) {
      copy._hasPromotionCount = true;
      copy._promotionCount = other._promotionCount;
    }
    if (other._hasDemotionCount) {
      copy._hasDemotionCount = true;
      copy._demotionCount = other._demotionCount;
    }
    if (other._hasDemotionIndex) {
      copy._hasDemotionIndex = true;
      copy._demotionIndex = other._demotionIndex;
    }
    if (other._hasMaxGroupSize) {
      copy._hasMaxGroupSize = true;
      copy._maxGroupSize = other._maxGroupSize;
    }
    return copy;
  }
}
MapEvent_EventGuildConfig_LeagueTier.default = new MapEvent_EventGuildConfig_LeagueTier();
class MapEvent_EventGuildConfig_LeagueTier_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig_LeagueTier(value);
  }
  build() {
    return new MapEvent_EventGuildConfig_LeagueTier(this._value);
  }
  addAllRankRewardTiers(values) {
    this._value._rankRewardTiers = this._value._rankRewardTiers.concat(values);
    return this;
  }
  addRankRewardTiers(value) {
    this._value._rankRewardTiers = this._value._rankRewardTiers.concat([value]);
    return this;
  }
  setRankRewardTiers(index, value) {
    this._value._rankRewardTiers = this._value._rankRewardTiers.concat();
    this._value._rankRewardTiers[index] = value;
    return this;
  }
  clearRankRewardTiers() {
    this._value._rankRewardTiers = [];
    return this;
  }
  addAllBossDamageRankRewards(values) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat(values);
    return this;
  }
  addBossDamageRankRewards(value) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat([value]);
    return this;
  }
  setBossDamageRankRewards(index, value) {
    this._value._bossDamageRankRewards = this._value._bossDamageRankRewards.concat();
    this._value._bossDamageRankRewards[index] = value;
    return this;
  }
  clearBossDamageRankRewards() {
    this._value._bossDamageRankRewards = [];
    return this;
  }
  addAllBossDamageRewards(values) {
    this._value._bossDamageRewards = this._value._bossDamageRewards.concat(values);
    return this;
  }
  addBossDamageRewards(value) {
    this._value._bossDamageRewards = this._value._bossDamageRewards.concat([value]);
    return this;
  }
  setBossDamageRewards(index, value) {
    this._value._bossDamageRewards = this._value._bossDamageRewards.concat();
    this._value._bossDamageRewards[index] = value;
    return this;
  }
  clearBossDamageRewards() {
    this._value._bossDamageRewards = [];
    return this;
  }
  setGroupSize(value) {
    this._value._hasGroupSize = true;
    this._value._groupSize = value;
    return this;
  }
  deleteGroupSize() {
    this._value._hasGroupSize = false;
    this._value._groupSize = null;
    return this;
  }
  setPromotionCount(value) {
    this._value._hasPromotionCount = true;
    this._value._promotionCount = value;
    return this;
  }
  deletePromotionCount() {
    this._value._hasPromotionCount = false;
    this._value._promotionCount = null;
    return this;
  }
  setDemotionCount(value) {
    this._value._hasDemotionCount = true;
    this._value._demotionCount = value;
    return this;
  }
  deleteDemotionCount() {
    this._value._hasDemotionCount = false;
    this._value._demotionCount = null;
    return this;
  }
  setDemotionIndex(value) {
    this._value._hasDemotionIndex = true;
    this._value._demotionIndex = value;
    return this;
  }
  deleteDemotionIndex() {
    this._value._hasDemotionIndex = false;
    this._value._demotionIndex = null;
    return this;
  }
  setMaxGroupSize(value) {
    this._value._hasMaxGroupSize = true;
    this._value._maxGroupSize = value;
    return this;
  }
  deleteMaxGroupSize() {
    this._value._hasMaxGroupSize = false;
    this._value._maxGroupSize = null;
    return this;
  }
}
MapEvent_EventGuildConfig_LeagueTier.Builder = MapEvent_EventGuildConfig_LeagueTier_Builder;
class MapEvent_EventGuildConfig_LeagueTier_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig_LeagueTier} value
   * @param {MapEvent_EventGuildConfig_LeagueTier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig_LeagueTier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRankRewardTiers() {
    if (!this._selfRankRewardTiers) {
      this._selfRankRewardTiers = [];
      for (let i of this._value.rankRewardTiers) {
        this._selfRankRewardTiers.push(new MapEvent_EventGuildConfig_GuildRewardTier.WithParent(i, null));
      }
    }
    return this._selfRankRewardTiers;
  }
  get inherentRankRewardTiers() {
    if (!this._inherentRankRewardTiers) {
      this._inherentRankRewardTiers = this._parent ? this._parent.rankRewardTiers : [];
    }
    return this._inherentRankRewardTiers;
  }
  get rankRewardTiers() {
    if (!this._allRankRewardTiers) {
      this._allRankRewardTiers = this._parent ? this._parent.rankRewardTiers.concat(this.selfRankRewardTiers) : this.selfRankRewardTiers;
    }
    return this._allRankRewardTiers;
  }
  get selfBossDamageRankRewards() {
    if (!this._selfBossDamageRankRewards) {
      this._selfBossDamageRankRewards = [];
      for (let i of this._value.bossDamageRankRewards) {
        this._selfBossDamageRankRewards.push(new MapEvent_EventGuildConfig_BossDamageRankRewardTire.WithParent(i, null));
      }
    }
    return this._selfBossDamageRankRewards;
  }
  get inherentBossDamageRankRewards() {
    if (!this._inherentBossDamageRankRewards) {
      this._inherentBossDamageRankRewards = this._parent ? this._parent.bossDamageRankRewards : [];
    }
    return this._inherentBossDamageRankRewards;
  }
  get bossDamageRankRewards() {
    if (!this._allBossDamageRankRewards) {
      this._allBossDamageRankRewards = this._parent ? this._parent.bossDamageRankRewards.concat(this.selfBossDamageRankRewards) : this.selfBossDamageRankRewards;
    }
    return this._allBossDamageRankRewards;
  }
  get selfBossDamageRewards() {
    if (!this._selfBossDamageRewards) {
      this._selfBossDamageRewards = [];
      for (let i of this._value.bossDamageRewards) {
        this._selfBossDamageRewards.push(new MapEvent_EventGuildConfig_BossDamageRewardTire.WithParent(i, null));
      }
    }
    return this._selfBossDamageRewards;
  }
  get inherentBossDamageRewards() {
    if (!this._inherentBossDamageRewards) {
      this._inherentBossDamageRewards = this._parent ? this._parent.bossDamageRewards : [];
    }
    return this._inherentBossDamageRewards;
  }
  get bossDamageRewards() {
    if (!this._allBossDamageRewards) {
      this._allBossDamageRewards = this._parent ? this._parent.bossDamageRewards.concat(this.selfBossDamageRewards) : this.selfBossDamageRewards;
    }
    return this._allBossDamageRewards;
  }
  get hasGroupSize() {
    if (this._cachedHasGroupSize === undefined) {
      if (this._value.hasGroupSize) {
        this._cachedHasGroupSize = true;
      } else {
        this._cachedHasGroupSize = this._parent ? this._parent.hasGroupSize : false;
      }
    }
    return this._cachedHasGroupSize;
  }
  get groupSize() {
    if (this._cachedGroupSize === undefined) {
      if (this._value.hasGroupSize) {
        this._cachedGroupSize = this._value.groupSize;
      } else {
        this._cachedGroupSize = this._parent ? this._parent.groupSize : this._value.groupSize;
      }
    }
    return this._cachedGroupSize;
  }
  get hasPromotionCount() {
    if (this._cachedHasPromotionCount === undefined) {
      if (this._value.hasPromotionCount) {
        this._cachedHasPromotionCount = true;
      } else {
        this._cachedHasPromotionCount = this._parent ? this._parent.hasPromotionCount : false;
      }
    }
    return this._cachedHasPromotionCount;
  }
  get promotionCount() {
    if (this._cachedPromotionCount === undefined) {
      if (this._value.hasPromotionCount) {
        this._cachedPromotionCount = this._value.promotionCount;
      } else {
        this._cachedPromotionCount = this._parent ? this._parent.promotionCount : this._value.promotionCount;
      }
    }
    return this._cachedPromotionCount;
  }
  get hasDemotionCount() {
    if (this._cachedHasDemotionCount === undefined) {
      if (this._value.hasDemotionCount) {
        this._cachedHasDemotionCount = true;
      } else {
        this._cachedHasDemotionCount = this._parent ? this._parent.hasDemotionCount : false;
      }
    }
    return this._cachedHasDemotionCount;
  }
  get demotionCount() {
    if (this._cachedDemotionCount === undefined) {
      if (this._value.hasDemotionCount) {
        this._cachedDemotionCount = this._value.demotionCount;
      } else {
        this._cachedDemotionCount = this._parent ? this._parent.demotionCount : this._value.demotionCount;
      }
    }
    return this._cachedDemotionCount;
  }
  get hasDemotionIndex() {
    if (this._cachedHasDemotionIndex === undefined) {
      if (this._value.hasDemotionIndex) {
        this._cachedHasDemotionIndex = true;
      } else {
        this._cachedHasDemotionIndex = this._parent ? this._parent.hasDemotionIndex : false;
      }
    }
    return this._cachedHasDemotionIndex;
  }
  get demotionIndex() {
    if (this._cachedDemotionIndex === undefined) {
      if (this._value.hasDemotionIndex) {
        this._cachedDemotionIndex = this._value.demotionIndex;
      } else {
        this._cachedDemotionIndex = this._parent ? this._parent.demotionIndex : this._value.demotionIndex;
      }
    }
    return this._cachedDemotionIndex;
  }
  get hasMaxGroupSize() {
    if (this._cachedHasMaxGroupSize === undefined) {
      if (this._value.hasMaxGroupSize) {
        this._cachedHasMaxGroupSize = true;
      } else {
        this._cachedHasMaxGroupSize = this._parent ? this._parent.hasMaxGroupSize : false;
      }
    }
    return this._cachedHasMaxGroupSize;
  }
  get maxGroupSize() {
    if (this._cachedMaxGroupSize === undefined) {
      if (this._value.hasMaxGroupSize) {
        this._cachedMaxGroupSize = this._value.maxGroupSize;
      } else {
        this._cachedMaxGroupSize = this._parent ? this._parent.maxGroupSize : this._value.maxGroupSize;
      }
    }
    return this._cachedMaxGroupSize;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_LeagueTier_WithParent(current, parent);
    if (this._selfRankRewardTiers) {
      if (this._value.rankRewardTiers === current.rankRewardTiers) {
        result._selfRankRewardTiers = this._selfRankRewardTiers;
      } else {
        result._selfRankRewardTiers = [];
        for (let i = 0; i < current.rankRewardTiers.length; i++) {
          const oldValue = this._value.rankRewardTiers[i];
          if (oldValue) {
            const oldCache = this._selfRankRewardTiers[i];
            if (oldValue === current.rankRewardTiers[i]) {
              result._selfRankRewardTiers[i] = oldCache;
            } else {
              result._selfRankRewardTiers[i] = oldCache.update(current.rankRewardTiers[i], null);
            }
          } else {
            result._selfRankRewardTiers[i] = new MapEvent_EventGuildConfig_GuildRewardTier.WithParent(current.rankRewardTiers[i], null);
          }
        }
      }
    }
    if (this._selfBossDamageRankRewards) {
      if (this._value.bossDamageRankRewards === current.bossDamageRankRewards) {
        result._selfBossDamageRankRewards = this._selfBossDamageRankRewards;
      } else {
        result._selfBossDamageRankRewards = [];
        for (let i = 0; i < current.bossDamageRankRewards.length; i++) {
          const oldValue = this._value.bossDamageRankRewards[i];
          if (oldValue) {
            const oldCache = this._selfBossDamageRankRewards[i];
            if (oldValue === current.bossDamageRankRewards[i]) {
              result._selfBossDamageRankRewards[i] = oldCache;
            } else {
              result._selfBossDamageRankRewards[i] = oldCache.update(current.bossDamageRankRewards[i], null);
            }
          } else {
            result._selfBossDamageRankRewards[i] = new MapEvent_EventGuildConfig_BossDamageRankRewardTire.WithParent(current.bossDamageRankRewards[i], null);
          }
        }
      }
    }
    if (this._selfBossDamageRewards) {
      if (this._value.bossDamageRewards === current.bossDamageRewards) {
        result._selfBossDamageRewards = this._selfBossDamageRewards;
      } else {
        result._selfBossDamageRewards = [];
        for (let i = 0; i < current.bossDamageRewards.length; i++) {
          const oldValue = this._value.bossDamageRewards[i];
          if (oldValue) {
            const oldCache = this._selfBossDamageRewards[i];
            if (oldValue === current.bossDamageRewards[i]) {
              result._selfBossDamageRewards[i] = oldCache;
            } else {
              result._selfBossDamageRewards[i] = oldCache.update(current.bossDamageRewards[i], null);
            }
          } else {
            result._selfBossDamageRewards[i] = new MapEvent_EventGuildConfig_BossDamageRewardTire.WithParent(current.bossDamageRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_LeagueTier_WithParent.default = new MapEvent_EventGuildConfig_LeagueTier_WithParent(MapEvent_EventGuildConfig_LeagueTier.default, null);
MapEvent_EventGuildConfig_LeagueTier.WithParent = MapEvent_EventGuildConfig_LeagueTier_WithParent;
class MapEvent_EventGuildConfig_LeagueTier_Descriptor {
  get rankRewardTiers() {
    if (!this._rankRewardTiers) {
      this._rankRewardTiers = {
        name: "rankRewardTiers",
        Name: "RankRewardTiers",
        number: 1,
        protoType: 11,
        protoName: "rank_reward_tiers",
        type: MapEvent_EventGuildConfig_GuildRewardTier,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankRewardTiers;
  }
  get bossDamageRankRewards() {
    if (!this._bossDamageRankRewards) {
      this._bossDamageRankRewards = {
        name: "bossDamageRankRewards",
        Name: "BossDamageRankRewards",
        number: 2,
        protoType: 11,
        protoName: "boss_damage_rank_rewards",
        type: MapEvent_EventGuildConfig_BossDamageRankRewardTire,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossDamageRankRewards;
  }
  get bossDamageRewards() {
    if (!this._bossDamageRewards) {
      this._bossDamageRewards = {
        name: "bossDamageRewards",
        Name: "BossDamageRewards",
        number: 3,
        protoType: 11,
        protoName: "boss_damage_rewards",
        type: MapEvent_EventGuildConfig_BossDamageRewardTire,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossDamageRewards;
  }
  get groupSize() {
    if (!this._groupSize) {
      this._groupSize = {
        name: "groupSize",
        Name: "GroupSize",
        number: 11,
        protoType: 5,
        protoName: "group_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupSize;
  }
  get promotionCount() {
    if (!this._promotionCount) {
      this._promotionCount = {
        name: "promotionCount",
        Name: "PromotionCount",
        number: 12,
        protoType: 5,
        protoName: "promotion_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionCount;
  }
  get demotionCount() {
    if (!this._demotionCount) {
      this._demotionCount = {
        name: "demotionCount",
        Name: "DemotionCount",
        number: 13,
        protoType: 5,
        protoName: "demotion_count",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._demotionCount;
  }
  get demotionIndex() {
    if (!this._demotionIndex) {
      this._demotionIndex = {
        name: "demotionIndex",
        Name: "DemotionIndex",
        number: 15,
        protoType: 5,
        protoName: "demotion_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._demotionIndex;
  }
  get maxGroupSize() {
    if (!this._maxGroupSize) {
      this._maxGroupSize = {
        name: "maxGroupSize",
        Name: "MaxGroupSize",
        number: 14,
        protoType: 5,
        protoName: "max_group_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxGroupSize;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rankRewardTiers,
        this.bossDamageRankRewards,
        this.bossDamageRewards,
        this.groupSize,
        this.promotionCount,
        this.demotionCount,
        this.demotionIndex,
        this.maxGroupSize,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGroupSize",
        Name: "DummyOneofForGroupSize",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPromotionCount",
        Name: "DummyOneofForPromotionCount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDemotionCount",
        Name: "DummyOneofForDemotionCount",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDemotionIndex",
        Name: "DummyOneofForDemotionIndex",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxGroupSize",
        Name: "DummyOneofForMaxGroupSize",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig_LeagueTier.descriptor = new MapEvent_EventGuildConfig_LeagueTier_Descriptor();
class MapEvent_EventGuildConfig_LeagueConfig {
  get descriptor() {
    return MapEvent_EventGuildConfig_LeagueConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._leagueTiers = [];
  }
  isEmpty() {
    if (this._leagueTiers.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig_LeagueConfig) {
      return value;
    }
    return MapEvent_EventGuildConfig_LeagueConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig_LeagueConfig();
    result._leagueTiers = JsonToList(json.leagueTiers, MapEvent_EventGuildConfig_LeagueTier);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._leagueTiers.length > 0) {
      result.leagueTiers = ArrayToJson(this._leagueTiers, MapEvent_EventGuildConfig_LeagueTier);
    }
    return result;
  }
  /**
   * @returns {MapEvent_EventGuildConfig_LeagueTier[]}
   */
  get leagueTiers() {
    return this._leagueTiers;
  }
  addLeagueTiers(path, value) {
    return {type: 'ADD', path: path.concat(['leagueTiers']), value: value.toJson()};
  }
  setLeagueTiers(path, value) {
    return {type: 'SET', path: path.concat(['leagueTiers']), value: ArrayToJson(value, MapEvent_EventGuildConfig_LeagueTier)};
  }
  setLeagueTiersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['leagueTiers', key]), value: value.toJson()};
  }
  deleteLeagueTiers(path) {
    return {type: 'DELETE', path: path.concat(['leagueTiers'])};
  }
  deleteLeagueTiersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['leagueTiers', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "leagueTiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
              copy._leagueTiers = [];        for (let i of value) {
                copy._leagueTiers.push(MapEvent_EventGuildConfig_LeagueTier.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
              copy._leagueTiers = copy._leagueTiers.concat([MapEvent_EventGuildConfig_LeagueTier.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._leagueTiers.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
              copy._leagueTiers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._leagueTiers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
              copy._leagueTiers = copy._leagueTiers.slice();
              copy._leagueTiers[path[1]] = MapEvent_EventGuildConfig_LeagueTier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
              copy._leagueTiers = copy._leagueTiers.slice(0, path[1]).concat(copy._leagueTiers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._leagueTiers.length) {
            return this;
          }
          const oldValue = this._leagueTiers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
          copy._leagueTiers = copy._leagueTiers.slice();
          copy._leagueTiers[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig_LeagueConfig} other
   * @returns {MapEvent_EventGuildConfig_LeagueConfig}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig_LeagueConfig(this);
    copy._leagueTiers = this._leagueTiers.concat(other._leagueTiers);
    return copy;
  }
}
MapEvent_EventGuildConfig_LeagueConfig.default = new MapEvent_EventGuildConfig_LeagueConfig();
class MapEvent_EventGuildConfig_LeagueConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig_LeagueConfig(value);
  }
  build() {
    return new MapEvent_EventGuildConfig_LeagueConfig(this._value);
  }
  addAllLeagueTiers(values) {
    this._value._leagueTiers = this._value._leagueTiers.concat(values);
    return this;
  }
  addLeagueTiers(value) {
    this._value._leagueTiers = this._value._leagueTiers.concat([value]);
    return this;
  }
  setLeagueTiers(index, value) {
    this._value._leagueTiers = this._value._leagueTiers.concat();
    this._value._leagueTiers[index] = value;
    return this;
  }
  clearLeagueTiers() {
    this._value._leagueTiers = [];
    return this;
  }
}
MapEvent_EventGuildConfig_LeagueConfig.Builder = MapEvent_EventGuildConfig_LeagueConfig_Builder;
class MapEvent_EventGuildConfig_LeagueConfig_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig_LeagueConfig} value
   * @param {MapEvent_EventGuildConfig_LeagueConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig_LeagueConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLeagueTiers() {
    if (!this._selfLeagueTiers) {
      this._selfLeagueTiers = [];
      for (let i of this._value.leagueTiers) {
        this._selfLeagueTiers.push(new MapEvent_EventGuildConfig_LeagueTier.WithParent(i, null));
      }
    }
    return this._selfLeagueTiers;
  }
  get inherentLeagueTiers() {
    if (!this._inherentLeagueTiers) {
      this._inherentLeagueTiers = this._parent ? this._parent.leagueTiers : [];
    }
    return this._inherentLeagueTiers;
  }
  get leagueTiers() {
    if (!this._allLeagueTiers) {
      this._allLeagueTiers = this._parent ? this._parent.leagueTiers.concat(this.selfLeagueTiers) : this.selfLeagueTiers;
    }
    return this._allLeagueTiers;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_LeagueConfig_WithParent(current, parent);
    if (this._selfLeagueTiers) {
      if (this._value.leagueTiers === current.leagueTiers) {
        result._selfLeagueTiers = this._selfLeagueTiers;
      } else {
        result._selfLeagueTiers = [];
        for (let i = 0; i < current.leagueTiers.length; i++) {
          const oldValue = this._value.leagueTiers[i];
          if (oldValue) {
            const oldCache = this._selfLeagueTiers[i];
            if (oldValue === current.leagueTiers[i]) {
              result._selfLeagueTiers[i] = oldCache;
            } else {
              result._selfLeagueTiers[i] = oldCache.update(current.leagueTiers[i], null);
            }
          } else {
            result._selfLeagueTiers[i] = new MapEvent_EventGuildConfig_LeagueTier.WithParent(current.leagueTiers[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_LeagueConfig_WithParent.default = new MapEvent_EventGuildConfig_LeagueConfig_WithParent(MapEvent_EventGuildConfig_LeagueConfig.default, null);
MapEvent_EventGuildConfig_LeagueConfig.WithParent = MapEvent_EventGuildConfig_LeagueConfig_WithParent;
class MapEvent_EventGuildConfig_LeagueConfig_Descriptor {
  get leagueTiers() {
    if (!this._leagueTiers) {
      this._leagueTiers = {
        name: "leagueTiers",
        Name: "LeagueTiers",
        number: 1,
        protoType: 11,
        protoName: "league_tiers",
        type: MapEvent_EventGuildConfig_LeagueTier,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leagueTiers;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.leagueTiers,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig_LeagueConfig.descriptor = new MapEvent_EventGuildConfig_LeagueConfig_Descriptor();
class MapEvent_EventGuildConfig {
  get descriptor() {
    return MapEvent_EventGuildConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._guildRewardTiers = [];
    this._hasLeagueConfig = false;
    this._leagueConfig = null;
  }
  isEmpty() {
    if (this._guildRewardTiers.length > 0) return false;
    if (this._hasLeagueConfig && !this._leagueConfig.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventGuildConfig) {
      return value;
    }
    return MapEvent_EventGuildConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventGuildConfig();
    result._guildRewardTiers = JsonToList(json.guildRewardTiers, MapEvent_EventGuildConfig_GuildRewardTier);
    if (json.leagueConfig != null) {
      result._hasLeagueConfig = true;
      result._leagueConfig = MapEvent_EventGuildConfig_LeagueConfig.fromJson(json.leagueConfig);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._guildRewardTiers.length > 0) {
      result.guildRewardTiers = ArrayToJson(this._guildRewardTiers, MapEvent_EventGuildConfig_GuildRewardTier);
    }
    if (this._hasLeagueConfig && !this._leagueConfig.isEmpty()) {
      result.leagueConfig = MapEvent_EventGuildConfig_LeagueConfig.toJson(this._leagueConfig);
    }
    return result;
  }
  /**
   * @returns {MapEvent_EventGuildConfig_GuildRewardTier[]}
   */
  get guildRewardTiers() {
    return this._guildRewardTiers;
  }
  addGuildRewardTiers(path, value) {
    return {type: 'ADD', path: path.concat(['guildRewardTiers']), value: value.toJson()};
  }
  setGuildRewardTiers(path, value) {
    return {type: 'SET', path: path.concat(['guildRewardTiers']), value: ArrayToJson(value, MapEvent_EventGuildConfig_GuildRewardTier)};
  }
  setGuildRewardTiersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['guildRewardTiers', key]), value: value.toJson()};
  }
  deleteGuildRewardTiers(path) {
    return {type: 'DELETE', path: path.concat(['guildRewardTiers'])};
  }
  deleteGuildRewardTiersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['guildRewardTiers', key])};
  }
  /**
   * @returns {MapEvent_EventGuildConfig_LeagueConfig}
   */
  get leagueConfig() {
    return this._hasLeagueConfig ? this._leagueConfig : MapEvent_EventGuildConfig_LeagueConfig.default;
  }
  get hasLeagueConfig() {
    return this._hasLeagueConfig;
  }
  setLeagueConfig(path, value) {
    return {type: 'SET', path: path.concat(['leagueConfig']), value: value.toJson()};
  }
  deleteLeagueConfig(path) {
    return {type: 'DELETE', path: path.concat(['leagueConfig'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "guildRewardTiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig(this);
              copy._guildRewardTiers = [];        for (let i of value) {
                copy._guildRewardTiers.push(MapEvent_EventGuildConfig_GuildRewardTier.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventGuildConfig(this);
              copy._guildRewardTiers = copy._guildRewardTiers.concat([MapEvent_EventGuildConfig_GuildRewardTier.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._guildRewardTiers.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig(this);
              copy._guildRewardTiers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._guildRewardTiers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig(this);
              copy._guildRewardTiers = copy._guildRewardTiers.slice();
              copy._guildRewardTiers[path[1]] = MapEvent_EventGuildConfig_GuildRewardTier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventGuildConfig(this);
              copy._guildRewardTiers = copy._guildRewardTiers.slice(0, path[1]).concat(copy._guildRewardTiers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._guildRewardTiers.length) {
            return this;
          }
          const oldValue = this._guildRewardTiers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig(this);
          copy._guildRewardTiers = copy._guildRewardTiers.slice();
          copy._guildRewardTiers[key] = newValue;
          return copy;
        }
      }
      case "leagueConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventGuildConfig(this);
              copy._hasLeagueConfig = true;
              copy._leagueConfig = MapEvent_EventGuildConfig_LeagueConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeagueConfig) {
                return this;
              }
              const copy = new MapEvent_EventGuildConfig(this);
              copy._hasLeagueConfig = false;
              copy._leagueConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeagueConfig) {
            const copy = new MapEvent_EventGuildConfig(this);
            copy._hasLeagueConfig = true;
            copy._leagueConfig = MapEvent_EventGuildConfig_LeagueConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leagueConfig.apply(type, path.slice(1), value);
          if (newValue === this._leagueConfig) {
            return this;
          }
          const copy = new MapEvent_EventGuildConfig(this);
          copy._leagueConfig = copy._leagueConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventGuildConfig} other
   * @returns {MapEvent_EventGuildConfig}
   */
  merge(other) {
    const copy = new MapEvent_EventGuildConfig(this);
    copy._guildRewardTiers = this._guildRewardTiers.concat(other._guildRewardTiers);
    if (other._hasLeagueConfig) {
      if (copy._hasLeagueConfig) {
        copy._leagueConfig = copy.leagueConfig.merge(other.leagueConfig);
      } else {
        copy._leagueConfig = other._leagueConfig;
      }
      copy._hasLeagueConfig = true;
    }
    return copy;
  }
}
MapEvent_EventGuildConfig.default = new MapEvent_EventGuildConfig();
MapEvent_EventGuildConfig.GuildRewardTier = MapEvent_EventGuildConfig_GuildRewardTier;
MapEvent_EventGuildConfig.BossDamageRankRewardTire = MapEvent_EventGuildConfig_BossDamageRankRewardTire;
MapEvent_EventGuildConfig.BossDamageRewardTire = MapEvent_EventGuildConfig_BossDamageRewardTire;
MapEvent_EventGuildConfig.LeagueTier = MapEvent_EventGuildConfig_LeagueTier;
MapEvent_EventGuildConfig.LeagueConfig = MapEvent_EventGuildConfig_LeagueConfig;
class MapEvent_EventGuildConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_EventGuildConfig(value);
  }
  build() {
    return new MapEvent_EventGuildConfig(this._value);
  }
  addAllGuildRewardTiers(values) {
    this._value._guildRewardTiers = this._value._guildRewardTiers.concat(values);
    return this;
  }
  addGuildRewardTiers(value) {
    this._value._guildRewardTiers = this._value._guildRewardTiers.concat([value]);
    return this;
  }
  setGuildRewardTiers(index, value) {
    this._value._guildRewardTiers = this._value._guildRewardTiers.concat();
    this._value._guildRewardTiers[index] = value;
    return this;
  }
  clearGuildRewardTiers() {
    this._value._guildRewardTiers = [];
    return this;
  }
  setLeagueConfig(value) {
    this._value._hasLeagueConfig = true;
    this._value._leagueConfig = value;
    return this;
  }
  deleteLeagueConfig() {
    this._value._hasLeagueConfig = false;
    this._value._leagueConfig = null;
    return this;
  }
}
MapEvent_EventGuildConfig.Builder = MapEvent_EventGuildConfig_Builder;
class MapEvent_EventGuildConfig_WithParent {
  /**
   * @param {MapEvent_EventGuildConfig} value
   * @param {MapEvent_EventGuildConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventGuildConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGuildRewardTiers() {
    if (!this._selfGuildRewardTiers) {
      this._selfGuildRewardTiers = [];
      for (let i of this._value.guildRewardTiers) {
        this._selfGuildRewardTiers.push(new MapEvent_EventGuildConfig_GuildRewardTier.WithParent(i, null));
      }
    }
    return this._selfGuildRewardTiers;
  }
  get inherentGuildRewardTiers() {
    if (!this._inherentGuildRewardTiers) {
      this._inherentGuildRewardTiers = this._parent ? this._parent.guildRewardTiers : [];
    }
    return this._inherentGuildRewardTiers;
  }
  get guildRewardTiers() {
    if (!this._allGuildRewardTiers) {
      this._allGuildRewardTiers = this._parent ? this._parent.guildRewardTiers.concat(this.selfGuildRewardTiers) : this.selfGuildRewardTiers;
    }
    return this._allGuildRewardTiers;
  }
  get hasLeagueConfig() {
    if (this._cachedHasLeagueConfig === undefined) {
      if (this._value.hasLeagueConfig) {
        this._cachedHasLeagueConfig = true;
      } else {
        this._cachedHasLeagueConfig = this._parent ? this._parent.hasLeagueConfig : false;
      }
    }
    return this._cachedHasLeagueConfig;
  }
  get leagueConfig() {
    if (!this._cachedLeagueConfig) {
      if (this._value.hasLeagueConfig) {
        this._cachedLeagueConfig = new MapEvent_EventGuildConfig_LeagueConfig.WithParent(this._value.leagueConfig, this._parent && this._parent.hasLeagueConfig ? this._parent.leagueConfig : null);
      } else {
        this._cachedLeagueConfig = this._parent ? new MapEvent_EventGuildConfig_LeagueConfig.WithParent(MapEvent_EventGuildConfig_LeagueConfig.default, this._parent.leagueConfig) : MapEvent_EventGuildConfig_LeagueConfig.WithParent.default;
      }
    }
    return this._cachedLeagueConfig;
  }
  update(current, parent) {
    const result = new MapEvent_EventGuildConfig_WithParent(current, parent);
    if (this._selfGuildRewardTiers) {
      if (this._value.guildRewardTiers === current.guildRewardTiers) {
        result._selfGuildRewardTiers = this._selfGuildRewardTiers;
      } else {
        result._selfGuildRewardTiers = [];
        for (let i = 0; i < current.guildRewardTiers.length; i++) {
          const oldValue = this._value.guildRewardTiers[i];
          if (oldValue) {
            const oldCache = this._selfGuildRewardTiers[i];
            if (oldValue === current.guildRewardTiers[i]) {
              result._selfGuildRewardTiers[i] = oldCache;
            } else {
              result._selfGuildRewardTiers[i] = oldCache.update(current.guildRewardTiers[i], null);
            }
          } else {
            result._selfGuildRewardTiers[i] = new MapEvent_EventGuildConfig_GuildRewardTier.WithParent(current.guildRewardTiers[i], null);
          }
        }
      }
    }
    if (this._cachedLeagueConfig && this._value.hasLeagueConfig && current.hasLeagueConfig) {
      if (this._value.leagueConfig === current.leagueConfig && this._parent === parent) {
        result._cachedLeagueConfig = this._cachedLeagueConfig;
      } else {
        result._cachedLeagueConfig = this._cachedLeagueConfig.update(current.leagueConfig, parent && parent.hasLeagueConfig ? parent.leagueConfig : null);
      }
    }
    return result;
  }
}
MapEvent_EventGuildConfig_WithParent.default = new MapEvent_EventGuildConfig_WithParent(MapEvent_EventGuildConfig.default, null);
MapEvent_EventGuildConfig.WithParent = MapEvent_EventGuildConfig_WithParent;
class MapEvent_EventGuildConfig_Descriptor {
  get guildRewardTiers() {
    if (!this._guildRewardTiers) {
      this._guildRewardTiers = {
        name: "guildRewardTiers",
        Name: "GuildRewardTiers",
        number: 1,
        protoType: 11,
        protoName: "guild_reward_tiers",
        type: MapEvent_EventGuildConfig_GuildRewardTier,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildRewardTiers;
  }
  get leagueConfig() {
    if (!this._leagueConfig) {
      this._leagueConfig = {
        name: "leagueConfig",
        Name: "LeagueConfig",
        number: 2,
        protoType: 11,
        protoName: "league_config",
        type: MapEvent_EventGuildConfig_LeagueConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leagueConfig;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.guildRewardTiers,
        this.leagueConfig,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeagueConfig",
        Name: "DummyOneofForLeagueConfig",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventGuildConfig.descriptor = new MapEvent_EventGuildConfig_Descriptor();
class MapEvent_GuildBossConfig_BossLevelKey {
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelKey.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInventoryKeyId = false;
    this._inventoryKeyId = null;
    this._hasUpfrontKeyAmount = false;
    this._upfrontKeyAmount = null;
    this._gemsCosts = [];
    this._hasGemsCostResetTimeInSecs = false;
    this._gemsCostResetTimeInSecs = null;
    this._hasKeysAmountPurPurchase = false;
    this._keysAmountPurPurchase = null;
    this._hasMaxPurchasePerDay = false;
    this._maxPurchasePerDay = null;
  }
  isEmpty() {
    if (this._hasInventoryKeyId) return false;
    if (this._hasUpfrontKeyAmount) return false;
    if (this._gemsCosts.length > 0) return false;
    if (this._hasGemsCostResetTimeInSecs) return false;
    if (this._hasKeysAmountPurPurchase) return false;
    if (this._hasMaxPurchasePerDay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_GuildBossConfig_BossLevelKey) {
      return value;
    }
    return MapEvent_GuildBossConfig_BossLevelKey.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_GuildBossConfig_BossLevelKey();
    if (json.inventoryKeyId != null) {
      result._hasInventoryKeyId = true;
      result._inventoryKeyId = JsonToString.fromJson(json.inventoryKeyId);
    }
    if (json.upfrontKeyAmount != null) {
      result._hasUpfrontKeyAmount = true;
      result._upfrontKeyAmount = JsonToInt32.fromJson(json.upfrontKeyAmount);
    }
    result._gemsCosts = JsonToList(json.gemsCosts, JsonToInt32);
    if (json.gemsCostResetTimeInSecs != null) {
      result._hasGemsCostResetTimeInSecs = true;
      result._gemsCostResetTimeInSecs = JsonToInt32.fromJson(json.gemsCostResetTimeInSecs);
    }
    if (json.keysAmountPurPurchase != null) {
      result._hasKeysAmountPurPurchase = true;
      result._keysAmountPurPurchase = JsonToInt32.fromJson(json.keysAmountPurPurchase);
    }
    if (json.maxPurchasePerDay != null) {
      result._hasMaxPurchasePerDay = true;
      result._maxPurchasePerDay = JsonToInt32.fromJson(json.maxPurchasePerDay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInventoryKeyId) {
      result.inventoryKeyId = JsonToString.toJson(this._inventoryKeyId);
    }
    if (this._hasUpfrontKeyAmount) {
      result.upfrontKeyAmount = JsonToInt32.toJson(this._upfrontKeyAmount);
    }
    if (this._gemsCosts.length > 0) {
      result.gemsCosts = ArrayToJson(this._gemsCosts, JsonToInt32);
    }
    if (this._hasGemsCostResetTimeInSecs) {
      result.gemsCostResetTimeInSecs = JsonToInt32.toJson(this._gemsCostResetTimeInSecs);
    }
    if (this._hasKeysAmountPurPurchase) {
      result.keysAmountPurPurchase = JsonToInt32.toJson(this._keysAmountPurPurchase);
    }
    if (this._hasMaxPurchasePerDay) {
      result.maxPurchasePerDay = JsonToInt32.toJson(this._maxPurchasePerDay);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get inventoryKeyId() {
    return this._hasInventoryKeyId ? this._inventoryKeyId : JsonToString.default;
  }
  get hasInventoryKeyId() {
    return this._hasInventoryKeyId;
  }
  setInventoryKeyId(path, value) {
    return {type: 'SET', path: path.concat(['inventoryKeyId']), value};
  }
  deleteInventoryKeyId(path) {
    return {type: 'DELETE', path: path.concat(['inventoryKeyId'])};
  }
  /**
   * @returns {number}
   */
  get upfrontKeyAmount() {
    return this._hasUpfrontKeyAmount ? this._upfrontKeyAmount : JsonToInt32.default;
  }
  get hasUpfrontKeyAmount() {
    return this._hasUpfrontKeyAmount;
  }
  setUpfrontKeyAmount(path, value) {
    return {type: 'SET', path: path.concat(['upfrontKeyAmount']), value};
  }
  deleteUpfrontKeyAmount(path) {
    return {type: 'DELETE', path: path.concat(['upfrontKeyAmount'])};
  }
  /**
   * @returns {number[]}
   */
  get gemsCosts() {
    return this._gemsCosts;
  }
  addGemsCosts(path, value) {
    return {type: 'ADD', path: path.concat(['gemsCosts']), value};
  }
  setGemsCosts(path, value) {
    return {type: 'SET', path: path.concat(['gemsCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGemsCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gemsCosts', key]), value};
  }
  deleteGemsCosts(path) {
    return {type: 'DELETE', path: path.concat(['gemsCosts'])};
  }
  deleteGemsCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gemsCosts', key])};
  }
  /**
   * @returns {number}
   */
  get gemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs ? this._gemsCostResetTimeInSecs : JsonToInt32.default;
  }
  get hasGemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs;
  }
  setGemsCostResetTimeInSecs(path, value) {
    return {type: 'SET', path: path.concat(['gemsCostResetTimeInSecs']), value};
  }
  deleteGemsCostResetTimeInSecs(path) {
    return {type: 'DELETE', path: path.concat(['gemsCostResetTimeInSecs'])};
  }
  /**
   * @returns {number}
   */
  get keysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase ? this._keysAmountPurPurchase : JsonToInt32.default;
  }
  get hasKeysAmountPurPurchase() {
    return this._hasKeysAmountPurPurchase;
  }
  setKeysAmountPurPurchase(path, value) {
    return {type: 'SET', path: path.concat(['keysAmountPurPurchase']), value};
  }
  deleteKeysAmountPurPurchase(path) {
    return {type: 'DELETE', path: path.concat(['keysAmountPurPurchase'])};
  }
  /**
   * @returns {number}
   */
  get maxPurchasePerDay() {
    return this._hasMaxPurchasePerDay ? this._maxPurchasePerDay : JsonToInt32.default;
  }
  get hasMaxPurchasePerDay() {
    return this._hasMaxPurchasePerDay;
  }
  setMaxPurchasePerDay(path, value) {
    return {type: 'SET', path: path.concat(['maxPurchasePerDay']), value};
  }
  deleteMaxPurchasePerDay(path) {
    return {type: 'DELETE', path: path.concat(['maxPurchasePerDay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "inventoryKeyId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasInventoryKeyId = true;
              copy._inventoryKeyId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInventoryKeyId) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasInventoryKeyId = false;
              copy._inventoryKeyId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upfrontKeyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasUpfrontKeyAmount = true;
              copy._upfrontKeyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpfrontKeyAmount) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasUpfrontKeyAmount = false;
              copy._upfrontKeyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemsCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._gemsCosts = [];        for (let i of value) {
                copy._gemsCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._gemsCosts = copy._gemsCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gemsCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._gemsCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._gemsCosts = copy._gemsCosts.slice();
              copy._gemsCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._gemsCosts = copy._gemsCosts.slice(0, path[1]).concat(copy._gemsCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          const oldValue = this._gemsCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
          copy._gemsCosts = copy._gemsCosts.slice();
          copy._gemsCosts[key] = newValue;
          return copy;
        }
      }
      case "gemsCostResetTimeInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasGemsCostResetTimeInSecs = true;
              copy._gemsCostResetTimeInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemsCostResetTimeInSecs) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasGemsCostResetTimeInSecs = false;
              copy._gemsCostResetTimeInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keysAmountPurPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasKeysAmountPurPurchase = true;
              copy._keysAmountPurPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeysAmountPurPurchase) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasKeysAmountPurPurchase = false;
              copy._keysAmountPurPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxPurchasePerDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasMaxPurchasePerDay = true;
              copy._maxPurchasePerDay = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxPurchasePerDay) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
              copy._hasMaxPurchasePerDay = false;
              copy._maxPurchasePerDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelKey} other
   * @returns {MapEvent_GuildBossConfig_BossLevelKey}
   */
  merge(other) {
    const copy = new MapEvent_GuildBossConfig_BossLevelKey(this);
    if (other._hasInventoryKeyId) {
      copy._hasInventoryKeyId = true;
      copy._inventoryKeyId = other._inventoryKeyId;
    }
    if (other._hasUpfrontKeyAmount) {
      copy._hasUpfrontKeyAmount = true;
      copy._upfrontKeyAmount = other._upfrontKeyAmount;
    }
    copy._gemsCosts = this._gemsCosts.concat(other._gemsCosts);
    if (other._hasGemsCostResetTimeInSecs) {
      copy._hasGemsCostResetTimeInSecs = true;
      copy._gemsCostResetTimeInSecs = other._gemsCostResetTimeInSecs;
    }
    if (other._hasKeysAmountPurPurchase) {
      copy._hasKeysAmountPurPurchase = true;
      copy._keysAmountPurPurchase = other._keysAmountPurPurchase;
    }
    if (other._hasMaxPurchasePerDay) {
      copy._hasMaxPurchasePerDay = true;
      copy._maxPurchasePerDay = other._maxPurchasePerDay;
    }
    return copy;
  }
}
MapEvent_GuildBossConfig_BossLevelKey.default = new MapEvent_GuildBossConfig_BossLevelKey();
class MapEvent_GuildBossConfig_BossLevelKey_Builder {
  constructor(value) {
    this._value = new MapEvent_GuildBossConfig_BossLevelKey(value);
  }
  build() {
    return new MapEvent_GuildBossConfig_BossLevelKey(this._value);
  }
  setInventoryKeyId(value) {
    this._value._hasInventoryKeyId = true;
    this._value._inventoryKeyId = value;
    return this;
  }
  deleteInventoryKeyId() {
    this._value._hasInventoryKeyId = false;
    this._value._inventoryKeyId = null;
    return this;
  }
  setUpfrontKeyAmount(value) {
    this._value._hasUpfrontKeyAmount = true;
    this._value._upfrontKeyAmount = value;
    return this;
  }
  deleteUpfrontKeyAmount() {
    this._value._hasUpfrontKeyAmount = false;
    this._value._upfrontKeyAmount = null;
    return this;
  }
  addAllGemsCosts(values) {
    this._value._gemsCosts = this._value._gemsCosts.concat(values);
    return this;
  }
  addGemsCosts(value) {
    this._value._gemsCosts = this._value._gemsCosts.concat([value]);
    return this;
  }
  setGemsCosts(index, value) {
    this._value._gemsCosts = this._value._gemsCosts.concat();
    this._value._gemsCosts[index] = value;
    return this;
  }
  clearGemsCosts() {
    this._value._gemsCosts = [];
    return this;
  }
  setGemsCostResetTimeInSecs(value) {
    this._value._hasGemsCostResetTimeInSecs = true;
    this._value._gemsCostResetTimeInSecs = value;
    return this;
  }
  deleteGemsCostResetTimeInSecs() {
    this._value._hasGemsCostResetTimeInSecs = false;
    this._value._gemsCostResetTimeInSecs = null;
    return this;
  }
  setKeysAmountPurPurchase(value) {
    this._value._hasKeysAmountPurPurchase = true;
    this._value._keysAmountPurPurchase = value;
    return this;
  }
  deleteKeysAmountPurPurchase() {
    this._value._hasKeysAmountPurPurchase = false;
    this._value._keysAmountPurPurchase = null;
    return this;
  }
  setMaxPurchasePerDay(value) {
    this._value._hasMaxPurchasePerDay = true;
    this._value._maxPurchasePerDay = value;
    return this;
  }
  deleteMaxPurchasePerDay() {
    this._value._hasMaxPurchasePerDay = false;
    this._value._maxPurchasePerDay = null;
    return this;
  }
}
MapEvent_GuildBossConfig_BossLevelKey.Builder = MapEvent_GuildBossConfig_BossLevelKey_Builder;
class MapEvent_GuildBossConfig_BossLevelKey_WithParent {
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelKey} value
   * @param {MapEvent_GuildBossConfig_BossLevelKey_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelKey.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInventoryKeyId() {
    if (this._cachedHasInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedHasInventoryKeyId = true;
      } else {
        this._cachedHasInventoryKeyId = this._parent ? this._parent.hasInventoryKeyId : false;
      }
    }
    return this._cachedHasInventoryKeyId;
  }
  get inventoryKeyId() {
    if (this._cachedInventoryKeyId === undefined) {
      if (this._value.hasInventoryKeyId) {
        this._cachedInventoryKeyId = this._value.inventoryKeyId;
      } else {
        this._cachedInventoryKeyId = this._parent ? this._parent.inventoryKeyId : this._value.inventoryKeyId;
      }
    }
    return this._cachedInventoryKeyId;
  }
  get hasUpfrontKeyAmount() {
    if (this._cachedHasUpfrontKeyAmount === undefined) {
      if (this._value.hasUpfrontKeyAmount) {
        this._cachedHasUpfrontKeyAmount = true;
      } else {
        this._cachedHasUpfrontKeyAmount = this._parent ? this._parent.hasUpfrontKeyAmount : false;
      }
    }
    return this._cachedHasUpfrontKeyAmount;
  }
  get upfrontKeyAmount() {
    if (this._cachedUpfrontKeyAmount === undefined) {
      if (this._value.hasUpfrontKeyAmount) {
        this._cachedUpfrontKeyAmount = this._value.upfrontKeyAmount;
      } else {
        this._cachedUpfrontKeyAmount = this._parent ? this._parent.upfrontKeyAmount : this._value.upfrontKeyAmount;
      }
    }
    return this._cachedUpfrontKeyAmount;
  }
  get selfGemsCosts() {
    return this._value.gemsCosts;
  }
  get inherentGemsCosts() {
    if (!this._inherentGemsCosts) {
      this._inherentGemsCosts = this._parent ? this._parent.gemsCosts : [];
    }
    return this._inherentGemsCosts;
  }
  get gemsCosts() {
    if (!this._allGemsCosts) {
      this._allGemsCosts = this._parent ? this._parent.gemsCosts.concat(this.selfGemsCosts) : this.selfGemsCosts;
    }
    return this._allGemsCosts;
  }
  get hasGemsCostResetTimeInSecs() {
    if (this._cachedHasGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedHasGemsCostResetTimeInSecs = true;
      } else {
        this._cachedHasGemsCostResetTimeInSecs = this._parent ? this._parent.hasGemsCostResetTimeInSecs : false;
      }
    }
    return this._cachedHasGemsCostResetTimeInSecs;
  }
  get gemsCostResetTimeInSecs() {
    if (this._cachedGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedGemsCostResetTimeInSecs = this._value.gemsCostResetTimeInSecs;
      } else {
        this._cachedGemsCostResetTimeInSecs = this._parent ? this._parent.gemsCostResetTimeInSecs : this._value.gemsCostResetTimeInSecs;
      }
    }
    return this._cachedGemsCostResetTimeInSecs;
  }
  get hasKeysAmountPurPurchase() {
    if (this._cachedHasKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedHasKeysAmountPurPurchase = true;
      } else {
        this._cachedHasKeysAmountPurPurchase = this._parent ? this._parent.hasKeysAmountPurPurchase : false;
      }
    }
    return this._cachedHasKeysAmountPurPurchase;
  }
  get keysAmountPurPurchase() {
    if (this._cachedKeysAmountPurPurchase === undefined) {
      if (this._value.hasKeysAmountPurPurchase) {
        this._cachedKeysAmountPurPurchase = this._value.keysAmountPurPurchase;
      } else {
        this._cachedKeysAmountPurPurchase = this._parent ? this._parent.keysAmountPurPurchase : this._value.keysAmountPurPurchase;
      }
    }
    return this._cachedKeysAmountPurPurchase;
  }
  get hasMaxPurchasePerDay() {
    if (this._cachedHasMaxPurchasePerDay === undefined) {
      if (this._value.hasMaxPurchasePerDay) {
        this._cachedHasMaxPurchasePerDay = true;
      } else {
        this._cachedHasMaxPurchasePerDay = this._parent ? this._parent.hasMaxPurchasePerDay : false;
      }
    }
    return this._cachedHasMaxPurchasePerDay;
  }
  get maxPurchasePerDay() {
    if (this._cachedMaxPurchasePerDay === undefined) {
      if (this._value.hasMaxPurchasePerDay) {
        this._cachedMaxPurchasePerDay = this._value.maxPurchasePerDay;
      } else {
        this._cachedMaxPurchasePerDay = this._parent ? this._parent.maxPurchasePerDay : this._value.maxPurchasePerDay;
      }
    }
    return this._cachedMaxPurchasePerDay;
  }
  update(current, parent) {
    const result = new MapEvent_GuildBossConfig_BossLevelKey_WithParent(current, parent);
    return result;
  }
}
MapEvent_GuildBossConfig_BossLevelKey_WithParent.default = new MapEvent_GuildBossConfig_BossLevelKey_WithParent(MapEvent_GuildBossConfig_BossLevelKey.default, null);
MapEvent_GuildBossConfig_BossLevelKey.WithParent = MapEvent_GuildBossConfig_BossLevelKey_WithParent;
class MapEvent_GuildBossConfig_BossLevelKey_Descriptor {
  get inventoryKeyId() {
    if (!this._inventoryKeyId) {
      this._inventoryKeyId = {
        name: "inventoryKeyId",
        Name: "InventoryKeyId",
        number: 1,
        protoType: 9,
        protoName: "inventory_key_id",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._inventoryKeyId;
  }
  get upfrontKeyAmount() {
    if (!this._upfrontKeyAmount) {
      this._upfrontKeyAmount = {
        name: "upfrontKeyAmount",
        Name: "UpfrontKeyAmount",
        number: 2,
        protoType: 5,
        protoName: "upfront_key_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upfrontKeyAmount;
  }
  get gemsCosts() {
    if (!this._gemsCosts) {
      this._gemsCosts = {
        name: "gemsCosts",
        Name: "GemsCosts",
        number: 3,
        protoType: 5,
        protoName: "gems_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCosts;
  }
  get gemsCostResetTimeInSecs() {
    if (!this._gemsCostResetTimeInSecs) {
      this._gemsCostResetTimeInSecs = {
        name: "gemsCostResetTimeInSecs",
        Name: "GemsCostResetTimeInSecs",
        number: 4,
        protoType: 5,
        protoName: "gems_cost_reset_time_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCostResetTimeInSecs;
  }
  get keysAmountPurPurchase() {
    if (!this._keysAmountPurPurchase) {
      this._keysAmountPurPurchase = {
        name: "keysAmountPurPurchase",
        Name: "KeysAmountPurPurchase",
        number: 5,
        protoType: 5,
        protoName: "keys_amount_pur_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keysAmountPurPurchase;
  }
  get maxPurchasePerDay() {
    if (!this._maxPurchasePerDay) {
      this._maxPurchasePerDay = {
        name: "maxPurchasePerDay",
        Name: "MaxPurchasePerDay",
        number: 6,
        protoType: 5,
        protoName: "max_purchase_per_day",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxPurchasePerDay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.inventoryKeyId,
        this.upfrontKeyAmount,
        this.gemsCosts,
        this.gemsCostResetTimeInSecs,
        this.keysAmountPurPurchase,
        this.maxPurchasePerDay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInventoryKeyId",
        Name: "DummyOneofForInventoryKeyId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpfrontKeyAmount",
        Name: "DummyOneofForUpfrontKeyAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemsCostResetTimeInSecs",
        Name: "DummyOneofForGemsCostResetTimeInSecs",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeysAmountPurPurchase",
        Name: "DummyOneofForKeysAmountPurPurchase",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxPurchasePerDay",
        Name: "DummyOneofForMaxPurchasePerDay",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_GuildBossConfig_BossLevelKey.descriptor = new MapEvent_GuildBossConfig_BossLevelKey_Descriptor();
class MapEvent_GuildBossConfig_BossRaidTicket {
  get descriptor() {
    return MapEvent_GuildBossConfig_BossRaidTicket.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInventoryTicketId = false;
    this._inventoryTicketId = null;
    this._hasUpfrontTicketAmount = false;
    this._upfrontTicketAmount = null;
    this._gemsCosts = [];
    this._hasGemsCostResetTimeInSecs = false;
    this._gemsCostResetTimeInSecs = null;
    this._hasTicketAmountPurPurchase = false;
    this._ticketAmountPurPurchase = null;
    this._hasMaxPurchasePerDay = false;
    this._maxPurchasePerDay = null;
  }
  isEmpty() {
    if (this._hasInventoryTicketId) return false;
    if (this._hasUpfrontTicketAmount) return false;
    if (this._gemsCosts.length > 0) return false;
    if (this._hasGemsCostResetTimeInSecs) return false;
    if (this._hasTicketAmountPurPurchase) return false;
    if (this._hasMaxPurchasePerDay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_GuildBossConfig_BossRaidTicket) {
      return value;
    }
    return MapEvent_GuildBossConfig_BossRaidTicket.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_GuildBossConfig_BossRaidTicket();
    if (json.inventoryTicketId != null) {
      result._hasInventoryTicketId = true;
      result._inventoryTicketId = JsonToString.fromJson(json.inventoryTicketId);
    }
    if (json.upfrontTicketAmount != null) {
      result._hasUpfrontTicketAmount = true;
      result._upfrontTicketAmount = JsonToInt32.fromJson(json.upfrontTicketAmount);
    }
    result._gemsCosts = JsonToList(json.gemsCosts, JsonToInt32);
    if (json.gemsCostResetTimeInSecs != null) {
      result._hasGemsCostResetTimeInSecs = true;
      result._gemsCostResetTimeInSecs = JsonToInt32.fromJson(json.gemsCostResetTimeInSecs);
    }
    if (json.ticketAmountPurPurchase != null) {
      result._hasTicketAmountPurPurchase = true;
      result._ticketAmountPurPurchase = JsonToInt32.fromJson(json.ticketAmountPurPurchase);
    }
    if (json.maxPurchasePerDay != null) {
      result._hasMaxPurchasePerDay = true;
      result._maxPurchasePerDay = JsonToInt32.fromJson(json.maxPurchasePerDay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInventoryTicketId) {
      result.inventoryTicketId = JsonToString.toJson(this._inventoryTicketId);
    }
    if (this._hasUpfrontTicketAmount) {
      result.upfrontTicketAmount = JsonToInt32.toJson(this._upfrontTicketAmount);
    }
    if (this._gemsCosts.length > 0) {
      result.gemsCosts = ArrayToJson(this._gemsCosts, JsonToInt32);
    }
    if (this._hasGemsCostResetTimeInSecs) {
      result.gemsCostResetTimeInSecs = JsonToInt32.toJson(this._gemsCostResetTimeInSecs);
    }
    if (this._hasTicketAmountPurPurchase) {
      result.ticketAmountPurPurchase = JsonToInt32.toJson(this._ticketAmountPurPurchase);
    }
    if (this._hasMaxPurchasePerDay) {
      result.maxPurchasePerDay = JsonToInt32.toJson(this._maxPurchasePerDay);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get inventoryTicketId() {
    return this._hasInventoryTicketId ? this._inventoryTicketId : JsonToString.default;
  }
  get hasInventoryTicketId() {
    return this._hasInventoryTicketId;
  }
  setInventoryTicketId(path, value) {
    return {type: 'SET', path: path.concat(['inventoryTicketId']), value};
  }
  deleteInventoryTicketId(path) {
    return {type: 'DELETE', path: path.concat(['inventoryTicketId'])};
  }
  /**
   * @returns {number}
   */
  get upfrontTicketAmount() {
    return this._hasUpfrontTicketAmount ? this._upfrontTicketAmount : JsonToInt32.default;
  }
  get hasUpfrontTicketAmount() {
    return this._hasUpfrontTicketAmount;
  }
  setUpfrontTicketAmount(path, value) {
    return {type: 'SET', path: path.concat(['upfrontTicketAmount']), value};
  }
  deleteUpfrontTicketAmount(path) {
    return {type: 'DELETE', path: path.concat(['upfrontTicketAmount'])};
  }
  /**
   * @returns {number[]}
   */
  get gemsCosts() {
    return this._gemsCosts;
  }
  addGemsCosts(path, value) {
    return {type: 'ADD', path: path.concat(['gemsCosts']), value};
  }
  setGemsCosts(path, value) {
    return {type: 'SET', path: path.concat(['gemsCosts']), value: ArrayToJson(value, JsonToInt32)};
  }
  setGemsCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gemsCosts', key]), value};
  }
  deleteGemsCosts(path) {
    return {type: 'DELETE', path: path.concat(['gemsCosts'])};
  }
  deleteGemsCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gemsCosts', key])};
  }
  /**
   * @returns {number}
   */
  get gemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs ? this._gemsCostResetTimeInSecs : JsonToInt32.default;
  }
  get hasGemsCostResetTimeInSecs() {
    return this._hasGemsCostResetTimeInSecs;
  }
  setGemsCostResetTimeInSecs(path, value) {
    return {type: 'SET', path: path.concat(['gemsCostResetTimeInSecs']), value};
  }
  deleteGemsCostResetTimeInSecs(path) {
    return {type: 'DELETE', path: path.concat(['gemsCostResetTimeInSecs'])};
  }
  /**
   * @returns {number}
   */
  get ticketAmountPurPurchase() {
    return this._hasTicketAmountPurPurchase ? this._ticketAmountPurPurchase : JsonToInt32.default;
  }
  get hasTicketAmountPurPurchase() {
    return this._hasTicketAmountPurPurchase;
  }
  setTicketAmountPurPurchase(path, value) {
    return {type: 'SET', path: path.concat(['ticketAmountPurPurchase']), value};
  }
  deleteTicketAmountPurPurchase(path) {
    return {type: 'DELETE', path: path.concat(['ticketAmountPurPurchase'])};
  }
  /**
   * @returns {number}
   */
  get maxPurchasePerDay() {
    return this._hasMaxPurchasePerDay ? this._maxPurchasePerDay : JsonToInt32.default;
  }
  get hasMaxPurchasePerDay() {
    return this._hasMaxPurchasePerDay;
  }
  setMaxPurchasePerDay(path, value) {
    return {type: 'SET', path: path.concat(['maxPurchasePerDay']), value};
  }
  deleteMaxPurchasePerDay(path) {
    return {type: 'DELETE', path: path.concat(['maxPurchasePerDay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "inventoryTicketId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasInventoryTicketId = true;
              copy._inventoryTicketId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInventoryTicketId) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasInventoryTicketId = false;
              copy._inventoryTicketId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upfrontTicketAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasUpfrontTicketAmount = true;
              copy._upfrontTicketAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpfrontTicketAmount) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasUpfrontTicketAmount = false;
              copy._upfrontTicketAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemsCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._gemsCosts = [];        for (let i of value) {
                copy._gemsCosts.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._gemsCosts = copy._gemsCosts.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gemsCosts.length === 0) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._gemsCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._gemsCosts = copy._gemsCosts.slice();
              copy._gemsCosts[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._gemsCosts = copy._gemsCosts.slice(0, path[1]).concat(copy._gemsCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gemsCosts.length) {
            return this;
          }
          const oldValue = this._gemsCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
          copy._gemsCosts = copy._gemsCosts.slice();
          copy._gemsCosts[key] = newValue;
          return copy;
        }
      }
      case "gemsCostResetTimeInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasGemsCostResetTimeInSecs = true;
              copy._gemsCostResetTimeInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemsCostResetTimeInSecs) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasGemsCostResetTimeInSecs = false;
              copy._gemsCostResetTimeInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ticketAmountPurPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasTicketAmountPurPurchase = true;
              copy._ticketAmountPurPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTicketAmountPurPurchase) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasTicketAmountPurPurchase = false;
              copy._ticketAmountPurPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxPurchasePerDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasMaxPurchasePerDay = true;
              copy._maxPurchasePerDay = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxPurchasePerDay) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
              copy._hasMaxPurchasePerDay = false;
              copy._maxPurchasePerDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_GuildBossConfig_BossRaidTicket} other
   * @returns {MapEvent_GuildBossConfig_BossRaidTicket}
   */
  merge(other) {
    const copy = new MapEvent_GuildBossConfig_BossRaidTicket(this);
    if (other._hasInventoryTicketId) {
      copy._hasInventoryTicketId = true;
      copy._inventoryTicketId = other._inventoryTicketId;
    }
    if (other._hasUpfrontTicketAmount) {
      copy._hasUpfrontTicketAmount = true;
      copy._upfrontTicketAmount = other._upfrontTicketAmount;
    }
    copy._gemsCosts = this._gemsCosts.concat(other._gemsCosts);
    if (other._hasGemsCostResetTimeInSecs) {
      copy._hasGemsCostResetTimeInSecs = true;
      copy._gemsCostResetTimeInSecs = other._gemsCostResetTimeInSecs;
    }
    if (other._hasTicketAmountPurPurchase) {
      copy._hasTicketAmountPurPurchase = true;
      copy._ticketAmountPurPurchase = other._ticketAmountPurPurchase;
    }
    if (other._hasMaxPurchasePerDay) {
      copy._hasMaxPurchasePerDay = true;
      copy._maxPurchasePerDay = other._maxPurchasePerDay;
    }
    return copy;
  }
}
MapEvent_GuildBossConfig_BossRaidTicket.default = new MapEvent_GuildBossConfig_BossRaidTicket();
class MapEvent_GuildBossConfig_BossRaidTicket_Builder {
  constructor(value) {
    this._value = new MapEvent_GuildBossConfig_BossRaidTicket(value);
  }
  build() {
    return new MapEvent_GuildBossConfig_BossRaidTicket(this._value);
  }
  setInventoryTicketId(value) {
    this._value._hasInventoryTicketId = true;
    this._value._inventoryTicketId = value;
    return this;
  }
  deleteInventoryTicketId() {
    this._value._hasInventoryTicketId = false;
    this._value._inventoryTicketId = null;
    return this;
  }
  setUpfrontTicketAmount(value) {
    this._value._hasUpfrontTicketAmount = true;
    this._value._upfrontTicketAmount = value;
    return this;
  }
  deleteUpfrontTicketAmount() {
    this._value._hasUpfrontTicketAmount = false;
    this._value._upfrontTicketAmount = null;
    return this;
  }
  addAllGemsCosts(values) {
    this._value._gemsCosts = this._value._gemsCosts.concat(values);
    return this;
  }
  addGemsCosts(value) {
    this._value._gemsCosts = this._value._gemsCosts.concat([value]);
    return this;
  }
  setGemsCosts(index, value) {
    this._value._gemsCosts = this._value._gemsCosts.concat();
    this._value._gemsCosts[index] = value;
    return this;
  }
  clearGemsCosts() {
    this._value._gemsCosts = [];
    return this;
  }
  setGemsCostResetTimeInSecs(value) {
    this._value._hasGemsCostResetTimeInSecs = true;
    this._value._gemsCostResetTimeInSecs = value;
    return this;
  }
  deleteGemsCostResetTimeInSecs() {
    this._value._hasGemsCostResetTimeInSecs = false;
    this._value._gemsCostResetTimeInSecs = null;
    return this;
  }
  setTicketAmountPurPurchase(value) {
    this._value._hasTicketAmountPurPurchase = true;
    this._value._ticketAmountPurPurchase = value;
    return this;
  }
  deleteTicketAmountPurPurchase() {
    this._value._hasTicketAmountPurPurchase = false;
    this._value._ticketAmountPurPurchase = null;
    return this;
  }
  setMaxPurchasePerDay(value) {
    this._value._hasMaxPurchasePerDay = true;
    this._value._maxPurchasePerDay = value;
    return this;
  }
  deleteMaxPurchasePerDay() {
    this._value._hasMaxPurchasePerDay = false;
    this._value._maxPurchasePerDay = null;
    return this;
  }
}
MapEvent_GuildBossConfig_BossRaidTicket.Builder = MapEvent_GuildBossConfig_BossRaidTicket_Builder;
class MapEvent_GuildBossConfig_BossRaidTicket_WithParent {
  /**
   * @param {MapEvent_GuildBossConfig_BossRaidTicket} value
   * @param {MapEvent_GuildBossConfig_BossRaidTicket_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_GuildBossConfig_BossRaidTicket.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInventoryTicketId() {
    if (this._cachedHasInventoryTicketId === undefined) {
      if (this._value.hasInventoryTicketId) {
        this._cachedHasInventoryTicketId = true;
      } else {
        this._cachedHasInventoryTicketId = this._parent ? this._parent.hasInventoryTicketId : false;
      }
    }
    return this._cachedHasInventoryTicketId;
  }
  get inventoryTicketId() {
    if (this._cachedInventoryTicketId === undefined) {
      if (this._value.hasInventoryTicketId) {
        this._cachedInventoryTicketId = this._value.inventoryTicketId;
      } else {
        this._cachedInventoryTicketId = this._parent ? this._parent.inventoryTicketId : this._value.inventoryTicketId;
      }
    }
    return this._cachedInventoryTicketId;
  }
  get hasUpfrontTicketAmount() {
    if (this._cachedHasUpfrontTicketAmount === undefined) {
      if (this._value.hasUpfrontTicketAmount) {
        this._cachedHasUpfrontTicketAmount = true;
      } else {
        this._cachedHasUpfrontTicketAmount = this._parent ? this._parent.hasUpfrontTicketAmount : false;
      }
    }
    return this._cachedHasUpfrontTicketAmount;
  }
  get upfrontTicketAmount() {
    if (this._cachedUpfrontTicketAmount === undefined) {
      if (this._value.hasUpfrontTicketAmount) {
        this._cachedUpfrontTicketAmount = this._value.upfrontTicketAmount;
      } else {
        this._cachedUpfrontTicketAmount = this._parent ? this._parent.upfrontTicketAmount : this._value.upfrontTicketAmount;
      }
    }
    return this._cachedUpfrontTicketAmount;
  }
  get selfGemsCosts() {
    return this._value.gemsCosts;
  }
  get inherentGemsCosts() {
    if (!this._inherentGemsCosts) {
      this._inherentGemsCosts = this._parent ? this._parent.gemsCosts : [];
    }
    return this._inherentGemsCosts;
  }
  get gemsCosts() {
    if (!this._allGemsCosts) {
      this._allGemsCosts = this._parent ? this._parent.gemsCosts.concat(this.selfGemsCosts) : this.selfGemsCosts;
    }
    return this._allGemsCosts;
  }
  get hasGemsCostResetTimeInSecs() {
    if (this._cachedHasGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedHasGemsCostResetTimeInSecs = true;
      } else {
        this._cachedHasGemsCostResetTimeInSecs = this._parent ? this._parent.hasGemsCostResetTimeInSecs : false;
      }
    }
    return this._cachedHasGemsCostResetTimeInSecs;
  }
  get gemsCostResetTimeInSecs() {
    if (this._cachedGemsCostResetTimeInSecs === undefined) {
      if (this._value.hasGemsCostResetTimeInSecs) {
        this._cachedGemsCostResetTimeInSecs = this._value.gemsCostResetTimeInSecs;
      } else {
        this._cachedGemsCostResetTimeInSecs = this._parent ? this._parent.gemsCostResetTimeInSecs : this._value.gemsCostResetTimeInSecs;
      }
    }
    return this._cachedGemsCostResetTimeInSecs;
  }
  get hasTicketAmountPurPurchase() {
    if (this._cachedHasTicketAmountPurPurchase === undefined) {
      if (this._value.hasTicketAmountPurPurchase) {
        this._cachedHasTicketAmountPurPurchase = true;
      } else {
        this._cachedHasTicketAmountPurPurchase = this._parent ? this._parent.hasTicketAmountPurPurchase : false;
      }
    }
    return this._cachedHasTicketAmountPurPurchase;
  }
  get ticketAmountPurPurchase() {
    if (this._cachedTicketAmountPurPurchase === undefined) {
      if (this._value.hasTicketAmountPurPurchase) {
        this._cachedTicketAmountPurPurchase = this._value.ticketAmountPurPurchase;
      } else {
        this._cachedTicketAmountPurPurchase = this._parent ? this._parent.ticketAmountPurPurchase : this._value.ticketAmountPurPurchase;
      }
    }
    return this._cachedTicketAmountPurPurchase;
  }
  get hasMaxPurchasePerDay() {
    if (this._cachedHasMaxPurchasePerDay === undefined) {
      if (this._value.hasMaxPurchasePerDay) {
        this._cachedHasMaxPurchasePerDay = true;
      } else {
        this._cachedHasMaxPurchasePerDay = this._parent ? this._parent.hasMaxPurchasePerDay : false;
      }
    }
    return this._cachedHasMaxPurchasePerDay;
  }
  get maxPurchasePerDay() {
    if (this._cachedMaxPurchasePerDay === undefined) {
      if (this._value.hasMaxPurchasePerDay) {
        this._cachedMaxPurchasePerDay = this._value.maxPurchasePerDay;
      } else {
        this._cachedMaxPurchasePerDay = this._parent ? this._parent.maxPurchasePerDay : this._value.maxPurchasePerDay;
      }
    }
    return this._cachedMaxPurchasePerDay;
  }
  update(current, parent) {
    const result = new MapEvent_GuildBossConfig_BossRaidTicket_WithParent(current, parent);
    return result;
  }
}
MapEvent_GuildBossConfig_BossRaidTicket_WithParent.default = new MapEvent_GuildBossConfig_BossRaidTicket_WithParent(MapEvent_GuildBossConfig_BossRaidTicket.default, null);
MapEvent_GuildBossConfig_BossRaidTicket.WithParent = MapEvent_GuildBossConfig_BossRaidTicket_WithParent;
class MapEvent_GuildBossConfig_BossRaidTicket_Descriptor {
  get inventoryTicketId() {
    if (!this._inventoryTicketId) {
      this._inventoryTicketId = {
        name: "inventoryTicketId",
        Name: "InventoryTicketId",
        number: 1,
        protoType: 9,
        protoName: "inventory_ticket_id",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._inventoryTicketId;
  }
  get upfrontTicketAmount() {
    if (!this._upfrontTicketAmount) {
      this._upfrontTicketAmount = {
        name: "upfrontTicketAmount",
        Name: "UpfrontTicketAmount",
        number: 2,
        protoType: 5,
        protoName: "upfront_ticket_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upfrontTicketAmount;
  }
  get gemsCosts() {
    if (!this._gemsCosts) {
      this._gemsCosts = {
        name: "gemsCosts",
        Name: "GemsCosts",
        number: 3,
        protoType: 5,
        protoName: "gems_costs",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCosts;
  }
  get gemsCostResetTimeInSecs() {
    if (!this._gemsCostResetTimeInSecs) {
      this._gemsCostResetTimeInSecs = {
        name: "gemsCostResetTimeInSecs",
        Name: "GemsCostResetTimeInSecs",
        number: 4,
        protoType: 5,
        protoName: "gems_cost_reset_time_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemsCostResetTimeInSecs;
  }
  get ticketAmountPurPurchase() {
    if (!this._ticketAmountPurPurchase) {
      this._ticketAmountPurPurchase = {
        name: "ticketAmountPurPurchase",
        Name: "TicketAmountPurPurchase",
        number: 5,
        protoType: 5,
        protoName: "ticket_amount_pur_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ticketAmountPurPurchase;
  }
  get maxPurchasePerDay() {
    if (!this._maxPurchasePerDay) {
      this._maxPurchasePerDay = {
        name: "maxPurchasePerDay",
        Name: "MaxPurchasePerDay",
        number: 6,
        protoType: 5,
        protoName: "max_purchase_per_day",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxPurchasePerDay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.inventoryTicketId,
        this.upfrontTicketAmount,
        this.gemsCosts,
        this.gemsCostResetTimeInSecs,
        this.ticketAmountPurPurchase,
        this.maxPurchasePerDay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInventoryTicketId",
        Name: "DummyOneofForInventoryTicketId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpfrontTicketAmount",
        Name: "DummyOneofForUpfrontTicketAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemsCostResetTimeInSecs",
        Name: "DummyOneofForGemsCostResetTimeInSecs",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTicketAmountPurPurchase",
        Name: "DummyOneofForTicketAmountPurPurchase",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxPurchasePerDay",
        Name: "DummyOneofForMaxPurchasePerDay",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_GuildBossConfig_BossRaidTicket.descriptor = new MapEvent_GuildBossConfig_BossRaidTicket_Descriptor();
class MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate {
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasCreepLevel = false;
    this._creepLevel = null;
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasCreepLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate) {
      return value;
    }
    return MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate} other
   * @returns {MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate}
   */
  merge(other) {
    const copy = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    return copy;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.default = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate();
class MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_Builder {
  constructor(value) {
    this._value = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(value);
  }
  build() {
    return new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.Builder = MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_Builder;
class MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent {
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate} value
   * @param {MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  update(current, parent) {
    const result = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent(current, parent);
    return result;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent.default = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent(MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.default, null);
MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.WithParent = MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_WithParent;
class MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 2,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.creepLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.descriptor = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate_Descriptor();
class MapEvent_GuildBossConfig_BossLevelConfig {
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDifficulty = false;
    this._difficulty = null;
    this._mapCandidates = [];
    this._hasTryphyAmount = false;
    this._tryphyAmount = null;
    this._hasDurationInSeconds = false;
    this._durationInSeconds = null;
  }
  isEmpty() {
    if (this._hasDifficulty) return false;
    if (this._mapCandidates.length > 0) return false;
    if (this._hasTryphyAmount) return false;
    if (this._hasDurationInSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_GuildBossConfig_BossLevelConfig) {
      return value;
    }
    return MapEvent_GuildBossConfig_BossLevelConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_GuildBossConfig_BossLevelConfig();
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    result._mapCandidates = JsonToList(json.mapCandidates, MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate);
    if (json.tryphyAmount != null) {
      result._hasTryphyAmount = true;
      result._tryphyAmount = JsonToInt32.fromJson(json.tryphyAmount);
    }
    if (json.durationInSeconds != null) {
      result._hasDurationInSeconds = true;
      result._durationInSeconds = JsonToInt32.fromJson(json.durationInSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._mapCandidates.length > 0) {
      result.mapCandidates = ArrayToJson(this._mapCandidates, MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate);
    }
    if (this._hasTryphyAmount) {
      result.tryphyAmount = JsonToInt32.toJson(this._tryphyAmount);
    }
    if (this._hasDurationInSeconds) {
      result.durationInSeconds = JsonToInt32.toJson(this._durationInSeconds);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate[]}
   */
  get mapCandidates() {
    return this._mapCandidates;
  }
  addMapCandidates(path, value) {
    return {type: 'ADD', path: path.concat(['mapCandidates']), value: value.toJson()};
  }
  setMapCandidates(path, value) {
    return {type: 'SET', path: path.concat(['mapCandidates']), value: ArrayToJson(value, MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate)};
  }
  setMapCandidatesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapCandidates', key]), value: value.toJson()};
  }
  deleteMapCandidates(path) {
    return {type: 'DELETE', path: path.concat(['mapCandidates'])};
  }
  deleteMapCandidatesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapCandidates', key])};
  }
  /**
   * @returns {number}
   */
  get tryphyAmount() {
    return this._hasTryphyAmount ? this._tryphyAmount : JsonToInt32.default;
  }
  get hasTryphyAmount() {
    return this._hasTryphyAmount;
  }
  setTryphyAmount(path, value) {
    return {type: 'SET', path: path.concat(['tryphyAmount']), value};
  }
  deleteTryphyAmount(path) {
    return {type: 'DELETE', path: path.concat(['tryphyAmount'])};
  }
  /**
   * @returns {number}
   */
  get durationInSeconds() {
    return this._hasDurationInSeconds ? this._durationInSeconds : JsonToInt32.default;
  }
  get hasDurationInSeconds() {
    return this._hasDurationInSeconds;
  }
  setDurationInSeconds(path, value) {
    return {type: 'SET', path: path.concat(['durationInSeconds']), value};
  }
  deleteDurationInSeconds(path) {
    return {type: 'DELETE', path: path.concat(['durationInSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapCandidates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._mapCandidates = [];        for (let i of value) {
                copy._mapCandidates.push(MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.concat([MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapCandidates.length === 0) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._mapCandidates = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapCandidates.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.slice();
              copy._mapCandidates[path[1]] = MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._mapCandidates = copy._mapCandidates.slice(0, path[1]).concat(copy._mapCandidates.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapCandidates.length) {
            return this;
          }
          const oldValue = this._mapCandidates[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
          copy._mapCandidates = copy._mapCandidates.slice();
          copy._mapCandidates[key] = newValue;
          return copy;
        }
      }
      case "tryphyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasTryphyAmount = true;
              copy._tryphyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTryphyAmount) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasTryphyAmount = false;
              copy._tryphyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "durationInSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasDurationInSeconds = true;
              copy._durationInSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationInSeconds) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
              copy._hasDurationInSeconds = false;
              copy._durationInSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelConfig} other
   * @returns {MapEvent_GuildBossConfig_BossLevelConfig}
   */
  merge(other) {
    const copy = new MapEvent_GuildBossConfig_BossLevelConfig(this);
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    copy._mapCandidates = this._mapCandidates.concat(other._mapCandidates);
    if (other._hasTryphyAmount) {
      copy._hasTryphyAmount = true;
      copy._tryphyAmount = other._tryphyAmount;
    }
    if (other._hasDurationInSeconds) {
      copy._hasDurationInSeconds = true;
      copy._durationInSeconds = other._durationInSeconds;
    }
    return copy;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig.default = new MapEvent_GuildBossConfig_BossLevelConfig();
MapEvent_GuildBossConfig_BossLevelConfig.MapCandidate = MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate;
class MapEvent_GuildBossConfig_BossLevelConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_GuildBossConfig_BossLevelConfig(value);
  }
  build() {
    return new MapEvent_GuildBossConfig_BossLevelConfig(this._value);
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  addAllMapCandidates(values) {
    this._value._mapCandidates = this._value._mapCandidates.concat(values);
    return this;
  }
  addMapCandidates(value) {
    this._value._mapCandidates = this._value._mapCandidates.concat([value]);
    return this;
  }
  setMapCandidates(index, value) {
    this._value._mapCandidates = this._value._mapCandidates.concat();
    this._value._mapCandidates[index] = value;
    return this;
  }
  clearMapCandidates() {
    this._value._mapCandidates = [];
    return this;
  }
  setTryphyAmount(value) {
    this._value._hasTryphyAmount = true;
    this._value._tryphyAmount = value;
    return this;
  }
  deleteTryphyAmount() {
    this._value._hasTryphyAmount = false;
    this._value._tryphyAmount = null;
    return this;
  }
  setDurationInSeconds(value) {
    this._value._hasDurationInSeconds = true;
    this._value._durationInSeconds = value;
    return this;
  }
  deleteDurationInSeconds() {
    this._value._hasDurationInSeconds = false;
    this._value._durationInSeconds = null;
    return this;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig.Builder = MapEvent_GuildBossConfig_BossLevelConfig_Builder;
class MapEvent_GuildBossConfig_BossLevelConfig_WithParent {
  /**
   * @param {MapEvent_GuildBossConfig_BossLevelConfig} value
   * @param {MapEvent_GuildBossConfig_BossLevelConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_GuildBossConfig_BossLevelConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get selfMapCandidates() {
    if (!this._selfMapCandidates) {
      this._selfMapCandidates = [];
      for (let i of this._value.mapCandidates) {
        this._selfMapCandidates.push(new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.WithParent(i, null));
      }
    }
    return this._selfMapCandidates;
  }
  get inherentMapCandidates() {
    if (!this._inherentMapCandidates) {
      this._inherentMapCandidates = this._parent ? this._parent.mapCandidates : [];
    }
    return this._inherentMapCandidates;
  }
  get mapCandidates() {
    if (!this._allMapCandidates) {
      this._allMapCandidates = this._parent ? this._parent.mapCandidates.concat(this.selfMapCandidates) : this.selfMapCandidates;
    }
    return this._allMapCandidates;
  }
  get hasTryphyAmount() {
    if (this._cachedHasTryphyAmount === undefined) {
      if (this._value.hasTryphyAmount) {
        this._cachedHasTryphyAmount = true;
      } else {
        this._cachedHasTryphyAmount = this._parent ? this._parent.hasTryphyAmount : false;
      }
    }
    return this._cachedHasTryphyAmount;
  }
  get tryphyAmount() {
    if (this._cachedTryphyAmount === undefined) {
      if (this._value.hasTryphyAmount) {
        this._cachedTryphyAmount = this._value.tryphyAmount;
      } else {
        this._cachedTryphyAmount = this._parent ? this._parent.tryphyAmount : this._value.tryphyAmount;
      }
    }
    return this._cachedTryphyAmount;
  }
  get hasDurationInSeconds() {
    if (this._cachedHasDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedHasDurationInSeconds = true;
      } else {
        this._cachedHasDurationInSeconds = this._parent ? this._parent.hasDurationInSeconds : false;
      }
    }
    return this._cachedHasDurationInSeconds;
  }
  get durationInSeconds() {
    if (this._cachedDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedDurationInSeconds = this._value.durationInSeconds;
      } else {
        this._cachedDurationInSeconds = this._parent ? this._parent.durationInSeconds : this._value.durationInSeconds;
      }
    }
    return this._cachedDurationInSeconds;
  }
  update(current, parent) {
    const result = new MapEvent_GuildBossConfig_BossLevelConfig_WithParent(current, parent);
    if (this._selfMapCandidates) {
      if (this._value.mapCandidates === current.mapCandidates) {
        result._selfMapCandidates = this._selfMapCandidates;
      } else {
        result._selfMapCandidates = [];
        for (let i = 0; i < current.mapCandidates.length; i++) {
          const oldValue = this._value.mapCandidates[i];
          if (oldValue) {
            const oldCache = this._selfMapCandidates[i];
            if (oldValue === current.mapCandidates[i]) {
              result._selfMapCandidates[i] = oldCache;
            } else {
              result._selfMapCandidates[i] = oldCache.update(current.mapCandidates[i], null);
            }
          } else {
            result._selfMapCandidates[i] = new MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate.WithParent(current.mapCandidates[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig_WithParent.default = new MapEvent_GuildBossConfig_BossLevelConfig_WithParent(MapEvent_GuildBossConfig_BossLevelConfig.default, null);
MapEvent_GuildBossConfig_BossLevelConfig.WithParent = MapEvent_GuildBossConfig_BossLevelConfig_WithParent;
class MapEvent_GuildBossConfig_BossLevelConfig_Descriptor {
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 1,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get mapCandidates() {
    if (!this._mapCandidates) {
      this._mapCandidates = {
        name: "mapCandidates",
        Name: "MapCandidates",
        number: 6,
        protoType: 11,
        protoName: "map_candidates",
        type: MapEvent_GuildBossConfig_BossLevelConfig_MapCandidate,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapCandidates;
  }
  get tryphyAmount() {
    if (!this._tryphyAmount) {
      this._tryphyAmount = {
        name: "tryphyAmount",
        Name: "TryphyAmount",
        number: 4,
        protoType: 5,
        protoName: "tryphy_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tryphyAmount;
  }
  get durationInSeconds() {
    if (!this._durationInSeconds) {
      this._durationInSeconds = {
        name: "durationInSeconds",
        Name: "DurationInSeconds",
        number: 5,
        protoType: 5,
        protoName: "duration_in_seconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationInSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.difficulty,
        this.mapCandidates,
        this.tryphyAmount,
        this.durationInSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTryphyAmount",
        Name: "DummyOneofForTryphyAmount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDurationInSeconds",
        Name: "DummyOneofForDurationInSeconds",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_GuildBossConfig_BossLevelConfig.descriptor = new MapEvent_GuildBossConfig_BossLevelConfig_Descriptor();
class MapEvent_GuildBossConfig {
  get descriptor() {
    return MapEvent_GuildBossConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStartTime = false;
    this._startTime = null;
    this._hasBossLevelKey = false;
    this._bossLevelKey = null;
    this._bossLevelConfigs = [];
    this._hasBossRaidTicket = false;
    this._bossRaidTicket = null;
  }
  isEmpty() {
    if (this._hasStartTime) return false;
    if (this._hasBossLevelKey && !this._bossLevelKey.isEmpty()) return false;
    if (this._bossLevelConfigs.length > 0) return false;
    if (this._hasBossRaidTicket && !this._bossRaidTicket.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_GuildBossConfig) {
      return value;
    }
    return MapEvent_GuildBossConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_GuildBossConfig();
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.bossLevelKey != null) {
      result._hasBossLevelKey = true;
      result._bossLevelKey = MapEvent_GuildBossConfig_BossLevelKey.fromJson(json.bossLevelKey);
    }
    result._bossLevelConfigs = JsonToList(json.bossLevelConfigs, MapEvent_GuildBossConfig_BossLevelConfig);
    if (json.bossRaidTicket != null) {
      result._hasBossRaidTicket = true;
      result._bossRaidTicket = MapEvent_GuildBossConfig_BossRaidTicket.fromJson(json.bossRaidTicket);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasBossLevelKey && !this._bossLevelKey.isEmpty()) {
      result.bossLevelKey = MapEvent_GuildBossConfig_BossLevelKey.toJson(this._bossLevelKey);
    }
    if (this._bossLevelConfigs.length > 0) {
      result.bossLevelConfigs = ArrayToJson(this._bossLevelConfigs, MapEvent_GuildBossConfig_BossLevelConfig);
    }
    if (this._hasBossRaidTicket && !this._bossRaidTicket.isEmpty()) {
      result.bossRaidTicket = MapEvent_GuildBossConfig_BossRaidTicket.toJson(this._bossRaidTicket);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {MapEvent_GuildBossConfig_BossLevelKey}
   */
  get bossLevelKey() {
    return this._hasBossLevelKey ? this._bossLevelKey : MapEvent_GuildBossConfig_BossLevelKey.default;
  }
  get hasBossLevelKey() {
    return this._hasBossLevelKey;
  }
  setBossLevelKey(path, value) {
    return {type: 'SET', path: path.concat(['bossLevelKey']), value: value.toJson()};
  }
  deleteBossLevelKey(path) {
    return {type: 'DELETE', path: path.concat(['bossLevelKey'])};
  }
  /**
   * @returns {MapEvent_GuildBossConfig_BossLevelConfig[]}
   */
  get bossLevelConfigs() {
    return this._bossLevelConfigs;
  }
  addBossLevelConfigs(path, value) {
    return {type: 'ADD', path: path.concat(['bossLevelConfigs']), value: value.toJson()};
  }
  setBossLevelConfigs(path, value) {
    return {type: 'SET', path: path.concat(['bossLevelConfigs']), value: ArrayToJson(value, MapEvent_GuildBossConfig_BossLevelConfig)};
  }
  setBossLevelConfigsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bossLevelConfigs', key]), value: value.toJson()};
  }
  deleteBossLevelConfigs(path) {
    return {type: 'DELETE', path: path.concat(['bossLevelConfigs'])};
  }
  deleteBossLevelConfigsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bossLevelConfigs', key])};
  }
  /**
   * @returns {MapEvent_GuildBossConfig_BossRaidTicket}
   */
  get bossRaidTicket() {
    return this._hasBossRaidTicket ? this._bossRaidTicket : MapEvent_GuildBossConfig_BossRaidTicket.default;
  }
  get hasBossRaidTicket() {
    return this._hasBossRaidTicket;
  }
  setBossRaidTicket(path, value) {
    return {type: 'SET', path: path.concat(['bossRaidTicket']), value: value.toJson()};
  }
  deleteBossRaidTicket(path) {
    return {type: 'DELETE', path: path.concat(['bossRaidTicket'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bossLevelKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasBossLevelKey = true;
              copy._bossLevelKey = MapEvent_GuildBossConfig_BossLevelKey.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBossLevelKey) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasBossLevelKey = false;
              copy._bossLevelKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBossLevelKey) {
            const copy = new MapEvent_GuildBossConfig(this);
            copy._hasBossLevelKey = true;
            copy._bossLevelKey = MapEvent_GuildBossConfig_BossLevelKey.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._bossLevelKey.apply(type, path.slice(1), value);
          if (newValue === this._bossLevelKey) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig(this);
          copy._bossLevelKey = copy._bossLevelKey.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "bossLevelConfigs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._bossLevelConfigs = [];        for (let i of value) {
                copy._bossLevelConfigs.push(MapEvent_GuildBossConfig_BossLevelConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._bossLevelConfigs = copy._bossLevelConfigs.concat([MapEvent_GuildBossConfig_BossLevelConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bossLevelConfigs.length === 0) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig(this);
              copy._bossLevelConfigs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bossLevelConfigs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._bossLevelConfigs = copy._bossLevelConfigs.slice();
              copy._bossLevelConfigs[path[1]] = MapEvent_GuildBossConfig_BossLevelConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._bossLevelConfigs = copy._bossLevelConfigs.slice(0, path[1]).concat(copy._bossLevelConfigs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bossLevelConfigs.length) {
            return this;
          }
          const oldValue = this._bossLevelConfigs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig(this);
          copy._bossLevelConfigs = copy._bossLevelConfigs.slice();
          copy._bossLevelConfigs[key] = newValue;
          return copy;
        }
      }
      case "bossRaidTicket": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasBossRaidTicket = true;
              copy._bossRaidTicket = MapEvent_GuildBossConfig_BossRaidTicket.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBossRaidTicket) {
                return this;
              }
              const copy = new MapEvent_GuildBossConfig(this);
              copy._hasBossRaidTicket = false;
              copy._bossRaidTicket = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBossRaidTicket) {
            const copy = new MapEvent_GuildBossConfig(this);
            copy._hasBossRaidTicket = true;
            copy._bossRaidTicket = MapEvent_GuildBossConfig_BossRaidTicket.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._bossRaidTicket.apply(type, path.slice(1), value);
          if (newValue === this._bossRaidTicket) {
            return this;
          }
          const copy = new MapEvent_GuildBossConfig(this);
          copy._bossRaidTicket = copy._bossRaidTicket.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_GuildBossConfig} other
   * @returns {MapEvent_GuildBossConfig}
   */
  merge(other) {
    const copy = new MapEvent_GuildBossConfig(this);
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasBossLevelKey) {
      if (copy._hasBossLevelKey) {
        copy._bossLevelKey = copy.bossLevelKey.merge(other.bossLevelKey);
      } else {
        copy._bossLevelKey = other._bossLevelKey;
      }
      copy._hasBossLevelKey = true;
    }
    copy._bossLevelConfigs = this._bossLevelConfigs.concat(other._bossLevelConfigs);
    if (other._hasBossRaidTicket) {
      if (copy._hasBossRaidTicket) {
        copy._bossRaidTicket = copy.bossRaidTicket.merge(other.bossRaidTicket);
      } else {
        copy._bossRaidTicket = other._bossRaidTicket;
      }
      copy._hasBossRaidTicket = true;
    }
    return copy;
  }
}
MapEvent_GuildBossConfig.default = new MapEvent_GuildBossConfig();
MapEvent_GuildBossConfig.BossLevelKey = MapEvent_GuildBossConfig_BossLevelKey;
MapEvent_GuildBossConfig.BossRaidTicket = MapEvent_GuildBossConfig_BossRaidTicket;
MapEvent_GuildBossConfig.BossLevelConfig = MapEvent_GuildBossConfig_BossLevelConfig;
class MapEvent_GuildBossConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_GuildBossConfig(value);
  }
  build() {
    return new MapEvent_GuildBossConfig(this._value);
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setBossLevelKey(value) {
    this._value._hasBossLevelKey = true;
    this._value._bossLevelKey = value;
    return this;
  }
  deleteBossLevelKey() {
    this._value._hasBossLevelKey = false;
    this._value._bossLevelKey = null;
    return this;
  }
  addAllBossLevelConfigs(values) {
    this._value._bossLevelConfigs = this._value._bossLevelConfigs.concat(values);
    return this;
  }
  addBossLevelConfigs(value) {
    this._value._bossLevelConfigs = this._value._bossLevelConfigs.concat([value]);
    return this;
  }
  setBossLevelConfigs(index, value) {
    this._value._bossLevelConfigs = this._value._bossLevelConfigs.concat();
    this._value._bossLevelConfigs[index] = value;
    return this;
  }
  clearBossLevelConfigs() {
    this._value._bossLevelConfigs = [];
    return this;
  }
  setBossRaidTicket(value) {
    this._value._hasBossRaidTicket = true;
    this._value._bossRaidTicket = value;
    return this;
  }
  deleteBossRaidTicket() {
    this._value._hasBossRaidTicket = false;
    this._value._bossRaidTicket = null;
    return this;
  }
}
MapEvent_GuildBossConfig.Builder = MapEvent_GuildBossConfig_Builder;
class MapEvent_GuildBossConfig_WithParent {
  /**
   * @param {MapEvent_GuildBossConfig} value
   * @param {MapEvent_GuildBossConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_GuildBossConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasBossLevelKey() {
    if (this._cachedHasBossLevelKey === undefined) {
      if (this._value.hasBossLevelKey) {
        this._cachedHasBossLevelKey = true;
      } else {
        this._cachedHasBossLevelKey = this._parent ? this._parent.hasBossLevelKey : false;
      }
    }
    return this._cachedHasBossLevelKey;
  }
  get bossLevelKey() {
    if (!this._cachedBossLevelKey) {
      if (this._value.hasBossLevelKey) {
        this._cachedBossLevelKey = new MapEvent_GuildBossConfig_BossLevelKey.WithParent(this._value.bossLevelKey, this._parent && this._parent.hasBossLevelKey ? this._parent.bossLevelKey : null);
      } else {
        this._cachedBossLevelKey = this._parent ? new MapEvent_GuildBossConfig_BossLevelKey.WithParent(MapEvent_GuildBossConfig_BossLevelKey.default, this._parent.bossLevelKey) : MapEvent_GuildBossConfig_BossLevelKey.WithParent.default;
      }
    }
    return this._cachedBossLevelKey;
  }
  get selfBossLevelConfigs() {
    if (!this._selfBossLevelConfigs) {
      this._selfBossLevelConfigs = [];
      for (let i of this._value.bossLevelConfigs) {
        this._selfBossLevelConfigs.push(new MapEvent_GuildBossConfig_BossLevelConfig.WithParent(i, null));
      }
    }
    return this._selfBossLevelConfigs;
  }
  get inherentBossLevelConfigs() {
    if (!this._inherentBossLevelConfigs) {
      this._inherentBossLevelConfigs = this._parent ? this._parent.bossLevelConfigs : [];
    }
    return this._inherentBossLevelConfigs;
  }
  get bossLevelConfigs() {
    if (!this._allBossLevelConfigs) {
      this._allBossLevelConfigs = this._parent ? this._parent.bossLevelConfigs.concat(this.selfBossLevelConfigs) : this.selfBossLevelConfigs;
    }
    return this._allBossLevelConfigs;
  }
  get hasBossRaidTicket() {
    if (this._cachedHasBossRaidTicket === undefined) {
      if (this._value.hasBossRaidTicket) {
        this._cachedHasBossRaidTicket = true;
      } else {
        this._cachedHasBossRaidTicket = this._parent ? this._parent.hasBossRaidTicket : false;
      }
    }
    return this._cachedHasBossRaidTicket;
  }
  get bossRaidTicket() {
    if (!this._cachedBossRaidTicket) {
      if (this._value.hasBossRaidTicket) {
        this._cachedBossRaidTicket = new MapEvent_GuildBossConfig_BossRaidTicket.WithParent(this._value.bossRaidTicket, this._parent && this._parent.hasBossRaidTicket ? this._parent.bossRaidTicket : null);
      } else {
        this._cachedBossRaidTicket = this._parent ? new MapEvent_GuildBossConfig_BossRaidTicket.WithParent(MapEvent_GuildBossConfig_BossRaidTicket.default, this._parent.bossRaidTicket) : MapEvent_GuildBossConfig_BossRaidTicket.WithParent.default;
      }
    }
    return this._cachedBossRaidTicket;
  }
  update(current, parent) {
    const result = new MapEvent_GuildBossConfig_WithParent(current, parent);
    if (this._cachedBossLevelKey && this._value.hasBossLevelKey && current.hasBossLevelKey) {
      if (this._value.bossLevelKey === current.bossLevelKey && this._parent === parent) {
        result._cachedBossLevelKey = this._cachedBossLevelKey;
      } else {
        result._cachedBossLevelKey = this._cachedBossLevelKey.update(current.bossLevelKey, parent && parent.hasBossLevelKey ? parent.bossLevelKey : null);
      }
    }
    if (this._selfBossLevelConfigs) {
      if (this._value.bossLevelConfigs === current.bossLevelConfigs) {
        result._selfBossLevelConfigs = this._selfBossLevelConfigs;
      } else {
        result._selfBossLevelConfigs = [];
        for (let i = 0; i < current.bossLevelConfigs.length; i++) {
          const oldValue = this._value.bossLevelConfigs[i];
          if (oldValue) {
            const oldCache = this._selfBossLevelConfigs[i];
            if (oldValue === current.bossLevelConfigs[i]) {
              result._selfBossLevelConfigs[i] = oldCache;
            } else {
              result._selfBossLevelConfigs[i] = oldCache.update(current.bossLevelConfigs[i], null);
            }
          } else {
            result._selfBossLevelConfigs[i] = new MapEvent_GuildBossConfig_BossLevelConfig.WithParent(current.bossLevelConfigs[i], null);
          }
        }
      }
    }
    if (this._cachedBossRaidTicket && this._value.hasBossRaidTicket && current.hasBossRaidTicket) {
      if (this._value.bossRaidTicket === current.bossRaidTicket && this._parent === parent) {
        result._cachedBossRaidTicket = this._cachedBossRaidTicket;
      } else {
        result._cachedBossRaidTicket = this._cachedBossRaidTicket.update(current.bossRaidTicket, parent && parent.hasBossRaidTicket ? parent.bossRaidTicket : null);
      }
    }
    return result;
  }
}
MapEvent_GuildBossConfig_WithParent.default = new MapEvent_GuildBossConfig_WithParent(MapEvent_GuildBossConfig.default, null);
MapEvent_GuildBossConfig.WithParent = MapEvent_GuildBossConfig_WithParent;
class MapEvent_GuildBossConfig_Descriptor {
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 1,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get bossLevelKey() {
    if (!this._bossLevelKey) {
      this._bossLevelKey = {
        name: "bossLevelKey",
        Name: "BossLevelKey",
        number: 4,
        protoType: 11,
        protoName: "boss_level_key",
        type: MapEvent_GuildBossConfig_BossLevelKey,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossLevelKey;
  }
  get bossLevelConfigs() {
    if (!this._bossLevelConfigs) {
      this._bossLevelConfigs = {
        name: "bossLevelConfigs",
        Name: "BossLevelConfigs",
        number: 5,
        protoType: 11,
        protoName: "boss_level_configs",
        type: MapEvent_GuildBossConfig_BossLevelConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossLevelConfigs;
  }
  get bossRaidTicket() {
    if (!this._bossRaidTicket) {
      this._bossRaidTicket = {
        name: "bossRaidTicket",
        Name: "BossRaidTicket",
        number: 6,
        protoType: 11,
        protoName: "boss_raid_ticket",
        type: MapEvent_GuildBossConfig_BossRaidTicket,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossRaidTicket;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.startTime,
        this.bossLevelKey,
        this.bossLevelConfigs,
        this.bossRaidTicket,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBossLevelKey",
        Name: "DummyOneofForBossLevelKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBossRaidTicket",
        Name: "DummyOneofForBossRaidTicket",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_GuildBossConfig.descriptor = new MapEvent_GuildBossConfig_Descriptor();
class MapEvent_PlayerLevelTrigger {
  get descriptor() {
    return MapEvent_PlayerLevelTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
  }
  isEmpty() {
    if (this._hasPlayerLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_PlayerLevelTrigger) {
      return value;
    }
    return MapEvent_PlayerLevelTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_PlayerLevelTrigger();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = JsonToInt32.fromJson(json.playerLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel) {
      result.playerLevel = JsonToInt32.toJson(this._playerLevel);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : JsonToInt32.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_PlayerLevelTrigger(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new MapEvent_PlayerLevelTrigger(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_PlayerLevelTrigger} other
   * @returns {MapEvent_PlayerLevelTrigger}
   */
  merge(other) {
    const copy = new MapEvent_PlayerLevelTrigger(this);
    if (other._hasPlayerLevel) {
      copy._hasPlayerLevel = true;
      copy._playerLevel = other._playerLevel;
    }
    return copy;
  }
}
MapEvent_PlayerLevelTrigger.default = new MapEvent_PlayerLevelTrigger();
class MapEvent_PlayerLevelTrigger_Builder {
  constructor(value) {
    this._value = new MapEvent_PlayerLevelTrigger(value);
  }
  build() {
    return new MapEvent_PlayerLevelTrigger(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
}
MapEvent_PlayerLevelTrigger.Builder = MapEvent_PlayerLevelTrigger_Builder;
class MapEvent_PlayerLevelTrigger_WithParent {
  /**
   * @param {MapEvent_PlayerLevelTrigger} value
   * @param {MapEvent_PlayerLevelTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_PlayerLevelTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (this._cachedPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = this._value.playerLevel;
      } else {
        this._cachedPlayerLevel = this._parent ? this._parent.playerLevel : this._value.playerLevel;
      }
    }
    return this._cachedPlayerLevel;
  }
  update(current, parent) {
    const result = new MapEvent_PlayerLevelTrigger_WithParent(current, parent);
    return result;
  }
}
MapEvent_PlayerLevelTrigger_WithParent.default = new MapEvent_PlayerLevelTrigger_WithParent(MapEvent_PlayerLevelTrigger.default, null);
MapEvent_PlayerLevelTrigger.WithParent = MapEvent_PlayerLevelTrigger_WithParent;
class MapEvent_PlayerLevelTrigger_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 5,
        protoName: "player_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_PlayerLevelTrigger.descriptor = new MapEvent_PlayerLevelTrigger_Descriptor();
class MapEvent_CampaignLevelTrigger {
  get descriptor() {
    return MapEvent_CampaignLevelTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWorldIndex = false;
    this._worldIndex = null;
    this._hasLevelIndex = false;
    this._levelIndex = null;
  }
  isEmpty() {
    if (this._hasWorldIndex) return false;
    if (this._hasLevelIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CampaignLevelTrigger) {
      return value;
    }
    return MapEvent_CampaignLevelTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CampaignLevelTrigger();
    if (json.worldIndex != null) {
      result._hasWorldIndex = true;
      result._worldIndex = JsonToInt32.fromJson(json.worldIndex);
    }
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWorldIndex) {
      result.worldIndex = JsonToInt32.toJson(this._worldIndex);
    }
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get worldIndex() {
    return this._hasWorldIndex ? this._worldIndex : JsonToInt32.default;
  }
  get hasWorldIndex() {
    return this._hasWorldIndex;
  }
  setWorldIndex(path, value) {
    return {type: 'SET', path: path.concat(['worldIndex']), value};
  }
  deleteWorldIndex(path) {
    return {type: 'DELETE', path: path.concat(['worldIndex'])};
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "worldIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CampaignLevelTrigger(this);
              copy._hasWorldIndex = true;
              copy._worldIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWorldIndex) {
                return this;
              }
              const copy = new MapEvent_CampaignLevelTrigger(this);
              copy._hasWorldIndex = false;
              copy._worldIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CampaignLevelTrigger(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new MapEvent_CampaignLevelTrigger(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CampaignLevelTrigger} other
   * @returns {MapEvent_CampaignLevelTrigger}
   */
  merge(other) {
    const copy = new MapEvent_CampaignLevelTrigger(this);
    if (other._hasWorldIndex) {
      copy._hasWorldIndex = true;
      copy._worldIndex = other._worldIndex;
    }
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    return copy;
  }
}
MapEvent_CampaignLevelTrigger.default = new MapEvent_CampaignLevelTrigger();
class MapEvent_CampaignLevelTrigger_Builder {
  constructor(value) {
    this._value = new MapEvent_CampaignLevelTrigger(value);
  }
  build() {
    return new MapEvent_CampaignLevelTrigger(this._value);
  }
  setWorldIndex(value) {
    this._value._hasWorldIndex = true;
    this._value._worldIndex = value;
    return this;
  }
  deleteWorldIndex() {
    this._value._hasWorldIndex = false;
    this._value._worldIndex = null;
    return this;
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
}
MapEvent_CampaignLevelTrigger.Builder = MapEvent_CampaignLevelTrigger_Builder;
class MapEvent_CampaignLevelTrigger_WithParent {
  /**
   * @param {MapEvent_CampaignLevelTrigger} value
   * @param {MapEvent_CampaignLevelTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CampaignLevelTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWorldIndex() {
    if (this._cachedHasWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedHasWorldIndex = true;
      } else {
        this._cachedHasWorldIndex = this._parent ? this._parent.hasWorldIndex : false;
      }
    }
    return this._cachedHasWorldIndex;
  }
  get worldIndex() {
    if (this._cachedWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedWorldIndex = this._value.worldIndex;
      } else {
        this._cachedWorldIndex = this._parent ? this._parent.worldIndex : this._value.worldIndex;
      }
    }
    return this._cachedWorldIndex;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  update(current, parent) {
    const result = new MapEvent_CampaignLevelTrigger_WithParent(current, parent);
    return result;
  }
}
MapEvent_CampaignLevelTrigger_WithParent.default = new MapEvent_CampaignLevelTrigger_WithParent(MapEvent_CampaignLevelTrigger.default, null);
MapEvent_CampaignLevelTrigger.WithParent = MapEvent_CampaignLevelTrigger_WithParent;
class MapEvent_CampaignLevelTrigger_Descriptor {
  get worldIndex() {
    if (!this._worldIndex) {
      this._worldIndex = {
        name: "worldIndex",
        Name: "WorldIndex",
        number: 1,
        protoType: 5,
        protoName: "world_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._worldIndex;
  }
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 2,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.worldIndex,
        this.levelIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWorldIndex",
        Name: "DummyOneofForWorldIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CampaignLevelTrigger.descriptor = new MapEvent_CampaignLevelTrigger_Descriptor();
class MapEvent_CalendarTimeTrigger {
  get descriptor() {
    return MapEvent_CalendarTimeTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEventStartTime = false;
    this._eventStartTime = null;
  }
  isEmpty() {
    if (this._hasEventStartTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CalendarTimeTrigger) {
      return value;
    }
    return MapEvent_CalendarTimeTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CalendarTimeTrigger();
    if (json.eventStartTime != null) {
      result._hasEventStartTime = true;
      result._eventStartTime = JsonToInt32.fromJson(json.eventStartTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEventStartTime) {
      result.eventStartTime = JsonToInt32.toJson(this._eventStartTime);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get eventStartTime() {
    return this._hasEventStartTime ? this._eventStartTime : JsonToInt32.default;
  }
  get hasEventStartTime() {
    return this._hasEventStartTime;
  }
  setEventStartTime(path, value) {
    return {type: 'SET', path: path.concat(['eventStartTime']), value};
  }
  deleteEventStartTime(path) {
    return {type: 'DELETE', path: path.concat(['eventStartTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "eventStartTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CalendarTimeTrigger(this);
              copy._hasEventStartTime = true;
              copy._eventStartTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventStartTime) {
                return this;
              }
              const copy = new MapEvent_CalendarTimeTrigger(this);
              copy._hasEventStartTime = false;
              copy._eventStartTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CalendarTimeTrigger} other
   * @returns {MapEvent_CalendarTimeTrigger}
   */
  merge(other) {
    const copy = new MapEvent_CalendarTimeTrigger(this);
    if (other._hasEventStartTime) {
      copy._hasEventStartTime = true;
      copy._eventStartTime = other._eventStartTime;
    }
    return copy;
  }
}
MapEvent_CalendarTimeTrigger.default = new MapEvent_CalendarTimeTrigger();
class MapEvent_CalendarTimeTrigger_Builder {
  constructor(value) {
    this._value = new MapEvent_CalendarTimeTrigger(value);
  }
  build() {
    return new MapEvent_CalendarTimeTrigger(this._value);
  }
  setEventStartTime(value) {
    this._value._hasEventStartTime = true;
    this._value._eventStartTime = value;
    return this;
  }
  deleteEventStartTime() {
    this._value._hasEventStartTime = false;
    this._value._eventStartTime = null;
    return this;
  }
}
MapEvent_CalendarTimeTrigger.Builder = MapEvent_CalendarTimeTrigger_Builder;
class MapEvent_CalendarTimeTrigger_WithParent {
  /**
   * @param {MapEvent_CalendarTimeTrigger} value
   * @param {MapEvent_CalendarTimeTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CalendarTimeTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEventStartTime() {
    if (this._cachedHasEventStartTime === undefined) {
      if (this._value.hasEventStartTime) {
        this._cachedHasEventStartTime = true;
      } else {
        this._cachedHasEventStartTime = this._parent ? this._parent.hasEventStartTime : false;
      }
    }
    return this._cachedHasEventStartTime;
  }
  get eventStartTime() {
    if (this._cachedEventStartTime === undefined) {
      if (this._value.hasEventStartTime) {
        this._cachedEventStartTime = this._value.eventStartTime;
      } else {
        this._cachedEventStartTime = this._parent ? this._parent.eventStartTime : this._value.eventStartTime;
      }
    }
    return this._cachedEventStartTime;
  }
  update(current, parent) {
    const result = new MapEvent_CalendarTimeTrigger_WithParent(current, parent);
    return result;
  }
}
MapEvent_CalendarTimeTrigger_WithParent.default = new MapEvent_CalendarTimeTrigger_WithParent(MapEvent_CalendarTimeTrigger.default, null);
MapEvent_CalendarTimeTrigger.WithParent = MapEvent_CalendarTimeTrigger_WithParent;
class MapEvent_CalendarTimeTrigger_Descriptor {
  get eventStartTime() {
    if (!this._eventStartTime) {
      this._eventStartTime = {
        name: "eventStartTime",
        Name: "EventStartTime",
        number: 1,
        protoType: 5,
        protoName: "event_start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventStartTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.eventStartTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEventStartTime",
        Name: "DummyOneofForEventStartTime",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CalendarTimeTrigger.descriptor = new MapEvent_CalendarTimeTrigger_Descriptor();
class MapEvent_ChestDropItemInfo {
  get descriptor() {
    return MapEvent_ChestDropItemInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
    this._hasAmountText = false;
    this._amountText = null;
    this._hasDescription = false;
    this._description = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    if (this._hasAmountText) return false;
    if (this._hasDescription) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_ChestDropItemInfo) {
      return value;
    }
    return MapEvent_ChestDropItemInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_ChestDropItemInfo();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.amountText != null) {
      result._hasAmountText = true;
      result._amountText = JsonToString.fromJson(json.amountText);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasAmountText) {
      result.amountText = JsonToString.toJson(this._amountText);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {string}
   */
  get amountText() {
    return this._hasAmountText ? this._amountText : JsonToString.default;
  }
  get hasAmountText() {
    return this._hasAmountText;
  }
  setAmountText(path, value) {
    return {type: 'SET', path: path.concat(['amountText']), value};
  }
  deleteAmountText(path) {
    return {type: 'DELETE', path: path.concat(['amountText'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountText": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasAmountText = true;
              copy._amountText = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountText) {
                return this;
              }
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasAmountText = false;
              copy._amountText = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new MapEvent_ChestDropItemInfo(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_ChestDropItemInfo} other
   * @returns {MapEvent_ChestDropItemInfo}
   */
  merge(other) {
    const copy = new MapEvent_ChestDropItemInfo(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasAmountText) {
      copy._hasAmountText = true;
      copy._amountText = other._amountText;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    return copy;
  }
}
MapEvent_ChestDropItemInfo.default = new MapEvent_ChestDropItemInfo();
class MapEvent_ChestDropItemInfo_Builder {
  constructor(value) {
    this._value = new MapEvent_ChestDropItemInfo(value);
  }
  build() {
    return new MapEvent_ChestDropItemInfo(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setAmountText(value) {
    this._value._hasAmountText = true;
    this._value._amountText = value;
    return this;
  }
  deleteAmountText() {
    this._value._hasAmountText = false;
    this._value._amountText = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
}
MapEvent_ChestDropItemInfo.Builder = MapEvent_ChestDropItemInfo_Builder;
class MapEvent_ChestDropItemInfo_WithParent {
  /**
   * @param {MapEvent_ChestDropItemInfo} value
   * @param {MapEvent_ChestDropItemInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_ChestDropItemInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasAmountText() {
    if (this._cachedHasAmountText === undefined) {
      if (this._value.hasAmountText) {
        this._cachedHasAmountText = true;
      } else {
        this._cachedHasAmountText = this._parent ? this._parent.hasAmountText : false;
      }
    }
    return this._cachedHasAmountText;
  }
  get amountText() {
    if (this._cachedAmountText === undefined) {
      if (this._value.hasAmountText) {
        this._cachedAmountText = this._value.amountText;
      } else {
        this._cachedAmountText = this._parent ? this._parent.amountText : this._value.amountText;
      }
    }
    return this._cachedAmountText;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  update(current, parent) {
    const result = new MapEvent_ChestDropItemInfo_WithParent(current, parent);
    return result;
  }
}
MapEvent_ChestDropItemInfo_WithParent.default = new MapEvent_ChestDropItemInfo_WithParent(MapEvent_ChestDropItemInfo.default, null);
MapEvent_ChestDropItemInfo.WithParent = MapEvent_ChestDropItemInfo_WithParent;
class MapEvent_ChestDropItemInfo_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get amountText() {
    if (!this._amountText) {
      this._amountText = {
        name: "amountText",
        Name: "AmountText",
        number: 4,
        protoType: 9,
        protoName: "amount_text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountText;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
        this.amountText,
        this.description,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountText",
        Name: "DummyOneofForAmountText",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_ChestDropItemInfo.descriptor = new MapEvent_ChestDropItemInfo_Descriptor();
class MapEvent_CardBoostInfo_BoostItem_CardItem {
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_CardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardUnit = false;
    this._cardUnit = null;
  }
  isEmpty() {
    if (this._hasCardUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CardBoostInfo_BoostItem_CardItem) {
      return value;
    }
    return MapEvent_CardBoostInfo_BoostItem_CardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CardBoostInfo_BoostItem_CardItem();
    if (json.cardUnit != null) {
      result._hasCardUnit = true;
      result._cardUnit = JsonToString.fromJson(json.cardUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardUnit) {
      result.cardUnit = JsonToString.toJson(this._cardUnit);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get cardUnit() {
    return this._hasCardUnit ? this._cardUnit : JsonToString.default;
  }
  get hasCardUnit() {
    return this._hasCardUnit;
  }
  setCardUnit(path, value) {
    return {type: 'SET', path: path.concat(['cardUnit']), value};
  }
  deleteCardUnit(path) {
    return {type: 'DELETE', path: path.concat(['cardUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem_CardItem(this);
              copy._hasCardUnit = true;
              copy._cardUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardUnit) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem_CardItem(this);
              copy._hasCardUnit = false;
              copy._cardUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_CardItem} other
   * @returns {MapEvent_CardBoostInfo_BoostItem_CardItem}
   */
  merge(other) {
    const copy = new MapEvent_CardBoostInfo_BoostItem_CardItem(this);
    if (other._hasCardUnit) {
      copy._hasCardUnit = true;
      copy._cardUnit = other._cardUnit;
    }
    return copy;
  }
}
MapEvent_CardBoostInfo_BoostItem_CardItem.default = new MapEvent_CardBoostInfo_BoostItem_CardItem();
class MapEvent_CardBoostInfo_BoostItem_CardItem_Builder {
  constructor(value) {
    this._value = new MapEvent_CardBoostInfo_BoostItem_CardItem(value);
  }
  build() {
    return new MapEvent_CardBoostInfo_BoostItem_CardItem(this._value);
  }
  setCardUnit(value) {
    this._value._hasCardUnit = true;
    this._value._cardUnit = value;
    return this;
  }
  deleteCardUnit() {
    this._value._hasCardUnit = false;
    this._value._cardUnit = null;
    return this;
  }
}
MapEvent_CardBoostInfo_BoostItem_CardItem.Builder = MapEvent_CardBoostInfo_BoostItem_CardItem_Builder;
class MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent {
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_CardItem} value
   * @param {MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_CardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardUnit() {
    if (this._cachedHasCardUnit === undefined) {
      if (this._value.hasCardUnit) {
        this._cachedHasCardUnit = true;
      } else {
        this._cachedHasCardUnit = this._parent ? this._parent.hasCardUnit : false;
      }
    }
    return this._cachedHasCardUnit;
  }
  get cardUnit() {
    if (this._cachedCardUnit === undefined) {
      if (this._value.hasCardUnit) {
        this._cachedCardUnit = this._value.cardUnit;
      } else {
        this._cachedCardUnit = this._parent ? this._parent.cardUnit : this._value.cardUnit;
      }
    }
    return this._cachedCardUnit;
  }
  update(current, parent) {
    const result = new MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent(current, parent);
    return result;
  }
}
MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent.default = new MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent(MapEvent_CardBoostInfo_BoostItem_CardItem.default, null);
MapEvent_CardBoostInfo_BoostItem_CardItem.WithParent = MapEvent_CardBoostInfo_BoostItem_CardItem_WithParent;
class MapEvent_CardBoostInfo_BoostItem_CardItem_Descriptor {
  get cardUnit() {
    if (!this._cardUnit) {
      this._cardUnit = {
        name: "cardUnit",
        Name: "CardUnit",
        number: 1,
        protoType: 9,
        protoName: "card_unit",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardUnit",
        Name: "DummyOneofForCardUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CardBoostInfo_BoostItem_CardItem.descriptor = new MapEvent_CardBoostInfo_BoostItem_CardItem_Descriptor();
class MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PHYSICAL": return 0;
        case "FIRE": return 1;
        case "WATER": return 2;
        case "NATURE": return 3;
        case "LIGHT": return 4;
        case "DARK": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(value);
  }
  static fromReact(e) {
    return MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(e);
  }
}
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.PHYSICAL = 0;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.FIRE = 1;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.WATER = 2;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.NATURE = 3;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.LIGHT = 4;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.DARK = 5;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.default = 0;
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.values = {
  PHYSICAL: 0,
  FIRE: 1,
  WATER: 2,
  NATURE: 3,
  LIGHT: 4,
  DARK: 5,
};
MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.names = {
  0: "PHYSICAL",
  1: "FIRE",
  2: "WATER",
  3: "NATURE",
  4: "LIGHT",
  5: "DARK",
};
class MapEvent_CardBoostInfo_BoostItem_AffinityItem {
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemAffinity = false;
    this._itemAffinity = null;
  }
  isEmpty() {
    if (this._hasItemAffinity) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CardBoostInfo_BoostItem_AffinityItem) {
      return value;
    }
    return MapEvent_CardBoostInfo_BoostItem_AffinityItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CardBoostInfo_BoostItem_AffinityItem();
    if (json.itemAffinity != null) {
      result._hasItemAffinity = true;
      result._itemAffinity = MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(json.itemAffinity);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemAffinity) {
      result.itemAffinity = MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.toJson(this._itemAffinity);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get itemAffinity() {
    return this._hasItemAffinity ? this._itemAffinity : MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.default;
  }
  get hasItemAffinity() {
    return this._hasItemAffinity;
  }
  setItemAffinity(path, value) {
    return {type: 'SET', path: path.concat(['itemAffinity']), value};
  }
  deleteItemAffinity(path) {
    return {type: 'DELETE', path: path.concat(['itemAffinity'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemAffinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem_AffinityItem(this);
              copy._hasItemAffinity = true;
              copy._itemAffinity = MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAffinity) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem_AffinityItem(this);
              copy._hasItemAffinity = false;
              copy._itemAffinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_AffinityItem} other
   * @returns {MapEvent_CardBoostInfo_BoostItem_AffinityItem}
   */
  merge(other) {
    const copy = new MapEvent_CardBoostInfo_BoostItem_AffinityItem(this);
    if (other._hasItemAffinity) {
      copy._hasItemAffinity = true;
      copy._itemAffinity = other._itemAffinity;
    }
    return copy;
  }
}
MapEvent_CardBoostInfo_BoostItem_AffinityItem.default = new MapEvent_CardBoostInfo_BoostItem_AffinityItem();
MapEvent_CardBoostInfo_BoostItem_AffinityItem.Affinity = MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity;
class MapEvent_CardBoostInfo_BoostItem_AffinityItem_Builder {
  constructor(value) {
    this._value = new MapEvent_CardBoostInfo_BoostItem_AffinityItem(value);
  }
  build() {
    return new MapEvent_CardBoostInfo_BoostItem_AffinityItem(this._value);
  }
  setItemAffinity(value) {
    this._value._hasItemAffinity = true;
    this._value._itemAffinity = value;
    return this;
  }
  deleteItemAffinity() {
    this._value._hasItemAffinity = false;
    this._value._itemAffinity = null;
    return this;
  }
}
MapEvent_CardBoostInfo_BoostItem_AffinityItem.Builder = MapEvent_CardBoostInfo_BoostItem_AffinityItem_Builder;
class MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent {
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_AffinityItem} value
   * @param {MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemAffinity() {
    if (this._cachedHasItemAffinity === undefined) {
      if (this._value.hasItemAffinity) {
        this._cachedHasItemAffinity = true;
      } else {
        this._cachedHasItemAffinity = this._parent ? this._parent.hasItemAffinity : false;
      }
    }
    return this._cachedHasItemAffinity;
  }
  get itemAffinity() {
    if (this._cachedItemAffinity === undefined) {
      if (this._value.hasItemAffinity) {
        this._cachedItemAffinity = this._value.itemAffinity;
      } else {
        this._cachedItemAffinity = this._parent ? this._parent.itemAffinity : this._value.itemAffinity;
      }
    }
    return this._cachedItemAffinity;
  }
  update(current, parent) {
    const result = new MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent(current, parent);
    return result;
  }
}
MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent.default = new MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent(MapEvent_CardBoostInfo_BoostItem_AffinityItem.default, null);
MapEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent = MapEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent;
class MapEvent_CardBoostInfo_BoostItem_AffinityItem_Descriptor {
  get itemAffinity() {
    if (!this._itemAffinity) {
      this._itemAffinity = {
        name: "itemAffinity",
        Name: "ItemAffinity",
        number: 1,
        protoType: 14,
        protoName: "item_affinity",
        type: MapEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAffinity;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemAffinity,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemAffinity",
        Name: "DummyOneofForItemAffinity",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor = new MapEvent_CardBoostInfo_BoostItem_AffinityItem_Descriptor();
class MapEvent_CardBoostInfo_BoostItem_BoostInfo {
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBoostType = false;
    this._boostType = null;
    this._hasBoostNumber = false;
    this._boostNumber = null;
  }
  isEmpty() {
    if (this._hasBoostType) return false;
    if (this._hasBoostNumber) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CardBoostInfo_BoostItem_BoostInfo) {
      return value;
    }
    return MapEvent_CardBoostInfo_BoostItem_BoostInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CardBoostInfo_BoostItem_BoostInfo();
    if (json.boostType != null) {
      result._hasBoostType = true;
      result._boostType = MapEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(json.boostType);
    }
    if (json.boostNumber != null) {
      result._hasBoostNumber = true;
      result._boostNumber = JsonToInt32.fromJson(json.boostNumber);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBoostType) {
      result.boostType = MapEvent_CardBoostInfo_BoostItem_BoostProperty.toJson(this._boostType);
    }
    if (this._hasBoostNumber) {
      result.boostNumber = JsonToInt32.toJson(this._boostNumber);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get boostType() {
    return this._hasBoostType ? this._boostType : MapEvent_CardBoostInfo_BoostItem_BoostProperty.default;
  }
  get hasBoostType() {
    return this._hasBoostType;
  }
  setBoostType(path, value) {
    return {type: 'SET', path: path.concat(['boostType']), value};
  }
  deleteBoostType(path) {
    return {type: 'DELETE', path: path.concat(['boostType'])};
  }
  /**
   * @returns {number}
   */
  get boostNumber() {
    return this._hasBoostNumber ? this._boostNumber : JsonToInt32.default;
  }
  get hasBoostNumber() {
    return this._hasBoostNumber;
  }
  setBoostNumber(path, value) {
    return {type: 'SET', path: path.concat(['boostNumber']), value};
  }
  deleteBoostNumber(path) {
    return {type: 'DELETE', path: path.concat(['boostNumber'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boostType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostType = true;
              copy._boostType = MapEvent_CardBoostInfo_BoostItem_BoostProperty.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBoostType) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostType = false;
              copy._boostType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "boostNumber": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostNumber = true;
              copy._boostNumber = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBoostNumber) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostNumber = false;
              copy._boostNumber = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_BoostInfo} other
   * @returns {MapEvent_CardBoostInfo_BoostItem_BoostInfo}
   */
  merge(other) {
    const copy = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this);
    if (other._hasBoostType) {
      copy._hasBoostType = true;
      copy._boostType = other._boostType;
    }
    if (other._hasBoostNumber) {
      copy._hasBoostNumber = true;
      copy._boostNumber = other._boostNumber;
    }
    return copy;
  }
}
MapEvent_CardBoostInfo_BoostItem_BoostInfo.default = new MapEvent_CardBoostInfo_BoostItem_BoostInfo();
class MapEvent_CardBoostInfo_BoostItem_BoostInfo_Builder {
  constructor(value) {
    this._value = new MapEvent_CardBoostInfo_BoostItem_BoostInfo(value);
  }
  build() {
    return new MapEvent_CardBoostInfo_BoostItem_BoostInfo(this._value);
  }
  setBoostType(value) {
    this._value._hasBoostType = true;
    this._value._boostType = value;
    return this;
  }
  deleteBoostType() {
    this._value._hasBoostType = false;
    this._value._boostType = null;
    return this;
  }
  setBoostNumber(value) {
    this._value._hasBoostNumber = true;
    this._value._boostNumber = value;
    return this;
  }
  deleteBoostNumber() {
    this._value._hasBoostNumber = false;
    this._value._boostNumber = null;
    return this;
  }
}
MapEvent_CardBoostInfo_BoostItem_BoostInfo.Builder = MapEvent_CardBoostInfo_BoostItem_BoostInfo_Builder;
class MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent {
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem_BoostInfo} value
   * @param {MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBoostType() {
    if (this._cachedHasBoostType === undefined) {
      if (this._value.hasBoostType) {
        this._cachedHasBoostType = true;
      } else {
        this._cachedHasBoostType = this._parent ? this._parent.hasBoostType : false;
      }
    }
    return this._cachedHasBoostType;
  }
  get boostType() {
    if (this._cachedBoostType === undefined) {
      if (this._value.hasBoostType) {
        this._cachedBoostType = this._value.boostType;
      } else {
        this._cachedBoostType = this._parent ? this._parent.boostType : this._value.boostType;
      }
    }
    return this._cachedBoostType;
  }
  get hasBoostNumber() {
    if (this._cachedHasBoostNumber === undefined) {
      if (this._value.hasBoostNumber) {
        this._cachedHasBoostNumber = true;
      } else {
        this._cachedHasBoostNumber = this._parent ? this._parent.hasBoostNumber : false;
      }
    }
    return this._cachedHasBoostNumber;
  }
  get boostNumber() {
    if (this._cachedBoostNumber === undefined) {
      if (this._value.hasBoostNumber) {
        this._cachedBoostNumber = this._value.boostNumber;
      } else {
        this._cachedBoostNumber = this._parent ? this._parent.boostNumber : this._value.boostNumber;
      }
    }
    return this._cachedBoostNumber;
  }
  update(current, parent) {
    const result = new MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent(current, parent);
    return result;
  }
}
MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent.default = new MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent(MapEvent_CardBoostInfo_BoostItem_BoostInfo.default, null);
MapEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent = MapEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent;
class MapEvent_CardBoostInfo_BoostItem_BoostInfo_Descriptor {
  get boostType() {
    if (!this._boostType) {
      this._boostType = {
        name: "boostType",
        Name: "BoostType",
        number: 1,
        protoType: 14,
        protoName: "boost_type",
        type: MapEvent_CardBoostInfo_BoostItem_BoostProperty,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostType;
  }
  get boostNumber() {
    if (!this._boostNumber) {
      this._boostNumber = {
        name: "boostNumber",
        Name: "BoostNumber",
        number: 2,
        protoType: 5,
        protoName: "boost_number",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostNumber;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boostType,
        this.boostNumber,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBoostType",
        Name: "DummyOneofForBoostType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBoostNumber",
        Name: "DummyOneofForBoostNumber",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor = new MapEvent_CardBoostInfo_BoostItem_BoostInfo_Descriptor();
class MapEvent_CardBoostInfo_BoostItem_BoostProperty {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LEVEL": return 0;
        case "SKILL": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(value);
  }
  static fromReact(e) {
    return MapEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(e);
  }
}
MapEvent_CardBoostInfo_BoostItem_BoostProperty.LEVEL = 0;
MapEvent_CardBoostInfo_BoostItem_BoostProperty.SKILL = 1;
MapEvent_CardBoostInfo_BoostItem_BoostProperty.default = 0;
MapEvent_CardBoostInfo_BoostItem_BoostProperty.values = {
  LEVEL: 0,
  SKILL: 1,
};
MapEvent_CardBoostInfo_BoostItem_BoostProperty.names = {
  0: "LEVEL",
  1: "SKILL",
};
class MapEvent_CardBoostInfo_BoostItem {
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
    this._boostInfoList = [];
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    if (this._boostInfoList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CardBoostInfo_BoostItem) {
      return value;
    }
    return MapEvent_CardBoostInfo_BoostItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CardBoostInfo_BoostItem();
    if (json.cardItem != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_CardItem.fromJson(json.cardItem);
    }
    if (json.affinityItem != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_AffinityItem.fromJson(json.affinityItem);
    }
    result._boostInfoList = JsonToList(json.boostInfoList, MapEvent_CardBoostInfo_BoostItem_BoostInfo);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.cardItem = MapEvent_CardBoostInfo_BoostItem_CardItem.toJson(this._itemTypeValue);
        break;
      case 2:
        result.affinityItem = MapEvent_CardBoostInfo_BoostItem_AffinityItem.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    if (this._boostInfoList.length > 0) {
      result.boostInfoList = ArrayToJson(this._boostInfoList, MapEvent_CardBoostInfo_BoostItem_BoostInfo);
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['cardItem'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['affinityItem'])};
      }
    }
  }
  /**
   * @returns {MapEvent_CardBoostInfo_BoostItem_CardItem}
   */
  get cardItem() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : MapEvent_CardBoostInfo_BoostItem_CardItem.default;
  }
  setCardItem(path, value) {
    return {type: 'SET', path: path.concat(['cardItem']), value: value.toJson()};
  }
  deleteCardItem(path) {
    return {type: 'DELETE', path: path.concat(['cardItem'])};
  }
  /**
   * @returns {MapEvent_CardBoostInfo_BoostItem_AffinityItem}
   */
  get affinityItem() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : MapEvent_CardBoostInfo_BoostItem_AffinityItem.default;
  }
  setAffinityItem(path, value) {
    return {type: 'SET', path: path.concat(['affinityItem']), value: value.toJson()};
  }
  deleteAffinityItem(path) {
    return {type: 'DELETE', path: path.concat(['affinityItem'])};
  }
  /**
   * @returns {MapEvent_CardBoostInfo_BoostItem_BoostInfo[]}
   */
  get boostInfoList() {
    return this._boostInfoList;
  }
  addBoostInfoList(path, value) {
    return {type: 'ADD', path: path.concat(['boostInfoList']), value: value.toJson()};
  }
  setBoostInfoList(path, value) {
    return {type: 'SET', path: path.concat(['boostInfoList']), value: ArrayToJson(value, MapEvent_CardBoostInfo_BoostItem_BoostInfo)};
  }
  setBoostInfoListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['boostInfoList', key]), value: value.toJson()};
  }
  deleteBoostInfoList(path) {
    return {type: 'DELETE', path: path.concat(['boostInfoList'])};
  }
  deleteBoostInfoListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['boostInfoList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_CardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._itemTypeCase !== 1) {
            const copy = new MapEvent_CardBoostInfo_BoostItem(this);
            copy._itemTypeCase = 1;
            copy._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_CardItem.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.cardItem.apply(type, path.slice(1), value);
          if (newValue === this.cardItem) {
            return this;
          }
          const copy = new MapEvent_CardBoostInfo_BoostItem(this);
          copy._itemTypeCase = 1;
          copy._itemTypeValue = newValue;
          return copy;
        }
      }
      case "affinityItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_AffinityItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._itemTypeCase !== 2) {
            const copy = new MapEvent_CardBoostInfo_BoostItem(this);
            copy._itemTypeCase = 2;
            copy._itemTypeValue = MapEvent_CardBoostInfo_BoostItem_AffinityItem.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.affinityItem.apply(type, path.slice(1), value);
          if (newValue === this.affinityItem) {
            return this;
          }
          const copy = new MapEvent_CardBoostInfo_BoostItem(this);
          copy._itemTypeCase = 2;
          copy._itemTypeValue = newValue;
          return copy;
        }
      }
      case "boostInfoList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = [];        for (let i of value) {
                copy._boostInfoList.push(MapEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.concat([MapEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._boostInfoList.length === 0) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._boostInfoList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.slice();
              copy._boostInfoList[path[1]] = MapEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.slice(0, path[1]).concat(copy._boostInfoList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._boostInfoList.length) {
            return this;
          }
          const oldValue = this._boostInfoList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CardBoostInfo_BoostItem(this);
          copy._boostInfoList = copy._boostInfoList.slice();
          copy._boostInfoList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem} other
   * @returns {MapEvent_CardBoostInfo_BoostItem}
   */
  merge(other) {
    const copy = new MapEvent_CardBoostInfo_BoostItem(this);
    if (other._itemTypeCase === 1) {
      if (this._itemTypeCase === 1) {
        copy._itemTypeValue = copy._itemTypeValue.merge(other._itemTypeValue);
      } else {
        copy._itemTypeValue = other._itemTypeValue;
      }
      copy._itemTypeCase = 1;
    }
    if (other._itemTypeCase === 1) {
      if (this._itemTypeCase === 1) {
        copy._itemTypeValue = copy._itemTypeValue.merge(other._itemTypeValue);
      } else {
        copy._itemTypeValue = other._itemTypeValue;
      }
      copy._itemTypeCase = 1;
    }
    copy._boostInfoList = this._boostInfoList.concat(other._boostInfoList);
    return copy;
  }
}
MapEvent_CardBoostInfo_BoostItem.default = new MapEvent_CardBoostInfo_BoostItem();
MapEvent_CardBoostInfo_BoostItem.CardItem = MapEvent_CardBoostInfo_BoostItem_CardItem;
MapEvent_CardBoostInfo_BoostItem.AffinityItem = MapEvent_CardBoostInfo_BoostItem_AffinityItem;
MapEvent_CardBoostInfo_BoostItem.BoostInfo = MapEvent_CardBoostInfo_BoostItem_BoostInfo;
MapEvent_CardBoostInfo_BoostItem.BoostProperty = MapEvent_CardBoostInfo_BoostItem_BoostProperty;
class MapEvent_CardBoostInfo_BoostItem_Builder {
  constructor(value) {
    this._value = new MapEvent_CardBoostInfo_BoostItem(value);
  }
  build() {
    return new MapEvent_CardBoostInfo_BoostItem(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setCardItem(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setAffinityItem(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
  addAllBoostInfoList(values) {
    this._value._boostInfoList = this._value._boostInfoList.concat(values);
    return this;
  }
  addBoostInfoList(value) {
    this._value._boostInfoList = this._value._boostInfoList.concat([value]);
    return this;
  }
  setBoostInfoList(index, value) {
    this._value._boostInfoList = this._value._boostInfoList.concat();
    this._value._boostInfoList[index] = value;
    return this;
  }
  clearBoostInfoList() {
    this._value._boostInfoList = [];
    return this;
  }
}
MapEvent_CardBoostInfo_BoostItem.Builder = MapEvent_CardBoostInfo_BoostItem_Builder;
class MapEvent_CardBoostInfo_BoostItem_WithParent {
  /**
   * @param {MapEvent_CardBoostInfo_BoostItem} value
   * @param {MapEvent_CardBoostInfo_BoostItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CardBoostInfo_BoostItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get cardItem() {
    if (!this._cachedCardItem) {
      if (this._value._itemTypeCase === 0) {
        this._cachedCardItem = this._parent ? new MapEvent_CardBoostInfo_BoostItem_CardItem.WithParent(MapEvent_CardBoostInfo_BoostItem_CardItem.default, this._parent.cardItem) : this._value.cardItem;
      } else if (this._value._itemTypeCase === 1) {
        this._cachedCardItem = new MapEvent_CardBoostInfo_BoostItem_CardItem.WithParent(this._value.cardItem, this._parent && this._parent.itemTypeCase === 1 ? this._parent.cardItem : null);
      } else {
        this._cachedCardItem = MapEvent_CardBoostInfo_BoostItem_CardItem.WithParent.default;
      }
    }
    return this._cachedCardItem;
  }
  get affinityItem() {
    if (!this._cachedAffinityItem) {
      if (this._value._itemTypeCase === 0) {
        this._cachedAffinityItem = this._parent ? new MapEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent(MapEvent_CardBoostInfo_BoostItem_AffinityItem.default, this._parent.affinityItem) : this._value.affinityItem;
      } else if (this._value._itemTypeCase === 2) {
        this._cachedAffinityItem = new MapEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent(this._value.affinityItem, this._parent && this._parent.itemTypeCase === 2 ? this._parent.affinityItem : null);
      } else {
        this._cachedAffinityItem = MapEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent.default;
      }
    }
    return this._cachedAffinityItem;
  }
  get selfBoostInfoList() {
    if (!this._selfBoostInfoList) {
      this._selfBoostInfoList = [];
      for (let i of this._value.boostInfoList) {
        this._selfBoostInfoList.push(new MapEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent(i, null));
      }
    }
    return this._selfBoostInfoList;
  }
  get inherentBoostInfoList() {
    if (!this._inherentBoostInfoList) {
      this._inherentBoostInfoList = this._parent ? this._parent.boostInfoList : [];
    }
    return this._inherentBoostInfoList;
  }
  get boostInfoList() {
    if (!this._allBoostInfoList) {
      this._allBoostInfoList = this._parent ? this._parent.boostInfoList.concat(this.selfBoostInfoList) : this.selfBoostInfoList;
    }
    return this._allBoostInfoList;
  }
  update(current, parent) {
    const result = new MapEvent_CardBoostInfo_BoostItem_WithParent(current, parent);
    if (this._cachedCardItem && this._value._itemTypeCase === 1 && current._itemTypeCase === 1) {
      if (this._value.cardItem === current.cardItem && this._parent === parent) {
        result._cachedCardItem = this._cachedCardItem;
      } else {
        result._cachedCardItem = this._cachedCardItem.update(current.cardItem, parent && parent.itemTypeCase === 1 ? parent.cardItem : null);
      }
    }
    if (this._cachedAffinityItem && this._value._itemTypeCase === 2 && current._itemTypeCase === 2) {
      if (this._value.affinityItem === current.affinityItem && this._parent === parent) {
        result._cachedAffinityItem = this._cachedAffinityItem;
      } else {
        result._cachedAffinityItem = this._cachedAffinityItem.update(current.affinityItem, parent && parent.itemTypeCase === 2 ? parent.affinityItem : null);
      }
    }
    if (this._selfBoostInfoList) {
      if (this._value.boostInfoList === current.boostInfoList) {
        result._selfBoostInfoList = this._selfBoostInfoList;
      } else {
        result._selfBoostInfoList = [];
        for (let i = 0; i < current.boostInfoList.length; i++) {
          const oldValue = this._value.boostInfoList[i];
          if (oldValue) {
            const oldCache = this._selfBoostInfoList[i];
            if (oldValue === current.boostInfoList[i]) {
              result._selfBoostInfoList[i] = oldCache;
            } else {
              result._selfBoostInfoList[i] = oldCache.update(current.boostInfoList[i], null);
            }
          } else {
            result._selfBoostInfoList[i] = new MapEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent(current.boostInfoList[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_CardBoostInfo_BoostItem_WithParent.default = new MapEvent_CardBoostInfo_BoostItem_WithParent(MapEvent_CardBoostInfo_BoostItem.default, null);
MapEvent_CardBoostInfo_BoostItem.WithParent = MapEvent_CardBoostInfo_BoostItem_WithParent;
class MapEvent_CardBoostInfo_BoostItem_Descriptor {
  get cardItem() {
    if (!this._cardItem) {
      this._cardItem = {
        name: "cardItem",
        Name: "CardItem",
        number: 1,
        protoType: 11,
        protoName: "card_item",
        oneofIndex: 0,
        type: MapEvent_CardBoostInfo_BoostItem_CardItem,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardItem;
  }
  get affinityItem() {
    if (!this._affinityItem) {
      this._affinityItem = {
        name: "affinityItem",
        Name: "AffinityItem",
        number: 2,
        protoType: 11,
        protoName: "affinity_item",
        oneofIndex: 0,
        type: MapEvent_CardBoostInfo_BoostItem_AffinityItem,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityItem;
  }
  get boostInfoList() {
    if (!this._boostInfoList) {
      this._boostInfoList = {
        name: "boostInfoList",
        Name: "BoostInfoList",
        number: 3,
        protoType: 11,
        protoName: "boost_info_list",
        type: MapEvent_CardBoostInfo_BoostItem_BoostInfo,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostInfoList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardItem,
        this.affinityItem,
        this.boostInfoList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_CardBoostInfo_BoostItem.descriptor = new MapEvent_CardBoostInfo_BoostItem_Descriptor();
class MapEvent_CardBoostInfo {
  get descriptor() {
    return MapEvent_CardBoostInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._boostItems = [];
  }
  isEmpty() {
    if (this._boostItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_CardBoostInfo) {
      return value;
    }
    return MapEvent_CardBoostInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_CardBoostInfo();
    result._boostItems = JsonToList(json.boostItems, MapEvent_CardBoostInfo_BoostItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._boostItems.length > 0) {
      result.boostItems = ArrayToJson(this._boostItems, MapEvent_CardBoostInfo_BoostItem);
    }
    return result;
  }
  /**
   * @returns {MapEvent_CardBoostInfo_BoostItem[]}
   */
  get boostItems() {
    return this._boostItems;
  }
  addBoostItems(path, value) {
    return {type: 'ADD', path: path.concat(['boostItems']), value: value.toJson()};
  }
  setBoostItems(path, value) {
    return {type: 'SET', path: path.concat(['boostItems']), value: ArrayToJson(value, MapEvent_CardBoostInfo_BoostItem)};
  }
  setBoostItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['boostItems', key]), value: value.toJson()};
  }
  deleteBoostItems(path) {
    return {type: 'DELETE', path: path.concat(['boostItems'])};
  }
  deleteBoostItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['boostItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boostItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo(this);
              copy._boostItems = [];        for (let i of value) {
                copy._boostItems.push(MapEvent_CardBoostInfo_BoostItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.concat([MapEvent_CardBoostInfo_BoostItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._boostItems.length === 0) {
                return this;
              }
              const copy = new MapEvent_CardBoostInfo(this);
              copy._boostItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._boostItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.slice();
              copy._boostItems[path[1]] = MapEvent_CardBoostInfo_BoostItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.slice(0, path[1]).concat(copy._boostItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._boostItems.length) {
            return this;
          }
          const oldValue = this._boostItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_CardBoostInfo(this);
          copy._boostItems = copy._boostItems.slice();
          copy._boostItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_CardBoostInfo} other
   * @returns {MapEvent_CardBoostInfo}
   */
  merge(other) {
    const copy = new MapEvent_CardBoostInfo(this);
    copy._boostItems = this._boostItems.concat(other._boostItems);
    return copy;
  }
}
MapEvent_CardBoostInfo.default = new MapEvent_CardBoostInfo();
MapEvent_CardBoostInfo.BoostItem = MapEvent_CardBoostInfo_BoostItem;
class MapEvent_CardBoostInfo_Builder {
  constructor(value) {
    this._value = new MapEvent_CardBoostInfo(value);
  }
  build() {
    return new MapEvent_CardBoostInfo(this._value);
  }
  addAllBoostItems(values) {
    this._value._boostItems = this._value._boostItems.concat(values);
    return this;
  }
  addBoostItems(value) {
    this._value._boostItems = this._value._boostItems.concat([value]);
    return this;
  }
  setBoostItems(index, value) {
    this._value._boostItems = this._value._boostItems.concat();
    this._value._boostItems[index] = value;
    return this;
  }
  clearBoostItems() {
    this._value._boostItems = [];
    return this;
  }
}
MapEvent_CardBoostInfo.Builder = MapEvent_CardBoostInfo_Builder;
class MapEvent_CardBoostInfo_WithParent {
  /**
   * @param {MapEvent_CardBoostInfo} value
   * @param {MapEvent_CardBoostInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_CardBoostInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfBoostItems() {
    if (!this._selfBoostItems) {
      this._selfBoostItems = [];
      for (let i of this._value.boostItems) {
        this._selfBoostItems.push(new MapEvent_CardBoostInfo_BoostItem.WithParent(i, null));
      }
    }
    return this._selfBoostItems;
  }
  get inherentBoostItems() {
    if (!this._inherentBoostItems) {
      this._inherentBoostItems = this._parent ? this._parent.boostItems : [];
    }
    return this._inherentBoostItems;
  }
  get boostItems() {
    if (!this._allBoostItems) {
      this._allBoostItems = this._parent ? this._parent.boostItems.concat(this.selfBoostItems) : this.selfBoostItems;
    }
    return this._allBoostItems;
  }
  update(current, parent) {
    const result = new MapEvent_CardBoostInfo_WithParent(current, parent);
    if (this._selfBoostItems) {
      if (this._value.boostItems === current.boostItems) {
        result._selfBoostItems = this._selfBoostItems;
      } else {
        result._selfBoostItems = [];
        for (let i = 0; i < current.boostItems.length; i++) {
          const oldValue = this._value.boostItems[i];
          if (oldValue) {
            const oldCache = this._selfBoostItems[i];
            if (oldValue === current.boostItems[i]) {
              result._selfBoostItems[i] = oldCache;
            } else {
              result._selfBoostItems[i] = oldCache.update(current.boostItems[i], null);
            }
          } else {
            result._selfBoostItems[i] = new MapEvent_CardBoostInfo_BoostItem.WithParent(current.boostItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_CardBoostInfo_WithParent.default = new MapEvent_CardBoostInfo_WithParent(MapEvent_CardBoostInfo.default, null);
MapEvent_CardBoostInfo.WithParent = MapEvent_CardBoostInfo_WithParent;
class MapEvent_CardBoostInfo_Descriptor {
  get boostItems() {
    if (!this._boostItems) {
      this._boostItems = {
        name: "boostItems",
        Name: "BoostItems",
        number: 1,
        protoType: 11,
        protoName: "boost_items",
        type: MapEvent_CardBoostInfo_BoostItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boostItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_CardBoostInfo.descriptor = new MapEvent_CardBoostInfo_Descriptor();
class MapEvent_EventChestGroup {
  get descriptor() {
    return MapEvent_EventChestGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._chests = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._chests.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventChestGroup) {
      return value;
    }
    return MapEvent_EventChestGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventChestGroup();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._chests = JsonToList(json.chests, dcei_wildsky_chest_proto.Chest);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._chests.length > 0) {
      result.chests = ArrayToJson(this._chests, dcei_wildsky_chest_proto.Chest);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_wildsky_chest_proto.Chest[]}
   */
  get chests() {
    return this._chests;
  }
  addChests(path, value) {
    return {type: 'ADD', path: path.concat(['chests']), value: value.toJson()};
  }
  setChests(path, value) {
    return {type: 'SET', path: path.concat(['chests']), value: ArrayToJson(value, dcei_wildsky_chest_proto.Chest)};
  }
  setChestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chests', key]), value: value.toJson()};
  }
  deleteChests(path) {
    return {type: 'DELETE', path: path.concat(['chests'])};
  }
  deleteChestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chests', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestGroup(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEvent_EventChestGroup(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestGroup(this);
              copy._chests = [];        for (let i of value) {
                copy._chests.push(dcei_wildsky_chest_proto.Chest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventChestGroup(this);
              copy._chests = copy._chests.concat([dcei_wildsky_chest_proto.Chest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chests.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventChestGroup(this);
              copy._chests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestGroup(this);
              copy._chests = copy._chests.slice();
              copy._chests[path[1]] = dcei_wildsky_chest_proto.Chest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventChestGroup(this);
              copy._chests = copy._chests.slice(0, path[1]).concat(copy._chests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          const oldValue = this._chests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventChestGroup(this);
          copy._chests = copy._chests.slice();
          copy._chests[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventChestGroup} other
   * @returns {MapEvent_EventChestGroup}
   */
  merge(other) {
    const copy = new MapEvent_EventChestGroup(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._chests = this._chests.concat(other._chests);
    return copy;
  }
}
MapEvent_EventChestGroup.default = new MapEvent_EventChestGroup();
class MapEvent_EventChestGroup_Builder {
  constructor(value) {
    this._value = new MapEvent_EventChestGroup(value);
  }
  build() {
    return new MapEvent_EventChestGroup(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllChests(values) {
    this._value._chests = this._value._chests.concat(values);
    return this;
  }
  addChests(value) {
    this._value._chests = this._value._chests.concat([value]);
    return this;
  }
  setChests(index, value) {
    this._value._chests = this._value._chests.concat();
    this._value._chests[index] = value;
    return this;
  }
  clearChests() {
    this._value._chests = [];
    return this;
  }
}
MapEvent_EventChestGroup.Builder = MapEvent_EventChestGroup_Builder;
class MapEvent_EventChestGroup_WithParent {
  /**
   * @param {MapEvent_EventChestGroup} value
   * @param {MapEvent_EventChestGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventChestGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfChests() {
    if (!this._selfChests) {
      this._selfChests = [];
      for (let i of this._value.chests) {
        this._selfChests.push(new dcei_wildsky_chest_proto.Chest.WithParent(i, null));
      }
    }
    return this._selfChests;
  }
  get inherentChests() {
    if (!this._inherentChests) {
      this._inherentChests = this._parent ? this._parent.chests : [];
    }
    return this._inherentChests;
  }
  get chests() {
    if (!this._allChests) {
      this._allChests = this._parent ? this._parent.chests.concat(this.selfChests) : this.selfChests;
    }
    return this._allChests;
  }
  update(current, parent) {
    const result = new MapEvent_EventChestGroup_WithParent(current, parent);
    if (this._selfChests) {
      if (this._value.chests === current.chests) {
        result._selfChests = this._selfChests;
      } else {
        result._selfChests = [];
        for (let i = 0; i < current.chests.length; i++) {
          const oldValue = this._value.chests[i];
          if (oldValue) {
            const oldCache = this._selfChests[i];
            if (oldValue === current.chests[i]) {
              result._selfChests[i] = oldCache;
            } else {
              result._selfChests[i] = oldCache.update(current.chests[i], null);
            }
          } else {
            result._selfChests[i] = new dcei_wildsky_chest_proto.Chest.WithParent(current.chests[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventChestGroup_WithParent.default = new MapEvent_EventChestGroup_WithParent(MapEvent_EventChestGroup.default, null);
MapEvent_EventChestGroup.WithParent = MapEvent_EventChestGroup_WithParent;
class MapEvent_EventChestGroup_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get chests() {
    if (!this._chests) {
      this._chests = {
        name: "chests",
        Name: "Chests",
        number: 2,
        protoType: 11,
        protoName: "chests",
        type: dcei_wildsky_chest_proto.Chest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chests;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.chests,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventChestGroup.descriptor = new MapEvent_EventChestGroup_Descriptor();
class MapEvent_EventChestConfig {
  get descriptor() {
    return MapEvent_EventChestConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUpfrontTokenAmount = false;
    this._upfrontTokenAmount = null;
    this._chestGroups = [];
  }
  isEmpty() {
    if (this._hasUpfrontTokenAmount) return false;
    if (this._chestGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventChestConfig) {
      return value;
    }
    return MapEvent_EventChestConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventChestConfig();
    if (json.upfrontTokenAmount != null) {
      result._hasUpfrontTokenAmount = true;
      result._upfrontTokenAmount = JsonToInt32.fromJson(json.upfrontTokenAmount);
    }
    result._chestGroups = JsonToList(json.chestGroups, MapEvent_EventChestGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUpfrontTokenAmount) {
      result.upfrontTokenAmount = JsonToInt32.toJson(this._upfrontTokenAmount);
    }
    if (this._chestGroups.length > 0) {
      result.chestGroups = ArrayToJson(this._chestGroups, MapEvent_EventChestGroup);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get upfrontTokenAmount() {
    return this._hasUpfrontTokenAmount ? this._upfrontTokenAmount : JsonToInt32.default;
  }
  get hasUpfrontTokenAmount() {
    return this._hasUpfrontTokenAmount;
  }
  setUpfrontTokenAmount(path, value) {
    return {type: 'SET', path: path.concat(['upfrontTokenAmount']), value};
  }
  deleteUpfrontTokenAmount(path) {
    return {type: 'DELETE', path: path.concat(['upfrontTokenAmount'])};
  }
  /**
   * @returns {MapEvent_EventChestGroup[]}
   */
  get chestGroups() {
    return this._chestGroups;
  }
  addChestGroups(path, value) {
    return {type: 'ADD', path: path.concat(['chestGroups']), value: value.toJson()};
  }
  setChestGroups(path, value) {
    return {type: 'SET', path: path.concat(['chestGroups']), value: ArrayToJson(value, MapEvent_EventChestGroup)};
  }
  setChestGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chestGroups', key]), value: value.toJson()};
  }
  deleteChestGroups(path) {
    return {type: 'DELETE', path: path.concat(['chestGroups'])};
  }
  deleteChestGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chestGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "upfrontTokenAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestConfig(this);
              copy._hasUpfrontTokenAmount = true;
              copy._upfrontTokenAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpfrontTokenAmount) {
                return this;
              }
              const copy = new MapEvent_EventChestConfig(this);
              copy._hasUpfrontTokenAmount = false;
              copy._upfrontTokenAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestConfig(this);
              copy._chestGroups = [];        for (let i of value) {
                copy._chestGroups.push(MapEvent_EventChestGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventChestConfig(this);
              copy._chestGroups = copy._chestGroups.concat([MapEvent_EventChestGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chestGroups.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventChestConfig(this);
              copy._chestGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chestGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventChestConfig(this);
              copy._chestGroups = copy._chestGroups.slice();
              copy._chestGroups[path[1]] = MapEvent_EventChestGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventChestConfig(this);
              copy._chestGroups = copy._chestGroups.slice(0, path[1]).concat(copy._chestGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chestGroups.length) {
            return this;
          }
          const oldValue = this._chestGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventChestConfig(this);
          copy._chestGroups = copy._chestGroups.slice();
          copy._chestGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventChestConfig} other
   * @returns {MapEvent_EventChestConfig}
   */
  merge(other) {
    const copy = new MapEvent_EventChestConfig(this);
    if (other._hasUpfrontTokenAmount) {
      copy._hasUpfrontTokenAmount = true;
      copy._upfrontTokenAmount = other._upfrontTokenAmount;
    }
    copy._chestGroups = this._chestGroups.concat(other._chestGroups);
    return copy;
  }
}
MapEvent_EventChestConfig.default = new MapEvent_EventChestConfig();
class MapEvent_EventChestConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_EventChestConfig(value);
  }
  build() {
    return new MapEvent_EventChestConfig(this._value);
  }
  setUpfrontTokenAmount(value) {
    this._value._hasUpfrontTokenAmount = true;
    this._value._upfrontTokenAmount = value;
    return this;
  }
  deleteUpfrontTokenAmount() {
    this._value._hasUpfrontTokenAmount = false;
    this._value._upfrontTokenAmount = null;
    return this;
  }
  addAllChestGroups(values) {
    this._value._chestGroups = this._value._chestGroups.concat(values);
    return this;
  }
  addChestGroups(value) {
    this._value._chestGroups = this._value._chestGroups.concat([value]);
    return this;
  }
  setChestGroups(index, value) {
    this._value._chestGroups = this._value._chestGroups.concat();
    this._value._chestGroups[index] = value;
    return this;
  }
  clearChestGroups() {
    this._value._chestGroups = [];
    return this;
  }
}
MapEvent_EventChestConfig.Builder = MapEvent_EventChestConfig_Builder;
class MapEvent_EventChestConfig_WithParent {
  /**
   * @param {MapEvent_EventChestConfig} value
   * @param {MapEvent_EventChestConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventChestConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUpfrontTokenAmount() {
    if (this._cachedHasUpfrontTokenAmount === undefined) {
      if (this._value.hasUpfrontTokenAmount) {
        this._cachedHasUpfrontTokenAmount = true;
      } else {
        this._cachedHasUpfrontTokenAmount = this._parent ? this._parent.hasUpfrontTokenAmount : false;
      }
    }
    return this._cachedHasUpfrontTokenAmount;
  }
  get upfrontTokenAmount() {
    if (this._cachedUpfrontTokenAmount === undefined) {
      if (this._value.hasUpfrontTokenAmount) {
        this._cachedUpfrontTokenAmount = this._value.upfrontTokenAmount;
      } else {
        this._cachedUpfrontTokenAmount = this._parent ? this._parent.upfrontTokenAmount : this._value.upfrontTokenAmount;
      }
    }
    return this._cachedUpfrontTokenAmount;
  }
  get selfChestGroups() {
    if (!this._selfChestGroups) {
      this._selfChestGroups = [];
      for (let i of this._value.chestGroups) {
        this._selfChestGroups.push(new MapEvent_EventChestGroup.WithParent(i, null));
      }
    }
    return this._selfChestGroups;
  }
  get inherentChestGroups() {
    if (!this._inherentChestGroups) {
      this._inherentChestGroups = this._parent ? this._parent.chestGroups : [];
    }
    return this._inherentChestGroups;
  }
  get chestGroups() {
    if (!this._allChestGroups) {
      this._allChestGroups = this._parent ? this._parent.chestGroups.concat(this.selfChestGroups) : this.selfChestGroups;
    }
    return this._allChestGroups;
  }
  update(current, parent) {
    const result = new MapEvent_EventChestConfig_WithParent(current, parent);
    if (this._selfChestGroups) {
      if (this._value.chestGroups === current.chestGroups) {
        result._selfChestGroups = this._selfChestGroups;
      } else {
        result._selfChestGroups = [];
        for (let i = 0; i < current.chestGroups.length; i++) {
          const oldValue = this._value.chestGroups[i];
          if (oldValue) {
            const oldCache = this._selfChestGroups[i];
            if (oldValue === current.chestGroups[i]) {
              result._selfChestGroups[i] = oldCache;
            } else {
              result._selfChestGroups[i] = oldCache.update(current.chestGroups[i], null);
            }
          } else {
            result._selfChestGroups[i] = new MapEvent_EventChestGroup.WithParent(current.chestGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventChestConfig_WithParent.default = new MapEvent_EventChestConfig_WithParent(MapEvent_EventChestConfig.default, null);
MapEvent_EventChestConfig.WithParent = MapEvent_EventChestConfig_WithParent;
class MapEvent_EventChestConfig_Descriptor {
  get upfrontTokenAmount() {
    if (!this._upfrontTokenAmount) {
      this._upfrontTokenAmount = {
        name: "upfrontTokenAmount",
        Name: "UpfrontTokenAmount",
        number: 1,
        protoType: 5,
        protoName: "upfront_token_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upfrontTokenAmount;
  }
  get chestGroups() {
    if (!this._chestGroups) {
      this._chestGroups = {
        name: "chestGroups",
        Name: "ChestGroups",
        number: 2,
        protoType: 11,
        protoName: "chest_groups",
        type: MapEvent_EventChestGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.upfrontTokenAmount,
        this.chestGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUpfrontTokenAmount",
        Name: "DummyOneofForUpfrontTokenAmount",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventChestConfig.descriptor = new MapEvent_EventChestConfig_Descriptor();
class MapEvent_EventMarketConfig_EventStoreTab {
  get descriptor() {
    return MapEvent_EventMarketConfig_EventStoreTab.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStoreTab = false;
    this._storeTab = null;
    this._hasTokenKey = false;
    this._tokenKey = null;
    this._hasResetTokenWhenOpen = false;
    this._resetTokenWhenOpen = null;
  }
  isEmpty() {
    if (this._hasStoreTab) return false;
    if (this._hasTokenKey) return false;
    if (this._hasResetTokenWhenOpen) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventMarketConfig_EventStoreTab) {
      return value;
    }
    return MapEvent_EventMarketConfig_EventStoreTab.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventMarketConfig_EventStoreTab();
    if (json.storeTab != null) {
      result._hasStoreTab = true;
      result._storeTab = JsonToString.fromJson(json.storeTab);
    }
    if (json.tokenKey != null) {
      result._hasTokenKey = true;
      result._tokenKey = JsonToString.fromJson(json.tokenKey);
    }
    if (json.resetTokenWhenOpen != null) {
      result._hasResetTokenWhenOpen = true;
      result._resetTokenWhenOpen = JsonToBoolean.fromJson(json.resetTokenWhenOpen);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStoreTab) {
      result.storeTab = JsonToString.toJson(this._storeTab);
    }
    if (this._hasTokenKey) {
      result.tokenKey = JsonToString.toJson(this._tokenKey);
    }
    if (this._hasResetTokenWhenOpen) {
      result.resetTokenWhenOpen = JsonToBoolean.toJson(this._resetTokenWhenOpen);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get storeTab() {
    return this._hasStoreTab ? this._storeTab : JsonToString.default;
  }
  get hasStoreTab() {
    return this._hasStoreTab;
  }
  setStoreTab(path, value) {
    return {type: 'SET', path: path.concat(['storeTab']), value};
  }
  deleteStoreTab(path) {
    return {type: 'DELETE', path: path.concat(['storeTab'])};
  }
  /**
   * @returns {string}
   */
  get tokenKey() {
    return this._hasTokenKey ? this._tokenKey : JsonToString.default;
  }
  get hasTokenKey() {
    return this._hasTokenKey;
  }
  setTokenKey(path, value) {
    return {type: 'SET', path: path.concat(['tokenKey']), value};
  }
  deleteTokenKey(path) {
    return {type: 'DELETE', path: path.concat(['tokenKey'])};
  }
  /**
   * @returns {boolean}
   */
  get resetTokenWhenOpen() {
    return this._hasResetTokenWhenOpen ? this._resetTokenWhenOpen : JsonToBoolean.default;
  }
  get hasResetTokenWhenOpen() {
    return this._hasResetTokenWhenOpen;
  }
  setResetTokenWhenOpen(path, value) {
    return {type: 'SET', path: path.concat(['resetTokenWhenOpen']), value};
  }
  deleteResetTokenWhenOpen(path) {
    return {type: 'DELETE', path: path.concat(['resetTokenWhenOpen'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storeTab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasStoreTab = true;
              copy._storeTab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStoreTab) {
                return this;
              }
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasStoreTab = false;
              copy._storeTab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tokenKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasTokenKey = true;
              copy._tokenKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTokenKey) {
                return this;
              }
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasTokenKey = false;
              copy._tokenKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resetTokenWhenOpen": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasResetTokenWhenOpen = true;
              copy._resetTokenWhenOpen = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetTokenWhenOpen) {
                return this;
              }
              const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
              copy._hasResetTokenWhenOpen = false;
              copy._resetTokenWhenOpen = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventMarketConfig_EventStoreTab} other
   * @returns {MapEvent_EventMarketConfig_EventStoreTab}
   */
  merge(other) {
    const copy = new MapEvent_EventMarketConfig_EventStoreTab(this);
    if (other._hasStoreTab) {
      copy._hasStoreTab = true;
      copy._storeTab = other._storeTab;
    }
    if (other._hasTokenKey) {
      copy._hasTokenKey = true;
      copy._tokenKey = other._tokenKey;
    }
    if (other._hasResetTokenWhenOpen) {
      copy._hasResetTokenWhenOpen = true;
      copy._resetTokenWhenOpen = other._resetTokenWhenOpen;
    }
    return copy;
  }
}
MapEvent_EventMarketConfig_EventStoreTab.default = new MapEvent_EventMarketConfig_EventStoreTab();
class MapEvent_EventMarketConfig_EventStoreTab_Builder {
  constructor(value) {
    this._value = new MapEvent_EventMarketConfig_EventStoreTab(value);
  }
  build() {
    return new MapEvent_EventMarketConfig_EventStoreTab(this._value);
  }
  setStoreTab(value) {
    this._value._hasStoreTab = true;
    this._value._storeTab = value;
    return this;
  }
  deleteStoreTab() {
    this._value._hasStoreTab = false;
    this._value._storeTab = null;
    return this;
  }
  setTokenKey(value) {
    this._value._hasTokenKey = true;
    this._value._tokenKey = value;
    return this;
  }
  deleteTokenKey() {
    this._value._hasTokenKey = false;
    this._value._tokenKey = null;
    return this;
  }
  setResetTokenWhenOpen(value) {
    this._value._hasResetTokenWhenOpen = true;
    this._value._resetTokenWhenOpen = value;
    return this;
  }
  deleteResetTokenWhenOpen() {
    this._value._hasResetTokenWhenOpen = false;
    this._value._resetTokenWhenOpen = null;
    return this;
  }
}
MapEvent_EventMarketConfig_EventStoreTab.Builder = MapEvent_EventMarketConfig_EventStoreTab_Builder;
class MapEvent_EventMarketConfig_EventStoreTab_WithParent {
  /**
   * @param {MapEvent_EventMarketConfig_EventStoreTab} value
   * @param {MapEvent_EventMarketConfig_EventStoreTab_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventMarketConfig_EventStoreTab.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStoreTab() {
    if (this._cachedHasStoreTab === undefined) {
      if (this._value.hasStoreTab) {
        this._cachedHasStoreTab = true;
      } else {
        this._cachedHasStoreTab = this._parent ? this._parent.hasStoreTab : false;
      }
    }
    return this._cachedHasStoreTab;
  }
  get storeTab() {
    if (this._cachedStoreTab === undefined) {
      if (this._value.hasStoreTab) {
        this._cachedStoreTab = this._value.storeTab;
      } else {
        this._cachedStoreTab = this._parent ? this._parent.storeTab : this._value.storeTab;
      }
    }
    return this._cachedStoreTab;
  }
  get hasTokenKey() {
    if (this._cachedHasTokenKey === undefined) {
      if (this._value.hasTokenKey) {
        this._cachedHasTokenKey = true;
      } else {
        this._cachedHasTokenKey = this._parent ? this._parent.hasTokenKey : false;
      }
    }
    return this._cachedHasTokenKey;
  }
  get tokenKey() {
    if (this._cachedTokenKey === undefined) {
      if (this._value.hasTokenKey) {
        this._cachedTokenKey = this._value.tokenKey;
      } else {
        this._cachedTokenKey = this._parent ? this._parent.tokenKey : this._value.tokenKey;
      }
    }
    return this._cachedTokenKey;
  }
  get hasResetTokenWhenOpen() {
    if (this._cachedHasResetTokenWhenOpen === undefined) {
      if (this._value.hasResetTokenWhenOpen) {
        this._cachedHasResetTokenWhenOpen = true;
      } else {
        this._cachedHasResetTokenWhenOpen = this._parent ? this._parent.hasResetTokenWhenOpen : false;
      }
    }
    return this._cachedHasResetTokenWhenOpen;
  }
  get resetTokenWhenOpen() {
    if (this._cachedResetTokenWhenOpen === undefined) {
      if (this._value.hasResetTokenWhenOpen) {
        this._cachedResetTokenWhenOpen = this._value.resetTokenWhenOpen;
      } else {
        this._cachedResetTokenWhenOpen = this._parent ? this._parent.resetTokenWhenOpen : this._value.resetTokenWhenOpen;
      }
    }
    return this._cachedResetTokenWhenOpen;
  }
  update(current, parent) {
    const result = new MapEvent_EventMarketConfig_EventStoreTab_WithParent(current, parent);
    return result;
  }
}
MapEvent_EventMarketConfig_EventStoreTab_WithParent.default = new MapEvent_EventMarketConfig_EventStoreTab_WithParent(MapEvent_EventMarketConfig_EventStoreTab.default, null);
MapEvent_EventMarketConfig_EventStoreTab.WithParent = MapEvent_EventMarketConfig_EventStoreTab_WithParent;
class MapEvent_EventMarketConfig_EventStoreTab_Descriptor {
  get storeTab() {
    if (!this._storeTab) {
      this._storeTab = {
        name: "storeTab",
        Name: "StoreTab",
        number: 1,
        protoType: 9,
        protoName: "store_tab",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storeTab;
  }
  get tokenKey() {
    if (!this._tokenKey) {
      this._tokenKey = {
        name: "tokenKey",
        Name: "TokenKey",
        number: 2,
        protoType: 9,
        protoName: "token_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokenKey;
  }
  get resetTokenWhenOpen() {
    if (!this._resetTokenWhenOpen) {
      this._resetTokenWhenOpen = {
        name: "resetTokenWhenOpen",
        Name: "ResetTokenWhenOpen",
        number: 3,
        protoType: 8,
        protoName: "reset_token_when_open",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetTokenWhenOpen;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storeTab,
        this.tokenKey,
        this.resetTokenWhenOpen,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStoreTab",
        Name: "DummyOneofForStoreTab",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTokenKey",
        Name: "DummyOneofForTokenKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetTokenWhenOpen",
        Name: "DummyOneofForResetTokenWhenOpen",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_EventMarketConfig_EventStoreTab.descriptor = new MapEvent_EventMarketConfig_EventStoreTab_Descriptor();
class MapEvent_EventMarketConfig {
  get descriptor() {
    return MapEvent_EventMarketConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._storeTabs = [];
  }
  isEmpty() {
    if (this._storeTabs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_EventMarketConfig) {
      return value;
    }
    return MapEvent_EventMarketConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_EventMarketConfig();
    result._storeTabs = JsonToList(json.storeTabs, MapEvent_EventMarketConfig_EventStoreTab);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._storeTabs.length > 0) {
      result.storeTabs = ArrayToJson(this._storeTabs, MapEvent_EventMarketConfig_EventStoreTab);
    }
    return result;
  }
  /**
   * @returns {MapEvent_EventMarketConfig_EventStoreTab[]}
   */
  get storeTabs() {
    return this._storeTabs;
  }
  addStoreTabs(path, value) {
    return {type: 'ADD', path: path.concat(['storeTabs']), value: value.toJson()};
  }
  setStoreTabs(path, value) {
    return {type: 'SET', path: path.concat(['storeTabs']), value: ArrayToJson(value, MapEvent_EventMarketConfig_EventStoreTab)};
  }
  setStoreTabsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['storeTabs', key]), value: value.toJson()};
  }
  deleteStoreTabs(path) {
    return {type: 'DELETE', path: path.concat(['storeTabs'])};
  }
  deleteStoreTabsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['storeTabs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storeTabs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMarketConfig(this);
              copy._storeTabs = [];        for (let i of value) {
                copy._storeTabs.push(MapEvent_EventMarketConfig_EventStoreTab.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent_EventMarketConfig(this);
              copy._storeTabs = copy._storeTabs.concat([MapEvent_EventMarketConfig_EventStoreTab.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._storeTabs.length === 0) {
                return this;
              }
              const copy = new MapEvent_EventMarketConfig(this);
              copy._storeTabs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._storeTabs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_EventMarketConfig(this);
              copy._storeTabs = copy._storeTabs.slice();
              copy._storeTabs[path[1]] = MapEvent_EventMarketConfig_EventStoreTab.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent_EventMarketConfig(this);
              copy._storeTabs = copy._storeTabs.slice(0, path[1]).concat(copy._storeTabs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._storeTabs.length) {
            return this;
          }
          const oldValue = this._storeTabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent_EventMarketConfig(this);
          copy._storeTabs = copy._storeTabs.slice();
          copy._storeTabs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_EventMarketConfig} other
   * @returns {MapEvent_EventMarketConfig}
   */
  merge(other) {
    const copy = new MapEvent_EventMarketConfig(this);
    copy._storeTabs = this._storeTabs.concat(other._storeTabs);
    return copy;
  }
}
MapEvent_EventMarketConfig.default = new MapEvent_EventMarketConfig();
MapEvent_EventMarketConfig.EventStoreTab = MapEvent_EventMarketConfig_EventStoreTab;
class MapEvent_EventMarketConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_EventMarketConfig(value);
  }
  build() {
    return new MapEvent_EventMarketConfig(this._value);
  }
  addAllStoreTabs(values) {
    this._value._storeTabs = this._value._storeTabs.concat(values);
    return this;
  }
  addStoreTabs(value) {
    this._value._storeTabs = this._value._storeTabs.concat([value]);
    return this;
  }
  setStoreTabs(index, value) {
    this._value._storeTabs = this._value._storeTabs.concat();
    this._value._storeTabs[index] = value;
    return this;
  }
  clearStoreTabs() {
    this._value._storeTabs = [];
    return this;
  }
}
MapEvent_EventMarketConfig.Builder = MapEvent_EventMarketConfig_Builder;
class MapEvent_EventMarketConfig_WithParent {
  /**
   * @param {MapEvent_EventMarketConfig} value
   * @param {MapEvent_EventMarketConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_EventMarketConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfStoreTabs() {
    if (!this._selfStoreTabs) {
      this._selfStoreTabs = [];
      for (let i of this._value.storeTabs) {
        this._selfStoreTabs.push(new MapEvent_EventMarketConfig_EventStoreTab.WithParent(i, null));
      }
    }
    return this._selfStoreTabs;
  }
  get inherentStoreTabs() {
    if (!this._inherentStoreTabs) {
      this._inherentStoreTabs = this._parent ? this._parent.storeTabs : [];
    }
    return this._inherentStoreTabs;
  }
  get storeTabs() {
    if (!this._allStoreTabs) {
      this._allStoreTabs = this._parent ? this._parent.storeTabs.concat(this.selfStoreTabs) : this.selfStoreTabs;
    }
    return this._allStoreTabs;
  }
  update(current, parent) {
    const result = new MapEvent_EventMarketConfig_WithParent(current, parent);
    if (this._selfStoreTabs) {
      if (this._value.storeTabs === current.storeTabs) {
        result._selfStoreTabs = this._selfStoreTabs;
      } else {
        result._selfStoreTabs = [];
        for (let i = 0; i < current.storeTabs.length; i++) {
          const oldValue = this._value.storeTabs[i];
          if (oldValue) {
            const oldCache = this._selfStoreTabs[i];
            if (oldValue === current.storeTabs[i]) {
              result._selfStoreTabs[i] = oldCache;
            } else {
              result._selfStoreTabs[i] = oldCache.update(current.storeTabs[i], null);
            }
          } else {
            result._selfStoreTabs[i] = new MapEvent_EventMarketConfig_EventStoreTab.WithParent(current.storeTabs[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEvent_EventMarketConfig_WithParent.default = new MapEvent_EventMarketConfig_WithParent(MapEvent_EventMarketConfig.default, null);
MapEvent_EventMarketConfig.WithParent = MapEvent_EventMarketConfig_WithParent;
class MapEvent_EventMarketConfig_Descriptor {
  get storeTabs() {
    if (!this._storeTabs) {
      this._storeTabs = {
        name: "storeTabs",
        Name: "StoreTabs",
        number: 1,
        protoType: 11,
        protoName: "store_tabs",
        type: MapEvent_EventMarketConfig_EventStoreTab,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storeTabs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storeTabs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapEvent_EventMarketConfig.descriptor = new MapEvent_EventMarketConfig_Descriptor();
class MapEvent_TrophyConfig {
  get descriptor() {
    return MapEvent_TrophyConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMaxRank = false;
    this._maxRank = null;
    this._hasAffinity = false;
    this._affinity = null;
    this._hasHighestTrophyId = false;
    this._highestTrophyId = null;
  }
  isEmpty() {
    if (this._hasMaxRank) return false;
    if (this._hasAffinity) return false;
    if (this._hasHighestTrophyId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent_TrophyConfig) {
      return value;
    }
    return MapEvent_TrophyConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent_TrophyConfig();
    if (json.maxRank != null) {
      result._hasMaxRank = true;
      result._maxRank = JsonToInt32.fromJson(json.maxRank);
    }
    if (json.affinity != null) {
      result._hasAffinity = true;
      result._affinity = dcei_wildsky_card_proto.CardDefinition.Affinity.fromJson(json.affinity);
    }
    if (json.highestTrophyId != null) {
      result._hasHighestTrophyId = true;
      result._highestTrophyId = JsonToInt32.fromJson(json.highestTrophyId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMaxRank) {
      result.maxRank = JsonToInt32.toJson(this._maxRank);
    }
    if (this._hasAffinity) {
      result.affinity = dcei_wildsky_card_proto.CardDefinition.Affinity.toJson(this._affinity);
    }
    if (this._hasHighestTrophyId) {
      result.highestTrophyId = JsonToInt32.toJson(this._highestTrophyId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get maxRank() {
    return this._hasMaxRank ? this._maxRank : JsonToInt32.default;
  }
  get hasMaxRank() {
    return this._hasMaxRank;
  }
  setMaxRank(path, value) {
    return {type: 'SET', path: path.concat(['maxRank']), value};
  }
  deleteMaxRank(path) {
    return {type: 'DELETE', path: path.concat(['maxRank'])};
  }
  /**
   * @returns {number}
   */
  get affinity() {
    return this._hasAffinity ? this._affinity : dcei_wildsky_card_proto.CardDefinition.Affinity.default;
  }
  get hasAffinity() {
    return this._hasAffinity;
  }
  setAffinity(path, value) {
    return {type: 'SET', path: path.concat(['affinity']), value};
  }
  deleteAffinity(path) {
    return {type: 'DELETE', path: path.concat(['affinity'])};
  }
  /**
   * @returns {number}
   */
  get highestTrophyId() {
    return this._hasHighestTrophyId ? this._highestTrophyId : JsonToInt32.default;
  }
  get hasHighestTrophyId() {
    return this._hasHighestTrophyId;
  }
  setHighestTrophyId(path, value) {
    return {type: 'SET', path: path.concat(['highestTrophyId']), value};
  }
  deleteHighestTrophyId(path) {
    return {type: 'DELETE', path: path.concat(['highestTrophyId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "maxRank": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasMaxRank = true;
              copy._maxRank = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxRank) {
                return this;
              }
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasMaxRank = false;
              copy._maxRank = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasAffinity = true;
              copy._affinity = dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinity) {
                return this;
              }
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasAffinity = false;
              copy._affinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "highestTrophyId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasHighestTrophyId = true;
              copy._highestTrophyId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHighestTrophyId) {
                return this;
              }
              const copy = new MapEvent_TrophyConfig(this);
              copy._hasHighestTrophyId = false;
              copy._highestTrophyId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent_TrophyConfig} other
   * @returns {MapEvent_TrophyConfig}
   */
  merge(other) {
    const copy = new MapEvent_TrophyConfig(this);
    if (other._hasMaxRank) {
      copy._hasMaxRank = true;
      copy._maxRank = other._maxRank;
    }
    if (other._hasAffinity) {
      copy._hasAffinity = true;
      copy._affinity = other._affinity;
    }
    if (other._hasHighestTrophyId) {
      copy._hasHighestTrophyId = true;
      copy._highestTrophyId = other._highestTrophyId;
    }
    return copy;
  }
}
MapEvent_TrophyConfig.default = new MapEvent_TrophyConfig();
class MapEvent_TrophyConfig_Builder {
  constructor(value) {
    this._value = new MapEvent_TrophyConfig(value);
  }
  build() {
    return new MapEvent_TrophyConfig(this._value);
  }
  setMaxRank(value) {
    this._value._hasMaxRank = true;
    this._value._maxRank = value;
    return this;
  }
  deleteMaxRank() {
    this._value._hasMaxRank = false;
    this._value._maxRank = null;
    return this;
  }
  setAffinity(value) {
    this._value._hasAffinity = true;
    this._value._affinity = value;
    return this;
  }
  deleteAffinity() {
    this._value._hasAffinity = false;
    this._value._affinity = null;
    return this;
  }
  setHighestTrophyId(value) {
    this._value._hasHighestTrophyId = true;
    this._value._highestTrophyId = value;
    return this;
  }
  deleteHighestTrophyId() {
    this._value._hasHighestTrophyId = false;
    this._value._highestTrophyId = null;
    return this;
  }
}
MapEvent_TrophyConfig.Builder = MapEvent_TrophyConfig_Builder;
class MapEvent_TrophyConfig_WithParent {
  /**
   * @param {MapEvent_TrophyConfig} value
   * @param {MapEvent_TrophyConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent_TrophyConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMaxRank() {
    if (this._cachedHasMaxRank === undefined) {
      if (this._value.hasMaxRank) {
        this._cachedHasMaxRank = true;
      } else {
        this._cachedHasMaxRank = this._parent ? this._parent.hasMaxRank : false;
      }
    }
    return this._cachedHasMaxRank;
  }
  get maxRank() {
    if (this._cachedMaxRank === undefined) {
      if (this._value.hasMaxRank) {
        this._cachedMaxRank = this._value.maxRank;
      } else {
        this._cachedMaxRank = this._parent ? this._parent.maxRank : this._value.maxRank;
      }
    }
    return this._cachedMaxRank;
  }
  get hasAffinity() {
    if (this._cachedHasAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedHasAffinity = true;
      } else {
        this._cachedHasAffinity = this._parent ? this._parent.hasAffinity : false;
      }
    }
    return this._cachedHasAffinity;
  }
  get affinity() {
    if (this._cachedAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedAffinity = this._value.affinity;
      } else {
        this._cachedAffinity = this._parent ? this._parent.affinity : this._value.affinity;
      }
    }
    return this._cachedAffinity;
  }
  get hasHighestTrophyId() {
    if (this._cachedHasHighestTrophyId === undefined) {
      if (this._value.hasHighestTrophyId) {
        this._cachedHasHighestTrophyId = true;
      } else {
        this._cachedHasHighestTrophyId = this._parent ? this._parent.hasHighestTrophyId : false;
      }
    }
    return this._cachedHasHighestTrophyId;
  }
  get highestTrophyId() {
    if (this._cachedHighestTrophyId === undefined) {
      if (this._value.hasHighestTrophyId) {
        this._cachedHighestTrophyId = this._value.highestTrophyId;
      } else {
        this._cachedHighestTrophyId = this._parent ? this._parent.highestTrophyId : this._value.highestTrophyId;
      }
    }
    return this._cachedHighestTrophyId;
  }
  update(current, parent) {
    const result = new MapEvent_TrophyConfig_WithParent(current, parent);
    return result;
  }
}
MapEvent_TrophyConfig_WithParent.default = new MapEvent_TrophyConfig_WithParent(MapEvent_TrophyConfig.default, null);
MapEvent_TrophyConfig.WithParent = MapEvent_TrophyConfig_WithParent;
class MapEvent_TrophyConfig_Descriptor {
  get maxRank() {
    if (!this._maxRank) {
      this._maxRank = {
        name: "maxRank",
        Name: "MaxRank",
        number: 1,
        protoType: 5,
        protoName: "max_rank",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxRank;
  }
  get affinity() {
    if (!this._affinity) {
      this._affinity = {
        name: "affinity",
        Name: "Affinity",
        number: 2,
        protoType: 14,
        protoName: "affinity",
        type: dcei_wildsky_card_proto.CardDefinition.Affinity,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinity;
  }
  get highestTrophyId() {
    if (!this._highestTrophyId) {
      this._highestTrophyId = {
        name: "highestTrophyId",
        Name: "HighestTrophyId",
        number: 3,
        protoType: 5,
        protoName: "highest_trophy_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._highestTrophyId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.maxRank,
        this.affinity,
        this.highestTrophyId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMaxRank",
        Name: "DummyOneofForMaxRank",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinity",
        Name: "DummyOneofForAffinity",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHighestTrophyId",
        Name: "DummyOneofForHighestTrophyId",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent_TrophyConfig.descriptor = new MapEvent_TrophyConfig_Descriptor();
export class MapEvent {
  get descriptor() {
    return MapEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasEventName = false;
    this._eventName = null;
    this._hasEventDurationInHours = false;
    this._eventDurationInHours = null;
    this._hasPostEventDurationInHours = false;
    this._postEventDurationInHours = null;
    this._hasLevelAccessKey = false;
    this._levelAccessKey = null;
    this._hasEventPointKey = false;
    this._eventPointKey = null;
    this._hasEventTokenKey = false;
    this._eventTokenKey = null;
    this._hasEventTokenFontSprite = false;
    this._eventTokenFontSprite = null;
    this._hasGoldPassSubscriptionId = false;
    this._goldPassSubscriptionId = null;
    this._hasGoldPassProductId = false;
    this._goldPassProductId = null;
    this._bundleIds = [];
    this._bundlesAvailableWhenEventOpen = [];
    this._hasEventMarketConfig = false;
    this._eventMarketConfig = null;
    this._hasEventMilestonePath = false;
    this._eventMilestonePath = null;
    this._hasEventLevel = false;
    this._eventLevel = null;
    this._hasEventQuest = false;
    this._eventQuest = null;
    this._hasEnableLiveEvent = false;
    this._enableLiveEvent = null;
    this._hasLiveEventConfig = false;
    this._liveEventConfig = null;
    this._hasEventGuildConfig = false;
    this._eventGuildConfig = null;
    this._hasGuildBossConfig = false;
    this._guildBossConfig = null;
    this._hasChestConfig = false;
    this._chestConfig = null;
    this._chestDropItemsInfo = [];
    this._hasTokensAmountPerPurchase = false;
    this._tokensAmountPerPurchase = null;
    this._tokensPriceList = [];
    this._hasTokensPriceResetTimeInSecs = false;
    this._tokensPriceResetTimeInSecs = null;
    this._hasEventChestPicPath = false;
    this._eventChestPicPath = null;
    this._hasEventBundlePicPath = false;
    this._eventBundlePicPath = null;
    this._hasShieldKey = false;
    this._shieldKey = null;
    this._hasShieldPrice = false;
    this._shieldPrice = null;
    this._hasUpfrontShieldAmount = false;
    this._upfrontShieldAmount = null;
    this._hasShieldAmountPerPurchase = false;
    this._shieldAmountPerPurchase = null;
    this._hasOverviewPanel = false;
    this._overviewPanel = null;
    this._triggerTypeCase = 0;
    this._triggerTypeValue = null;
    this._hasCardBoostInfo = false;
    this._cardBoostInfo = null;
    this._hasFeaturedCard = false;
    this._featuredCard = null;
    this._hasFeaturedSkin = false;
    this._featuredSkin = null;
    this._hasTrophyConfig = false;
    this._trophyConfig = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasEventName) return false;
    if (this._hasEventDurationInHours) return false;
    if (this._hasPostEventDurationInHours) return false;
    if (this._hasLevelAccessKey && !this._levelAccessKey.isEmpty()) return false;
    if (this._hasEventPointKey) return false;
    if (this._hasEventTokenKey) return false;
    if (this._hasEventTokenFontSprite) return false;
    if (this._hasGoldPassSubscriptionId) return false;
    if (this._hasGoldPassProductId) return false;
    if (this._bundleIds.length > 0) return false;
    if (this._bundlesAvailableWhenEventOpen.length > 0) return false;
    if (this._hasEventMarketConfig && !this._eventMarketConfig.isEmpty()) return false;
    if (this._hasEventMilestonePath && !this._eventMilestonePath.isEmpty()) return false;
    if (this._hasEventLevel && !this._eventLevel.isEmpty()) return false;
    if (this._hasEventQuest && !this._eventQuest.isEmpty()) return false;
    if (this._hasEnableLiveEvent) return false;
    if (this._hasLiveEventConfig && !this._liveEventConfig.isEmpty()) return false;
    if (this._hasEventGuildConfig && !this._eventGuildConfig.isEmpty()) return false;
    if (this._hasGuildBossConfig && !this._guildBossConfig.isEmpty()) return false;
    if (this._hasChestConfig && !this._chestConfig.isEmpty()) return false;
    if (this._chestDropItemsInfo.length > 0) return false;
    if (this._hasTokensAmountPerPurchase) return false;
    if (this._tokensPriceList.length > 0) return false;
    if (this._hasTokensPriceResetTimeInSecs) return false;
    if (this._hasEventChestPicPath) return false;
    if (this._hasEventBundlePicPath) return false;
    if (this._hasShieldKey) return false;
    if (this._hasShieldPrice) return false;
    if (this._hasUpfrontShieldAmount) return false;
    if (this._hasShieldAmountPerPurchase) return false;
    if (this._hasOverviewPanel) return false;
    if (this._triggerTypeCase !== 0) return false;
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) return false;
    if (this._hasFeaturedCard) return false;
    if (this._hasFeaturedSkin && !this._featuredSkin.isEmpty()) return false;
    if (this._hasTrophyConfig && !this._trophyConfig.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEvent) {
      return value;
    }
    return MapEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEvent();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.eventName != null) {
      result._hasEventName = true;
      result._eventName = JsonToString.fromJson(json.eventName);
    }
    if (json.eventDurationInHours != null) {
      result._hasEventDurationInHours = true;
      result._eventDurationInHours = JsonToInt32.fromJson(json.eventDurationInHours);
    }
    if (json.postEventDurationInHours != null) {
      result._hasPostEventDurationInHours = true;
      result._postEventDurationInHours = JsonToInt32.fromJson(json.postEventDurationInHours);
    }
    if (json.levelAccessKey != null) {
      result._hasLevelAccessKey = true;
      result._levelAccessKey = MapEvent_LevelAccessKey.fromJson(json.levelAccessKey);
    }
    if (json.eventPointKey != null) {
      result._hasEventPointKey = true;
      result._eventPointKey = JsonToString.fromJson(json.eventPointKey);
    }
    if (json.eventTokenKey != null) {
      result._hasEventTokenKey = true;
      result._eventTokenKey = JsonToString.fromJson(json.eventTokenKey);
    }
    if (json.eventTokenFontSprite != null) {
      result._hasEventTokenFontSprite = true;
      result._eventTokenFontSprite = JsonToString.fromJson(json.eventTokenFontSprite);
    }
    if (json.goldPassSubscriptionId != null) {
      result._hasGoldPassSubscriptionId = true;
      result._goldPassSubscriptionId = JsonToString.fromJson(json.goldPassSubscriptionId);
    }
    if (json.goldPassProductId != null) {
      result._hasGoldPassProductId = true;
      result._goldPassProductId = JsonToString.fromJson(json.goldPassProductId);
    }
    result._bundleIds = JsonToList(json.bundleIds, JsonToString);
    result._bundlesAvailableWhenEventOpen = JsonToList(json.bundlesAvailableWhenEventOpen, JsonToString);
    if (json.eventMarketConfig != null) {
      result._hasEventMarketConfig = true;
      result._eventMarketConfig = MapEvent_EventMarketConfig.fromJson(json.eventMarketConfig);
    }
    if (json.eventMilestonePath != null) {
      result._hasEventMilestonePath = true;
      result._eventMilestonePath = MapEvent_EventMilestonePath.fromJson(json.eventMilestonePath);
    }
    if (json.eventLevel != null) {
      result._hasEventLevel = true;
      result._eventLevel = MapEvent_EventLevel.fromJson(json.eventLevel);
    }
    if (json.eventQuest != null) {
      result._hasEventQuest = true;
      result._eventQuest = MapEvent_EventQuest.fromJson(json.eventQuest);
    }
    if (json.enableLiveEvent != null) {
      result._hasEnableLiveEvent = true;
      result._enableLiveEvent = JsonToBoolean.fromJson(json.enableLiveEvent);
    }
    if (json.liveEventConfig != null) {
      result._hasLiveEventConfig = true;
      result._liveEventConfig = MapEvent_LiveEventConfig.fromJson(json.liveEventConfig);
    }
    if (json.eventGuildConfig != null) {
      result._hasEventGuildConfig = true;
      result._eventGuildConfig = MapEvent_EventGuildConfig.fromJson(json.eventGuildConfig);
    }
    if (json.guildBossConfig != null) {
      result._hasGuildBossConfig = true;
      result._guildBossConfig = MapEvent_GuildBossConfig.fromJson(json.guildBossConfig);
    }
    if (json.chestConfig != null) {
      result._hasChestConfig = true;
      result._chestConfig = MapEvent_EventChestConfig.fromJson(json.chestConfig);
    }
    result._chestDropItemsInfo = JsonToList(json.chestDropItemsInfo, MapEvent_ChestDropItemInfo);
    if (json.tokensAmountPerPurchase != null) {
      result._hasTokensAmountPerPurchase = true;
      result._tokensAmountPerPurchase = JsonToInt32.fromJson(json.tokensAmountPerPurchase);
    }
    result._tokensPriceList = JsonToList(json.tokensPriceList, JsonToInt32);
    if (json.tokensPriceResetTimeInSecs != null) {
      result._hasTokensPriceResetTimeInSecs = true;
      result._tokensPriceResetTimeInSecs = JsonToInt32.fromJson(json.tokensPriceResetTimeInSecs);
    }
    if (json.eventChestPicPath != null) {
      result._hasEventChestPicPath = true;
      result._eventChestPicPath = JsonToString.fromJson(json.eventChestPicPath);
    }
    if (json.eventBundlePicPath != null) {
      result._hasEventBundlePicPath = true;
      result._eventBundlePicPath = JsonToString.fromJson(json.eventBundlePicPath);
    }
    if (json.shieldKey != null) {
      result._hasShieldKey = true;
      result._shieldKey = JsonToString.fromJson(json.shieldKey);
    }
    if (json.shieldPrice != null) {
      result._hasShieldPrice = true;
      result._shieldPrice = JsonToInt32.fromJson(json.shieldPrice);
    }
    if (json.upfrontShieldAmount != null) {
      result._hasUpfrontShieldAmount = true;
      result._upfrontShieldAmount = JsonToInt32.fromJson(json.upfrontShieldAmount);
    }
    if (json.shieldAmountPerPurchase != null) {
      result._hasShieldAmountPerPurchase = true;
      result._shieldAmountPerPurchase = JsonToInt32.fromJson(json.shieldAmountPerPurchase);
    }
    if (json.overviewPanel != null) {
      result._hasOverviewPanel = true;
      result._overviewPanel = JsonToString.fromJson(json.overviewPanel);
    }
    if (json.playerLevelTrigger != null) {
      result._triggerTypeCase = 31;
      result._triggerTypeValue = MapEvent_PlayerLevelTrigger.fromJson(json.playerLevelTrigger);
    }
    if (json.campaignLevelTrigger != null) {
      result._triggerTypeCase = 32;
      result._triggerTypeValue = MapEvent_CampaignLevelTrigger.fromJson(json.campaignLevelTrigger);
    }
    if (json.calendarTimeTrigger != null) {
      result._triggerTypeCase = 33;
      result._triggerTypeValue = MapEvent_CalendarTimeTrigger.fromJson(json.calendarTimeTrigger);
    }
    if (json.cardBoostInfo != null) {
      result._hasCardBoostInfo = true;
      result._cardBoostInfo = MapEvent_CardBoostInfo.fromJson(json.cardBoostInfo);
    }
    if (json.featuredCard != null) {
      result._hasFeaturedCard = true;
      result._featuredCard = JsonToString.fromJson(json.featuredCard);
    }
    if (json.featuredSkin != null) {
      result._hasFeaturedSkin = true;
      result._featuredSkin = dcei_wildsky_card_proto.CardSkin.fromJson(json.featuredSkin);
    }
    if (json.trophyConfig != null) {
      result._hasTrophyConfig = true;
      result._trophyConfig = MapEvent_TrophyConfig.fromJson(json.trophyConfig);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasEventName) {
      result.eventName = JsonToString.toJson(this._eventName);
    }
    if (this._hasEventDurationInHours) {
      result.eventDurationInHours = JsonToInt32.toJson(this._eventDurationInHours);
    }
    if (this._hasPostEventDurationInHours) {
      result.postEventDurationInHours = JsonToInt32.toJson(this._postEventDurationInHours);
    }
    if (this._hasLevelAccessKey && !this._levelAccessKey.isEmpty()) {
      result.levelAccessKey = MapEvent_LevelAccessKey.toJson(this._levelAccessKey);
    }
    if (this._hasEventPointKey) {
      result.eventPointKey = JsonToString.toJson(this._eventPointKey);
    }
    if (this._hasEventTokenKey) {
      result.eventTokenKey = JsonToString.toJson(this._eventTokenKey);
    }
    if (this._hasEventTokenFontSprite) {
      result.eventTokenFontSprite = JsonToString.toJson(this._eventTokenFontSprite);
    }
    if (this._hasGoldPassSubscriptionId) {
      result.goldPassSubscriptionId = JsonToString.toJson(this._goldPassSubscriptionId);
    }
    if (this._hasGoldPassProductId) {
      result.goldPassProductId = JsonToString.toJson(this._goldPassProductId);
    }
    if (this._bundleIds.length > 0) {
      result.bundleIds = ArrayToJson(this._bundleIds, JsonToString);
    }
    if (this._bundlesAvailableWhenEventOpen.length > 0) {
      result.bundlesAvailableWhenEventOpen = ArrayToJson(this._bundlesAvailableWhenEventOpen, JsonToString);
    }
    if (this._hasEventMarketConfig && !this._eventMarketConfig.isEmpty()) {
      result.eventMarketConfig = MapEvent_EventMarketConfig.toJson(this._eventMarketConfig);
    }
    if (this._hasEventMilestonePath && !this._eventMilestonePath.isEmpty()) {
      result.eventMilestonePath = MapEvent_EventMilestonePath.toJson(this._eventMilestonePath);
    }
    if (this._hasEventLevel && !this._eventLevel.isEmpty()) {
      result.eventLevel = MapEvent_EventLevel.toJson(this._eventLevel);
    }
    if (this._hasEventQuest && !this._eventQuest.isEmpty()) {
      result.eventQuest = MapEvent_EventQuest.toJson(this._eventQuest);
    }
    if (this._hasEnableLiveEvent) {
      result.enableLiveEvent = JsonToBoolean.toJson(this._enableLiveEvent);
    }
    if (this._hasLiveEventConfig && !this._liveEventConfig.isEmpty()) {
      result.liveEventConfig = MapEvent_LiveEventConfig.toJson(this._liveEventConfig);
    }
    if (this._hasEventGuildConfig && !this._eventGuildConfig.isEmpty()) {
      result.eventGuildConfig = MapEvent_EventGuildConfig.toJson(this._eventGuildConfig);
    }
    if (this._hasGuildBossConfig && !this._guildBossConfig.isEmpty()) {
      result.guildBossConfig = MapEvent_GuildBossConfig.toJson(this._guildBossConfig);
    }
    if (this._hasChestConfig && !this._chestConfig.isEmpty()) {
      result.chestConfig = MapEvent_EventChestConfig.toJson(this._chestConfig);
    }
    if (this._chestDropItemsInfo.length > 0) {
      result.chestDropItemsInfo = ArrayToJson(this._chestDropItemsInfo, MapEvent_ChestDropItemInfo);
    }
    if (this._hasTokensAmountPerPurchase) {
      result.tokensAmountPerPurchase = JsonToInt32.toJson(this._tokensAmountPerPurchase);
    }
    if (this._tokensPriceList.length > 0) {
      result.tokensPriceList = ArrayToJson(this._tokensPriceList, JsonToInt32);
    }
    if (this._hasTokensPriceResetTimeInSecs) {
      result.tokensPriceResetTimeInSecs = JsonToInt32.toJson(this._tokensPriceResetTimeInSecs);
    }
    if (this._hasEventChestPicPath) {
      result.eventChestPicPath = JsonToString.toJson(this._eventChestPicPath);
    }
    if (this._hasEventBundlePicPath) {
      result.eventBundlePicPath = JsonToString.toJson(this._eventBundlePicPath);
    }
    if (this._hasShieldKey) {
      result.shieldKey = JsonToString.toJson(this._shieldKey);
    }
    if (this._hasShieldPrice) {
      result.shieldPrice = JsonToInt32.toJson(this._shieldPrice);
    }
    if (this._hasUpfrontShieldAmount) {
      result.upfrontShieldAmount = JsonToInt32.toJson(this._upfrontShieldAmount);
    }
    if (this._hasShieldAmountPerPurchase) {
      result.shieldAmountPerPurchase = JsonToInt32.toJson(this._shieldAmountPerPurchase);
    }
    if (this._hasOverviewPanel) {
      result.overviewPanel = JsonToString.toJson(this._overviewPanel);
    }
    switch (this._triggerTypeCase) {
      case 31:
        result.playerLevelTrigger = MapEvent_PlayerLevelTrigger.toJson(this._triggerTypeValue);
        break;
      case 32:
        result.campaignLevelTrigger = MapEvent_CampaignLevelTrigger.toJson(this._triggerTypeValue);
        break;
      case 33:
        result.calendarTimeTrigger = MapEvent_CalendarTimeTrigger.toJson(this._triggerTypeValue);
        break;
      default:
        break;
    }
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) {
      result.cardBoostInfo = MapEvent_CardBoostInfo.toJson(this._cardBoostInfo);
    }
    if (this._hasFeaturedCard) {
      result.featuredCard = JsonToString.toJson(this._featuredCard);
    }
    if (this._hasFeaturedSkin && !this._featuredSkin.isEmpty()) {
      result.featuredSkin = dcei_wildsky_card_proto.CardSkin.toJson(this._featuredSkin);
    }
    if (this._hasTrophyConfig && !this._trophyConfig.isEmpty()) {
      result.trophyConfig = MapEvent_TrophyConfig.toJson(this._trophyConfig);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get eventName() {
    return this._hasEventName ? this._eventName : JsonToString.default;
  }
  get hasEventName() {
    return this._hasEventName;
  }
  setEventName(path, value) {
    return {type: 'SET', path: path.concat(['eventName']), value};
  }
  deleteEventName(path) {
    return {type: 'DELETE', path: path.concat(['eventName'])};
  }
  /**
   * @returns {number}
   */
  get eventDurationInHours() {
    return this._hasEventDurationInHours ? this._eventDurationInHours : JsonToInt32.default;
  }
  get hasEventDurationInHours() {
    return this._hasEventDurationInHours;
  }
  setEventDurationInHours(path, value) {
    return {type: 'SET', path: path.concat(['eventDurationInHours']), value};
  }
  deleteEventDurationInHours(path) {
    return {type: 'DELETE', path: path.concat(['eventDurationInHours'])};
  }
  /**
   * @returns {number}
   */
  get postEventDurationInHours() {
    return this._hasPostEventDurationInHours ? this._postEventDurationInHours : JsonToInt32.default;
  }
  get hasPostEventDurationInHours() {
    return this._hasPostEventDurationInHours;
  }
  setPostEventDurationInHours(path, value) {
    return {type: 'SET', path: path.concat(['postEventDurationInHours']), value};
  }
  deletePostEventDurationInHours(path) {
    return {type: 'DELETE', path: path.concat(['postEventDurationInHours'])};
  }
  /**
   * @returns {MapEvent_LevelAccessKey}
   */
  get levelAccessKey() {
    return this._hasLevelAccessKey ? this._levelAccessKey : MapEvent_LevelAccessKey.default;
  }
  get hasLevelAccessKey() {
    return this._hasLevelAccessKey;
  }
  setLevelAccessKey(path, value) {
    return {type: 'SET', path: path.concat(['levelAccessKey']), value: value.toJson()};
  }
  deleteLevelAccessKey(path) {
    return {type: 'DELETE', path: path.concat(['levelAccessKey'])};
  }
  /**
   * @returns {string}
   */
  get eventPointKey() {
    return this._hasEventPointKey ? this._eventPointKey : JsonToString.default;
  }
  get hasEventPointKey() {
    return this._hasEventPointKey;
  }
  setEventPointKey(path, value) {
    return {type: 'SET', path: path.concat(['eventPointKey']), value};
  }
  deleteEventPointKey(path) {
    return {type: 'DELETE', path: path.concat(['eventPointKey'])};
  }
  /**
   * @returns {string}
   */
  get eventTokenKey() {
    return this._hasEventTokenKey ? this._eventTokenKey : JsonToString.default;
  }
  get hasEventTokenKey() {
    return this._hasEventTokenKey;
  }
  setEventTokenKey(path, value) {
    return {type: 'SET', path: path.concat(['eventTokenKey']), value};
  }
  deleteEventTokenKey(path) {
    return {type: 'DELETE', path: path.concat(['eventTokenKey'])};
  }
  /**
   * @returns {string}
   */
  get eventTokenFontSprite() {
    return this._hasEventTokenFontSprite ? this._eventTokenFontSprite : JsonToString.default;
  }
  get hasEventTokenFontSprite() {
    return this._hasEventTokenFontSprite;
  }
  setEventTokenFontSprite(path, value) {
    return {type: 'SET', path: path.concat(['eventTokenFontSprite']), value};
  }
  deleteEventTokenFontSprite(path) {
    return {type: 'DELETE', path: path.concat(['eventTokenFontSprite'])};
  }
  /**
   * @returns {string}
   */
  get goldPassSubscriptionId() {
    return this._hasGoldPassSubscriptionId ? this._goldPassSubscriptionId : JsonToString.default;
  }
  get hasGoldPassSubscriptionId() {
    return this._hasGoldPassSubscriptionId;
  }
  setGoldPassSubscriptionId(path, value) {
    return {type: 'SET', path: path.concat(['goldPassSubscriptionId']), value};
  }
  deleteGoldPassSubscriptionId(path) {
    return {type: 'DELETE', path: path.concat(['goldPassSubscriptionId'])};
  }
  /**
   * @returns {string}
   */
  get goldPassProductId() {
    return this._hasGoldPassProductId ? this._goldPassProductId : JsonToString.default;
  }
  get hasGoldPassProductId() {
    return this._hasGoldPassProductId;
  }
  setGoldPassProductId(path, value) {
    return {type: 'SET', path: path.concat(['goldPassProductId']), value};
  }
  deleteGoldPassProductId(path) {
    return {type: 'DELETE', path: path.concat(['goldPassProductId'])};
  }
  /**
   * @returns {string[]}
   */
  get bundleIds() {
    return this._bundleIds;
  }
  addBundleIds(path, value) {
    return {type: 'ADD', path: path.concat(['bundleIds']), value};
  }
  setBundleIds(path, value) {
    return {type: 'SET', path: path.concat(['bundleIds']), value: ArrayToJson(value, JsonToString)};
  }
  setBundleIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleIds', key]), value};
  }
  deleteBundleIds(path) {
    return {type: 'DELETE', path: path.concat(['bundleIds'])};
  }
  deleteBundleIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleIds', key])};
  }
  /**
   * @returns {string[]}
   */
  get bundlesAvailableWhenEventOpen() {
    return this._bundlesAvailableWhenEventOpen;
  }
  addBundlesAvailableWhenEventOpen(path, value) {
    return {type: 'ADD', path: path.concat(['bundlesAvailableWhenEventOpen']), value};
  }
  setBundlesAvailableWhenEventOpen(path, value) {
    return {type: 'SET', path: path.concat(['bundlesAvailableWhenEventOpen']), value: ArrayToJson(value, JsonToString)};
  }
  setBundlesAvailableWhenEventOpenByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundlesAvailableWhenEventOpen', key]), value};
  }
  deleteBundlesAvailableWhenEventOpen(path) {
    return {type: 'DELETE', path: path.concat(['bundlesAvailableWhenEventOpen'])};
  }
  deleteBundlesAvailableWhenEventOpenByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundlesAvailableWhenEventOpen', key])};
  }
  /**
   * @returns {MapEvent_EventMarketConfig}
   */
  get eventMarketConfig() {
    return this._hasEventMarketConfig ? this._eventMarketConfig : MapEvent_EventMarketConfig.default;
  }
  get hasEventMarketConfig() {
    return this._hasEventMarketConfig;
  }
  setEventMarketConfig(path, value) {
    return {type: 'SET', path: path.concat(['eventMarketConfig']), value: value.toJson()};
  }
  deleteEventMarketConfig(path) {
    return {type: 'DELETE', path: path.concat(['eventMarketConfig'])};
  }
  /**
   * @returns {MapEvent_EventMilestonePath}
   */
  get eventMilestonePath() {
    return this._hasEventMilestonePath ? this._eventMilestonePath : MapEvent_EventMilestonePath.default;
  }
  get hasEventMilestonePath() {
    return this._hasEventMilestonePath;
  }
  setEventMilestonePath(path, value) {
    return {type: 'SET', path: path.concat(['eventMilestonePath']), value: value.toJson()};
  }
  deleteEventMilestonePath(path) {
    return {type: 'DELETE', path: path.concat(['eventMilestonePath'])};
  }
  /**
   * @returns {MapEvent_EventLevel}
   */
  get eventLevel() {
    return this._hasEventLevel ? this._eventLevel : MapEvent_EventLevel.default;
  }
  get hasEventLevel() {
    return this._hasEventLevel;
  }
  setEventLevel(path, value) {
    return {type: 'SET', path: path.concat(['eventLevel']), value: value.toJson()};
  }
  deleteEventLevel(path) {
    return {type: 'DELETE', path: path.concat(['eventLevel'])};
  }
  /**
   * @returns {MapEvent_EventQuest}
   */
  get eventQuest() {
    return this._hasEventQuest ? this._eventQuest : MapEvent_EventQuest.default;
  }
  get hasEventQuest() {
    return this._hasEventQuest;
  }
  setEventQuest(path, value) {
    return {type: 'SET', path: path.concat(['eventQuest']), value: value.toJson()};
  }
  deleteEventQuest(path) {
    return {type: 'DELETE', path: path.concat(['eventQuest'])};
  }
  /**
   * @returns {boolean}
   */
  get enableLiveEvent() {
    return this._hasEnableLiveEvent ? this._enableLiveEvent : JsonToBoolean.default;
  }
  get hasEnableLiveEvent() {
    return this._hasEnableLiveEvent;
  }
  setEnableLiveEvent(path, value) {
    return {type: 'SET', path: path.concat(['enableLiveEvent']), value};
  }
  deleteEnableLiveEvent(path) {
    return {type: 'DELETE', path: path.concat(['enableLiveEvent'])};
  }
  /**
   * @returns {MapEvent_LiveEventConfig}
   */
  get liveEventConfig() {
    return this._hasLiveEventConfig ? this._liveEventConfig : MapEvent_LiveEventConfig.default;
  }
  get hasLiveEventConfig() {
    return this._hasLiveEventConfig;
  }
  setLiveEventConfig(path, value) {
    return {type: 'SET', path: path.concat(['liveEventConfig']), value: value.toJson()};
  }
  deleteLiveEventConfig(path) {
    return {type: 'DELETE', path: path.concat(['liveEventConfig'])};
  }
  /**
   * @returns {MapEvent_EventGuildConfig}
   */
  get eventGuildConfig() {
    return this._hasEventGuildConfig ? this._eventGuildConfig : MapEvent_EventGuildConfig.default;
  }
  get hasEventGuildConfig() {
    return this._hasEventGuildConfig;
  }
  setEventGuildConfig(path, value) {
    return {type: 'SET', path: path.concat(['eventGuildConfig']), value: value.toJson()};
  }
  deleteEventGuildConfig(path) {
    return {type: 'DELETE', path: path.concat(['eventGuildConfig'])};
  }
  /**
   * @returns {MapEvent_GuildBossConfig}
   */
  get guildBossConfig() {
    return this._hasGuildBossConfig ? this._guildBossConfig : MapEvent_GuildBossConfig.default;
  }
  get hasGuildBossConfig() {
    return this._hasGuildBossConfig;
  }
  setGuildBossConfig(path, value) {
    return {type: 'SET', path: path.concat(['guildBossConfig']), value: value.toJson()};
  }
  deleteGuildBossConfig(path) {
    return {type: 'DELETE', path: path.concat(['guildBossConfig'])};
  }
  /**
   * @returns {MapEvent_EventChestConfig}
   */
  get chestConfig() {
    return this._hasChestConfig ? this._chestConfig : MapEvent_EventChestConfig.default;
  }
  get hasChestConfig() {
    return this._hasChestConfig;
  }
  setChestConfig(path, value) {
    return {type: 'SET', path: path.concat(['chestConfig']), value: value.toJson()};
  }
  deleteChestConfig(path) {
    return {type: 'DELETE', path: path.concat(['chestConfig'])};
  }
  /**
   * @returns {MapEvent_ChestDropItemInfo[]}
   */
  get chestDropItemsInfo() {
    return this._chestDropItemsInfo;
  }
  addChestDropItemsInfo(path, value) {
    return {type: 'ADD', path: path.concat(['chestDropItemsInfo']), value: value.toJson()};
  }
  setChestDropItemsInfo(path, value) {
    return {type: 'SET', path: path.concat(['chestDropItemsInfo']), value: ArrayToJson(value, MapEvent_ChestDropItemInfo)};
  }
  setChestDropItemsInfoByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chestDropItemsInfo', key]), value: value.toJson()};
  }
  deleteChestDropItemsInfo(path) {
    return {type: 'DELETE', path: path.concat(['chestDropItemsInfo'])};
  }
  deleteChestDropItemsInfoByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chestDropItemsInfo', key])};
  }
  /**
   * @returns {number}
   */
  get tokensAmountPerPurchase() {
    return this._hasTokensAmountPerPurchase ? this._tokensAmountPerPurchase : JsonToInt32.default;
  }
  get hasTokensAmountPerPurchase() {
    return this._hasTokensAmountPerPurchase;
  }
  setTokensAmountPerPurchase(path, value) {
    return {type: 'SET', path: path.concat(['tokensAmountPerPurchase']), value};
  }
  deleteTokensAmountPerPurchase(path) {
    return {type: 'DELETE', path: path.concat(['tokensAmountPerPurchase'])};
  }
  /**
   * @returns {number[]}
   */
  get tokensPriceList() {
    return this._tokensPriceList;
  }
  addTokensPriceList(path, value) {
    return {type: 'ADD', path: path.concat(['tokensPriceList']), value};
  }
  setTokensPriceList(path, value) {
    return {type: 'SET', path: path.concat(['tokensPriceList']), value: ArrayToJson(value, JsonToInt32)};
  }
  setTokensPriceListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tokensPriceList', key]), value};
  }
  deleteTokensPriceList(path) {
    return {type: 'DELETE', path: path.concat(['tokensPriceList'])};
  }
  deleteTokensPriceListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tokensPriceList', key])};
  }
  /**
   * @returns {number}
   */
  get tokensPriceResetTimeInSecs() {
    return this._hasTokensPriceResetTimeInSecs ? this._tokensPriceResetTimeInSecs : JsonToInt32.default;
  }
  get hasTokensPriceResetTimeInSecs() {
    return this._hasTokensPriceResetTimeInSecs;
  }
  setTokensPriceResetTimeInSecs(path, value) {
    return {type: 'SET', path: path.concat(['tokensPriceResetTimeInSecs']), value};
  }
  deleteTokensPriceResetTimeInSecs(path) {
    return {type: 'DELETE', path: path.concat(['tokensPriceResetTimeInSecs'])};
  }
  /**
   * @returns {string}
   */
  get eventChestPicPath() {
    return this._hasEventChestPicPath ? this._eventChestPicPath : JsonToString.default;
  }
  get hasEventChestPicPath() {
    return this._hasEventChestPicPath;
  }
  setEventChestPicPath(path, value) {
    return {type: 'SET', path: path.concat(['eventChestPicPath']), value};
  }
  deleteEventChestPicPath(path) {
    return {type: 'DELETE', path: path.concat(['eventChestPicPath'])};
  }
  /**
   * @returns {string}
   */
  get eventBundlePicPath() {
    return this._hasEventBundlePicPath ? this._eventBundlePicPath : JsonToString.default;
  }
  get hasEventBundlePicPath() {
    return this._hasEventBundlePicPath;
  }
  setEventBundlePicPath(path, value) {
    return {type: 'SET', path: path.concat(['eventBundlePicPath']), value};
  }
  deleteEventBundlePicPath(path) {
    return {type: 'DELETE', path: path.concat(['eventBundlePicPath'])};
  }
  /**
   * @returns {string}
   */
  get shieldKey() {
    return this._hasShieldKey ? this._shieldKey : JsonToString.default;
  }
  get hasShieldKey() {
    return this._hasShieldKey;
  }
  setShieldKey(path, value) {
    return {type: 'SET', path: path.concat(['shieldKey']), value};
  }
  deleteShieldKey(path) {
    return {type: 'DELETE', path: path.concat(['shieldKey'])};
  }
  /**
   * @returns {number}
   */
  get shieldPrice() {
    return this._hasShieldPrice ? this._shieldPrice : JsonToInt32.default;
  }
  get hasShieldPrice() {
    return this._hasShieldPrice;
  }
  setShieldPrice(path, value) {
    return {type: 'SET', path: path.concat(['shieldPrice']), value};
  }
  deleteShieldPrice(path) {
    return {type: 'DELETE', path: path.concat(['shieldPrice'])};
  }
  /**
   * @returns {number}
   */
  get upfrontShieldAmount() {
    return this._hasUpfrontShieldAmount ? this._upfrontShieldAmount : JsonToInt32.default;
  }
  get hasUpfrontShieldAmount() {
    return this._hasUpfrontShieldAmount;
  }
  setUpfrontShieldAmount(path, value) {
    return {type: 'SET', path: path.concat(['upfrontShieldAmount']), value};
  }
  deleteUpfrontShieldAmount(path) {
    return {type: 'DELETE', path: path.concat(['upfrontShieldAmount'])};
  }
  /**
   * @returns {number}
   */
  get shieldAmountPerPurchase() {
    return this._hasShieldAmountPerPurchase ? this._shieldAmountPerPurchase : JsonToInt32.default;
  }
  get hasShieldAmountPerPurchase() {
    return this._hasShieldAmountPerPurchase;
  }
  setShieldAmountPerPurchase(path, value) {
    return {type: 'SET', path: path.concat(['shieldAmountPerPurchase']), value};
  }
  deleteShieldAmountPerPurchase(path) {
    return {type: 'DELETE', path: path.concat(['shieldAmountPerPurchase'])};
  }
  /**
   * @returns {string}
   */
  get overviewPanel() {
    return this._hasOverviewPanel ? this._overviewPanel : JsonToString.default;
  }
  get hasOverviewPanel() {
    return this._hasOverviewPanel;
  }
  setOverviewPanel(path, value) {
    return {type: 'SET', path: path.concat(['overviewPanel']), value};
  }
  deleteOverviewPanel(path) {
    return {type: 'DELETE', path: path.concat(['overviewPanel'])};
  }
  get triggerTypeCase() {
    return this._triggerTypeCase;
  }
  deleteTriggerType(path) {
    switch (this._triggerTypeCase) {
      default:
      case 31: {
        return {type: 'DELETE', path: path.concat(['playerLevelTrigger'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['campaignLevelTrigger'])};
      }
      case 33: {
        return {type: 'DELETE', path: path.concat(['calendarTimeTrigger'])};
      }
    }
  }
  /**
   * @returns {MapEvent_PlayerLevelTrigger}
   */
  get playerLevelTrigger() {
    return this._triggerTypeCase === 31 ? this._triggerTypeValue : MapEvent_PlayerLevelTrigger.default;
  }
  setPlayerLevelTrigger(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelTrigger']), value: value.toJson()};
  }
  deletePlayerLevelTrigger(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelTrigger'])};
  }
  /**
   * @returns {MapEvent_CampaignLevelTrigger}
   */
  get campaignLevelTrigger() {
    return this._triggerTypeCase === 32 ? this._triggerTypeValue : MapEvent_CampaignLevelTrigger.default;
  }
  setCampaignLevelTrigger(path, value) {
    return {type: 'SET', path: path.concat(['campaignLevelTrigger']), value: value.toJson()};
  }
  deleteCampaignLevelTrigger(path) {
    return {type: 'DELETE', path: path.concat(['campaignLevelTrigger'])};
  }
  /**
   * @returns {MapEvent_CalendarTimeTrigger}
   */
  get calendarTimeTrigger() {
    return this._triggerTypeCase === 33 ? this._triggerTypeValue : MapEvent_CalendarTimeTrigger.default;
  }
  setCalendarTimeTrigger(path, value) {
    return {type: 'SET', path: path.concat(['calendarTimeTrigger']), value: value.toJson()};
  }
  deleteCalendarTimeTrigger(path) {
    return {type: 'DELETE', path: path.concat(['calendarTimeTrigger'])};
  }
  /**
   * @returns {MapEvent_CardBoostInfo}
   */
  get cardBoostInfo() {
    return this._hasCardBoostInfo ? this._cardBoostInfo : MapEvent_CardBoostInfo.default;
  }
  get hasCardBoostInfo() {
    return this._hasCardBoostInfo;
  }
  setCardBoostInfo(path, value) {
    return {type: 'SET', path: path.concat(['cardBoostInfo']), value: value.toJson()};
  }
  deleteCardBoostInfo(path) {
    return {type: 'DELETE', path: path.concat(['cardBoostInfo'])};
  }
  /**
   * @returns {string}
   */
  get featuredCard() {
    return this._hasFeaturedCard ? this._featuredCard : JsonToString.default;
  }
  get hasFeaturedCard() {
    return this._hasFeaturedCard;
  }
  setFeaturedCard(path, value) {
    return {type: 'SET', path: path.concat(['featuredCard']), value};
  }
  deleteFeaturedCard(path) {
    return {type: 'DELETE', path: path.concat(['featuredCard'])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardSkin}
   */
  get featuredSkin() {
    return this._hasFeaturedSkin ? this._featuredSkin : dcei_wildsky_card_proto.CardSkin.default;
  }
  get hasFeaturedSkin() {
    return this._hasFeaturedSkin;
  }
  setFeaturedSkin(path, value) {
    return {type: 'SET', path: path.concat(['featuredSkin']), value: value.toJson()};
  }
  deleteFeaturedSkin(path) {
    return {type: 'DELETE', path: path.concat(['featuredSkin'])};
  }
  /**
   * @returns {MapEvent_TrophyConfig}
   */
  get trophyConfig() {
    return this._hasTrophyConfig ? this._trophyConfig : MapEvent_TrophyConfig.default;
  }
  get hasTrophyConfig() {
    return this._hasTrophyConfig;
  }
  setTrophyConfig(path, value) {
    return {type: 'SET', path: path.concat(['trophyConfig']), value: value.toJson()};
  }
  deleteTrophyConfig(path) {
    return {type: 'DELETE', path: path.concat(['trophyConfig'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventName = true;
              copy._eventName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventName) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventName = false;
              copy._eventName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventDurationInHours": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventDurationInHours = true;
              copy._eventDurationInHours = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventDurationInHours) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventDurationInHours = false;
              copy._eventDurationInHours = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postEventDurationInHours": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasPostEventDurationInHours = true;
              copy._postEventDurationInHours = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPostEventDurationInHours) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasPostEventDurationInHours = false;
              copy._postEventDurationInHours = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelAccessKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasLevelAccessKey = true;
              copy._levelAccessKey = MapEvent_LevelAccessKey.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelAccessKey) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasLevelAccessKey = false;
              copy._levelAccessKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLevelAccessKey) {
            const copy = new MapEvent(this);
            copy._hasLevelAccessKey = true;
            copy._levelAccessKey = MapEvent_LevelAccessKey.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._levelAccessKey.apply(type, path.slice(1), value);
          if (newValue === this._levelAccessKey) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._levelAccessKey = copy._levelAccessKey.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventPointKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventPointKey = true;
              copy._eventPointKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventPointKey) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventPointKey = false;
              copy._eventPointKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventTokenKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventTokenKey = true;
              copy._eventTokenKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventTokenKey) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventTokenKey = false;
              copy._eventTokenKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventTokenFontSprite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventTokenFontSprite = true;
              copy._eventTokenFontSprite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventTokenFontSprite) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventTokenFontSprite = false;
              copy._eventTokenFontSprite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldPassSubscriptionId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasGoldPassSubscriptionId = true;
              copy._goldPassSubscriptionId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldPassSubscriptionId) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasGoldPassSubscriptionId = false;
              copy._goldPassSubscriptionId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldPassProductId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasGoldPassProductId = true;
              copy._goldPassProductId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldPassProductId) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasGoldPassProductId = false;
              copy._goldPassProductId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bundleIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._bundleIds = [];        for (let i of value) {
                copy._bundleIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent(this);
              copy._bundleIds = copy._bundleIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleIds.length === 0) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._bundleIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._bundleIds = copy._bundleIds.slice();
              copy._bundleIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent(this);
              copy._bundleIds = copy._bundleIds.slice(0, path[1]).concat(copy._bundleIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          const oldValue = this._bundleIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._bundleIds = copy._bundleIds.slice();
          copy._bundleIds[key] = newValue;
          return copy;
        }
      }
      case "bundlesAvailableWhenEventOpen": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._bundlesAvailableWhenEventOpen = [];        for (let i of value) {
                copy._bundlesAvailableWhenEventOpen.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent(this);
              copy._bundlesAvailableWhenEventOpen = copy._bundlesAvailableWhenEventOpen.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundlesAvailableWhenEventOpen.length === 0) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._bundlesAvailableWhenEventOpen = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundlesAvailableWhenEventOpen.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._bundlesAvailableWhenEventOpen = copy._bundlesAvailableWhenEventOpen.slice();
              copy._bundlesAvailableWhenEventOpen[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent(this);
              copy._bundlesAvailableWhenEventOpen = copy._bundlesAvailableWhenEventOpen.slice(0, path[1]).concat(copy._bundlesAvailableWhenEventOpen.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundlesAvailableWhenEventOpen.length) {
            return this;
          }
          const oldValue = this._bundlesAvailableWhenEventOpen[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._bundlesAvailableWhenEventOpen = copy._bundlesAvailableWhenEventOpen.slice();
          copy._bundlesAvailableWhenEventOpen[key] = newValue;
          return copy;
        }
      }
      case "eventMarketConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventMarketConfig = true;
              copy._eventMarketConfig = MapEvent_EventMarketConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventMarketConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventMarketConfig = false;
              copy._eventMarketConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventMarketConfig) {
            const copy = new MapEvent(this);
            copy._hasEventMarketConfig = true;
            copy._eventMarketConfig = MapEvent_EventMarketConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventMarketConfig.apply(type, path.slice(1), value);
          if (newValue === this._eventMarketConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._eventMarketConfig = copy._eventMarketConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventMilestonePath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventMilestonePath = true;
              copy._eventMilestonePath = MapEvent_EventMilestonePath.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventMilestonePath) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventMilestonePath = false;
              copy._eventMilestonePath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventMilestonePath) {
            const copy = new MapEvent(this);
            copy._hasEventMilestonePath = true;
            copy._eventMilestonePath = MapEvent_EventMilestonePath.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventMilestonePath.apply(type, path.slice(1), value);
          if (newValue === this._eventMilestonePath) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._eventMilestonePath = copy._eventMilestonePath.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventLevel = true;
              copy._eventLevel = MapEvent_EventLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventLevel) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventLevel = false;
              copy._eventLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventLevel) {
            const copy = new MapEvent(this);
            copy._hasEventLevel = true;
            copy._eventLevel = MapEvent_EventLevel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventLevel.apply(type, path.slice(1), value);
          if (newValue === this._eventLevel) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._eventLevel = copy._eventLevel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventQuest": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventQuest = true;
              copy._eventQuest = MapEvent_EventQuest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventQuest) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventQuest = false;
              copy._eventQuest = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventQuest) {
            const copy = new MapEvent(this);
            copy._hasEventQuest = true;
            copy._eventQuest = MapEvent_EventQuest.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventQuest.apply(type, path.slice(1), value);
          if (newValue === this._eventQuest) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._eventQuest = copy._eventQuest.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "enableLiveEvent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEnableLiveEvent = true;
              copy._enableLiveEvent = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableLiveEvent) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEnableLiveEvent = false;
              copy._enableLiveEvent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "liveEventConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasLiveEventConfig = true;
              copy._liveEventConfig = MapEvent_LiveEventConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLiveEventConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasLiveEventConfig = false;
              copy._liveEventConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLiveEventConfig) {
            const copy = new MapEvent(this);
            copy._hasLiveEventConfig = true;
            copy._liveEventConfig = MapEvent_LiveEventConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._liveEventConfig.apply(type, path.slice(1), value);
          if (newValue === this._liveEventConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._liveEventConfig = copy._liveEventConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventGuildConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventGuildConfig = true;
              copy._eventGuildConfig = MapEvent_EventGuildConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventGuildConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventGuildConfig = false;
              copy._eventGuildConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventGuildConfig) {
            const copy = new MapEvent(this);
            copy._hasEventGuildConfig = true;
            copy._eventGuildConfig = MapEvent_EventGuildConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventGuildConfig.apply(type, path.slice(1), value);
          if (newValue === this._eventGuildConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._eventGuildConfig = copy._eventGuildConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "guildBossConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasGuildBossConfig = true;
              copy._guildBossConfig = MapEvent_GuildBossConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildBossConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasGuildBossConfig = false;
              copy._guildBossConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasGuildBossConfig) {
            const copy = new MapEvent(this);
            copy._hasGuildBossConfig = true;
            copy._guildBossConfig = MapEvent_GuildBossConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._guildBossConfig.apply(type, path.slice(1), value);
          if (newValue === this._guildBossConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._guildBossConfig = copy._guildBossConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chestConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasChestConfig = true;
              copy._chestConfig = MapEvent_EventChestConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasChestConfig = false;
              copy._chestConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChestConfig) {
            const copy = new MapEvent(this);
            copy._hasChestConfig = true;
            copy._chestConfig = MapEvent_EventChestConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chestConfig.apply(type, path.slice(1), value);
          if (newValue === this._chestConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._chestConfig = copy._chestConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chestDropItemsInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._chestDropItemsInfo = [];        for (let i of value) {
                copy._chestDropItemsInfo.push(MapEvent_ChestDropItemInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent(this);
              copy._chestDropItemsInfo = copy._chestDropItemsInfo.concat([MapEvent_ChestDropItemInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chestDropItemsInfo.length === 0) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._chestDropItemsInfo = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chestDropItemsInfo.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._chestDropItemsInfo = copy._chestDropItemsInfo.slice();
              copy._chestDropItemsInfo[path[1]] = MapEvent_ChestDropItemInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent(this);
              copy._chestDropItemsInfo = copy._chestDropItemsInfo.slice(0, path[1]).concat(copy._chestDropItemsInfo.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chestDropItemsInfo.length) {
            return this;
          }
          const oldValue = this._chestDropItemsInfo[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._chestDropItemsInfo = copy._chestDropItemsInfo.slice();
          copy._chestDropItemsInfo[key] = newValue;
          return copy;
        }
      }
      case "tokensAmountPerPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasTokensAmountPerPurchase = true;
              copy._tokensAmountPerPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTokensAmountPerPurchase) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasTokensAmountPerPurchase = false;
              copy._tokensAmountPerPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tokensPriceList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._tokensPriceList = [];        for (let i of value) {
                copy._tokensPriceList.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEvent(this);
              copy._tokensPriceList = copy._tokensPriceList.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tokensPriceList.length === 0) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._tokensPriceList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tokensPriceList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._tokensPriceList = copy._tokensPriceList.slice();
              copy._tokensPriceList[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEvent(this);
              copy._tokensPriceList = copy._tokensPriceList.slice(0, path[1]).concat(copy._tokensPriceList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tokensPriceList.length) {
            return this;
          }
          const oldValue = this._tokensPriceList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._tokensPriceList = copy._tokensPriceList.slice();
          copy._tokensPriceList[key] = newValue;
          return copy;
        }
      }
      case "tokensPriceResetTimeInSecs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasTokensPriceResetTimeInSecs = true;
              copy._tokensPriceResetTimeInSecs = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTokensPriceResetTimeInSecs) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasTokensPriceResetTimeInSecs = false;
              copy._tokensPriceResetTimeInSecs = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventChestPicPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventChestPicPath = true;
              copy._eventChestPicPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventChestPicPath) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventChestPicPath = false;
              copy._eventChestPicPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventBundlePicPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasEventBundlePicPath = true;
              copy._eventBundlePicPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventBundlePicPath) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasEventBundlePicPath = false;
              copy._eventBundlePicPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shieldKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasShieldKey = true;
              copy._shieldKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShieldKey) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasShieldKey = false;
              copy._shieldKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shieldPrice": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasShieldPrice = true;
              copy._shieldPrice = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShieldPrice) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasShieldPrice = false;
              copy._shieldPrice = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upfrontShieldAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasUpfrontShieldAmount = true;
              copy._upfrontShieldAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpfrontShieldAmount) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasUpfrontShieldAmount = false;
              copy._upfrontShieldAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shieldAmountPerPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasShieldAmountPerPurchase = true;
              copy._shieldAmountPerPurchase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShieldAmountPerPurchase) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasShieldAmountPerPurchase = false;
              copy._shieldAmountPerPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overviewPanel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasOverviewPanel = true;
              copy._overviewPanel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverviewPanel) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasOverviewPanel = false;
              copy._overviewPanel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 31;
              copy._triggerTypeValue = MapEvent_PlayerLevelTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._triggerTypeCase !== 31) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 0;
              copy._triggerTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._triggerTypeCase !== 31) {
            const copy = new MapEvent(this);
            copy._triggerTypeCase = 31;
            copy._triggerTypeValue = MapEvent_PlayerLevelTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playerLevelTrigger.apply(type, path.slice(1), value);
          if (newValue === this.playerLevelTrigger) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._triggerTypeCase = 31;
          copy._triggerTypeValue = newValue;
          return copy;
        }
      }
      case "campaignLevelTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 32;
              copy._triggerTypeValue = MapEvent_CampaignLevelTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._triggerTypeCase !== 32) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 0;
              copy._triggerTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._triggerTypeCase !== 32) {
            const copy = new MapEvent(this);
            copy._triggerTypeCase = 32;
            copy._triggerTypeValue = MapEvent_CampaignLevelTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.campaignLevelTrigger.apply(type, path.slice(1), value);
          if (newValue === this.campaignLevelTrigger) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._triggerTypeCase = 32;
          copy._triggerTypeValue = newValue;
          return copy;
        }
      }
      case "calendarTimeTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 33;
              copy._triggerTypeValue = MapEvent_CalendarTimeTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._triggerTypeCase !== 33) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._triggerTypeCase = 0;
              copy._triggerTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._triggerTypeCase !== 33) {
            const copy = new MapEvent(this);
            copy._triggerTypeCase = 33;
            copy._triggerTypeValue = MapEvent_CalendarTimeTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.calendarTimeTrigger.apply(type, path.slice(1), value);
          if (newValue === this.calendarTimeTrigger) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._triggerTypeCase = 33;
          copy._triggerTypeValue = newValue;
          return copy;
        }
      }
      case "cardBoostInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasCardBoostInfo = true;
              copy._cardBoostInfo = MapEvent_CardBoostInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardBoostInfo) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasCardBoostInfo = false;
              copy._cardBoostInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardBoostInfo) {
            const copy = new MapEvent(this);
            copy._hasCardBoostInfo = true;
            copy._cardBoostInfo = MapEvent_CardBoostInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardBoostInfo.apply(type, path.slice(1), value);
          if (newValue === this._cardBoostInfo) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._cardBoostInfo = copy._cardBoostInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "featuredCard": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasFeaturedCard = true;
              copy._featuredCard = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeaturedCard) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasFeaturedCard = false;
              copy._featuredCard = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "featuredSkin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasFeaturedSkin = true;
              copy._featuredSkin = dcei_wildsky_card_proto.CardSkin.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeaturedSkin) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasFeaturedSkin = false;
              copy._featuredSkin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFeaturedSkin) {
            const copy = new MapEvent(this);
            copy._hasFeaturedSkin = true;
            copy._featuredSkin = dcei_wildsky_card_proto.CardSkin.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._featuredSkin.apply(type, path.slice(1), value);
          if (newValue === this._featuredSkin) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._featuredSkin = copy._featuredSkin.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "trophyConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEvent(this);
              copy._hasTrophyConfig = true;
              copy._trophyConfig = MapEvent_TrophyConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTrophyConfig) {
                return this;
              }
              const copy = new MapEvent(this);
              copy._hasTrophyConfig = false;
              copy._trophyConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTrophyConfig) {
            const copy = new MapEvent(this);
            copy._hasTrophyConfig = true;
            copy._trophyConfig = MapEvent_TrophyConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._trophyConfig.apply(type, path.slice(1), value);
          if (newValue === this._trophyConfig) {
            return this;
          }
          const copy = new MapEvent(this);
          copy._trophyConfig = copy._trophyConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEvent} other
   * @returns {MapEvent}
   */
  merge(other) {
    const copy = new MapEvent(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasEventName) {
      copy._hasEventName = true;
      copy._eventName = other._eventName;
    }
    if (other._hasEventDurationInHours) {
      copy._hasEventDurationInHours = true;
      copy._eventDurationInHours = other._eventDurationInHours;
    }
    if (other._hasPostEventDurationInHours) {
      copy._hasPostEventDurationInHours = true;
      copy._postEventDurationInHours = other._postEventDurationInHours;
    }
    if (other._hasLevelAccessKey) {
      if (copy._hasLevelAccessKey) {
        copy._levelAccessKey = copy.levelAccessKey.merge(other.levelAccessKey);
      } else {
        copy._levelAccessKey = other._levelAccessKey;
      }
      copy._hasLevelAccessKey = true;
    }
    if (other._hasEventPointKey) {
      copy._hasEventPointKey = true;
      copy._eventPointKey = other._eventPointKey;
    }
    if (other._hasEventTokenKey) {
      copy._hasEventTokenKey = true;
      copy._eventTokenKey = other._eventTokenKey;
    }
    if (other._hasEventTokenFontSprite) {
      copy._hasEventTokenFontSprite = true;
      copy._eventTokenFontSprite = other._eventTokenFontSprite;
    }
    if (other._hasGoldPassSubscriptionId) {
      copy._hasGoldPassSubscriptionId = true;
      copy._goldPassSubscriptionId = other._goldPassSubscriptionId;
    }
    if (other._hasGoldPassProductId) {
      copy._hasGoldPassProductId = true;
      copy._goldPassProductId = other._goldPassProductId;
    }
    copy._bundleIds = this._bundleIds.concat(other._bundleIds);
    copy._bundlesAvailableWhenEventOpen = this._bundlesAvailableWhenEventOpen.concat(other._bundlesAvailableWhenEventOpen);
    if (other._hasEventMarketConfig) {
      if (copy._hasEventMarketConfig) {
        copy._eventMarketConfig = copy.eventMarketConfig.merge(other.eventMarketConfig);
      } else {
        copy._eventMarketConfig = other._eventMarketConfig;
      }
      copy._hasEventMarketConfig = true;
    }
    if (other._hasEventMilestonePath) {
      if (copy._hasEventMilestonePath) {
        copy._eventMilestonePath = copy.eventMilestonePath.merge(other.eventMilestonePath);
      } else {
        copy._eventMilestonePath = other._eventMilestonePath;
      }
      copy._hasEventMilestonePath = true;
    }
    if (other._hasEventLevel) {
      if (copy._hasEventLevel) {
        copy._eventLevel = copy.eventLevel.merge(other.eventLevel);
      } else {
        copy._eventLevel = other._eventLevel;
      }
      copy._hasEventLevel = true;
    }
    if (other._hasEventQuest) {
      if (copy._hasEventQuest) {
        copy._eventQuest = copy.eventQuest.merge(other.eventQuest);
      } else {
        copy._eventQuest = other._eventQuest;
      }
      copy._hasEventQuest = true;
    }
    if (other._hasEnableLiveEvent) {
      copy._hasEnableLiveEvent = true;
      copy._enableLiveEvent = other._enableLiveEvent;
    }
    if (other._hasLiveEventConfig) {
      if (copy._hasLiveEventConfig) {
        copy._liveEventConfig = copy.liveEventConfig.merge(other.liveEventConfig);
      } else {
        copy._liveEventConfig = other._liveEventConfig;
      }
      copy._hasLiveEventConfig = true;
    }
    if (other._hasEventGuildConfig) {
      if (copy._hasEventGuildConfig) {
        copy._eventGuildConfig = copy.eventGuildConfig.merge(other.eventGuildConfig);
      } else {
        copy._eventGuildConfig = other._eventGuildConfig;
      }
      copy._hasEventGuildConfig = true;
    }
    if (other._hasGuildBossConfig) {
      if (copy._hasGuildBossConfig) {
        copy._guildBossConfig = copy.guildBossConfig.merge(other.guildBossConfig);
      } else {
        copy._guildBossConfig = other._guildBossConfig;
      }
      copy._hasGuildBossConfig = true;
    }
    if (other._hasChestConfig) {
      if (copy._hasChestConfig) {
        copy._chestConfig = copy.chestConfig.merge(other.chestConfig);
      } else {
        copy._chestConfig = other._chestConfig;
      }
      copy._hasChestConfig = true;
    }
    copy._chestDropItemsInfo = this._chestDropItemsInfo.concat(other._chestDropItemsInfo);
    if (other._hasTokensAmountPerPurchase) {
      copy._hasTokensAmountPerPurchase = true;
      copy._tokensAmountPerPurchase = other._tokensAmountPerPurchase;
    }
    copy._tokensPriceList = this._tokensPriceList.concat(other._tokensPriceList);
    if (other._hasTokensPriceResetTimeInSecs) {
      copy._hasTokensPriceResetTimeInSecs = true;
      copy._tokensPriceResetTimeInSecs = other._tokensPriceResetTimeInSecs;
    }
    if (other._hasEventChestPicPath) {
      copy._hasEventChestPicPath = true;
      copy._eventChestPicPath = other._eventChestPicPath;
    }
    if (other._hasEventBundlePicPath) {
      copy._hasEventBundlePicPath = true;
      copy._eventBundlePicPath = other._eventBundlePicPath;
    }
    if (other._hasShieldKey) {
      copy._hasShieldKey = true;
      copy._shieldKey = other._shieldKey;
    }
    if (other._hasShieldPrice) {
      copy._hasShieldPrice = true;
      copy._shieldPrice = other._shieldPrice;
    }
    if (other._hasUpfrontShieldAmount) {
      copy._hasUpfrontShieldAmount = true;
      copy._upfrontShieldAmount = other._upfrontShieldAmount;
    }
    if (other._hasShieldAmountPerPurchase) {
      copy._hasShieldAmountPerPurchase = true;
      copy._shieldAmountPerPurchase = other._shieldAmountPerPurchase;
    }
    if (other._hasOverviewPanel) {
      copy._hasOverviewPanel = true;
      copy._overviewPanel = other._overviewPanel;
    }
    if (other._triggerTypeCase === 31) {
      if (this._triggerTypeCase === 31) {
        copy._triggerTypeValue = copy._triggerTypeValue.merge(other._triggerTypeValue);
      } else {
        copy._triggerTypeValue = other._triggerTypeValue;
      }
      copy._triggerTypeCase = 31;
    }
    if (other._triggerTypeCase === 31) {
      if (this._triggerTypeCase === 31) {
        copy._triggerTypeValue = copy._triggerTypeValue.merge(other._triggerTypeValue);
      } else {
        copy._triggerTypeValue = other._triggerTypeValue;
      }
      copy._triggerTypeCase = 31;
    }
    if (other._triggerTypeCase === 31) {
      if (this._triggerTypeCase === 31) {
        copy._triggerTypeValue = copy._triggerTypeValue.merge(other._triggerTypeValue);
      } else {
        copy._triggerTypeValue = other._triggerTypeValue;
      }
      copy._triggerTypeCase = 31;
    }
    if (other._hasCardBoostInfo) {
      if (copy._hasCardBoostInfo) {
        copy._cardBoostInfo = copy.cardBoostInfo.merge(other.cardBoostInfo);
      } else {
        copy._cardBoostInfo = other._cardBoostInfo;
      }
      copy._hasCardBoostInfo = true;
    }
    if (other._hasFeaturedCard) {
      copy._hasFeaturedCard = true;
      copy._featuredCard = other._featuredCard;
    }
    if (other._hasFeaturedSkin) {
      if (copy._hasFeaturedSkin) {
        copy._featuredSkin = copy.featuredSkin.merge(other.featuredSkin);
      } else {
        copy._featuredSkin = other._featuredSkin;
      }
      copy._hasFeaturedSkin = true;
    }
    if (other._hasTrophyConfig) {
      if (copy._hasTrophyConfig) {
        copy._trophyConfig = copy.trophyConfig.merge(other.trophyConfig);
      } else {
        copy._trophyConfig = other._trophyConfig;
      }
      copy._hasTrophyConfig = true;
    }
    return copy;
  }
}
MapEvent.default = new MapEvent();
MapEvent.LevelAccessKey = MapEvent_LevelAccessKey;
MapEvent.EventMilestonePath = MapEvent_EventMilestonePath;
MapEvent.EventLevel = MapEvent_EventLevel;
MapEvent.EventQuest = MapEvent_EventQuest;
MapEvent.PossibleReward = MapEvent_PossibleReward;
MapEvent.CoopRewardPattern = MapEvent_CoopRewardPattern;
MapEvent.LiveEventConfig = MapEvent_LiveEventConfig;
MapEvent.EventGuildConfig = MapEvent_EventGuildConfig;
MapEvent.GuildBossConfig = MapEvent_GuildBossConfig;
MapEvent.PlayerLevelTrigger = MapEvent_PlayerLevelTrigger;
MapEvent.CampaignLevelTrigger = MapEvent_CampaignLevelTrigger;
MapEvent.CalendarTimeTrigger = MapEvent_CalendarTimeTrigger;
MapEvent.ChestDropItemInfo = MapEvent_ChestDropItemInfo;
MapEvent.CardBoostInfo = MapEvent_CardBoostInfo;
MapEvent.EventChestGroup = MapEvent_EventChestGroup;
MapEvent.EventChestConfig = MapEvent_EventChestConfig;
MapEvent.EventMarketConfig = MapEvent_EventMarketConfig;
MapEvent.TrophyConfig = MapEvent_TrophyConfig;
class MapEvent_Builder {
  constructor(value) {
    this._value = new MapEvent(value);
  }
  build() {
    return new MapEvent(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setEventName(value) {
    this._value._hasEventName = true;
    this._value._eventName = value;
    return this;
  }
  deleteEventName() {
    this._value._hasEventName = false;
    this._value._eventName = null;
    return this;
  }
  setEventDurationInHours(value) {
    this._value._hasEventDurationInHours = true;
    this._value._eventDurationInHours = value;
    return this;
  }
  deleteEventDurationInHours() {
    this._value._hasEventDurationInHours = false;
    this._value._eventDurationInHours = null;
    return this;
  }
  setPostEventDurationInHours(value) {
    this._value._hasPostEventDurationInHours = true;
    this._value._postEventDurationInHours = value;
    return this;
  }
  deletePostEventDurationInHours() {
    this._value._hasPostEventDurationInHours = false;
    this._value._postEventDurationInHours = null;
    return this;
  }
  setLevelAccessKey(value) {
    this._value._hasLevelAccessKey = true;
    this._value._levelAccessKey = value;
    return this;
  }
  deleteLevelAccessKey() {
    this._value._hasLevelAccessKey = false;
    this._value._levelAccessKey = null;
    return this;
  }
  setEventPointKey(value) {
    this._value._hasEventPointKey = true;
    this._value._eventPointKey = value;
    return this;
  }
  deleteEventPointKey() {
    this._value._hasEventPointKey = false;
    this._value._eventPointKey = null;
    return this;
  }
  setEventTokenKey(value) {
    this._value._hasEventTokenKey = true;
    this._value._eventTokenKey = value;
    return this;
  }
  deleteEventTokenKey() {
    this._value._hasEventTokenKey = false;
    this._value._eventTokenKey = null;
    return this;
  }
  setEventTokenFontSprite(value) {
    this._value._hasEventTokenFontSprite = true;
    this._value._eventTokenFontSprite = value;
    return this;
  }
  deleteEventTokenFontSprite() {
    this._value._hasEventTokenFontSprite = false;
    this._value._eventTokenFontSprite = null;
    return this;
  }
  setGoldPassSubscriptionId(value) {
    this._value._hasGoldPassSubscriptionId = true;
    this._value._goldPassSubscriptionId = value;
    return this;
  }
  deleteGoldPassSubscriptionId() {
    this._value._hasGoldPassSubscriptionId = false;
    this._value._goldPassSubscriptionId = null;
    return this;
  }
  setGoldPassProductId(value) {
    this._value._hasGoldPassProductId = true;
    this._value._goldPassProductId = value;
    return this;
  }
  deleteGoldPassProductId() {
    this._value._hasGoldPassProductId = false;
    this._value._goldPassProductId = null;
    return this;
  }
  addAllBundleIds(values) {
    this._value._bundleIds = this._value._bundleIds.concat(values);
    return this;
  }
  addBundleIds(value) {
    this._value._bundleIds = this._value._bundleIds.concat([value]);
    return this;
  }
  setBundleIds(index, value) {
    this._value._bundleIds = this._value._bundleIds.concat();
    this._value._bundleIds[index] = value;
    return this;
  }
  clearBundleIds() {
    this._value._bundleIds = [];
    return this;
  }
  addAllBundlesAvailableWhenEventOpen(values) {
    this._value._bundlesAvailableWhenEventOpen = this._value._bundlesAvailableWhenEventOpen.concat(values);
    return this;
  }
  addBundlesAvailableWhenEventOpen(value) {
    this._value._bundlesAvailableWhenEventOpen = this._value._bundlesAvailableWhenEventOpen.concat([value]);
    return this;
  }
  setBundlesAvailableWhenEventOpen(index, value) {
    this._value._bundlesAvailableWhenEventOpen = this._value._bundlesAvailableWhenEventOpen.concat();
    this._value._bundlesAvailableWhenEventOpen[index] = value;
    return this;
  }
  clearBundlesAvailableWhenEventOpen() {
    this._value._bundlesAvailableWhenEventOpen = [];
    return this;
  }
  setEventMarketConfig(value) {
    this._value._hasEventMarketConfig = true;
    this._value._eventMarketConfig = value;
    return this;
  }
  deleteEventMarketConfig() {
    this._value._hasEventMarketConfig = false;
    this._value._eventMarketConfig = null;
    return this;
  }
  setEventMilestonePath(value) {
    this._value._hasEventMilestonePath = true;
    this._value._eventMilestonePath = value;
    return this;
  }
  deleteEventMilestonePath() {
    this._value._hasEventMilestonePath = false;
    this._value._eventMilestonePath = null;
    return this;
  }
  setEventLevel(value) {
    this._value._hasEventLevel = true;
    this._value._eventLevel = value;
    return this;
  }
  deleteEventLevel() {
    this._value._hasEventLevel = false;
    this._value._eventLevel = null;
    return this;
  }
  setEventQuest(value) {
    this._value._hasEventQuest = true;
    this._value._eventQuest = value;
    return this;
  }
  deleteEventQuest() {
    this._value._hasEventQuest = false;
    this._value._eventQuest = null;
    return this;
  }
  setEnableLiveEvent(value) {
    this._value._hasEnableLiveEvent = true;
    this._value._enableLiveEvent = value;
    return this;
  }
  deleteEnableLiveEvent() {
    this._value._hasEnableLiveEvent = false;
    this._value._enableLiveEvent = null;
    return this;
  }
  setLiveEventConfig(value) {
    this._value._hasLiveEventConfig = true;
    this._value._liveEventConfig = value;
    return this;
  }
  deleteLiveEventConfig() {
    this._value._hasLiveEventConfig = false;
    this._value._liveEventConfig = null;
    return this;
  }
  setEventGuildConfig(value) {
    this._value._hasEventGuildConfig = true;
    this._value._eventGuildConfig = value;
    return this;
  }
  deleteEventGuildConfig() {
    this._value._hasEventGuildConfig = false;
    this._value._eventGuildConfig = null;
    return this;
  }
  setGuildBossConfig(value) {
    this._value._hasGuildBossConfig = true;
    this._value._guildBossConfig = value;
    return this;
  }
  deleteGuildBossConfig() {
    this._value._hasGuildBossConfig = false;
    this._value._guildBossConfig = null;
    return this;
  }
  setChestConfig(value) {
    this._value._hasChestConfig = true;
    this._value._chestConfig = value;
    return this;
  }
  deleteChestConfig() {
    this._value._hasChestConfig = false;
    this._value._chestConfig = null;
    return this;
  }
  addAllChestDropItemsInfo(values) {
    this._value._chestDropItemsInfo = this._value._chestDropItemsInfo.concat(values);
    return this;
  }
  addChestDropItemsInfo(value) {
    this._value._chestDropItemsInfo = this._value._chestDropItemsInfo.concat([value]);
    return this;
  }
  setChestDropItemsInfo(index, value) {
    this._value._chestDropItemsInfo = this._value._chestDropItemsInfo.concat();
    this._value._chestDropItemsInfo[index] = value;
    return this;
  }
  clearChestDropItemsInfo() {
    this._value._chestDropItemsInfo = [];
    return this;
  }
  setTokensAmountPerPurchase(value) {
    this._value._hasTokensAmountPerPurchase = true;
    this._value._tokensAmountPerPurchase = value;
    return this;
  }
  deleteTokensAmountPerPurchase() {
    this._value._hasTokensAmountPerPurchase = false;
    this._value._tokensAmountPerPurchase = null;
    return this;
  }
  addAllTokensPriceList(values) {
    this._value._tokensPriceList = this._value._tokensPriceList.concat(values);
    return this;
  }
  addTokensPriceList(value) {
    this._value._tokensPriceList = this._value._tokensPriceList.concat([value]);
    return this;
  }
  setTokensPriceList(index, value) {
    this._value._tokensPriceList = this._value._tokensPriceList.concat();
    this._value._tokensPriceList[index] = value;
    return this;
  }
  clearTokensPriceList() {
    this._value._tokensPriceList = [];
    return this;
  }
  setTokensPriceResetTimeInSecs(value) {
    this._value._hasTokensPriceResetTimeInSecs = true;
    this._value._tokensPriceResetTimeInSecs = value;
    return this;
  }
  deleteTokensPriceResetTimeInSecs() {
    this._value._hasTokensPriceResetTimeInSecs = false;
    this._value._tokensPriceResetTimeInSecs = null;
    return this;
  }
  setEventChestPicPath(value) {
    this._value._hasEventChestPicPath = true;
    this._value._eventChestPicPath = value;
    return this;
  }
  deleteEventChestPicPath() {
    this._value._hasEventChestPicPath = false;
    this._value._eventChestPicPath = null;
    return this;
  }
  setEventBundlePicPath(value) {
    this._value._hasEventBundlePicPath = true;
    this._value._eventBundlePicPath = value;
    return this;
  }
  deleteEventBundlePicPath() {
    this._value._hasEventBundlePicPath = false;
    this._value._eventBundlePicPath = null;
    return this;
  }
  setShieldKey(value) {
    this._value._hasShieldKey = true;
    this._value._shieldKey = value;
    return this;
  }
  deleteShieldKey() {
    this._value._hasShieldKey = false;
    this._value._shieldKey = null;
    return this;
  }
  setShieldPrice(value) {
    this._value._hasShieldPrice = true;
    this._value._shieldPrice = value;
    return this;
  }
  deleteShieldPrice() {
    this._value._hasShieldPrice = false;
    this._value._shieldPrice = null;
    return this;
  }
  setUpfrontShieldAmount(value) {
    this._value._hasUpfrontShieldAmount = true;
    this._value._upfrontShieldAmount = value;
    return this;
  }
  deleteUpfrontShieldAmount() {
    this._value._hasUpfrontShieldAmount = false;
    this._value._upfrontShieldAmount = null;
    return this;
  }
  setShieldAmountPerPurchase(value) {
    this._value._hasShieldAmountPerPurchase = true;
    this._value._shieldAmountPerPurchase = value;
    return this;
  }
  deleteShieldAmountPerPurchase() {
    this._value._hasShieldAmountPerPurchase = false;
    this._value._shieldAmountPerPurchase = null;
    return this;
  }
  setOverviewPanel(value) {
    this._value._hasOverviewPanel = true;
    this._value._overviewPanel = value;
    return this;
  }
  deleteOverviewPanel() {
    this._value._hasOverviewPanel = false;
    this._value._overviewPanel = null;
    return this;
  }
  cleartriggerType() {
    this._value._triggerTypeCase = 0;
    this._value._triggerTypeValue = null;
    return this;
  }
  setPlayerLevelTrigger(value) {
    this._value._triggerTypeCase = 31;
    this._value._triggerTypeValue = value;
    return this;
  }
  setCampaignLevelTrigger(value) {
    this._value._triggerTypeCase = 32;
    this._value._triggerTypeValue = value;
    return this;
  }
  setCalendarTimeTrigger(value) {
    this._value._triggerTypeCase = 33;
    this._value._triggerTypeValue = value;
    return this;
  }
  setCardBoostInfo(value) {
    this._value._hasCardBoostInfo = true;
    this._value._cardBoostInfo = value;
    return this;
  }
  deleteCardBoostInfo() {
    this._value._hasCardBoostInfo = false;
    this._value._cardBoostInfo = null;
    return this;
  }
  setFeaturedCard(value) {
    this._value._hasFeaturedCard = true;
    this._value._featuredCard = value;
    return this;
  }
  deleteFeaturedCard() {
    this._value._hasFeaturedCard = false;
    this._value._featuredCard = null;
    return this;
  }
  setFeaturedSkin(value) {
    this._value._hasFeaturedSkin = true;
    this._value._featuredSkin = value;
    return this;
  }
  deleteFeaturedSkin() {
    this._value._hasFeaturedSkin = false;
    this._value._featuredSkin = null;
    return this;
  }
  setTrophyConfig(value) {
    this._value._hasTrophyConfig = true;
    this._value._trophyConfig = value;
    return this;
  }
  deleteTrophyConfig() {
    this._value._hasTrophyConfig = false;
    this._value._trophyConfig = null;
    return this;
  }
}
MapEvent.Builder = MapEvent_Builder;
class MapEvent_WithParent {
  /**
   * @param {MapEvent} value
   * @param {MapEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasEventName() {
    if (this._cachedHasEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedHasEventName = true;
      } else {
        this._cachedHasEventName = this._parent ? this._parent.hasEventName : false;
      }
    }
    return this._cachedHasEventName;
  }
  get eventName() {
    if (this._cachedEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedEventName = this._value.eventName;
      } else {
        this._cachedEventName = this._parent ? this._parent.eventName : this._value.eventName;
      }
    }
    return this._cachedEventName;
  }
  get hasEventDurationInHours() {
    if (this._cachedHasEventDurationInHours === undefined) {
      if (this._value.hasEventDurationInHours) {
        this._cachedHasEventDurationInHours = true;
      } else {
        this._cachedHasEventDurationInHours = this._parent ? this._parent.hasEventDurationInHours : false;
      }
    }
    return this._cachedHasEventDurationInHours;
  }
  get eventDurationInHours() {
    if (this._cachedEventDurationInHours === undefined) {
      if (this._value.hasEventDurationInHours) {
        this._cachedEventDurationInHours = this._value.eventDurationInHours;
      } else {
        this._cachedEventDurationInHours = this._parent ? this._parent.eventDurationInHours : this._value.eventDurationInHours;
      }
    }
    return this._cachedEventDurationInHours;
  }
  get hasPostEventDurationInHours() {
    if (this._cachedHasPostEventDurationInHours === undefined) {
      if (this._value.hasPostEventDurationInHours) {
        this._cachedHasPostEventDurationInHours = true;
      } else {
        this._cachedHasPostEventDurationInHours = this._parent ? this._parent.hasPostEventDurationInHours : false;
      }
    }
    return this._cachedHasPostEventDurationInHours;
  }
  get postEventDurationInHours() {
    if (this._cachedPostEventDurationInHours === undefined) {
      if (this._value.hasPostEventDurationInHours) {
        this._cachedPostEventDurationInHours = this._value.postEventDurationInHours;
      } else {
        this._cachedPostEventDurationInHours = this._parent ? this._parent.postEventDurationInHours : this._value.postEventDurationInHours;
      }
    }
    return this._cachedPostEventDurationInHours;
  }
  get hasLevelAccessKey() {
    if (this._cachedHasLevelAccessKey === undefined) {
      if (this._value.hasLevelAccessKey) {
        this._cachedHasLevelAccessKey = true;
      } else {
        this._cachedHasLevelAccessKey = this._parent ? this._parent.hasLevelAccessKey : false;
      }
    }
    return this._cachedHasLevelAccessKey;
  }
  get levelAccessKey() {
    if (!this._cachedLevelAccessKey) {
      if (this._value.hasLevelAccessKey) {
        this._cachedLevelAccessKey = new MapEvent_LevelAccessKey.WithParent(this._value.levelAccessKey, this._parent && this._parent.hasLevelAccessKey ? this._parent.levelAccessKey : null);
      } else {
        this._cachedLevelAccessKey = this._parent ? new MapEvent_LevelAccessKey.WithParent(MapEvent_LevelAccessKey.default, this._parent.levelAccessKey) : MapEvent_LevelAccessKey.WithParent.default;
      }
    }
    return this._cachedLevelAccessKey;
  }
  get hasEventPointKey() {
    if (this._cachedHasEventPointKey === undefined) {
      if (this._value.hasEventPointKey) {
        this._cachedHasEventPointKey = true;
      } else {
        this._cachedHasEventPointKey = this._parent ? this._parent.hasEventPointKey : false;
      }
    }
    return this._cachedHasEventPointKey;
  }
  get eventPointKey() {
    if (this._cachedEventPointKey === undefined) {
      if (this._value.hasEventPointKey) {
        this._cachedEventPointKey = this._value.eventPointKey;
      } else {
        this._cachedEventPointKey = this._parent ? this._parent.eventPointKey : this._value.eventPointKey;
      }
    }
    return this._cachedEventPointKey;
  }
  get hasEventTokenKey() {
    if (this._cachedHasEventTokenKey === undefined) {
      if (this._value.hasEventTokenKey) {
        this._cachedHasEventTokenKey = true;
      } else {
        this._cachedHasEventTokenKey = this._parent ? this._parent.hasEventTokenKey : false;
      }
    }
    return this._cachedHasEventTokenKey;
  }
  get eventTokenKey() {
    if (this._cachedEventTokenKey === undefined) {
      if (this._value.hasEventTokenKey) {
        this._cachedEventTokenKey = this._value.eventTokenKey;
      } else {
        this._cachedEventTokenKey = this._parent ? this._parent.eventTokenKey : this._value.eventTokenKey;
      }
    }
    return this._cachedEventTokenKey;
  }
  get hasEventTokenFontSprite() {
    if (this._cachedHasEventTokenFontSprite === undefined) {
      if (this._value.hasEventTokenFontSprite) {
        this._cachedHasEventTokenFontSprite = true;
      } else {
        this._cachedHasEventTokenFontSprite = this._parent ? this._parent.hasEventTokenFontSprite : false;
      }
    }
    return this._cachedHasEventTokenFontSprite;
  }
  get eventTokenFontSprite() {
    if (this._cachedEventTokenFontSprite === undefined) {
      if (this._value.hasEventTokenFontSprite) {
        this._cachedEventTokenFontSprite = this._value.eventTokenFontSprite;
      } else {
        this._cachedEventTokenFontSprite = this._parent ? this._parent.eventTokenFontSprite : this._value.eventTokenFontSprite;
      }
    }
    return this._cachedEventTokenFontSprite;
  }
  get hasGoldPassSubscriptionId() {
    if (this._cachedHasGoldPassSubscriptionId === undefined) {
      if (this._value.hasGoldPassSubscriptionId) {
        this._cachedHasGoldPassSubscriptionId = true;
      } else {
        this._cachedHasGoldPassSubscriptionId = this._parent ? this._parent.hasGoldPassSubscriptionId : false;
      }
    }
    return this._cachedHasGoldPassSubscriptionId;
  }
  get goldPassSubscriptionId() {
    if (this._cachedGoldPassSubscriptionId === undefined) {
      if (this._value.hasGoldPassSubscriptionId) {
        this._cachedGoldPassSubscriptionId = this._value.goldPassSubscriptionId;
      } else {
        this._cachedGoldPassSubscriptionId = this._parent ? this._parent.goldPassSubscriptionId : this._value.goldPassSubscriptionId;
      }
    }
    return this._cachedGoldPassSubscriptionId;
  }
  get hasGoldPassProductId() {
    if (this._cachedHasGoldPassProductId === undefined) {
      if (this._value.hasGoldPassProductId) {
        this._cachedHasGoldPassProductId = true;
      } else {
        this._cachedHasGoldPassProductId = this._parent ? this._parent.hasGoldPassProductId : false;
      }
    }
    return this._cachedHasGoldPassProductId;
  }
  get goldPassProductId() {
    if (this._cachedGoldPassProductId === undefined) {
      if (this._value.hasGoldPassProductId) {
        this._cachedGoldPassProductId = this._value.goldPassProductId;
      } else {
        this._cachedGoldPassProductId = this._parent ? this._parent.goldPassProductId : this._value.goldPassProductId;
      }
    }
    return this._cachedGoldPassProductId;
  }
  get selfBundleIds() {
    return this._value.bundleIds;
  }
  get inherentBundleIds() {
    if (!this._inherentBundleIds) {
      this._inherentBundleIds = this._parent ? this._parent.bundleIds : [];
    }
    return this._inherentBundleIds;
  }
  get bundleIds() {
    if (!this._allBundleIds) {
      this._allBundleIds = this._parent ? this._parent.bundleIds.concat(this.selfBundleIds) : this.selfBundleIds;
    }
    return this._allBundleIds;
  }
  get selfBundlesAvailableWhenEventOpen() {
    return this._value.bundlesAvailableWhenEventOpen;
  }
  get inherentBundlesAvailableWhenEventOpen() {
    if (!this._inherentBundlesAvailableWhenEventOpen) {
      this._inherentBundlesAvailableWhenEventOpen = this._parent ? this._parent.bundlesAvailableWhenEventOpen : [];
    }
    return this._inherentBundlesAvailableWhenEventOpen;
  }
  get bundlesAvailableWhenEventOpen() {
    if (!this._allBundlesAvailableWhenEventOpen) {
      this._allBundlesAvailableWhenEventOpen = this._parent ? this._parent.bundlesAvailableWhenEventOpen.concat(this.selfBundlesAvailableWhenEventOpen) : this.selfBundlesAvailableWhenEventOpen;
    }
    return this._allBundlesAvailableWhenEventOpen;
  }
  get hasEventMarketConfig() {
    if (this._cachedHasEventMarketConfig === undefined) {
      if (this._value.hasEventMarketConfig) {
        this._cachedHasEventMarketConfig = true;
      } else {
        this._cachedHasEventMarketConfig = this._parent ? this._parent.hasEventMarketConfig : false;
      }
    }
    return this._cachedHasEventMarketConfig;
  }
  get eventMarketConfig() {
    if (!this._cachedEventMarketConfig) {
      if (this._value.hasEventMarketConfig) {
        this._cachedEventMarketConfig = new MapEvent_EventMarketConfig.WithParent(this._value.eventMarketConfig, this._parent && this._parent.hasEventMarketConfig ? this._parent.eventMarketConfig : null);
      } else {
        this._cachedEventMarketConfig = this._parent ? new MapEvent_EventMarketConfig.WithParent(MapEvent_EventMarketConfig.default, this._parent.eventMarketConfig) : MapEvent_EventMarketConfig.WithParent.default;
      }
    }
    return this._cachedEventMarketConfig;
  }
  get hasEventMilestonePath() {
    if (this._cachedHasEventMilestonePath === undefined) {
      if (this._value.hasEventMilestonePath) {
        this._cachedHasEventMilestonePath = true;
      } else {
        this._cachedHasEventMilestonePath = this._parent ? this._parent.hasEventMilestonePath : false;
      }
    }
    return this._cachedHasEventMilestonePath;
  }
  get eventMilestonePath() {
    if (!this._cachedEventMilestonePath) {
      if (this._value.hasEventMilestonePath) {
        this._cachedEventMilestonePath = new MapEvent_EventMilestonePath.WithParent(this._value.eventMilestonePath, this._parent && this._parent.hasEventMilestonePath ? this._parent.eventMilestonePath : null);
      } else {
        this._cachedEventMilestonePath = this._parent ? new MapEvent_EventMilestonePath.WithParent(MapEvent_EventMilestonePath.default, this._parent.eventMilestonePath) : MapEvent_EventMilestonePath.WithParent.default;
      }
    }
    return this._cachedEventMilestonePath;
  }
  get hasEventLevel() {
    if (this._cachedHasEventLevel === undefined) {
      if (this._value.hasEventLevel) {
        this._cachedHasEventLevel = true;
      } else {
        this._cachedHasEventLevel = this._parent ? this._parent.hasEventLevel : false;
      }
    }
    return this._cachedHasEventLevel;
  }
  get eventLevel() {
    if (!this._cachedEventLevel) {
      if (this._value.hasEventLevel) {
        this._cachedEventLevel = new MapEvent_EventLevel.WithParent(this._value.eventLevel, this._parent && this._parent.hasEventLevel ? this._parent.eventLevel : null);
      } else {
        this._cachedEventLevel = this._parent ? new MapEvent_EventLevel.WithParent(MapEvent_EventLevel.default, this._parent.eventLevel) : MapEvent_EventLevel.WithParent.default;
      }
    }
    return this._cachedEventLevel;
  }
  get hasEventQuest() {
    if (this._cachedHasEventQuest === undefined) {
      if (this._value.hasEventQuest) {
        this._cachedHasEventQuest = true;
      } else {
        this._cachedHasEventQuest = this._parent ? this._parent.hasEventQuest : false;
      }
    }
    return this._cachedHasEventQuest;
  }
  get eventQuest() {
    if (!this._cachedEventQuest) {
      if (this._value.hasEventQuest) {
        this._cachedEventQuest = new MapEvent_EventQuest.WithParent(this._value.eventQuest, this._parent && this._parent.hasEventQuest ? this._parent.eventQuest : null);
      } else {
        this._cachedEventQuest = this._parent ? new MapEvent_EventQuest.WithParent(MapEvent_EventQuest.default, this._parent.eventQuest) : MapEvent_EventQuest.WithParent.default;
      }
    }
    return this._cachedEventQuest;
  }
  get hasEnableLiveEvent() {
    if (this._cachedHasEnableLiveEvent === undefined) {
      if (this._value.hasEnableLiveEvent) {
        this._cachedHasEnableLiveEvent = true;
      } else {
        this._cachedHasEnableLiveEvent = this._parent ? this._parent.hasEnableLiveEvent : false;
      }
    }
    return this._cachedHasEnableLiveEvent;
  }
  get enableLiveEvent() {
    if (this._cachedEnableLiveEvent === undefined) {
      if (this._value.hasEnableLiveEvent) {
        this._cachedEnableLiveEvent = this._value.enableLiveEvent;
      } else {
        this._cachedEnableLiveEvent = this._parent ? this._parent.enableLiveEvent : this._value.enableLiveEvent;
      }
    }
    return this._cachedEnableLiveEvent;
  }
  get hasLiveEventConfig() {
    if (this._cachedHasLiveEventConfig === undefined) {
      if (this._value.hasLiveEventConfig) {
        this._cachedHasLiveEventConfig = true;
      } else {
        this._cachedHasLiveEventConfig = this._parent ? this._parent.hasLiveEventConfig : false;
      }
    }
    return this._cachedHasLiveEventConfig;
  }
  get liveEventConfig() {
    if (!this._cachedLiveEventConfig) {
      if (this._value.hasLiveEventConfig) {
        this._cachedLiveEventConfig = new MapEvent_LiveEventConfig.WithParent(this._value.liveEventConfig, this._parent && this._parent.hasLiveEventConfig ? this._parent.liveEventConfig : null);
      } else {
        this._cachedLiveEventConfig = this._parent ? new MapEvent_LiveEventConfig.WithParent(MapEvent_LiveEventConfig.default, this._parent.liveEventConfig) : MapEvent_LiveEventConfig.WithParent.default;
      }
    }
    return this._cachedLiveEventConfig;
  }
  get hasEventGuildConfig() {
    if (this._cachedHasEventGuildConfig === undefined) {
      if (this._value.hasEventGuildConfig) {
        this._cachedHasEventGuildConfig = true;
      } else {
        this._cachedHasEventGuildConfig = this._parent ? this._parent.hasEventGuildConfig : false;
      }
    }
    return this._cachedHasEventGuildConfig;
  }
  get eventGuildConfig() {
    if (!this._cachedEventGuildConfig) {
      if (this._value.hasEventGuildConfig) {
        this._cachedEventGuildConfig = new MapEvent_EventGuildConfig.WithParent(this._value.eventGuildConfig, this._parent && this._parent.hasEventGuildConfig ? this._parent.eventGuildConfig : null);
      } else {
        this._cachedEventGuildConfig = this._parent ? new MapEvent_EventGuildConfig.WithParent(MapEvent_EventGuildConfig.default, this._parent.eventGuildConfig) : MapEvent_EventGuildConfig.WithParent.default;
      }
    }
    return this._cachedEventGuildConfig;
  }
  get hasGuildBossConfig() {
    if (this._cachedHasGuildBossConfig === undefined) {
      if (this._value.hasGuildBossConfig) {
        this._cachedHasGuildBossConfig = true;
      } else {
        this._cachedHasGuildBossConfig = this._parent ? this._parent.hasGuildBossConfig : false;
      }
    }
    return this._cachedHasGuildBossConfig;
  }
  get guildBossConfig() {
    if (!this._cachedGuildBossConfig) {
      if (this._value.hasGuildBossConfig) {
        this._cachedGuildBossConfig = new MapEvent_GuildBossConfig.WithParent(this._value.guildBossConfig, this._parent && this._parent.hasGuildBossConfig ? this._parent.guildBossConfig : null);
      } else {
        this._cachedGuildBossConfig = this._parent ? new MapEvent_GuildBossConfig.WithParent(MapEvent_GuildBossConfig.default, this._parent.guildBossConfig) : MapEvent_GuildBossConfig.WithParent.default;
      }
    }
    return this._cachedGuildBossConfig;
  }
  get hasChestConfig() {
    if (this._cachedHasChestConfig === undefined) {
      if (this._value.hasChestConfig) {
        this._cachedHasChestConfig = true;
      } else {
        this._cachedHasChestConfig = this._parent ? this._parent.hasChestConfig : false;
      }
    }
    return this._cachedHasChestConfig;
  }
  get chestConfig() {
    if (!this._cachedChestConfig) {
      if (this._value.hasChestConfig) {
        this._cachedChestConfig = new MapEvent_EventChestConfig.WithParent(this._value.chestConfig, this._parent && this._parent.hasChestConfig ? this._parent.chestConfig : null);
      } else {
        this._cachedChestConfig = this._parent ? new MapEvent_EventChestConfig.WithParent(MapEvent_EventChestConfig.default, this._parent.chestConfig) : MapEvent_EventChestConfig.WithParent.default;
      }
    }
    return this._cachedChestConfig;
  }
  get selfChestDropItemsInfo() {
    if (!this._selfChestDropItemsInfo) {
      this._selfChestDropItemsInfo = [];
      for (let i of this._value.chestDropItemsInfo) {
        this._selfChestDropItemsInfo.push(new MapEvent_ChestDropItemInfo.WithParent(i, null));
      }
    }
    return this._selfChestDropItemsInfo;
  }
  get inherentChestDropItemsInfo() {
    if (!this._inherentChestDropItemsInfo) {
      this._inherentChestDropItemsInfo = this._parent ? this._parent.chestDropItemsInfo : [];
    }
    return this._inherentChestDropItemsInfo;
  }
  get chestDropItemsInfo() {
    if (!this._allChestDropItemsInfo) {
      this._allChestDropItemsInfo = this._parent ? this._parent.chestDropItemsInfo.concat(this.selfChestDropItemsInfo) : this.selfChestDropItemsInfo;
    }
    return this._allChestDropItemsInfo;
  }
  get hasTokensAmountPerPurchase() {
    if (this._cachedHasTokensAmountPerPurchase === undefined) {
      if (this._value.hasTokensAmountPerPurchase) {
        this._cachedHasTokensAmountPerPurchase = true;
      } else {
        this._cachedHasTokensAmountPerPurchase = this._parent ? this._parent.hasTokensAmountPerPurchase : false;
      }
    }
    return this._cachedHasTokensAmountPerPurchase;
  }
  get tokensAmountPerPurchase() {
    if (this._cachedTokensAmountPerPurchase === undefined) {
      if (this._value.hasTokensAmountPerPurchase) {
        this._cachedTokensAmountPerPurchase = this._value.tokensAmountPerPurchase;
      } else {
        this._cachedTokensAmountPerPurchase = this._parent ? this._parent.tokensAmountPerPurchase : this._value.tokensAmountPerPurchase;
      }
    }
    return this._cachedTokensAmountPerPurchase;
  }
  get selfTokensPriceList() {
    return this._value.tokensPriceList;
  }
  get inherentTokensPriceList() {
    if (!this._inherentTokensPriceList) {
      this._inherentTokensPriceList = this._parent ? this._parent.tokensPriceList : [];
    }
    return this._inherentTokensPriceList;
  }
  get tokensPriceList() {
    if (!this._allTokensPriceList) {
      this._allTokensPriceList = this._parent ? this._parent.tokensPriceList.concat(this.selfTokensPriceList) : this.selfTokensPriceList;
    }
    return this._allTokensPriceList;
  }
  get hasTokensPriceResetTimeInSecs() {
    if (this._cachedHasTokensPriceResetTimeInSecs === undefined) {
      if (this._value.hasTokensPriceResetTimeInSecs) {
        this._cachedHasTokensPriceResetTimeInSecs = true;
      } else {
        this._cachedHasTokensPriceResetTimeInSecs = this._parent ? this._parent.hasTokensPriceResetTimeInSecs : false;
      }
    }
    return this._cachedHasTokensPriceResetTimeInSecs;
  }
  get tokensPriceResetTimeInSecs() {
    if (this._cachedTokensPriceResetTimeInSecs === undefined) {
      if (this._value.hasTokensPriceResetTimeInSecs) {
        this._cachedTokensPriceResetTimeInSecs = this._value.tokensPriceResetTimeInSecs;
      } else {
        this._cachedTokensPriceResetTimeInSecs = this._parent ? this._parent.tokensPriceResetTimeInSecs : this._value.tokensPriceResetTimeInSecs;
      }
    }
    return this._cachedTokensPriceResetTimeInSecs;
  }
  get hasEventChestPicPath() {
    if (this._cachedHasEventChestPicPath === undefined) {
      if (this._value.hasEventChestPicPath) {
        this._cachedHasEventChestPicPath = true;
      } else {
        this._cachedHasEventChestPicPath = this._parent ? this._parent.hasEventChestPicPath : false;
      }
    }
    return this._cachedHasEventChestPicPath;
  }
  get eventChestPicPath() {
    if (this._cachedEventChestPicPath === undefined) {
      if (this._value.hasEventChestPicPath) {
        this._cachedEventChestPicPath = this._value.eventChestPicPath;
      } else {
        this._cachedEventChestPicPath = this._parent ? this._parent.eventChestPicPath : this._value.eventChestPicPath;
      }
    }
    return this._cachedEventChestPicPath;
  }
  get hasEventBundlePicPath() {
    if (this._cachedHasEventBundlePicPath === undefined) {
      if (this._value.hasEventBundlePicPath) {
        this._cachedHasEventBundlePicPath = true;
      } else {
        this._cachedHasEventBundlePicPath = this._parent ? this._parent.hasEventBundlePicPath : false;
      }
    }
    return this._cachedHasEventBundlePicPath;
  }
  get eventBundlePicPath() {
    if (this._cachedEventBundlePicPath === undefined) {
      if (this._value.hasEventBundlePicPath) {
        this._cachedEventBundlePicPath = this._value.eventBundlePicPath;
      } else {
        this._cachedEventBundlePicPath = this._parent ? this._parent.eventBundlePicPath : this._value.eventBundlePicPath;
      }
    }
    return this._cachedEventBundlePicPath;
  }
  get hasShieldKey() {
    if (this._cachedHasShieldKey === undefined) {
      if (this._value.hasShieldKey) {
        this._cachedHasShieldKey = true;
      } else {
        this._cachedHasShieldKey = this._parent ? this._parent.hasShieldKey : false;
      }
    }
    return this._cachedHasShieldKey;
  }
  get shieldKey() {
    if (this._cachedShieldKey === undefined) {
      if (this._value.hasShieldKey) {
        this._cachedShieldKey = this._value.shieldKey;
      } else {
        this._cachedShieldKey = this._parent ? this._parent.shieldKey : this._value.shieldKey;
      }
    }
    return this._cachedShieldKey;
  }
  get hasShieldPrice() {
    if (this._cachedHasShieldPrice === undefined) {
      if (this._value.hasShieldPrice) {
        this._cachedHasShieldPrice = true;
      } else {
        this._cachedHasShieldPrice = this._parent ? this._parent.hasShieldPrice : false;
      }
    }
    return this._cachedHasShieldPrice;
  }
  get shieldPrice() {
    if (this._cachedShieldPrice === undefined) {
      if (this._value.hasShieldPrice) {
        this._cachedShieldPrice = this._value.shieldPrice;
      } else {
        this._cachedShieldPrice = this._parent ? this._parent.shieldPrice : this._value.shieldPrice;
      }
    }
    return this._cachedShieldPrice;
  }
  get hasUpfrontShieldAmount() {
    if (this._cachedHasUpfrontShieldAmount === undefined) {
      if (this._value.hasUpfrontShieldAmount) {
        this._cachedHasUpfrontShieldAmount = true;
      } else {
        this._cachedHasUpfrontShieldAmount = this._parent ? this._parent.hasUpfrontShieldAmount : false;
      }
    }
    return this._cachedHasUpfrontShieldAmount;
  }
  get upfrontShieldAmount() {
    if (this._cachedUpfrontShieldAmount === undefined) {
      if (this._value.hasUpfrontShieldAmount) {
        this._cachedUpfrontShieldAmount = this._value.upfrontShieldAmount;
      } else {
        this._cachedUpfrontShieldAmount = this._parent ? this._parent.upfrontShieldAmount : this._value.upfrontShieldAmount;
      }
    }
    return this._cachedUpfrontShieldAmount;
  }
  get hasShieldAmountPerPurchase() {
    if (this._cachedHasShieldAmountPerPurchase === undefined) {
      if (this._value.hasShieldAmountPerPurchase) {
        this._cachedHasShieldAmountPerPurchase = true;
      } else {
        this._cachedHasShieldAmountPerPurchase = this._parent ? this._parent.hasShieldAmountPerPurchase : false;
      }
    }
    return this._cachedHasShieldAmountPerPurchase;
  }
  get shieldAmountPerPurchase() {
    if (this._cachedShieldAmountPerPurchase === undefined) {
      if (this._value.hasShieldAmountPerPurchase) {
        this._cachedShieldAmountPerPurchase = this._value.shieldAmountPerPurchase;
      } else {
        this._cachedShieldAmountPerPurchase = this._parent ? this._parent.shieldAmountPerPurchase : this._value.shieldAmountPerPurchase;
      }
    }
    return this._cachedShieldAmountPerPurchase;
  }
  get hasOverviewPanel() {
    if (this._cachedHasOverviewPanel === undefined) {
      if (this._value.hasOverviewPanel) {
        this._cachedHasOverviewPanel = true;
      } else {
        this._cachedHasOverviewPanel = this._parent ? this._parent.hasOverviewPanel : false;
      }
    }
    return this._cachedHasOverviewPanel;
  }
  get overviewPanel() {
    if (this._cachedOverviewPanel === undefined) {
      if (this._value.hasOverviewPanel) {
        this._cachedOverviewPanel = this._value.overviewPanel;
      } else {
        this._cachedOverviewPanel = this._parent ? this._parent.overviewPanel : this._value.overviewPanel;
      }
    }
    return this._cachedOverviewPanel;
  }
  get triggerTypeCase() {
    if (this._cachedtriggerTypeCase === undefined) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedtriggerTypeCase = this._parent ? this._parent.triggerTypeCase : 0;
      } else {
        this._cachedtriggerTypeCase = this._value._triggerTypeCase;
      }
    }
    return this._cachedtriggerTypeCase;
  }
  get playerLevelTrigger() {
    if (!this._cachedPlayerLevelTrigger) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedPlayerLevelTrigger = this._parent ? new MapEvent_PlayerLevelTrigger.WithParent(MapEvent_PlayerLevelTrigger.default, this._parent.playerLevelTrigger) : this._value.playerLevelTrigger;
      } else if (this._value._triggerTypeCase === 31) {
        this._cachedPlayerLevelTrigger = new MapEvent_PlayerLevelTrigger.WithParent(this._value.playerLevelTrigger, this._parent && this._parent.triggerTypeCase === 31 ? this._parent.playerLevelTrigger : null);
      } else {
        this._cachedPlayerLevelTrigger = MapEvent_PlayerLevelTrigger.WithParent.default;
      }
    }
    return this._cachedPlayerLevelTrigger;
  }
  get campaignLevelTrigger() {
    if (!this._cachedCampaignLevelTrigger) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedCampaignLevelTrigger = this._parent ? new MapEvent_CampaignLevelTrigger.WithParent(MapEvent_CampaignLevelTrigger.default, this._parent.campaignLevelTrigger) : this._value.campaignLevelTrigger;
      } else if (this._value._triggerTypeCase === 32) {
        this._cachedCampaignLevelTrigger = new MapEvent_CampaignLevelTrigger.WithParent(this._value.campaignLevelTrigger, this._parent && this._parent.triggerTypeCase === 32 ? this._parent.campaignLevelTrigger : null);
      } else {
        this._cachedCampaignLevelTrigger = MapEvent_CampaignLevelTrigger.WithParent.default;
      }
    }
    return this._cachedCampaignLevelTrigger;
  }
  get calendarTimeTrigger() {
    if (!this._cachedCalendarTimeTrigger) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedCalendarTimeTrigger = this._parent ? new MapEvent_CalendarTimeTrigger.WithParent(MapEvent_CalendarTimeTrigger.default, this._parent.calendarTimeTrigger) : this._value.calendarTimeTrigger;
      } else if (this._value._triggerTypeCase === 33) {
        this._cachedCalendarTimeTrigger = new MapEvent_CalendarTimeTrigger.WithParent(this._value.calendarTimeTrigger, this._parent && this._parent.triggerTypeCase === 33 ? this._parent.calendarTimeTrigger : null);
      } else {
        this._cachedCalendarTimeTrigger = MapEvent_CalendarTimeTrigger.WithParent.default;
      }
    }
    return this._cachedCalendarTimeTrigger;
  }
  get hasCardBoostInfo() {
    if (this._cachedHasCardBoostInfo === undefined) {
      if (this._value.hasCardBoostInfo) {
        this._cachedHasCardBoostInfo = true;
      } else {
        this._cachedHasCardBoostInfo = this._parent ? this._parent.hasCardBoostInfo : false;
      }
    }
    return this._cachedHasCardBoostInfo;
  }
  get cardBoostInfo() {
    if (!this._cachedCardBoostInfo) {
      if (this._value.hasCardBoostInfo) {
        this._cachedCardBoostInfo = new MapEvent_CardBoostInfo.WithParent(this._value.cardBoostInfo, this._parent && this._parent.hasCardBoostInfo ? this._parent.cardBoostInfo : null);
      } else {
        this._cachedCardBoostInfo = this._parent ? new MapEvent_CardBoostInfo.WithParent(MapEvent_CardBoostInfo.default, this._parent.cardBoostInfo) : MapEvent_CardBoostInfo.WithParent.default;
      }
    }
    return this._cachedCardBoostInfo;
  }
  get hasFeaturedCard() {
    if (this._cachedHasFeaturedCard === undefined) {
      if (this._value.hasFeaturedCard) {
        this._cachedHasFeaturedCard = true;
      } else {
        this._cachedHasFeaturedCard = this._parent ? this._parent.hasFeaturedCard : false;
      }
    }
    return this._cachedHasFeaturedCard;
  }
  get featuredCard() {
    if (this._cachedFeaturedCard === undefined) {
      if (this._value.hasFeaturedCard) {
        this._cachedFeaturedCard = this._value.featuredCard;
      } else {
        this._cachedFeaturedCard = this._parent ? this._parent.featuredCard : this._value.featuredCard;
      }
    }
    return this._cachedFeaturedCard;
  }
  get hasFeaturedSkin() {
    if (this._cachedHasFeaturedSkin === undefined) {
      if (this._value.hasFeaturedSkin) {
        this._cachedHasFeaturedSkin = true;
      } else {
        this._cachedHasFeaturedSkin = this._parent ? this._parent.hasFeaturedSkin : false;
      }
    }
    return this._cachedHasFeaturedSkin;
  }
  get featuredSkin() {
    if (!this._cachedFeaturedSkin) {
      if (this._value.hasFeaturedSkin) {
        this._cachedFeaturedSkin = new dcei_wildsky_card_proto.CardSkin.WithParent(this._value.featuredSkin, this._parent && this._parent.hasFeaturedSkin ? this._parent.featuredSkin : null);
      } else {
        this._cachedFeaturedSkin = this._parent ? new dcei_wildsky_card_proto.CardSkin.WithParent(dcei_wildsky_card_proto.CardSkin.default, this._parent.featuredSkin) : dcei_wildsky_card_proto.CardSkin.WithParent.default;
      }
    }
    return this._cachedFeaturedSkin;
  }
  get hasTrophyConfig() {
    if (this._cachedHasTrophyConfig === undefined) {
      if (this._value.hasTrophyConfig) {
        this._cachedHasTrophyConfig = true;
      } else {
        this._cachedHasTrophyConfig = this._parent ? this._parent.hasTrophyConfig : false;
      }
    }
    return this._cachedHasTrophyConfig;
  }
  get trophyConfig() {
    if (!this._cachedTrophyConfig) {
      if (this._value.hasTrophyConfig) {
        this._cachedTrophyConfig = new MapEvent_TrophyConfig.WithParent(this._value.trophyConfig, this._parent && this._parent.hasTrophyConfig ? this._parent.trophyConfig : null);
      } else {
        this._cachedTrophyConfig = this._parent ? new MapEvent_TrophyConfig.WithParent(MapEvent_TrophyConfig.default, this._parent.trophyConfig) : MapEvent_TrophyConfig.WithParent.default;
      }
    }
    return this._cachedTrophyConfig;
  }
  update(current, parent) {
    const result = new MapEvent_WithParent(current, parent);
    if (this._cachedLevelAccessKey && this._value.hasLevelAccessKey && current.hasLevelAccessKey) {
      if (this._value.levelAccessKey === current.levelAccessKey && this._parent === parent) {
        result._cachedLevelAccessKey = this._cachedLevelAccessKey;
      } else {
        result._cachedLevelAccessKey = this._cachedLevelAccessKey.update(current.levelAccessKey, parent && parent.hasLevelAccessKey ? parent.levelAccessKey : null);
      }
    }
    if (this._cachedEventMarketConfig && this._value.hasEventMarketConfig && current.hasEventMarketConfig) {
      if (this._value.eventMarketConfig === current.eventMarketConfig && this._parent === parent) {
        result._cachedEventMarketConfig = this._cachedEventMarketConfig;
      } else {
        result._cachedEventMarketConfig = this._cachedEventMarketConfig.update(current.eventMarketConfig, parent && parent.hasEventMarketConfig ? parent.eventMarketConfig : null);
      }
    }
    if (this._cachedEventMilestonePath && this._value.hasEventMilestonePath && current.hasEventMilestonePath) {
      if (this._value.eventMilestonePath === current.eventMilestonePath && this._parent === parent) {
        result._cachedEventMilestonePath = this._cachedEventMilestonePath;
      } else {
        result._cachedEventMilestonePath = this._cachedEventMilestonePath.update(current.eventMilestonePath, parent && parent.hasEventMilestonePath ? parent.eventMilestonePath : null);
      }
    }
    if (this._cachedEventLevel && this._value.hasEventLevel && current.hasEventLevel) {
      if (this._value.eventLevel === current.eventLevel && this._parent === parent) {
        result._cachedEventLevel = this._cachedEventLevel;
      } else {
        result._cachedEventLevel = this._cachedEventLevel.update(current.eventLevel, parent && parent.hasEventLevel ? parent.eventLevel : null);
      }
    }
    if (this._cachedEventQuest && this._value.hasEventQuest && current.hasEventQuest) {
      if (this._value.eventQuest === current.eventQuest && this._parent === parent) {
        result._cachedEventQuest = this._cachedEventQuest;
      } else {
        result._cachedEventQuest = this._cachedEventQuest.update(current.eventQuest, parent && parent.hasEventQuest ? parent.eventQuest : null);
      }
    }
    if (this._cachedLiveEventConfig && this._value.hasLiveEventConfig && current.hasLiveEventConfig) {
      if (this._value.liveEventConfig === current.liveEventConfig && this._parent === parent) {
        result._cachedLiveEventConfig = this._cachedLiveEventConfig;
      } else {
        result._cachedLiveEventConfig = this._cachedLiveEventConfig.update(current.liveEventConfig, parent && parent.hasLiveEventConfig ? parent.liveEventConfig : null);
      }
    }
    if (this._cachedEventGuildConfig && this._value.hasEventGuildConfig && current.hasEventGuildConfig) {
      if (this._value.eventGuildConfig === current.eventGuildConfig && this._parent === parent) {
        result._cachedEventGuildConfig = this._cachedEventGuildConfig;
      } else {
        result._cachedEventGuildConfig = this._cachedEventGuildConfig.update(current.eventGuildConfig, parent && parent.hasEventGuildConfig ? parent.eventGuildConfig : null);
      }
    }
    if (this._cachedGuildBossConfig && this._value.hasGuildBossConfig && current.hasGuildBossConfig) {
      if (this._value.guildBossConfig === current.guildBossConfig && this._parent === parent) {
        result._cachedGuildBossConfig = this._cachedGuildBossConfig;
      } else {
        result._cachedGuildBossConfig = this._cachedGuildBossConfig.update(current.guildBossConfig, parent && parent.hasGuildBossConfig ? parent.guildBossConfig : null);
      }
    }
    if (this._cachedChestConfig && this._value.hasChestConfig && current.hasChestConfig) {
      if (this._value.chestConfig === current.chestConfig && this._parent === parent) {
        result._cachedChestConfig = this._cachedChestConfig;
      } else {
        result._cachedChestConfig = this._cachedChestConfig.update(current.chestConfig, parent && parent.hasChestConfig ? parent.chestConfig : null);
      }
    }
    if (this._selfChestDropItemsInfo) {
      if (this._value.chestDropItemsInfo === current.chestDropItemsInfo) {
        result._selfChestDropItemsInfo = this._selfChestDropItemsInfo;
      } else {
        result._selfChestDropItemsInfo = [];
        for (let i = 0; i < current.chestDropItemsInfo.length; i++) {
          const oldValue = this._value.chestDropItemsInfo[i];
          if (oldValue) {
            const oldCache = this._selfChestDropItemsInfo[i];
            if (oldValue === current.chestDropItemsInfo[i]) {
              result._selfChestDropItemsInfo[i] = oldCache;
            } else {
              result._selfChestDropItemsInfo[i] = oldCache.update(current.chestDropItemsInfo[i], null);
            }
          } else {
            result._selfChestDropItemsInfo[i] = new MapEvent_ChestDropItemInfo.WithParent(current.chestDropItemsInfo[i], null);
          }
        }
      }
    }
    if (this._cachedPlayerLevelTrigger && this._value._triggerTypeCase === 31 && current._triggerTypeCase === 31) {
      if (this._value.playerLevelTrigger === current.playerLevelTrigger && this._parent === parent) {
        result._cachedPlayerLevelTrigger = this._cachedPlayerLevelTrigger;
      } else {
        result._cachedPlayerLevelTrigger = this._cachedPlayerLevelTrigger.update(current.playerLevelTrigger, parent && parent.triggerTypeCase === 31 ? parent.playerLevelTrigger : null);
      }
    }
    if (this._cachedCampaignLevelTrigger && this._value._triggerTypeCase === 32 && current._triggerTypeCase === 32) {
      if (this._value.campaignLevelTrigger === current.campaignLevelTrigger && this._parent === parent) {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger;
      } else {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger.update(current.campaignLevelTrigger, parent && parent.triggerTypeCase === 32 ? parent.campaignLevelTrigger : null);
      }
    }
    if (this._cachedCalendarTimeTrigger && this._value._triggerTypeCase === 33 && current._triggerTypeCase === 33) {
      if (this._value.calendarTimeTrigger === current.calendarTimeTrigger && this._parent === parent) {
        result._cachedCalendarTimeTrigger = this._cachedCalendarTimeTrigger;
      } else {
        result._cachedCalendarTimeTrigger = this._cachedCalendarTimeTrigger.update(current.calendarTimeTrigger, parent && parent.triggerTypeCase === 33 ? parent.calendarTimeTrigger : null);
      }
    }
    if (this._cachedCardBoostInfo && this._value.hasCardBoostInfo && current.hasCardBoostInfo) {
      if (this._value.cardBoostInfo === current.cardBoostInfo && this._parent === parent) {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo;
      } else {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo.update(current.cardBoostInfo, parent && parent.hasCardBoostInfo ? parent.cardBoostInfo : null);
      }
    }
    if (this._cachedFeaturedSkin && this._value.hasFeaturedSkin && current.hasFeaturedSkin) {
      if (this._value.featuredSkin === current.featuredSkin && this._parent === parent) {
        result._cachedFeaturedSkin = this._cachedFeaturedSkin;
      } else {
        result._cachedFeaturedSkin = this._cachedFeaturedSkin.update(current.featuredSkin, parent && parent.hasFeaturedSkin ? parent.featuredSkin : null);
      }
    }
    if (this._cachedTrophyConfig && this._value.hasTrophyConfig && current.hasTrophyConfig) {
      if (this._value.trophyConfig === current.trophyConfig && this._parent === parent) {
        result._cachedTrophyConfig = this._cachedTrophyConfig;
      } else {
        result._cachedTrophyConfig = this._cachedTrophyConfig.update(current.trophyConfig, parent && parent.hasTrophyConfig ? parent.trophyConfig : null);
      }
    }
    return result;
  }
}
MapEvent_WithParent.default = new MapEvent_WithParent(MapEvent.default, null);
MapEvent.WithParent = MapEvent_WithParent;
class MapEvent_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get eventName() {
    if (!this._eventName) {
      this._eventName = {
        name: "eventName",
        Name: "EventName",
        number: 20,
        protoType: 9,
        protoName: "event_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventName;
  }
  get eventDurationInHours() {
    if (!this._eventDurationInHours) {
      this._eventDurationInHours = {
        name: "eventDurationInHours",
        Name: "EventDurationInHours",
        number: 201,
        protoType: 5,
        protoName: "event_duration_in_hours",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventDurationInHours;
  }
  get postEventDurationInHours() {
    if (!this._postEventDurationInHours) {
      this._postEventDurationInHours = {
        name: "postEventDurationInHours",
        Name: "PostEventDurationInHours",
        number: 40,
        protoType: 5,
        protoName: "post_event_duration_in_hours",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postEventDurationInHours;
  }
  get levelAccessKey() {
    if (!this._levelAccessKey) {
      this._levelAccessKey = {
        name: "levelAccessKey",
        Name: "LevelAccessKey",
        number: 4,
        protoType: 11,
        protoName: "level_access_key",
        type: MapEvent_LevelAccessKey,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelAccessKey;
  }
  get eventPointKey() {
    if (!this._eventPointKey) {
      this._eventPointKey = {
        name: "eventPointKey",
        Name: "EventPointKey",
        number: 5,
        protoType: 9,
        protoName: "event_point_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventPointKey;
  }
  get eventTokenKey() {
    if (!this._eventTokenKey) {
      this._eventTokenKey = {
        name: "eventTokenKey",
        Name: "EventTokenKey",
        number: 6,
        protoType: 9,
        protoName: "event_token_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventTokenKey;
  }
  get eventTokenFontSprite() {
    if (!this._eventTokenFontSprite) {
      this._eventTokenFontSprite = {
        name: "eventTokenFontSprite",
        Name: "EventTokenFontSprite",
        number: 24,
        protoType: 9,
        protoName: "event_token_font_sprite",
        type: JsonToString,
        options: {
          valueDropdown: "FontSprites",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventTokenFontSprite;
  }
  get goldPassSubscriptionId() {
    if (!this._goldPassSubscriptionId) {
      this._goldPassSubscriptionId = {
        name: "goldPassSubscriptionId",
        Name: "GoldPassSubscriptionId",
        number: 7,
        protoType: 9,
        protoName: "gold_pass_subscription_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldPassSubscriptionId;
  }
  get goldPassProductId() {
    if (!this._goldPassProductId) {
      this._goldPassProductId = {
        name: "goldPassProductId",
        Name: "GoldPassProductId",
        number: 8,
        protoType: 9,
        protoName: "gold_pass_product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldPassProductId;
  }
  get bundleIds() {
    if (!this._bundleIds) {
      this._bundleIds = {
        name: "bundleIds",
        Name: "BundleIds",
        number: 43,
        protoType: 9,
        protoName: "bundle_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleIds;
  }
  get bundlesAvailableWhenEventOpen() {
    if (!this._bundlesAvailableWhenEventOpen) {
      this._bundlesAvailableWhenEventOpen = {
        name: "bundlesAvailableWhenEventOpen",
        Name: "BundlesAvailableWhenEventOpen",
        number: 46,
        protoType: 9,
        protoName: "bundles_available_when_event_open",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundlesAvailableWhenEventOpen;
  }
  get eventMarketConfig() {
    if (!this._eventMarketConfig) {
      this._eventMarketConfig = {
        name: "eventMarketConfig",
        Name: "EventMarketConfig",
        number: 47,
        protoType: 11,
        protoName: "event_market_config",
        type: MapEvent_EventMarketConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventMarketConfig;
  }
  get eventMilestonePath() {
    if (!this._eventMilestonePath) {
      this._eventMilestonePath = {
        name: "eventMilestonePath",
        Name: "EventMilestonePath",
        number: 10,
        protoType: 11,
        protoName: "event_milestone_path",
        type: MapEvent_EventMilestonePath,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventMilestonePath;
  }
  get eventLevel() {
    if (!this._eventLevel) {
      this._eventLevel = {
        name: "eventLevel",
        Name: "EventLevel",
        number: 11,
        protoType: 11,
        protoName: "event_level",
        type: MapEvent_EventLevel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventLevel;
  }
  get eventQuest() {
    if (!this._eventQuest) {
      this._eventQuest = {
        name: "eventQuest",
        Name: "EventQuest",
        number: 12,
        protoType: 11,
        protoName: "event_quest",
        type: MapEvent_EventQuest,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventQuest;
  }
  get enableLiveEvent() {
    if (!this._enableLiveEvent) {
      this._enableLiveEvent = {
        name: "enableLiveEvent",
        Name: "EnableLiveEvent",
        number: 26,
        protoType: 8,
        protoName: "enable_live_event",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableLiveEvent;
  }
  get liveEventConfig() {
    if (!this._liveEventConfig) {
      this._liveEventConfig = {
        name: "liveEventConfig",
        Name: "LiveEventConfig",
        number: 27,
        protoType: 11,
        protoName: "live_event_config",
        type: MapEvent_LiveEventConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._liveEventConfig;
  }
  get eventGuildConfig() {
    if (!this._eventGuildConfig) {
      this._eventGuildConfig = {
        name: "eventGuildConfig",
        Name: "EventGuildConfig",
        number: 30,
        protoType: 11,
        protoName: "event_guild_config",
        type: MapEvent_EventGuildConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventGuildConfig;
  }
  get guildBossConfig() {
    if (!this._guildBossConfig) {
      this._guildBossConfig = {
        name: "guildBossConfig",
        Name: "GuildBossConfig",
        number: 45,
        protoType: 11,
        protoName: "guild_boss_config",
        type: MapEvent_GuildBossConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildBossConfig;
  }
  get chestConfig() {
    if (!this._chestConfig) {
      this._chestConfig = {
        name: "chestConfig",
        Name: "ChestConfig",
        number: 44,
        protoType: 11,
        protoName: "chest_config",
        type: MapEvent_EventChestConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestConfig;
  }
  get chestDropItemsInfo() {
    if (!this._chestDropItemsInfo) {
      this._chestDropItemsInfo = {
        name: "chestDropItemsInfo",
        Name: "ChestDropItemsInfo",
        number: 22,
        protoType: 11,
        protoName: "chest_drop_items_info",
        type: MapEvent_ChestDropItemInfo,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestDropItemsInfo;
  }
  get tokensAmountPerPurchase() {
    if (!this._tokensAmountPerPurchase) {
      this._tokensAmountPerPurchase = {
        name: "tokensAmountPerPurchase",
        Name: "TokensAmountPerPurchase",
        number: 15,
        protoType: 5,
        protoName: "tokens_amount_per_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokensAmountPerPurchase;
  }
  get tokensPriceList() {
    if (!this._tokensPriceList) {
      this._tokensPriceList = {
        name: "tokensPriceList",
        Name: "TokensPriceList",
        number: 41,
        protoType: 5,
        protoName: "tokens_price_list",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokensPriceList;
  }
  get tokensPriceResetTimeInSecs() {
    if (!this._tokensPriceResetTimeInSecs) {
      this._tokensPriceResetTimeInSecs = {
        name: "tokensPriceResetTimeInSecs",
        Name: "TokensPriceResetTimeInSecs",
        number: 42,
        protoType: 5,
        protoName: "tokens_price_reset_time_in_secs",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokensPriceResetTimeInSecs;
  }
  get eventChestPicPath() {
    if (!this._eventChestPicPath) {
      this._eventChestPicPath = {
        name: "eventChestPicPath",
        Name: "EventChestPicPath",
        number: 16,
        protoType: 9,
        protoName: "event_chest_pic_path",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventChestPicPath;
  }
  get eventBundlePicPath() {
    if (!this._eventBundlePicPath) {
      this._eventBundlePicPath = {
        name: "eventBundlePicPath",
        Name: "EventBundlePicPath",
        number: 17,
        protoType: 9,
        protoName: "event_bundle_pic_path",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventBundlePicPath;
  }
  get shieldKey() {
    if (!this._shieldKey) {
      this._shieldKey = {
        name: "shieldKey",
        Name: "ShieldKey",
        number: 18,
        protoType: 9,
        protoName: "shield_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shieldKey;
  }
  get shieldPrice() {
    if (!this._shieldPrice) {
      this._shieldPrice = {
        name: "shieldPrice",
        Name: "ShieldPrice",
        number: 19,
        protoType: 5,
        protoName: "shield_price",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shieldPrice;
  }
  get upfrontShieldAmount() {
    if (!this._upfrontShieldAmount) {
      this._upfrontShieldAmount = {
        name: "upfrontShieldAmount",
        Name: "UpfrontShieldAmount",
        number: 21,
        protoType: 5,
        protoName: "upfront_shield_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upfrontShieldAmount;
  }
  get shieldAmountPerPurchase() {
    if (!this._shieldAmountPerPurchase) {
      this._shieldAmountPerPurchase = {
        name: "shieldAmountPerPurchase",
        Name: "ShieldAmountPerPurchase",
        number: 23,
        protoType: 5,
        protoName: "shield_amount_per_purchase",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shieldAmountPerPurchase;
  }
  get overviewPanel() {
    if (!this._overviewPanel) {
      this._overviewPanel = {
        name: "overviewPanel",
        Name: "OverviewPanel",
        number: 25,
        protoType: 9,
        protoName: "overview_panel",
        type: JsonToString,
        options: {
          valueDropdown: "MapEventOverviewPanels",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overviewPanel;
  }
  get playerLevelTrigger() {
    if (!this._playerLevelTrigger) {
      this._playerLevelTrigger = {
        name: "playerLevelTrigger",
        Name: "PlayerLevelTrigger",
        number: 31,
        protoType: 11,
        protoName: "player_level_trigger",
        oneofIndex: 28,
        type: MapEvent_PlayerLevelTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelTrigger;
  }
  get campaignLevelTrigger() {
    if (!this._campaignLevelTrigger) {
      this._campaignLevelTrigger = {
        name: "campaignLevelTrigger",
        Name: "CampaignLevelTrigger",
        number: 32,
        protoType: 11,
        protoName: "campaign_level_trigger",
        oneofIndex: 28,
        type: MapEvent_CampaignLevelTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignLevelTrigger;
  }
  get calendarTimeTrigger() {
    if (!this._calendarTimeTrigger) {
      this._calendarTimeTrigger = {
        name: "calendarTimeTrigger",
        Name: "CalendarTimeTrigger",
        number: 33,
        protoType: 11,
        protoName: "calendar_time_trigger",
        oneofIndex: 28,
        type: MapEvent_CalendarTimeTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._calendarTimeTrigger;
  }
  get cardBoostInfo() {
    if (!this._cardBoostInfo) {
      this._cardBoostInfo = {
        name: "cardBoostInfo",
        Name: "CardBoostInfo",
        number: 50,
        protoType: 11,
        protoName: "card_boost_info",
        type: MapEvent_CardBoostInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardBoostInfo;
  }
  get featuredCard() {
    if (!this._featuredCard) {
      this._featuredCard = {
        name: "featuredCard",
        Name: "FeaturedCard",
        number: 51,
        protoType: 9,
        protoName: "featured_card",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featuredCard;
  }
  get featuredSkin() {
    if (!this._featuredSkin) {
      this._featuredSkin = {
        name: "featuredSkin",
        Name: "FeaturedSkin",
        number: 52,
        protoType: 11,
        protoName: "featured_skin",
        type: dcei_wildsky_card_proto.CardSkin,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featuredSkin;
  }
  get trophyConfig() {
    if (!this._trophyConfig) {
      this._trophyConfig = {
        name: "trophyConfig",
        Name: "TrophyConfig",
        number: 61,
        protoType: 11,
        protoName: "trophy_config",
        type: MapEvent_TrophyConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._trophyConfig;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.eventName,
        this.eventDurationInHours,
        this.postEventDurationInHours,
        this.levelAccessKey,
        this.eventPointKey,
        this.eventTokenKey,
        this.eventTokenFontSprite,
        this.goldPassSubscriptionId,
        this.goldPassProductId,
        this.bundleIds,
        this.bundlesAvailableWhenEventOpen,
        this.eventMarketConfig,
        this.eventMilestonePath,
        this.eventLevel,
        this.eventQuest,
        this.enableLiveEvent,
        this.liveEventConfig,
        this.eventGuildConfig,
        this.guildBossConfig,
        this.chestConfig,
        this.chestDropItemsInfo,
        this.tokensAmountPerPurchase,
        this.tokensPriceList,
        this.tokensPriceResetTimeInSecs,
        this.eventChestPicPath,
        this.eventBundlePicPath,
        this.shieldKey,
        this.shieldPrice,
        this.upfrontShieldAmount,
        this.shieldAmountPerPurchase,
        this.overviewPanel,
        this.playerLevelTrigger,
        this.campaignLevelTrigger,
        this.calendarTimeTrigger,
        this.cardBoostInfo,
        this.featuredCard,
        this.featuredSkin,
        this.trophyConfig,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventName",
        Name: "DummyOneofForEventName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventDurationInHours",
        Name: "DummyOneofForEventDurationInHours",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPostEventDurationInHours",
        Name: "DummyOneofForPostEventDurationInHours",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelAccessKey",
        Name: "DummyOneofForLevelAccessKey",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventPointKey",
        Name: "DummyOneofForEventPointKey",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventTokenKey",
        Name: "DummyOneofForEventTokenKey",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventTokenFontSprite",
        Name: "DummyOneofForEventTokenFontSprite",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldPassSubscriptionId",
        Name: "DummyOneofForGoldPassSubscriptionId",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldPassProductId",
        Name: "DummyOneofForGoldPassProductId",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventMarketConfig",
        Name: "DummyOneofForEventMarketConfig",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventMilestonePath",
        Name: "DummyOneofForEventMilestonePath",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventLevel",
        Name: "DummyOneofForEventLevel",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventQuest",
        Name: "DummyOneofForEventQuest",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableLiveEvent",
        Name: "DummyOneofForEnableLiveEvent",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLiveEventConfig",
        Name: "DummyOneofForLiveEventConfig",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventGuildConfig",
        Name: "DummyOneofForEventGuildConfig",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildBossConfig",
        Name: "DummyOneofForGuildBossConfig",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestConfig",
        Name: "DummyOneofForChestConfig",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTokensAmountPerPurchase",
        Name: "DummyOneofForTokensAmountPerPurchase",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTokensPriceResetTimeInSecs",
        Name: "DummyOneofForTokensPriceResetTimeInSecs",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventChestPicPath",
        Name: "DummyOneofForEventChestPicPath",
        fields: [
          this.fields[25],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventBundlePicPath",
        Name: "DummyOneofForEventBundlePicPath",
        fields: [
          this.fields[26],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShieldKey",
        Name: "DummyOneofForShieldKey",
        fields: [
          this.fields[27],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShieldPrice",
        Name: "DummyOneofForShieldPrice",
        fields: [
          this.fields[28],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpfrontShieldAmount",
        Name: "DummyOneofForUpfrontShieldAmount",
        fields: [
          this.fields[29],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShieldAmountPerPurchase",
        Name: "DummyOneofForShieldAmountPerPurchase",
        fields: [
          this.fields[30],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverviewPanel",
        Name: "DummyOneofForOverviewPanel",
        fields: [
          this.fields[31],
        ],
      });
      this._oneofs.push({
        name: "triggerType",
        Name: "TriggerType",
        fields: [
          this.fields[32],
          this.fields[33],
          this.fields[34],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardBoostInfo",
        Name: "DummyOneofForCardBoostInfo",
        fields: [
          this.fields[35],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeaturedCard",
        Name: "DummyOneofForFeaturedCard",
        fields: [
          this.fields[36],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeaturedSkin",
        Name: "DummyOneofForFeaturedSkin",
        fields: [
          this.fields[37],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTrophyConfig",
        Name: "DummyOneofForTrophyConfig",
        fields: [
          this.fields[38],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEvent.descriptor = new MapEvent_Descriptor();
export class LevelPrefix {
  get descriptor() {
    return LevelPrefix.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDifficultyMultiplier = false;
    this._difficultyMultiplier = null;
    this._hasKeyRequired = false;
    this._keyRequired = null;
    this._hasDurationInSeconds = false;
    this._durationInSeconds = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDifficultyMultiplier) return false;
    if (this._hasKeyRequired) return false;
    if (this._hasDurationInSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LevelPrefix) {
      return value;
    }
    return LevelPrefix.fromJson(value);
  }
  static fromJson(json) {
    const result = new LevelPrefix();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.difficultyMultiplier != null) {
      result._hasDifficultyMultiplier = true;
      result._difficultyMultiplier = JsonToInt32.fromJson(json.difficultyMultiplier);
    }
    if (json.keyRequired != null) {
      result._hasKeyRequired = true;
      result._keyRequired = JsonToInt32.fromJson(json.keyRequired);
    }
    if (json.durationInSeconds != null) {
      result._hasDurationInSeconds = true;
      result._durationInSeconds = JsonToInt32.fromJson(json.durationInSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDifficultyMultiplier) {
      result.difficultyMultiplier = JsonToInt32.toJson(this._difficultyMultiplier);
    }
    if (this._hasKeyRequired) {
      result.keyRequired = JsonToInt32.toJson(this._keyRequired);
    }
    if (this._hasDurationInSeconds) {
      result.durationInSeconds = JsonToInt32.toJson(this._durationInSeconds);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get difficultyMultiplier() {
    return this._hasDifficultyMultiplier ? this._difficultyMultiplier : JsonToInt32.default;
  }
  get hasDifficultyMultiplier() {
    return this._hasDifficultyMultiplier;
  }
  setDifficultyMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['difficultyMultiplier']), value};
  }
  deleteDifficultyMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['difficultyMultiplier'])};
  }
  /**
   * @returns {number}
   */
  get keyRequired() {
    return this._hasKeyRequired ? this._keyRequired : JsonToInt32.default;
  }
  get hasKeyRequired() {
    return this._hasKeyRequired;
  }
  setKeyRequired(path, value) {
    return {type: 'SET', path: path.concat(['keyRequired']), value};
  }
  deleteKeyRequired(path) {
    return {type: 'DELETE', path: path.concat(['keyRequired'])};
  }
  /**
   * @returns {number}
   */
  get durationInSeconds() {
    return this._hasDurationInSeconds ? this._durationInSeconds : JsonToInt32.default;
  }
  get hasDurationInSeconds() {
    return this._hasDurationInSeconds;
  }
  setDurationInSeconds(path, value) {
    return {type: 'SET', path: path.concat(['durationInSeconds']), value};
  }
  deleteDurationInSeconds(path) {
    return {type: 'DELETE', path: path.concat(['durationInSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LevelPrefix(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new LevelPrefix(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LevelPrefix(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new LevelPrefix(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficultyMultiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LevelPrefix(this);
              copy._hasDifficultyMultiplier = true;
              copy._difficultyMultiplier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficultyMultiplier) {
                return this;
              }
              const copy = new LevelPrefix(this);
              copy._hasDifficultyMultiplier = false;
              copy._difficultyMultiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyRequired": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LevelPrefix(this);
              copy._hasKeyRequired = true;
              copy._keyRequired = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyRequired) {
                return this;
              }
              const copy = new LevelPrefix(this);
              copy._hasKeyRequired = false;
              copy._keyRequired = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "durationInSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LevelPrefix(this);
              copy._hasDurationInSeconds = true;
              copy._durationInSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationInSeconds) {
                return this;
              }
              const copy = new LevelPrefix(this);
              copy._hasDurationInSeconds = false;
              copy._durationInSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LevelPrefix} other
   * @returns {LevelPrefix}
   */
  merge(other) {
    const copy = new LevelPrefix(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDifficultyMultiplier) {
      copy._hasDifficultyMultiplier = true;
      copy._difficultyMultiplier = other._difficultyMultiplier;
    }
    if (other._hasKeyRequired) {
      copy._hasKeyRequired = true;
      copy._keyRequired = other._keyRequired;
    }
    if (other._hasDurationInSeconds) {
      copy._hasDurationInSeconds = true;
      copy._durationInSeconds = other._durationInSeconds;
    }
    return copy;
  }
}
LevelPrefix.default = new LevelPrefix();
class LevelPrefix_Builder {
  constructor(value) {
    this._value = new LevelPrefix(value);
  }
  build() {
    return new LevelPrefix(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDifficultyMultiplier(value) {
    this._value._hasDifficultyMultiplier = true;
    this._value._difficultyMultiplier = value;
    return this;
  }
  deleteDifficultyMultiplier() {
    this._value._hasDifficultyMultiplier = false;
    this._value._difficultyMultiplier = null;
    return this;
  }
  setKeyRequired(value) {
    this._value._hasKeyRequired = true;
    this._value._keyRequired = value;
    return this;
  }
  deleteKeyRequired() {
    this._value._hasKeyRequired = false;
    this._value._keyRequired = null;
    return this;
  }
  setDurationInSeconds(value) {
    this._value._hasDurationInSeconds = true;
    this._value._durationInSeconds = value;
    return this;
  }
  deleteDurationInSeconds() {
    this._value._hasDurationInSeconds = false;
    this._value._durationInSeconds = null;
    return this;
  }
}
LevelPrefix.Builder = LevelPrefix_Builder;
class LevelPrefix_WithParent {
  /**
   * @param {LevelPrefix} value
   * @param {LevelPrefix_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LevelPrefix.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDifficultyMultiplier() {
    if (this._cachedHasDifficultyMultiplier === undefined) {
      if (this._value.hasDifficultyMultiplier) {
        this._cachedHasDifficultyMultiplier = true;
      } else {
        this._cachedHasDifficultyMultiplier = this._parent ? this._parent.hasDifficultyMultiplier : false;
      }
    }
    return this._cachedHasDifficultyMultiplier;
  }
  get difficultyMultiplier() {
    if (this._cachedDifficultyMultiplier === undefined) {
      if (this._value.hasDifficultyMultiplier) {
        this._cachedDifficultyMultiplier = this._value.difficultyMultiplier;
      } else {
        this._cachedDifficultyMultiplier = this._parent ? this._parent.difficultyMultiplier : this._value.difficultyMultiplier;
      }
    }
    return this._cachedDifficultyMultiplier;
  }
  get hasKeyRequired() {
    if (this._cachedHasKeyRequired === undefined) {
      if (this._value.hasKeyRequired) {
        this._cachedHasKeyRequired = true;
      } else {
        this._cachedHasKeyRequired = this._parent ? this._parent.hasKeyRequired : false;
      }
    }
    return this._cachedHasKeyRequired;
  }
  get keyRequired() {
    if (this._cachedKeyRequired === undefined) {
      if (this._value.hasKeyRequired) {
        this._cachedKeyRequired = this._value.keyRequired;
      } else {
        this._cachedKeyRequired = this._parent ? this._parent.keyRequired : this._value.keyRequired;
      }
    }
    return this._cachedKeyRequired;
  }
  get hasDurationInSeconds() {
    if (this._cachedHasDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedHasDurationInSeconds = true;
      } else {
        this._cachedHasDurationInSeconds = this._parent ? this._parent.hasDurationInSeconds : false;
      }
    }
    return this._cachedHasDurationInSeconds;
  }
  get durationInSeconds() {
    if (this._cachedDurationInSeconds === undefined) {
      if (this._value.hasDurationInSeconds) {
        this._cachedDurationInSeconds = this._value.durationInSeconds;
      } else {
        this._cachedDurationInSeconds = this._parent ? this._parent.durationInSeconds : this._value.durationInSeconds;
      }
    }
    return this._cachedDurationInSeconds;
  }
  update(current, parent) {
    const result = new LevelPrefix_WithParent(current, parent);
    return result;
  }
}
LevelPrefix_WithParent.default = new LevelPrefix_WithParent(LevelPrefix.default, null);
LevelPrefix.WithParent = LevelPrefix_WithParent;
class LevelPrefix_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get difficultyMultiplier() {
    if (!this._difficultyMultiplier) {
      this._difficultyMultiplier = {
        name: "difficultyMultiplier",
        Name: "DifficultyMultiplier",
        number: 3,
        protoType: 5,
        protoName: "difficulty_multiplier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficultyMultiplier;
  }
  get keyRequired() {
    if (!this._keyRequired) {
      this._keyRequired = {
        name: "keyRequired",
        Name: "KeyRequired",
        number: 4,
        protoType: 5,
        protoName: "key_required",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyRequired;
  }
  get durationInSeconds() {
    if (!this._durationInSeconds) {
      this._durationInSeconds = {
        name: "durationInSeconds",
        Name: "DurationInSeconds",
        number: 5,
        protoType: 5,
        protoName: "duration_in_seconds",
        type: JsonToInt32,
        options: {
          comments: "If set to non 0 value, this duration will override coop level config\'s duration time",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationInSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.difficultyMultiplier,
        this.keyRequired,
        this.durationInSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDifficultyMultiplier",
        Name: "DummyOneofForDifficultyMultiplier",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyRequired",
        Name: "DummyOneofForKeyRequired",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDurationInSeconds",
        Name: "DummyOneofForDurationInSeconds",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
LevelPrefix.descriptor = new LevelPrefix_Descriptor();
export class MapEventData {
  get descriptor() {
    return MapEventData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._mapEvents = [];
    this._levelPrefixes = [];
    this._hasDataVersion = false;
    this._dataVersion = null;
  }
  isEmpty() {
    if (this._mapEvents.length > 0) return false;
    if (this._levelPrefixes.length > 0) return false;
    if (this._hasDataVersion) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventData) {
      return value;
    }
    return MapEventData.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventData();
    result._mapEvents = JsonToList(json.mapEvents, MapEvent);
    result._levelPrefixes = JsonToList(json.levelPrefixes, LevelPrefix);
    if (json.dataVersion != null) {
      result._hasDataVersion = true;
      result._dataVersion = JsonToString.fromJson(json.dataVersion);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._mapEvents.length > 0) {
      result.mapEvents = ArrayToJson(this._mapEvents, MapEvent);
    }
    if (this._levelPrefixes.length > 0) {
      result.levelPrefixes = ArrayToJson(this._levelPrefixes, LevelPrefix);
    }
    if (this._hasDataVersion) {
      result.dataVersion = JsonToString.toJson(this._dataVersion);
    }
    return result;
  }
  /**
   * @returns {MapEvent[]}
   */
  get mapEvents() {
    return this._mapEvents;
  }
  addMapEvents(path, value) {
    return {type: 'ADD', path: path.concat(['mapEvents']), value: value.toJson()};
  }
  setMapEvents(path, value) {
    return {type: 'SET', path: path.concat(['mapEvents']), value: ArrayToJson(value, MapEvent)};
  }
  setMapEventsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapEvents', key]), value: value.toJson()};
  }
  deleteMapEvents(path) {
    return {type: 'DELETE', path: path.concat(['mapEvents'])};
  }
  deleteMapEventsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapEvents', key])};
  }
  /**
   * @returns {LevelPrefix[]}
   */
  get levelPrefixes() {
    return this._levelPrefixes;
  }
  addLevelPrefixes(path, value) {
    return {type: 'ADD', path: path.concat(['levelPrefixes']), value: value.toJson()};
  }
  setLevelPrefixes(path, value) {
    return {type: 'SET', path: path.concat(['levelPrefixes']), value: ArrayToJson(value, LevelPrefix)};
  }
  setLevelPrefixesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levelPrefixes', key]), value: value.toJson()};
  }
  deleteLevelPrefixes(path) {
    return {type: 'DELETE', path: path.concat(['levelPrefixes'])};
  }
  deleteLevelPrefixesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levelPrefixes', key])};
  }
  /**
   * @returns {string}
   */
  get dataVersion() {
    return this._hasDataVersion ? this._dataVersion : JsonToString.default;
  }
  get hasDataVersion() {
    return this._hasDataVersion;
  }
  setDataVersion(path, value) {
    return {type: 'SET', path: path.concat(['dataVersion']), value};
  }
  deleteDataVersion(path) {
    return {type: 'DELETE', path: path.concat(['dataVersion'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapEvents": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventData(this);
              copy._mapEvents = [];        for (let i of value) {
                copy._mapEvents.push(MapEvent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventData(this);
              copy._mapEvents = copy._mapEvents.concat([MapEvent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapEvents.length === 0) {
                return this;
              }
              const copy = new MapEventData(this);
              copy._mapEvents = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapEvents.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventData(this);
              copy._mapEvents = copy._mapEvents.slice();
              copy._mapEvents[path[1]] = MapEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventData(this);
              copy._mapEvents = copy._mapEvents.slice(0, path[1]).concat(copy._mapEvents.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapEvents.length) {
            return this;
          }
          const oldValue = this._mapEvents[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventData(this);
          copy._mapEvents = copy._mapEvents.slice();
          copy._mapEvents[key] = newValue;
          return copy;
        }
      }
      case "levelPrefixes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventData(this);
              copy._levelPrefixes = [];        for (let i of value) {
                copy._levelPrefixes.push(LevelPrefix.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventData(this);
              copy._levelPrefixes = copy._levelPrefixes.concat([LevelPrefix.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levelPrefixes.length === 0) {
                return this;
              }
              const copy = new MapEventData(this);
              copy._levelPrefixes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levelPrefixes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventData(this);
              copy._levelPrefixes = copy._levelPrefixes.slice();
              copy._levelPrefixes[path[1]] = LevelPrefix.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventData(this);
              copy._levelPrefixes = copy._levelPrefixes.slice(0, path[1]).concat(copy._levelPrefixes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levelPrefixes.length) {
            return this;
          }
          const oldValue = this._levelPrefixes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventData(this);
          copy._levelPrefixes = copy._levelPrefixes.slice();
          copy._levelPrefixes[key] = newValue;
          return copy;
        }
      }
      case "dataVersion": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventData(this);
              copy._hasDataVersion = true;
              copy._dataVersion = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDataVersion) {
                return this;
              }
              const copy = new MapEventData(this);
              copy._hasDataVersion = false;
              copy._dataVersion = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventData} other
   * @returns {MapEventData}
   */
  merge(other) {
    const copy = new MapEventData(this);
    copy._mapEvents = this._mapEvents.concat(other._mapEvents);
    copy._levelPrefixes = this._levelPrefixes.concat(other._levelPrefixes);
    if (other._hasDataVersion) {
      copy._hasDataVersion = true;
      copy._dataVersion = other._dataVersion;
    }
    return copy;
  }
}
MapEventData.default = new MapEventData();
class MapEventData_Builder {
  constructor(value) {
    this._value = new MapEventData(value);
  }
  build() {
    return new MapEventData(this._value);
  }
  addAllMapEvents(values) {
    this._value._mapEvents = this._value._mapEvents.concat(values);
    return this;
  }
  addMapEvents(value) {
    this._value._mapEvents = this._value._mapEvents.concat([value]);
    return this;
  }
  setMapEvents(index, value) {
    this._value._mapEvents = this._value._mapEvents.concat();
    this._value._mapEvents[index] = value;
    return this;
  }
  clearMapEvents() {
    this._value._mapEvents = [];
    return this;
  }
  addAllLevelPrefixes(values) {
    this._value._levelPrefixes = this._value._levelPrefixes.concat(values);
    return this;
  }
  addLevelPrefixes(value) {
    this._value._levelPrefixes = this._value._levelPrefixes.concat([value]);
    return this;
  }
  setLevelPrefixes(index, value) {
    this._value._levelPrefixes = this._value._levelPrefixes.concat();
    this._value._levelPrefixes[index] = value;
    return this;
  }
  clearLevelPrefixes() {
    this._value._levelPrefixes = [];
    return this;
  }
  setDataVersion(value) {
    this._value._hasDataVersion = true;
    this._value._dataVersion = value;
    return this;
  }
  deleteDataVersion() {
    this._value._hasDataVersion = false;
    this._value._dataVersion = null;
    return this;
  }
}
MapEventData.Builder = MapEventData_Builder;
class MapEventData_WithParent {
  /**
   * @param {MapEventData} value
   * @param {MapEventData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMapEvents() {
    if (!this._selfMapEvents) {
      this._selfMapEvents = [];
      for (let i of this._value.mapEvents) {
        this._selfMapEvents.push(new MapEvent.WithParent(i, null));
      }
    }
    return this._selfMapEvents;
  }
  get inherentMapEvents() {
    if (!this._inherentMapEvents) {
      this._inherentMapEvents = this._parent ? this._parent.mapEvents : [];
    }
    return this._inherentMapEvents;
  }
  get mapEvents() {
    if (!this._allMapEvents) {
      this._allMapEvents = this._parent ? this._parent.mapEvents.concat(this.selfMapEvents) : this.selfMapEvents;
    }
    return this._allMapEvents;
  }
  get selfLevelPrefixes() {
    if (!this._selfLevelPrefixes) {
      this._selfLevelPrefixes = [];
      for (let i of this._value.levelPrefixes) {
        this._selfLevelPrefixes.push(new LevelPrefix.WithParent(i, null));
      }
    }
    return this._selfLevelPrefixes;
  }
  get inherentLevelPrefixes() {
    if (!this._inherentLevelPrefixes) {
      this._inherentLevelPrefixes = this._parent ? this._parent.levelPrefixes : [];
    }
    return this._inherentLevelPrefixes;
  }
  get levelPrefixes() {
    if (!this._allLevelPrefixes) {
      this._allLevelPrefixes = this._parent ? this._parent.levelPrefixes.concat(this.selfLevelPrefixes) : this.selfLevelPrefixes;
    }
    return this._allLevelPrefixes;
  }
  get hasDataVersion() {
    if (this._cachedHasDataVersion === undefined) {
      if (this._value.hasDataVersion) {
        this._cachedHasDataVersion = true;
      } else {
        this._cachedHasDataVersion = this._parent ? this._parent.hasDataVersion : false;
      }
    }
    return this._cachedHasDataVersion;
  }
  get dataVersion() {
    if (this._cachedDataVersion === undefined) {
      if (this._value.hasDataVersion) {
        this._cachedDataVersion = this._value.dataVersion;
      } else {
        this._cachedDataVersion = this._parent ? this._parent.dataVersion : this._value.dataVersion;
      }
    }
    return this._cachedDataVersion;
  }
  update(current, parent) {
    const result = new MapEventData_WithParent(current, parent);
    if (this._selfMapEvents) {
      if (this._value.mapEvents === current.mapEvents) {
        result._selfMapEvents = this._selfMapEvents;
      } else {
        result._selfMapEvents = [];
        for (let i = 0; i < current.mapEvents.length; i++) {
          const oldValue = this._value.mapEvents[i];
          if (oldValue) {
            const oldCache = this._selfMapEvents[i];
            if (oldValue === current.mapEvents[i]) {
              result._selfMapEvents[i] = oldCache;
            } else {
              result._selfMapEvents[i] = oldCache.update(current.mapEvents[i], null);
            }
          } else {
            result._selfMapEvents[i] = new MapEvent.WithParent(current.mapEvents[i], null);
          }
        }
      }
    }
    if (this._selfLevelPrefixes) {
      if (this._value.levelPrefixes === current.levelPrefixes) {
        result._selfLevelPrefixes = this._selfLevelPrefixes;
      } else {
        result._selfLevelPrefixes = [];
        for (let i = 0; i < current.levelPrefixes.length; i++) {
          const oldValue = this._value.levelPrefixes[i];
          if (oldValue) {
            const oldCache = this._selfLevelPrefixes[i];
            if (oldValue === current.levelPrefixes[i]) {
              result._selfLevelPrefixes[i] = oldCache;
            } else {
              result._selfLevelPrefixes[i] = oldCache.update(current.levelPrefixes[i], null);
            }
          } else {
            result._selfLevelPrefixes[i] = new LevelPrefix.WithParent(current.levelPrefixes[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEventData_WithParent.default = new MapEventData_WithParent(MapEventData.default, null);
MapEventData.WithParent = MapEventData_WithParent;
class MapEventData_Descriptor {
  get mapEvents() {
    if (!this._mapEvents) {
      this._mapEvents = {
        name: "mapEvents",
        Name: "MapEvents",
        number: 1,
        protoType: 11,
        protoName: "map_events",
        type: MapEvent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapEvents;
  }
  get levelPrefixes() {
    if (!this._levelPrefixes) {
      this._levelPrefixes = {
        name: "levelPrefixes",
        Name: "LevelPrefixes",
        number: 2,
        protoType: 11,
        protoName: "level_prefixes",
        type: LevelPrefix,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelPrefixes;
  }
  get dataVersion() {
    if (!this._dataVersion) {
      this._dataVersion = {
        name: "dataVersion",
        Name: "DataVersion",
        number: 3,
        protoType: 9,
        protoName: "data_version",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dataVersion;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapEvents,
        this.levelPrefixes,
        this.dataVersion,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDataVersion",
        Name: "DummyOneofForDataVersion",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventData.descriptor = new MapEventData_Descriptor();
class MapEventStatus_QuestStatus {
  get descriptor() {
    return MapEventStatus_QuestStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasProgress = false;
    this._progress = null;
    this._hasCompletionTimes = false;
    this._completionTimes = null;
    this._hasIsFinished = false;
    this._isFinished = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasProgress) return false;
    if (this._hasCompletionTimes) return false;
    if (this._hasIsFinished) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_QuestStatus) {
      return value;
    }
    return MapEventStatus_QuestStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_QuestStatus();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.progress != null) {
      result._hasProgress = true;
      result._progress = JsonToDouble.fromJson(json.progress);
    }
    if (json.completionTimes != null) {
      result._hasCompletionTimes = true;
      result._completionTimes = JsonToInt32.fromJson(json.completionTimes);
    }
    if (json.isFinished != null) {
      result._hasIsFinished = true;
      result._isFinished = JsonToBoolean.fromJson(json.isFinished);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasProgress) {
      result.progress = JsonToDouble.toJson(this._progress);
    }
    if (this._hasCompletionTimes) {
      result.completionTimes = JsonToInt32.toJson(this._completionTimes);
    }
    if (this._hasIsFinished) {
      result.isFinished = JsonToBoolean.toJson(this._isFinished);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get progress() {
    return this._hasProgress ? this._progress : JsonToDouble.default;
  }
  get hasProgress() {
    return this._hasProgress;
  }
  setProgress(path, value) {
    return {type: 'SET', path: path.concat(['progress']), value};
  }
  deleteProgress(path) {
    return {type: 'DELETE', path: path.concat(['progress'])};
  }
  /**
   * @returns {number}
   */
  get completionTimes() {
    return this._hasCompletionTimes ? this._completionTimes : JsonToInt32.default;
  }
  get hasCompletionTimes() {
    return this._hasCompletionTimes;
  }
  setCompletionTimes(path, value) {
    return {type: 'SET', path: path.concat(['completionTimes']), value};
  }
  deleteCompletionTimes(path) {
    return {type: 'DELETE', path: path.concat(['completionTimes'])};
  }
  /**
   * @returns {boolean}
   */
  get isFinished() {
    return this._hasIsFinished ? this._isFinished : JsonToBoolean.default;
  }
  get hasIsFinished() {
    return this._hasIsFinished;
  }
  setIsFinished(path, value) {
    return {type: 'SET', path: path.concat(['isFinished']), value};
  }
  deleteIsFinished(path) {
    return {type: 'DELETE', path: path.concat(['isFinished'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasProgress = true;
              copy._progress = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgress) {
                return this;
              }
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasProgress = false;
              copy._progress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "completionTimes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasCompletionTimes = true;
              copy._completionTimes = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompletionTimes) {
                return this;
              }
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasCompletionTimes = false;
              copy._completionTimes = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isFinished": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasIsFinished = true;
              copy._isFinished = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsFinished) {
                return this;
              }
              const copy = new MapEventStatus_QuestStatus(this);
              copy._hasIsFinished = false;
              copy._isFinished = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_QuestStatus} other
   * @returns {MapEventStatus_QuestStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_QuestStatus(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasProgress) {
      copy._hasProgress = true;
      copy._progress = other._progress;
    }
    if (other._hasCompletionTimes) {
      copy._hasCompletionTimes = true;
      copy._completionTimes = other._completionTimes;
    }
    if (other._hasIsFinished) {
      copy._hasIsFinished = true;
      copy._isFinished = other._isFinished;
    }
    return copy;
  }
}
MapEventStatus_QuestStatus.default = new MapEventStatus_QuestStatus();
class MapEventStatus_QuestStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_QuestStatus(value);
  }
  build() {
    return new MapEventStatus_QuestStatus(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setProgress(value) {
    this._value._hasProgress = true;
    this._value._progress = value;
    return this;
  }
  deleteProgress() {
    this._value._hasProgress = false;
    this._value._progress = null;
    return this;
  }
  setCompletionTimes(value) {
    this._value._hasCompletionTimes = true;
    this._value._completionTimes = value;
    return this;
  }
  deleteCompletionTimes() {
    this._value._hasCompletionTimes = false;
    this._value._completionTimes = null;
    return this;
  }
  setIsFinished(value) {
    this._value._hasIsFinished = true;
    this._value._isFinished = value;
    return this;
  }
  deleteIsFinished() {
    this._value._hasIsFinished = false;
    this._value._isFinished = null;
    return this;
  }
}
MapEventStatus_QuestStatus.Builder = MapEventStatus_QuestStatus_Builder;
class MapEventStatus_QuestStatus_WithParent {
  /**
   * @param {MapEventStatus_QuestStatus} value
   * @param {MapEventStatus_QuestStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_QuestStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasProgress() {
    if (this._cachedHasProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedHasProgress = true;
      } else {
        this._cachedHasProgress = this._parent ? this._parent.hasProgress : false;
      }
    }
    return this._cachedHasProgress;
  }
  get progress() {
    if (this._cachedProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedProgress = this._value.progress;
      } else {
        this._cachedProgress = this._parent ? this._parent.progress : this._value.progress;
      }
    }
    return this._cachedProgress;
  }
  get hasCompletionTimes() {
    if (this._cachedHasCompletionTimes === undefined) {
      if (this._value.hasCompletionTimes) {
        this._cachedHasCompletionTimes = true;
      } else {
        this._cachedHasCompletionTimes = this._parent ? this._parent.hasCompletionTimes : false;
      }
    }
    return this._cachedHasCompletionTimes;
  }
  get completionTimes() {
    if (this._cachedCompletionTimes === undefined) {
      if (this._value.hasCompletionTimes) {
        this._cachedCompletionTimes = this._value.completionTimes;
      } else {
        this._cachedCompletionTimes = this._parent ? this._parent.completionTimes : this._value.completionTimes;
      }
    }
    return this._cachedCompletionTimes;
  }
  get hasIsFinished() {
    if (this._cachedHasIsFinished === undefined) {
      if (this._value.hasIsFinished) {
        this._cachedHasIsFinished = true;
      } else {
        this._cachedHasIsFinished = this._parent ? this._parent.hasIsFinished : false;
      }
    }
    return this._cachedHasIsFinished;
  }
  get isFinished() {
    if (this._cachedIsFinished === undefined) {
      if (this._value.hasIsFinished) {
        this._cachedIsFinished = this._value.isFinished;
      } else {
        this._cachedIsFinished = this._parent ? this._parent.isFinished : this._value.isFinished;
      }
    }
    return this._cachedIsFinished;
  }
  update(current, parent) {
    const result = new MapEventStatus_QuestStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_QuestStatus_WithParent.default = new MapEventStatus_QuestStatus_WithParent(MapEventStatus_QuestStatus.default, null);
MapEventStatus_QuestStatus.WithParent = MapEventStatus_QuestStatus_WithParent;
class MapEventStatus_QuestStatus_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get progress() {
    if (!this._progress) {
      this._progress = {
        name: "progress",
        Name: "Progress",
        number: 2,
        protoType: 1,
        protoName: "progress",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progress;
  }
  get completionTimes() {
    if (!this._completionTimes) {
      this._completionTimes = {
        name: "completionTimes",
        Name: "CompletionTimes",
        number: 3,
        protoType: 5,
        protoName: "completion_times",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._completionTimes;
  }
  get isFinished() {
    if (!this._isFinished) {
      this._isFinished = {
        name: "isFinished",
        Name: "IsFinished",
        number: 4,
        protoType: 8,
        protoName: "is_finished",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isFinished;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.progress,
        this.completionTimes,
        this.isFinished,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgress",
        Name: "DummyOneofForProgress",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCompletionTimes",
        Name: "DummyOneofForCompletionTimes",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsFinished",
        Name: "DummyOneofForIsFinished",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_QuestStatus.descriptor = new MapEventStatus_QuestStatus_Descriptor();
class MapEventStatus_MilestoneStatus {
  get descriptor() {
    return MapEventStatus_MilestoneStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasSilverAwardClaimed = false;
    this._silverAwardClaimed = null;
    this._hasGoldAwardClaimed = false;
    this._goldAwardClaimed = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasSilverAwardClaimed) return false;
    if (this._hasGoldAwardClaimed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_MilestoneStatus) {
      return value;
    }
    return MapEventStatus_MilestoneStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_MilestoneStatus();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.silverAwardClaimed != null) {
      result._hasSilverAwardClaimed = true;
      result._silverAwardClaimed = JsonToBoolean.fromJson(json.silverAwardClaimed);
    }
    if (json.goldAwardClaimed != null) {
      result._hasGoldAwardClaimed = true;
      result._goldAwardClaimed = JsonToBoolean.fromJson(json.goldAwardClaimed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasSilverAwardClaimed) {
      result.silverAwardClaimed = JsonToBoolean.toJson(this._silverAwardClaimed);
    }
    if (this._hasGoldAwardClaimed) {
      result.goldAwardClaimed = JsonToBoolean.toJson(this._goldAwardClaimed);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {boolean}
   */
  get silverAwardClaimed() {
    return this._hasSilverAwardClaimed ? this._silverAwardClaimed : JsonToBoolean.default;
  }
  get hasSilverAwardClaimed() {
    return this._hasSilverAwardClaimed;
  }
  setSilverAwardClaimed(path, value) {
    return {type: 'SET', path: path.concat(['silverAwardClaimed']), value};
  }
  deleteSilverAwardClaimed(path) {
    return {type: 'DELETE', path: path.concat(['silverAwardClaimed'])};
  }
  /**
   * @returns {boolean}
   */
  get goldAwardClaimed() {
    return this._hasGoldAwardClaimed ? this._goldAwardClaimed : JsonToBoolean.default;
  }
  get hasGoldAwardClaimed() {
    return this._hasGoldAwardClaimed;
  }
  setGoldAwardClaimed(path, value) {
    return {type: 'SET', path: path.concat(['goldAwardClaimed']), value};
  }
  deleteGoldAwardClaimed(path) {
    return {type: 'DELETE', path: path.concat(['goldAwardClaimed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverAwardClaimed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasSilverAwardClaimed = true;
              copy._silverAwardClaimed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSilverAwardClaimed) {
                return this;
              }
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasSilverAwardClaimed = false;
              copy._silverAwardClaimed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldAwardClaimed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasGoldAwardClaimed = true;
              copy._goldAwardClaimed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldAwardClaimed) {
                return this;
              }
              const copy = new MapEventStatus_MilestoneStatus(this);
              copy._hasGoldAwardClaimed = false;
              copy._goldAwardClaimed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_MilestoneStatus} other
   * @returns {MapEventStatus_MilestoneStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_MilestoneStatus(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasSilverAwardClaimed) {
      copy._hasSilverAwardClaimed = true;
      copy._silverAwardClaimed = other._silverAwardClaimed;
    }
    if (other._hasGoldAwardClaimed) {
      copy._hasGoldAwardClaimed = true;
      copy._goldAwardClaimed = other._goldAwardClaimed;
    }
    return copy;
  }
}
MapEventStatus_MilestoneStatus.default = new MapEventStatus_MilestoneStatus();
class MapEventStatus_MilestoneStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_MilestoneStatus(value);
  }
  build() {
    return new MapEventStatus_MilestoneStatus(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setSilverAwardClaimed(value) {
    this._value._hasSilverAwardClaimed = true;
    this._value._silverAwardClaimed = value;
    return this;
  }
  deleteSilverAwardClaimed() {
    this._value._hasSilverAwardClaimed = false;
    this._value._silverAwardClaimed = null;
    return this;
  }
  setGoldAwardClaimed(value) {
    this._value._hasGoldAwardClaimed = true;
    this._value._goldAwardClaimed = value;
    return this;
  }
  deleteGoldAwardClaimed() {
    this._value._hasGoldAwardClaimed = false;
    this._value._goldAwardClaimed = null;
    return this;
  }
}
MapEventStatus_MilestoneStatus.Builder = MapEventStatus_MilestoneStatus_Builder;
class MapEventStatus_MilestoneStatus_WithParent {
  /**
   * @param {MapEventStatus_MilestoneStatus} value
   * @param {MapEventStatus_MilestoneStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_MilestoneStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasSilverAwardClaimed() {
    if (this._cachedHasSilverAwardClaimed === undefined) {
      if (this._value.hasSilverAwardClaimed) {
        this._cachedHasSilverAwardClaimed = true;
      } else {
        this._cachedHasSilverAwardClaimed = this._parent ? this._parent.hasSilverAwardClaimed : false;
      }
    }
    return this._cachedHasSilverAwardClaimed;
  }
  get silverAwardClaimed() {
    if (this._cachedSilverAwardClaimed === undefined) {
      if (this._value.hasSilverAwardClaimed) {
        this._cachedSilverAwardClaimed = this._value.silverAwardClaimed;
      } else {
        this._cachedSilverAwardClaimed = this._parent ? this._parent.silverAwardClaimed : this._value.silverAwardClaimed;
      }
    }
    return this._cachedSilverAwardClaimed;
  }
  get hasGoldAwardClaimed() {
    if (this._cachedHasGoldAwardClaimed === undefined) {
      if (this._value.hasGoldAwardClaimed) {
        this._cachedHasGoldAwardClaimed = true;
      } else {
        this._cachedHasGoldAwardClaimed = this._parent ? this._parent.hasGoldAwardClaimed : false;
      }
    }
    return this._cachedHasGoldAwardClaimed;
  }
  get goldAwardClaimed() {
    if (this._cachedGoldAwardClaimed === undefined) {
      if (this._value.hasGoldAwardClaimed) {
        this._cachedGoldAwardClaimed = this._value.goldAwardClaimed;
      } else {
        this._cachedGoldAwardClaimed = this._parent ? this._parent.goldAwardClaimed : this._value.goldAwardClaimed;
      }
    }
    return this._cachedGoldAwardClaimed;
  }
  update(current, parent) {
    const result = new MapEventStatus_MilestoneStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_MilestoneStatus_WithParent.default = new MapEventStatus_MilestoneStatus_WithParent(MapEventStatus_MilestoneStatus.default, null);
MapEventStatus_MilestoneStatus.WithParent = MapEventStatus_MilestoneStatus_WithParent;
class MapEventStatus_MilestoneStatus_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get silverAwardClaimed() {
    if (!this._silverAwardClaimed) {
      this._silverAwardClaimed = {
        name: "silverAwardClaimed",
        Name: "SilverAwardClaimed",
        number: 2,
        protoType: 8,
        protoName: "silver_award_claimed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverAwardClaimed;
  }
  get goldAwardClaimed() {
    if (!this._goldAwardClaimed) {
      this._goldAwardClaimed = {
        name: "goldAwardClaimed",
        Name: "GoldAwardClaimed",
        number: 3,
        protoType: 8,
        protoName: "gold_award_claimed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldAwardClaimed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.silverAwardClaimed,
        this.goldAwardClaimed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSilverAwardClaimed",
        Name: "DummyOneofForSilverAwardClaimed",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldAwardClaimed",
        Name: "DummyOneofForGoldAwardClaimed",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_MilestoneStatus.descriptor = new MapEventStatus_MilestoneStatus_Descriptor();
class MapEventStatus_LevelStatus_LevelState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LOCKED": return 0;
        case "UNLOCKED": return 1;
        case "FINISHED": return 2;
        case "PERFECT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapEventStatus_LevelStatus_LevelState.fromJson(value);
  }
  static fromReact(e) {
    return MapEventStatus_LevelStatus_LevelState.fromJson(e);
  }
}
MapEventStatus_LevelStatus_LevelState.LOCKED = 0;
MapEventStatus_LevelStatus_LevelState.UNLOCKED = 1;
MapEventStatus_LevelStatus_LevelState.FINISHED = 2;
MapEventStatus_LevelStatus_LevelState.PERFECT = 3;
MapEventStatus_LevelStatus_LevelState.default = 0;
MapEventStatus_LevelStatus_LevelState.values = {
  LOCKED: 0,
  UNLOCKED: 1,
  FINISHED: 2,
  PERFECT: 3,
};
MapEventStatus_LevelStatus_LevelState.names = {
  0: "LOCKED",
  1: "UNLOCKED",
  2: "FINISHED",
  3: "PERFECT",
};
class MapEventStatus_LevelStatus {
  get descriptor() {
    return MapEventStatus_LevelStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasState = false;
    this._state = null;
    this._hasLevelIndex = false;
    this._levelIndex = null;
  }
  isEmpty() {
    if (this._hasState) return false;
    if (this._hasLevelIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_LevelStatus) {
      return value;
    }
    return MapEventStatus_LevelStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_LevelStatus();
    if (json.state != null) {
      result._hasState = true;
      result._state = MapEventStatus_LevelStatus_LevelState.fromJson(json.state);
    }
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasState) {
      result.state = MapEventStatus_LevelStatus_LevelState.toJson(this._state);
    }
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get state() {
    return this._hasState ? this._state : MapEventStatus_LevelStatus_LevelState.default;
  }
  get hasState() {
    return this._hasState;
  }
  setState(path, value) {
    return {type: 'SET', path: path.concat(['state']), value};
  }
  deleteState(path) {
    return {type: 'DELETE', path: path.concat(['state'])};
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "state": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_LevelStatus(this);
              copy._hasState = true;
              copy._state = MapEventStatus_LevelStatus_LevelState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasState) {
                return this;
              }
              const copy = new MapEventStatus_LevelStatus(this);
              copy._hasState = false;
              copy._state = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_LevelStatus(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new MapEventStatus_LevelStatus(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_LevelStatus} other
   * @returns {MapEventStatus_LevelStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_LevelStatus(this);
    if (other._hasState) {
      copy._hasState = true;
      copy._state = other._state;
    }
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    return copy;
  }
}
MapEventStatus_LevelStatus.default = new MapEventStatus_LevelStatus();
MapEventStatus_LevelStatus.LevelState = MapEventStatus_LevelStatus_LevelState;
class MapEventStatus_LevelStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_LevelStatus(value);
  }
  build() {
    return new MapEventStatus_LevelStatus(this._value);
  }
  setState(value) {
    this._value._hasState = true;
    this._value._state = value;
    return this;
  }
  deleteState() {
    this._value._hasState = false;
    this._value._state = null;
    return this;
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
}
MapEventStatus_LevelStatus.Builder = MapEventStatus_LevelStatus_Builder;
class MapEventStatus_LevelStatus_WithParent {
  /**
   * @param {MapEventStatus_LevelStatus} value
   * @param {MapEventStatus_LevelStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_LevelStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasState() {
    if (this._cachedHasState === undefined) {
      if (this._value.hasState) {
        this._cachedHasState = true;
      } else {
        this._cachedHasState = this._parent ? this._parent.hasState : false;
      }
    }
    return this._cachedHasState;
  }
  get state() {
    if (this._cachedState === undefined) {
      if (this._value.hasState) {
        this._cachedState = this._value.state;
      } else {
        this._cachedState = this._parent ? this._parent.state : this._value.state;
      }
    }
    return this._cachedState;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  update(current, parent) {
    const result = new MapEventStatus_LevelStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_LevelStatus_WithParent.default = new MapEventStatus_LevelStatus_WithParent(MapEventStatus_LevelStatus.default, null);
MapEventStatus_LevelStatus.WithParent = MapEventStatus_LevelStatus_WithParent;
class MapEventStatus_LevelStatus_Descriptor {
  get state() {
    if (!this._state) {
      this._state = {
        name: "state",
        Name: "State",
        number: 2,
        protoType: 14,
        protoName: "state",
        type: MapEventStatus_LevelStatus_LevelState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._state;
  }
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 3,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.state,
        this.levelIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForState",
        Name: "DummyOneofForState",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_LevelStatus.descriptor = new MapEventStatus_LevelStatus_Descriptor();
class MapEventStatus_SoloLevelStatus_DifficultyStatus {
  get descriptor() {
    return MapEventStatus_SoloLevelStatus_DifficultyStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDifficulty = false;
    this._difficulty = null;
    this._hasState = false;
    this._state = null;
  }
  isEmpty() {
    if (this._hasDifficulty) return false;
    if (this._hasState) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_SoloLevelStatus_DifficultyStatus) {
      return value;
    }
    return MapEventStatus_SoloLevelStatus_DifficultyStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_SoloLevelStatus_DifficultyStatus();
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    if (json.state != null) {
      result._hasState = true;
      result._state = MapEventStatus_SoloLevelStatus_LevelState.fromJson(json.state);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._hasState) {
      result.state = MapEventStatus_SoloLevelStatus_LevelState.toJson(this._state);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {number}
   */
  get state() {
    return this._hasState ? this._state : MapEventStatus_SoloLevelStatus_LevelState.default;
  }
  get hasState() {
    return this._hasState;
  }
  setState(path, value) {
    return {type: 'SET', path: path.concat(['state']), value};
  }
  deleteState(path) {
    return {type: 'DELETE', path: path.concat(['state'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new MapEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "state": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasState = true;
              copy._state = MapEventStatus_SoloLevelStatus_LevelState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasState) {
                return this;
              }
              const copy = new MapEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasState = false;
              copy._state = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_SoloLevelStatus_DifficultyStatus} other
   * @returns {MapEventStatus_SoloLevelStatus_DifficultyStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_SoloLevelStatus_DifficultyStatus(this);
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    if (other._hasState) {
      copy._hasState = true;
      copy._state = other._state;
    }
    return copy;
  }
}
MapEventStatus_SoloLevelStatus_DifficultyStatus.default = new MapEventStatus_SoloLevelStatus_DifficultyStatus();
class MapEventStatus_SoloLevelStatus_DifficultyStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_SoloLevelStatus_DifficultyStatus(value);
  }
  build() {
    return new MapEventStatus_SoloLevelStatus_DifficultyStatus(this._value);
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  setState(value) {
    this._value._hasState = true;
    this._value._state = value;
    return this;
  }
  deleteState() {
    this._value._hasState = false;
    this._value._state = null;
    return this;
  }
}
MapEventStatus_SoloLevelStatus_DifficultyStatus.Builder = MapEventStatus_SoloLevelStatus_DifficultyStatus_Builder;
class MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent {
  /**
   * @param {MapEventStatus_SoloLevelStatus_DifficultyStatus} value
   * @param {MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_SoloLevelStatus_DifficultyStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get hasState() {
    if (this._cachedHasState === undefined) {
      if (this._value.hasState) {
        this._cachedHasState = true;
      } else {
        this._cachedHasState = this._parent ? this._parent.hasState : false;
      }
    }
    return this._cachedHasState;
  }
  get state() {
    if (this._cachedState === undefined) {
      if (this._value.hasState) {
        this._cachedState = this._value.state;
      } else {
        this._cachedState = this._parent ? this._parent.state : this._value.state;
      }
    }
    return this._cachedState;
  }
  update(current, parent) {
    const result = new MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent.default = new MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent(MapEventStatus_SoloLevelStatus_DifficultyStatus.default, null);
MapEventStatus_SoloLevelStatus_DifficultyStatus.WithParent = MapEventStatus_SoloLevelStatus_DifficultyStatus_WithParent;
class MapEventStatus_SoloLevelStatus_DifficultyStatus_Descriptor {
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 1,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get state() {
    if (!this._state) {
      this._state = {
        name: "state",
        Name: "State",
        number: 2,
        protoType: 14,
        protoName: "state",
        type: MapEventStatus_SoloLevelStatus_LevelState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._state;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.difficulty,
        this.state,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForState",
        Name: "DummyOneofForState",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_SoloLevelStatus_DifficultyStatus.descriptor = new MapEventStatus_SoloLevelStatus_DifficultyStatus_Descriptor();
class MapEventStatus_SoloLevelStatus_LevelState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LOCKED": return 0;
        case "UNLOCKED": return 1;
        case "FINISHED": return 2;
        case "PERFECT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapEventStatus_SoloLevelStatus_LevelState.fromJson(value);
  }
  static fromReact(e) {
    return MapEventStatus_SoloLevelStatus_LevelState.fromJson(e);
  }
}
MapEventStatus_SoloLevelStatus_LevelState.LOCKED = 0;
MapEventStatus_SoloLevelStatus_LevelState.UNLOCKED = 1;
MapEventStatus_SoloLevelStatus_LevelState.FINISHED = 2;
MapEventStatus_SoloLevelStatus_LevelState.PERFECT = 3;
MapEventStatus_SoloLevelStatus_LevelState.default = 0;
MapEventStatus_SoloLevelStatus_LevelState.values = {
  LOCKED: 0,
  UNLOCKED: 1,
  FINISHED: 2,
  PERFECT: 3,
};
MapEventStatus_SoloLevelStatus_LevelState.names = {
  0: "LOCKED",
  1: "UNLOCKED",
  2: "FINISHED",
  3: "PERFECT",
};
class MapEventStatus_SoloLevelStatus {
  get descriptor() {
    return MapEventStatus_SoloLevelStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLevelIndex = false;
    this._levelIndex = null;
    this._difficultyStatus = [];
  }
  isEmpty() {
    if (this._hasLevelIndex) return false;
    if (this._difficultyStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_SoloLevelStatus) {
      return value;
    }
    return MapEventStatus_SoloLevelStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_SoloLevelStatus();
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    result._difficultyStatus = JsonToList(json.difficultyStatus, MapEventStatus_SoloLevelStatus_DifficultyStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    if (this._difficultyStatus.length > 0) {
      result.difficultyStatus = ArrayToJson(this._difficultyStatus, MapEventStatus_SoloLevelStatus_DifficultyStatus);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  /**
   * @returns {MapEventStatus_SoloLevelStatus_DifficultyStatus[]}
   */
  get difficultyStatus() {
    return this._difficultyStatus;
  }
  addDifficultyStatus(path, value) {
    return {type: 'ADD', path: path.concat(['difficultyStatus']), value: value.toJson()};
  }
  setDifficultyStatus(path, value) {
    return {type: 'SET', path: path.concat(['difficultyStatus']), value: ArrayToJson(value, MapEventStatus_SoloLevelStatus_DifficultyStatus)};
  }
  setDifficultyStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['difficultyStatus', key]), value: value.toJson()};
  }
  deleteDifficultyStatus(path) {
    return {type: 'DELETE', path: path.concat(['difficultyStatus'])};
  }
  deleteDifficultyStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['difficultyStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficultyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = [];        for (let i of value) {
                copy._difficultyStatus.push(MapEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.concat([MapEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._difficultyStatus.length === 0) {
                return this;
              }
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._difficultyStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.slice();
              copy._difficultyStatus[path[1]] = MapEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.slice(0, path[1]).concat(copy._difficultyStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._difficultyStatus.length) {
            return this;
          }
          const oldValue = this._difficultyStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus_SoloLevelStatus(this);
          copy._difficultyStatus = copy._difficultyStatus.slice();
          copy._difficultyStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_SoloLevelStatus} other
   * @returns {MapEventStatus_SoloLevelStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_SoloLevelStatus(this);
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    copy._difficultyStatus = this._difficultyStatus.concat(other._difficultyStatus);
    return copy;
  }
}
MapEventStatus_SoloLevelStatus.default = new MapEventStatus_SoloLevelStatus();
MapEventStatus_SoloLevelStatus.DifficultyStatus = MapEventStatus_SoloLevelStatus_DifficultyStatus;
MapEventStatus_SoloLevelStatus.LevelState = MapEventStatus_SoloLevelStatus_LevelState;
class MapEventStatus_SoloLevelStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_SoloLevelStatus(value);
  }
  build() {
    return new MapEventStatus_SoloLevelStatus(this._value);
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
  addAllDifficultyStatus(values) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat(values);
    return this;
  }
  addDifficultyStatus(value) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat([value]);
    return this;
  }
  setDifficultyStatus(index, value) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat();
    this._value._difficultyStatus[index] = value;
    return this;
  }
  clearDifficultyStatus() {
    this._value._difficultyStatus = [];
    return this;
  }
}
MapEventStatus_SoloLevelStatus.Builder = MapEventStatus_SoloLevelStatus_Builder;
class MapEventStatus_SoloLevelStatus_WithParent {
  /**
   * @param {MapEventStatus_SoloLevelStatus} value
   * @param {MapEventStatus_SoloLevelStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_SoloLevelStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  get selfDifficultyStatus() {
    if (!this._selfDifficultyStatus) {
      this._selfDifficultyStatus = [];
      for (let i of this._value.difficultyStatus) {
        this._selfDifficultyStatus.push(new MapEventStatus_SoloLevelStatus_DifficultyStatus.WithParent(i, null));
      }
    }
    return this._selfDifficultyStatus;
  }
  get inherentDifficultyStatus() {
    if (!this._inherentDifficultyStatus) {
      this._inherentDifficultyStatus = this._parent ? this._parent.difficultyStatus : [];
    }
    return this._inherentDifficultyStatus;
  }
  get difficultyStatus() {
    if (!this._allDifficultyStatus) {
      this._allDifficultyStatus = this._parent ? this._parent.difficultyStatus.concat(this.selfDifficultyStatus) : this.selfDifficultyStatus;
    }
    return this._allDifficultyStatus;
  }
  update(current, parent) {
    const result = new MapEventStatus_SoloLevelStatus_WithParent(current, parent);
    if (this._selfDifficultyStatus) {
      if (this._value.difficultyStatus === current.difficultyStatus) {
        result._selfDifficultyStatus = this._selfDifficultyStatus;
      } else {
        result._selfDifficultyStatus = [];
        for (let i = 0; i < current.difficultyStatus.length; i++) {
          const oldValue = this._value.difficultyStatus[i];
          if (oldValue) {
            const oldCache = this._selfDifficultyStatus[i];
            if (oldValue === current.difficultyStatus[i]) {
              result._selfDifficultyStatus[i] = oldCache;
            } else {
              result._selfDifficultyStatus[i] = oldCache.update(current.difficultyStatus[i], null);
            }
          } else {
            result._selfDifficultyStatus[i] = new MapEventStatus_SoloLevelStatus_DifficultyStatus.WithParent(current.difficultyStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEventStatus_SoloLevelStatus_WithParent.default = new MapEventStatus_SoloLevelStatus_WithParent(MapEventStatus_SoloLevelStatus.default, null);
MapEventStatus_SoloLevelStatus.WithParent = MapEventStatus_SoloLevelStatus_WithParent;
class MapEventStatus_SoloLevelStatus_Descriptor {
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 3,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get difficultyStatus() {
    if (!this._difficultyStatus) {
      this._difficultyStatus = {
        name: "difficultyStatus",
        Name: "DifficultyStatus",
        number: 4,
        protoType: 11,
        protoName: "difficulty_status",
        type: MapEventStatus_SoloLevelStatus_DifficultyStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficultyStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levelIndex,
        this.difficultyStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_SoloLevelStatus.descriptor = new MapEventStatus_SoloLevelStatus_Descriptor();
class MapEventStatus_AccessKeyStatus {
  get descriptor() {
    return MapEventStatus_AccessKeyStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasRemainingAds = false;
    this._remainingAds = null;
    this._hasNextKeyRemainingSeconds = false;
    this._nextKeyRemainingSeconds = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasRemainingAds) return false;
    if (this._hasNextKeyRemainingSeconds) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_AccessKeyStatus) {
      return value;
    }
    return MapEventStatus_AccessKeyStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_AccessKeyStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.remainingAds != null) {
      result._hasRemainingAds = true;
      result._remainingAds = JsonToInt32.fromJson(json.remainingAds);
    }
    if (json.nextKeyRemainingSeconds != null) {
      result._hasNextKeyRemainingSeconds = true;
      result._nextKeyRemainingSeconds = JsonToDouble.fromJson(json.nextKeyRemainingSeconds);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasRemainingAds) {
      result.remainingAds = JsonToInt32.toJson(this._remainingAds);
    }
    if (this._hasNextKeyRemainingSeconds) {
      result.nextKeyRemainingSeconds = JsonToDouble.toJson(this._nextKeyRemainingSeconds);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get remainingAds() {
    return this._hasRemainingAds ? this._remainingAds : JsonToInt32.default;
  }
  get hasRemainingAds() {
    return this._hasRemainingAds;
  }
  setRemainingAds(path, value) {
    return {type: 'SET', path: path.concat(['remainingAds']), value};
  }
  deleteRemainingAds(path) {
    return {type: 'DELETE', path: path.concat(['remainingAds'])};
  }
  /**
   * @returns {number}
   */
  get nextKeyRemainingSeconds() {
    return this._hasNextKeyRemainingSeconds ? this._nextKeyRemainingSeconds : JsonToDouble.default;
  }
  get hasNextKeyRemainingSeconds() {
    return this._hasNextKeyRemainingSeconds;
  }
  setNextKeyRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['nextKeyRemainingSeconds']), value};
  }
  deleteNextKeyRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['nextKeyRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "remainingAds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasRemainingAds = true;
              copy._remainingAds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRemainingAds) {
                return this;
              }
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasRemainingAds = false;
              copy._remainingAds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nextKeyRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasNextKeyRemainingSeconds = true;
              copy._nextKeyRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNextKeyRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasNextKeyRemainingSeconds = false;
              copy._nextKeyRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_AccessKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_AccessKeyStatus} other
   * @returns {MapEventStatus_AccessKeyStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_AccessKeyStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasRemainingAds) {
      copy._hasRemainingAds = true;
      copy._remainingAds = other._remainingAds;
    }
    if (other._hasNextKeyRemainingSeconds) {
      copy._hasNextKeyRemainingSeconds = true;
      copy._nextKeyRemainingSeconds = other._nextKeyRemainingSeconds;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    return copy;
  }
}
MapEventStatus_AccessKeyStatus.default = new MapEventStatus_AccessKeyStatus();
class MapEventStatus_AccessKeyStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_AccessKeyStatus(value);
  }
  build() {
    return new MapEventStatus_AccessKeyStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setRemainingAds(value) {
    this._value._hasRemainingAds = true;
    this._value._remainingAds = value;
    return this;
  }
  deleteRemainingAds() {
    this._value._hasRemainingAds = false;
    this._value._remainingAds = null;
    return this;
  }
  setNextKeyRemainingSeconds(value) {
    this._value._hasNextKeyRemainingSeconds = true;
    this._value._nextKeyRemainingSeconds = value;
    return this;
  }
  deleteNextKeyRemainingSeconds() {
    this._value._hasNextKeyRemainingSeconds = false;
    this._value._nextKeyRemainingSeconds = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
}
MapEventStatus_AccessKeyStatus.Builder = MapEventStatus_AccessKeyStatus_Builder;
class MapEventStatus_AccessKeyStatus_WithParent {
  /**
   * @param {MapEventStatus_AccessKeyStatus} value
   * @param {MapEventStatus_AccessKeyStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_AccessKeyStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasRemainingAds() {
    if (this._cachedHasRemainingAds === undefined) {
      if (this._value.hasRemainingAds) {
        this._cachedHasRemainingAds = true;
      } else {
        this._cachedHasRemainingAds = this._parent ? this._parent.hasRemainingAds : false;
      }
    }
    return this._cachedHasRemainingAds;
  }
  get remainingAds() {
    if (this._cachedRemainingAds === undefined) {
      if (this._value.hasRemainingAds) {
        this._cachedRemainingAds = this._value.remainingAds;
      } else {
        this._cachedRemainingAds = this._parent ? this._parent.remainingAds : this._value.remainingAds;
      }
    }
    return this._cachedRemainingAds;
  }
  get hasNextKeyRemainingSeconds() {
    if (this._cachedHasNextKeyRemainingSeconds === undefined) {
      if (this._value.hasNextKeyRemainingSeconds) {
        this._cachedHasNextKeyRemainingSeconds = true;
      } else {
        this._cachedHasNextKeyRemainingSeconds = this._parent ? this._parent.hasNextKeyRemainingSeconds : false;
      }
    }
    return this._cachedHasNextKeyRemainingSeconds;
  }
  get nextKeyRemainingSeconds() {
    if (this._cachedNextKeyRemainingSeconds === undefined) {
      if (this._value.hasNextKeyRemainingSeconds) {
        this._cachedNextKeyRemainingSeconds = this._value.nextKeyRemainingSeconds;
      } else {
        this._cachedNextKeyRemainingSeconds = this._parent ? this._parent.nextKeyRemainingSeconds : this._value.nextKeyRemainingSeconds;
      }
    }
    return this._cachedNextKeyRemainingSeconds;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  update(current, parent) {
    const result = new MapEventStatus_AccessKeyStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_AccessKeyStatus_WithParent.default = new MapEventStatus_AccessKeyStatus_WithParent(MapEventStatus_AccessKeyStatus.default, null);
MapEventStatus_AccessKeyStatus.WithParent = MapEventStatus_AccessKeyStatus_WithParent;
class MapEventStatus_AccessKeyStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 3,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get remainingAds() {
    if (!this._remainingAds) {
      this._remainingAds = {
        name: "remainingAds",
        Name: "RemainingAds",
        number: 4,
        protoType: 5,
        protoName: "remaining_ads",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingAds;
  }
  get nextKeyRemainingSeconds() {
    if (!this._nextKeyRemainingSeconds) {
      this._nextKeyRemainingSeconds = {
        name: "nextKeyRemainingSeconds",
        Name: "NextKeyRemainingSeconds",
        number: 5,
        protoType: 1,
        protoName: "next_key_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nextKeyRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 6,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.remainingAds,
        this.nextKeyRemainingSeconds,
        this.gemCostResetRemainingSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRemainingAds",
        Name: "DummyOneofForRemainingAds",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNextKeyRemainingSeconds",
        Name: "DummyOneofForNextKeyRemainingSeconds",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_AccessKeyStatus.descriptor = new MapEventStatus_AccessKeyStatus_Descriptor();
class MapEventStatus_TokenStatus {
  get descriptor() {
    return MapEventStatus_TokenStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_TokenStatus) {
      return value;
    }
    return MapEventStatus_TokenStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_TokenStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_TokenStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_TokenStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_TokenStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_TokenStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_TokenStatus} other
   * @returns {MapEventStatus_TokenStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_TokenStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    return copy;
  }
}
MapEventStatus_TokenStatus.default = new MapEventStatus_TokenStatus();
class MapEventStatus_TokenStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_TokenStatus(value);
  }
  build() {
    return new MapEventStatus_TokenStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
}
MapEventStatus_TokenStatus.Builder = MapEventStatus_TokenStatus_Builder;
class MapEventStatus_TokenStatus_WithParent {
  /**
   * @param {MapEventStatus_TokenStatus} value
   * @param {MapEventStatus_TokenStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_TokenStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  update(current, parent) {
    const result = new MapEventStatus_TokenStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_TokenStatus_WithParent.default = new MapEventStatus_TokenStatus_WithParent(MapEventStatus_TokenStatus.default, null);
MapEventStatus_TokenStatus.WithParent = MapEventStatus_TokenStatus_WithParent;
class MapEventStatus_TokenStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 1,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 2,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.gemCostResetRemainingSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_TokenStatus.descriptor = new MapEventStatus_TokenStatus_Descriptor();
class MapEventStatus_BossKeyStatus {
  get descriptor() {
    return MapEventStatus_BossKeyStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
    this._hasRemainingBossKey = false;
    this._remainingBossKey = null;
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    if (this._hasRemainingBossKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_BossKeyStatus) {
      return value;
    }
    return MapEventStatus_BossKeyStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_BossKeyStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    if (json.remainingBossKey != null) {
      result._hasRemainingBossKey = true;
      result._remainingBossKey = JsonToInt32.fromJson(json.remainingBossKey);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    if (this._hasRemainingBossKey) {
      result.remainingBossKey = JsonToInt32.toJson(this._remainingBossKey);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get remainingBossKey() {
    return this._hasRemainingBossKey ? this._remainingBossKey : JsonToInt32.default;
  }
  get hasRemainingBossKey() {
    return this._hasRemainingBossKey;
  }
  setRemainingBossKey(path, value) {
    return {type: 'SET', path: path.concat(['remainingBossKey']), value};
  }
  deleteRemainingBossKey(path) {
    return {type: 'DELETE', path: path.concat(['remainingBossKey'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "remainingBossKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasRemainingBossKey = true;
              copy._remainingBossKey = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRemainingBossKey) {
                return this;
              }
              const copy = new MapEventStatus_BossKeyStatus(this);
              copy._hasRemainingBossKey = false;
              copy._remainingBossKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_BossKeyStatus} other
   * @returns {MapEventStatus_BossKeyStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_BossKeyStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    if (other._hasRemainingBossKey) {
      copy._hasRemainingBossKey = true;
      copy._remainingBossKey = other._remainingBossKey;
    }
    return copy;
  }
}
MapEventStatus_BossKeyStatus.default = new MapEventStatus_BossKeyStatus();
class MapEventStatus_BossKeyStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_BossKeyStatus(value);
  }
  build() {
    return new MapEventStatus_BossKeyStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
  setRemainingBossKey(value) {
    this._value._hasRemainingBossKey = true;
    this._value._remainingBossKey = value;
    return this;
  }
  deleteRemainingBossKey() {
    this._value._hasRemainingBossKey = false;
    this._value._remainingBossKey = null;
    return this;
  }
}
MapEventStatus_BossKeyStatus.Builder = MapEventStatus_BossKeyStatus_Builder;
class MapEventStatus_BossKeyStatus_WithParent {
  /**
   * @param {MapEventStatus_BossKeyStatus} value
   * @param {MapEventStatus_BossKeyStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_BossKeyStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  get hasRemainingBossKey() {
    if (this._cachedHasRemainingBossKey === undefined) {
      if (this._value.hasRemainingBossKey) {
        this._cachedHasRemainingBossKey = true;
      } else {
        this._cachedHasRemainingBossKey = this._parent ? this._parent.hasRemainingBossKey : false;
      }
    }
    return this._cachedHasRemainingBossKey;
  }
  get remainingBossKey() {
    if (this._cachedRemainingBossKey === undefined) {
      if (this._value.hasRemainingBossKey) {
        this._cachedRemainingBossKey = this._value.remainingBossKey;
      } else {
        this._cachedRemainingBossKey = this._parent ? this._parent.remainingBossKey : this._value.remainingBossKey;
      }
    }
    return this._cachedRemainingBossKey;
  }
  update(current, parent) {
    const result = new MapEventStatus_BossKeyStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_BossKeyStatus_WithParent.default = new MapEventStatus_BossKeyStatus_WithParent(MapEventStatus_BossKeyStatus.default, null);
MapEventStatus_BossKeyStatus.WithParent = MapEventStatus_BossKeyStatus_WithParent;
class MapEventStatus_BossKeyStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 1,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 2,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get remainingBossKey() {
    if (!this._remainingBossKey) {
      this._remainingBossKey = {
        name: "remainingBossKey",
        Name: "RemainingBossKey",
        number: 3,
        protoType: 5,
        protoName: "remaining_boss_key",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingBossKey;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.gemCostResetRemainingSeconds,
        this.remainingBossKey,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRemainingBossKey",
        Name: "DummyOneofForRemainingBossKey",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_BossKeyStatus.descriptor = new MapEventStatus_BossKeyStatus_Descriptor();
class MapEventStatus_CoopKeyStatus {
  get descriptor() {
    return MapEventStatus_CoopKeyStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasCurGoldCost = false;
    this._curGoldCost = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasCurGoldCost) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_CoopKeyStatus) {
      return value;
    }
    return MapEventStatus_CoopKeyStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_CoopKeyStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.curGoldCost != null) {
      result._hasCurGoldCost = true;
      result._curGoldCost = JsonToInt32.fromJson(json.curGoldCost);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasCurGoldCost) {
      result.curGoldCost = JsonToInt32.toJson(this._curGoldCost);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get curGoldCost() {
    return this._hasCurGoldCost ? this._curGoldCost : JsonToInt32.default;
  }
  get hasCurGoldCost() {
    return this._hasCurGoldCost;
  }
  setCurGoldCost(path, value) {
    return {type: 'SET', path: path.concat(['curGoldCost']), value};
  }
  deleteCurGoldCost(path) {
    return {type: 'DELETE', path: path.concat(['curGoldCost'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "curGoldCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasCurGoldCost = true;
              copy._curGoldCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGoldCost) {
                return this;
              }
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasCurGoldCost = false;
              copy._curGoldCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_CoopKeyStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_CoopKeyStatus} other
   * @returns {MapEventStatus_CoopKeyStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_CoopKeyStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasCurGoldCost) {
      copy._hasCurGoldCost = true;
      copy._curGoldCost = other._curGoldCost;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    return copy;
  }
}
MapEventStatus_CoopKeyStatus.default = new MapEventStatus_CoopKeyStatus();
class MapEventStatus_CoopKeyStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_CoopKeyStatus(value);
  }
  build() {
    return new MapEventStatus_CoopKeyStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setCurGoldCost(value) {
    this._value._hasCurGoldCost = true;
    this._value._curGoldCost = value;
    return this;
  }
  deleteCurGoldCost() {
    this._value._hasCurGoldCost = false;
    this._value._curGoldCost = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
}
MapEventStatus_CoopKeyStatus.Builder = MapEventStatus_CoopKeyStatus_Builder;
class MapEventStatus_CoopKeyStatus_WithParent {
  /**
   * @param {MapEventStatus_CoopKeyStatus} value
   * @param {MapEventStatus_CoopKeyStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_CoopKeyStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasCurGoldCost() {
    if (this._cachedHasCurGoldCost === undefined) {
      if (this._value.hasCurGoldCost) {
        this._cachedHasCurGoldCost = true;
      } else {
        this._cachedHasCurGoldCost = this._parent ? this._parent.hasCurGoldCost : false;
      }
    }
    return this._cachedHasCurGoldCost;
  }
  get curGoldCost() {
    if (this._cachedCurGoldCost === undefined) {
      if (this._value.hasCurGoldCost) {
        this._cachedCurGoldCost = this._value.curGoldCost;
      } else {
        this._cachedCurGoldCost = this._parent ? this._parent.curGoldCost : this._value.curGoldCost;
      }
    }
    return this._cachedCurGoldCost;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  update(current, parent) {
    const result = new MapEventStatus_CoopKeyStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_CoopKeyStatus_WithParent.default = new MapEventStatus_CoopKeyStatus_WithParent(MapEventStatus_CoopKeyStatus.default, null);
MapEventStatus_CoopKeyStatus.WithParent = MapEventStatus_CoopKeyStatus_WithParent;
class MapEventStatus_CoopKeyStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 1,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get curGoldCost() {
    if (!this._curGoldCost) {
      this._curGoldCost = {
        name: "curGoldCost",
        Name: "CurGoldCost",
        number: 2,
        protoType: 5,
        protoName: "cur_gold_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGoldCost;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 3,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.curGoldCost,
        this.gemCostResetRemainingSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurGoldCost",
        Name: "DummyOneofForCurGoldCost",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_CoopKeyStatus.descriptor = new MapEventStatus_CoopKeyStatus_Descriptor();
class MapEventStatus_BossRaidTicketStatus {
  get descriptor() {
    return MapEventStatus_BossRaidTicketStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
    this._hasRemainingRaidTicket = false;
    this._remainingRaidTicket = null;
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    if (this._hasRemainingRaidTicket) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_BossRaidTicketStatus) {
      return value;
    }
    return MapEventStatus_BossRaidTicketStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_BossRaidTicketStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    if (json.remainingRaidTicket != null) {
      result._hasRemainingRaidTicket = true;
      result._remainingRaidTicket = JsonToInt32.fromJson(json.remainingRaidTicket);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    if (this._hasRemainingRaidTicket) {
      result.remainingRaidTicket = JsonToInt32.toJson(this._remainingRaidTicket);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get remainingRaidTicket() {
    return this._hasRemainingRaidTicket ? this._remainingRaidTicket : JsonToInt32.default;
  }
  get hasRemainingRaidTicket() {
    return this._hasRemainingRaidTicket;
  }
  setRemainingRaidTicket(path, value) {
    return {type: 'SET', path: path.concat(['remainingRaidTicket']), value};
  }
  deleteRemainingRaidTicket(path) {
    return {type: 'DELETE', path: path.concat(['remainingRaidTicket'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "remainingRaidTicket": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasRemainingRaidTicket = true;
              copy._remainingRaidTicket = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRemainingRaidTicket) {
                return this;
              }
              const copy = new MapEventStatus_BossRaidTicketStatus(this);
              copy._hasRemainingRaidTicket = false;
              copy._remainingRaidTicket = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_BossRaidTicketStatus} other
   * @returns {MapEventStatus_BossRaidTicketStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_BossRaidTicketStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    if (other._hasRemainingRaidTicket) {
      copy._hasRemainingRaidTicket = true;
      copy._remainingRaidTicket = other._remainingRaidTicket;
    }
    return copy;
  }
}
MapEventStatus_BossRaidTicketStatus.default = new MapEventStatus_BossRaidTicketStatus();
class MapEventStatus_BossRaidTicketStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_BossRaidTicketStatus(value);
  }
  build() {
    return new MapEventStatus_BossRaidTicketStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
  setRemainingRaidTicket(value) {
    this._value._hasRemainingRaidTicket = true;
    this._value._remainingRaidTicket = value;
    return this;
  }
  deleteRemainingRaidTicket() {
    this._value._hasRemainingRaidTicket = false;
    this._value._remainingRaidTicket = null;
    return this;
  }
}
MapEventStatus_BossRaidTicketStatus.Builder = MapEventStatus_BossRaidTicketStatus_Builder;
class MapEventStatus_BossRaidTicketStatus_WithParent {
  /**
   * @param {MapEventStatus_BossRaidTicketStatus} value
   * @param {MapEventStatus_BossRaidTicketStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_BossRaidTicketStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  get hasRemainingRaidTicket() {
    if (this._cachedHasRemainingRaidTicket === undefined) {
      if (this._value.hasRemainingRaidTicket) {
        this._cachedHasRemainingRaidTicket = true;
      } else {
        this._cachedHasRemainingRaidTicket = this._parent ? this._parent.hasRemainingRaidTicket : false;
      }
    }
    return this._cachedHasRemainingRaidTicket;
  }
  get remainingRaidTicket() {
    if (this._cachedRemainingRaidTicket === undefined) {
      if (this._value.hasRemainingRaidTicket) {
        this._cachedRemainingRaidTicket = this._value.remainingRaidTicket;
      } else {
        this._cachedRemainingRaidTicket = this._parent ? this._parent.remainingRaidTicket : this._value.remainingRaidTicket;
      }
    }
    return this._cachedRemainingRaidTicket;
  }
  update(current, parent) {
    const result = new MapEventStatus_BossRaidTicketStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_BossRaidTicketStatus_WithParent.default = new MapEventStatus_BossRaidTicketStatus_WithParent(MapEventStatus_BossRaidTicketStatus.default, null);
MapEventStatus_BossRaidTicketStatus.WithParent = MapEventStatus_BossRaidTicketStatus_WithParent;
class MapEventStatus_BossRaidTicketStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 1,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 2,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get remainingRaidTicket() {
    if (!this._remainingRaidTicket) {
      this._remainingRaidTicket = {
        name: "remainingRaidTicket",
        Name: "RemainingRaidTicket",
        number: 3,
        protoType: 5,
        protoName: "remaining_raid_ticket",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingRaidTicket;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.gemCostResetRemainingSeconds,
        this.remainingRaidTicket,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRemainingRaidTicket",
        Name: "DummyOneofForRemainingRaidTicket",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_BossRaidTicketStatus.descriptor = new MapEventStatus_BossRaidTicketStatus_Descriptor();
class MapEventStatus_CoopStatus {
  get descriptor() {
    return MapEventStatus_CoopStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurGemCost = false;
    this._curGemCost = null;
    this._hasCurGoldCost = false;
    this._curGoldCost = null;
    this._hasRemainingAds = false;
    this._remainingAds = null;
    this._hasNextKeyRemainingSeconds = false;
    this._nextKeyRemainingSeconds = null;
    this._hasGemCostResetRemainingSeconds = false;
    this._gemCostResetRemainingSeconds = null;
    this._claimedReceipts = [];
    this._claimedGuildReceipts = [];
    this._claimedBossRankReceipts = [];
  }
  isEmpty() {
    if (this._hasCurGemCost) return false;
    if (this._hasCurGoldCost) return false;
    if (this._hasRemainingAds) return false;
    if (this._hasNextKeyRemainingSeconds) return false;
    if (this._hasGemCostResetRemainingSeconds) return false;
    if (this._claimedReceipts.length > 0) return false;
    if (this._claimedGuildReceipts.length > 0) return false;
    if (this._claimedBossRankReceipts.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_CoopStatus) {
      return value;
    }
    return MapEventStatus_CoopStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_CoopStatus();
    if (json.curGemCost != null) {
      result._hasCurGemCost = true;
      result._curGemCost = JsonToInt32.fromJson(json.curGemCost);
    }
    if (json.curGoldCost != null) {
      result._hasCurGoldCost = true;
      result._curGoldCost = JsonToInt32.fromJson(json.curGoldCost);
    }
    if (json.remainingAds != null) {
      result._hasRemainingAds = true;
      result._remainingAds = JsonToInt32.fromJson(json.remainingAds);
    }
    if (json.nextKeyRemainingSeconds != null) {
      result._hasNextKeyRemainingSeconds = true;
      result._nextKeyRemainingSeconds = JsonToDouble.fromJson(json.nextKeyRemainingSeconds);
    }
    if (json.gemCostResetRemainingSeconds != null) {
      result._hasGemCostResetRemainingSeconds = true;
      result._gemCostResetRemainingSeconds = JsonToDouble.fromJson(json.gemCostResetRemainingSeconds);
    }
    result._claimedReceipts = JsonToList(json.claimedReceipts, JsonToString);
    result._claimedGuildReceipts = JsonToList(json.claimedGuildReceipts, JsonToString);
    result._claimedBossRankReceipts = JsonToList(json.claimedBossRankReceipts, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurGemCost) {
      result.curGemCost = JsonToInt32.toJson(this._curGemCost);
    }
    if (this._hasCurGoldCost) {
      result.curGoldCost = JsonToInt32.toJson(this._curGoldCost);
    }
    if (this._hasRemainingAds) {
      result.remainingAds = JsonToInt32.toJson(this._remainingAds);
    }
    if (this._hasNextKeyRemainingSeconds) {
      result.nextKeyRemainingSeconds = JsonToDouble.toJson(this._nextKeyRemainingSeconds);
    }
    if (this._hasGemCostResetRemainingSeconds) {
      result.gemCostResetRemainingSeconds = JsonToDouble.toJson(this._gemCostResetRemainingSeconds);
    }
    if (this._claimedReceipts.length > 0) {
      result.claimedReceipts = ArrayToJson(this._claimedReceipts, JsonToString);
    }
    if (this._claimedGuildReceipts.length > 0) {
      result.claimedGuildReceipts = ArrayToJson(this._claimedGuildReceipts, JsonToString);
    }
    if (this._claimedBossRankReceipts.length > 0) {
      result.claimedBossRankReceipts = ArrayToJson(this._claimedBossRankReceipts, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get curGemCost() {
    return this._hasCurGemCost ? this._curGemCost : JsonToInt32.default;
  }
  get hasCurGemCost() {
    return this._hasCurGemCost;
  }
  setCurGemCost(path, value) {
    return {type: 'SET', path: path.concat(['curGemCost']), value};
  }
  deleteCurGemCost(path) {
    return {type: 'DELETE', path: path.concat(['curGemCost'])};
  }
  /**
   * @returns {number}
   */
  get curGoldCost() {
    return this._hasCurGoldCost ? this._curGoldCost : JsonToInt32.default;
  }
  get hasCurGoldCost() {
    return this._hasCurGoldCost;
  }
  setCurGoldCost(path, value) {
    return {type: 'SET', path: path.concat(['curGoldCost']), value};
  }
  deleteCurGoldCost(path) {
    return {type: 'DELETE', path: path.concat(['curGoldCost'])};
  }
  /**
   * @returns {number}
   */
  get remainingAds() {
    return this._hasRemainingAds ? this._remainingAds : JsonToInt32.default;
  }
  get hasRemainingAds() {
    return this._hasRemainingAds;
  }
  setRemainingAds(path, value) {
    return {type: 'SET', path: path.concat(['remainingAds']), value};
  }
  deleteRemainingAds(path) {
    return {type: 'DELETE', path: path.concat(['remainingAds'])};
  }
  /**
   * @returns {number}
   */
  get nextKeyRemainingSeconds() {
    return this._hasNextKeyRemainingSeconds ? this._nextKeyRemainingSeconds : JsonToDouble.default;
  }
  get hasNextKeyRemainingSeconds() {
    return this._hasNextKeyRemainingSeconds;
  }
  setNextKeyRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['nextKeyRemainingSeconds']), value};
  }
  deleteNextKeyRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['nextKeyRemainingSeconds'])};
  }
  /**
   * @returns {number}
   */
  get gemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds ? this._gemCostResetRemainingSeconds : JsonToDouble.default;
  }
  get hasGemCostResetRemainingSeconds() {
    return this._hasGemCostResetRemainingSeconds;
  }
  setGemCostResetRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['gemCostResetRemainingSeconds']), value};
  }
  deleteGemCostResetRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['gemCostResetRemainingSeconds'])};
  }
  /**
   * @returns {string[]}
   */
  get claimedReceipts() {
    return this._claimedReceipts;
  }
  addClaimedReceipts(path, value) {
    return {type: 'ADD', path: path.concat(['claimedReceipts']), value};
  }
  setClaimedReceipts(path, value) {
    return {type: 'SET', path: path.concat(['claimedReceipts']), value: ArrayToJson(value, JsonToString)};
  }
  setClaimedReceiptsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['claimedReceipts', key]), value};
  }
  deleteClaimedReceipts(path) {
    return {type: 'DELETE', path: path.concat(['claimedReceipts'])};
  }
  deleteClaimedReceiptsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['claimedReceipts', key])};
  }
  /**
   * @returns {string[]}
   */
  get claimedGuildReceipts() {
    return this._claimedGuildReceipts;
  }
  addClaimedGuildReceipts(path, value) {
    return {type: 'ADD', path: path.concat(['claimedGuildReceipts']), value};
  }
  setClaimedGuildReceipts(path, value) {
    return {type: 'SET', path: path.concat(['claimedGuildReceipts']), value: ArrayToJson(value, JsonToString)};
  }
  setClaimedGuildReceiptsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['claimedGuildReceipts', key]), value};
  }
  deleteClaimedGuildReceipts(path) {
    return {type: 'DELETE', path: path.concat(['claimedGuildReceipts'])};
  }
  deleteClaimedGuildReceiptsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['claimedGuildReceipts', key])};
  }
  /**
   * @returns {string[]}
   */
  get claimedBossRankReceipts() {
    return this._claimedBossRankReceipts;
  }
  addClaimedBossRankReceipts(path, value) {
    return {type: 'ADD', path: path.concat(['claimedBossRankReceipts']), value};
  }
  setClaimedBossRankReceipts(path, value) {
    return {type: 'SET', path: path.concat(['claimedBossRankReceipts']), value: ArrayToJson(value, JsonToString)};
  }
  setClaimedBossRankReceiptsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['claimedBossRankReceipts', key]), value};
  }
  deleteClaimedBossRankReceipts(path) {
    return {type: 'DELETE', path: path.concat(['claimedBossRankReceipts'])};
  }
  deleteClaimedBossRankReceiptsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['claimedBossRankReceipts', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "curGemCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasCurGemCost = true;
              copy._curGemCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGemCost) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasCurGemCost = false;
              copy._curGemCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "curGoldCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasCurGoldCost = true;
              copy._curGoldCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurGoldCost) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasCurGoldCost = false;
              copy._curGoldCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "remainingAds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasRemainingAds = true;
              copy._remainingAds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRemainingAds) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasRemainingAds = false;
              copy._remainingAds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nextKeyRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasNextKeyRemainingSeconds = true;
              copy._nextKeyRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNextKeyRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasNextKeyRemainingSeconds = false;
              copy._nextKeyRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gemCostResetRemainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasGemCostResetRemainingSeconds = true;
              copy._gemCostResetRemainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGemCostResetRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._hasGemCostResetRemainingSeconds = false;
              copy._gemCostResetRemainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "claimedReceipts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedReceipts = [];        for (let i of value) {
                copy._claimedReceipts.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedReceipts = copy._claimedReceipts.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._claimedReceipts.length === 0) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedReceipts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._claimedReceipts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedReceipts = copy._claimedReceipts.slice();
              copy._claimedReceipts[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedReceipts = copy._claimedReceipts.slice(0, path[1]).concat(copy._claimedReceipts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._claimedReceipts.length) {
            return this;
          }
          const oldValue = this._claimedReceipts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus_CoopStatus(this);
          copy._claimedReceipts = copy._claimedReceipts.slice();
          copy._claimedReceipts[key] = newValue;
          return copy;
        }
      }
      case "claimedGuildReceipts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedGuildReceipts = [];        for (let i of value) {
                copy._claimedGuildReceipts.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedGuildReceipts = copy._claimedGuildReceipts.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._claimedGuildReceipts.length === 0) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedGuildReceipts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._claimedGuildReceipts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedGuildReceipts = copy._claimedGuildReceipts.slice();
              copy._claimedGuildReceipts[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedGuildReceipts = copy._claimedGuildReceipts.slice(0, path[1]).concat(copy._claimedGuildReceipts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._claimedGuildReceipts.length) {
            return this;
          }
          const oldValue = this._claimedGuildReceipts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus_CoopStatus(this);
          copy._claimedGuildReceipts = copy._claimedGuildReceipts.slice();
          copy._claimedGuildReceipts[key] = newValue;
          return copy;
        }
      }
      case "claimedBossRankReceipts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedBossRankReceipts = [];        for (let i of value) {
                copy._claimedBossRankReceipts.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedBossRankReceipts = copy._claimedBossRankReceipts.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._claimedBossRankReceipts.length === 0) {
                return this;
              }
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedBossRankReceipts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._claimedBossRankReceipts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedBossRankReceipts = copy._claimedBossRankReceipts.slice();
              copy._claimedBossRankReceipts[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus_CoopStatus(this);
              copy._claimedBossRankReceipts = copy._claimedBossRankReceipts.slice(0, path[1]).concat(copy._claimedBossRankReceipts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._claimedBossRankReceipts.length) {
            return this;
          }
          const oldValue = this._claimedBossRankReceipts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus_CoopStatus(this);
          copy._claimedBossRankReceipts = copy._claimedBossRankReceipts.slice();
          copy._claimedBossRankReceipts[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_CoopStatus} other
   * @returns {MapEventStatus_CoopStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_CoopStatus(this);
    if (other._hasCurGemCost) {
      copy._hasCurGemCost = true;
      copy._curGemCost = other._curGemCost;
    }
    if (other._hasCurGoldCost) {
      copy._hasCurGoldCost = true;
      copy._curGoldCost = other._curGoldCost;
    }
    if (other._hasRemainingAds) {
      copy._hasRemainingAds = true;
      copy._remainingAds = other._remainingAds;
    }
    if (other._hasNextKeyRemainingSeconds) {
      copy._hasNextKeyRemainingSeconds = true;
      copy._nextKeyRemainingSeconds = other._nextKeyRemainingSeconds;
    }
    if (other._hasGemCostResetRemainingSeconds) {
      copy._hasGemCostResetRemainingSeconds = true;
      copy._gemCostResetRemainingSeconds = other._gemCostResetRemainingSeconds;
    }
    copy._claimedReceipts = this._claimedReceipts.concat(other._claimedReceipts);
    copy._claimedGuildReceipts = this._claimedGuildReceipts.concat(other._claimedGuildReceipts);
    copy._claimedBossRankReceipts = this._claimedBossRankReceipts.concat(other._claimedBossRankReceipts);
    return copy;
  }
}
MapEventStatus_CoopStatus.default = new MapEventStatus_CoopStatus();
class MapEventStatus_CoopStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_CoopStatus(value);
  }
  build() {
    return new MapEventStatus_CoopStatus(this._value);
  }
  setCurGemCost(value) {
    this._value._hasCurGemCost = true;
    this._value._curGemCost = value;
    return this;
  }
  deleteCurGemCost() {
    this._value._hasCurGemCost = false;
    this._value._curGemCost = null;
    return this;
  }
  setCurGoldCost(value) {
    this._value._hasCurGoldCost = true;
    this._value._curGoldCost = value;
    return this;
  }
  deleteCurGoldCost() {
    this._value._hasCurGoldCost = false;
    this._value._curGoldCost = null;
    return this;
  }
  setRemainingAds(value) {
    this._value._hasRemainingAds = true;
    this._value._remainingAds = value;
    return this;
  }
  deleteRemainingAds() {
    this._value._hasRemainingAds = false;
    this._value._remainingAds = null;
    return this;
  }
  setNextKeyRemainingSeconds(value) {
    this._value._hasNextKeyRemainingSeconds = true;
    this._value._nextKeyRemainingSeconds = value;
    return this;
  }
  deleteNextKeyRemainingSeconds() {
    this._value._hasNextKeyRemainingSeconds = false;
    this._value._nextKeyRemainingSeconds = null;
    return this;
  }
  setGemCostResetRemainingSeconds(value) {
    this._value._hasGemCostResetRemainingSeconds = true;
    this._value._gemCostResetRemainingSeconds = value;
    return this;
  }
  deleteGemCostResetRemainingSeconds() {
    this._value._hasGemCostResetRemainingSeconds = false;
    this._value._gemCostResetRemainingSeconds = null;
    return this;
  }
  addAllClaimedReceipts(values) {
    this._value._claimedReceipts = this._value._claimedReceipts.concat(values);
    return this;
  }
  addClaimedReceipts(value) {
    this._value._claimedReceipts = this._value._claimedReceipts.concat([value]);
    return this;
  }
  setClaimedReceipts(index, value) {
    this._value._claimedReceipts = this._value._claimedReceipts.concat();
    this._value._claimedReceipts[index] = value;
    return this;
  }
  clearClaimedReceipts() {
    this._value._claimedReceipts = [];
    return this;
  }
  addAllClaimedGuildReceipts(values) {
    this._value._claimedGuildReceipts = this._value._claimedGuildReceipts.concat(values);
    return this;
  }
  addClaimedGuildReceipts(value) {
    this._value._claimedGuildReceipts = this._value._claimedGuildReceipts.concat([value]);
    return this;
  }
  setClaimedGuildReceipts(index, value) {
    this._value._claimedGuildReceipts = this._value._claimedGuildReceipts.concat();
    this._value._claimedGuildReceipts[index] = value;
    return this;
  }
  clearClaimedGuildReceipts() {
    this._value._claimedGuildReceipts = [];
    return this;
  }
  addAllClaimedBossRankReceipts(values) {
    this._value._claimedBossRankReceipts = this._value._claimedBossRankReceipts.concat(values);
    return this;
  }
  addClaimedBossRankReceipts(value) {
    this._value._claimedBossRankReceipts = this._value._claimedBossRankReceipts.concat([value]);
    return this;
  }
  setClaimedBossRankReceipts(index, value) {
    this._value._claimedBossRankReceipts = this._value._claimedBossRankReceipts.concat();
    this._value._claimedBossRankReceipts[index] = value;
    return this;
  }
  clearClaimedBossRankReceipts() {
    this._value._claimedBossRankReceipts = [];
    return this;
  }
}
MapEventStatus_CoopStatus.Builder = MapEventStatus_CoopStatus_Builder;
class MapEventStatus_CoopStatus_WithParent {
  /**
   * @param {MapEventStatus_CoopStatus} value
   * @param {MapEventStatus_CoopStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_CoopStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurGemCost() {
    if (this._cachedHasCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedHasCurGemCost = true;
      } else {
        this._cachedHasCurGemCost = this._parent ? this._parent.hasCurGemCost : false;
      }
    }
    return this._cachedHasCurGemCost;
  }
  get curGemCost() {
    if (this._cachedCurGemCost === undefined) {
      if (this._value.hasCurGemCost) {
        this._cachedCurGemCost = this._value.curGemCost;
      } else {
        this._cachedCurGemCost = this._parent ? this._parent.curGemCost : this._value.curGemCost;
      }
    }
    return this._cachedCurGemCost;
  }
  get hasCurGoldCost() {
    if (this._cachedHasCurGoldCost === undefined) {
      if (this._value.hasCurGoldCost) {
        this._cachedHasCurGoldCost = true;
      } else {
        this._cachedHasCurGoldCost = this._parent ? this._parent.hasCurGoldCost : false;
      }
    }
    return this._cachedHasCurGoldCost;
  }
  get curGoldCost() {
    if (this._cachedCurGoldCost === undefined) {
      if (this._value.hasCurGoldCost) {
        this._cachedCurGoldCost = this._value.curGoldCost;
      } else {
        this._cachedCurGoldCost = this._parent ? this._parent.curGoldCost : this._value.curGoldCost;
      }
    }
    return this._cachedCurGoldCost;
  }
  get hasRemainingAds() {
    if (this._cachedHasRemainingAds === undefined) {
      if (this._value.hasRemainingAds) {
        this._cachedHasRemainingAds = true;
      } else {
        this._cachedHasRemainingAds = this._parent ? this._parent.hasRemainingAds : false;
      }
    }
    return this._cachedHasRemainingAds;
  }
  get remainingAds() {
    if (this._cachedRemainingAds === undefined) {
      if (this._value.hasRemainingAds) {
        this._cachedRemainingAds = this._value.remainingAds;
      } else {
        this._cachedRemainingAds = this._parent ? this._parent.remainingAds : this._value.remainingAds;
      }
    }
    return this._cachedRemainingAds;
  }
  get hasNextKeyRemainingSeconds() {
    if (this._cachedHasNextKeyRemainingSeconds === undefined) {
      if (this._value.hasNextKeyRemainingSeconds) {
        this._cachedHasNextKeyRemainingSeconds = true;
      } else {
        this._cachedHasNextKeyRemainingSeconds = this._parent ? this._parent.hasNextKeyRemainingSeconds : false;
      }
    }
    return this._cachedHasNextKeyRemainingSeconds;
  }
  get nextKeyRemainingSeconds() {
    if (this._cachedNextKeyRemainingSeconds === undefined) {
      if (this._value.hasNextKeyRemainingSeconds) {
        this._cachedNextKeyRemainingSeconds = this._value.nextKeyRemainingSeconds;
      } else {
        this._cachedNextKeyRemainingSeconds = this._parent ? this._parent.nextKeyRemainingSeconds : this._value.nextKeyRemainingSeconds;
      }
    }
    return this._cachedNextKeyRemainingSeconds;
  }
  get hasGemCostResetRemainingSeconds() {
    if (this._cachedHasGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedHasGemCostResetRemainingSeconds = true;
      } else {
        this._cachedHasGemCostResetRemainingSeconds = this._parent ? this._parent.hasGemCostResetRemainingSeconds : false;
      }
    }
    return this._cachedHasGemCostResetRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (this._cachedGemCostResetRemainingSeconds === undefined) {
      if (this._value.hasGemCostResetRemainingSeconds) {
        this._cachedGemCostResetRemainingSeconds = this._value.gemCostResetRemainingSeconds;
      } else {
        this._cachedGemCostResetRemainingSeconds = this._parent ? this._parent.gemCostResetRemainingSeconds : this._value.gemCostResetRemainingSeconds;
      }
    }
    return this._cachedGemCostResetRemainingSeconds;
  }
  get selfClaimedReceipts() {
    return this._value.claimedReceipts;
  }
  get inherentClaimedReceipts() {
    if (!this._inherentClaimedReceipts) {
      this._inherentClaimedReceipts = this._parent ? this._parent.claimedReceipts : [];
    }
    return this._inherentClaimedReceipts;
  }
  get claimedReceipts() {
    if (!this._allClaimedReceipts) {
      this._allClaimedReceipts = this._parent ? this._parent.claimedReceipts.concat(this.selfClaimedReceipts) : this.selfClaimedReceipts;
    }
    return this._allClaimedReceipts;
  }
  get selfClaimedGuildReceipts() {
    return this._value.claimedGuildReceipts;
  }
  get inherentClaimedGuildReceipts() {
    if (!this._inherentClaimedGuildReceipts) {
      this._inherentClaimedGuildReceipts = this._parent ? this._parent.claimedGuildReceipts : [];
    }
    return this._inherentClaimedGuildReceipts;
  }
  get claimedGuildReceipts() {
    if (!this._allClaimedGuildReceipts) {
      this._allClaimedGuildReceipts = this._parent ? this._parent.claimedGuildReceipts.concat(this.selfClaimedGuildReceipts) : this.selfClaimedGuildReceipts;
    }
    return this._allClaimedGuildReceipts;
  }
  get selfClaimedBossRankReceipts() {
    return this._value.claimedBossRankReceipts;
  }
  get inherentClaimedBossRankReceipts() {
    if (!this._inherentClaimedBossRankReceipts) {
      this._inherentClaimedBossRankReceipts = this._parent ? this._parent.claimedBossRankReceipts : [];
    }
    return this._inherentClaimedBossRankReceipts;
  }
  get claimedBossRankReceipts() {
    if (!this._allClaimedBossRankReceipts) {
      this._allClaimedBossRankReceipts = this._parent ? this._parent.claimedBossRankReceipts.concat(this.selfClaimedBossRankReceipts) : this.selfClaimedBossRankReceipts;
    }
    return this._allClaimedBossRankReceipts;
  }
  update(current, parent) {
    const result = new MapEventStatus_CoopStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_CoopStatus_WithParent.default = new MapEventStatus_CoopStatus_WithParent(MapEventStatus_CoopStatus.default, null);
MapEventStatus_CoopStatus.WithParent = MapEventStatus_CoopStatus_WithParent;
class MapEventStatus_CoopStatus_Descriptor {
  get curGemCost() {
    if (!this._curGemCost) {
      this._curGemCost = {
        name: "curGemCost",
        Name: "CurGemCost",
        number: 1,
        protoType: 5,
        protoName: "cur_gem_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGemCost;
  }
  get curGoldCost() {
    if (!this._curGoldCost) {
      this._curGoldCost = {
        name: "curGoldCost",
        Name: "CurGoldCost",
        number: 8,
        protoType: 5,
        protoName: "cur_gold_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curGoldCost;
  }
  get remainingAds() {
    if (!this._remainingAds) {
      this._remainingAds = {
        name: "remainingAds",
        Name: "RemainingAds",
        number: 2,
        protoType: 5,
        protoName: "remaining_ads",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingAds;
  }
  get nextKeyRemainingSeconds() {
    if (!this._nextKeyRemainingSeconds) {
      this._nextKeyRemainingSeconds = {
        name: "nextKeyRemainingSeconds",
        Name: "NextKeyRemainingSeconds",
        number: 3,
        protoType: 1,
        protoName: "next_key_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nextKeyRemainingSeconds;
  }
  get gemCostResetRemainingSeconds() {
    if (!this._gemCostResetRemainingSeconds) {
      this._gemCostResetRemainingSeconds = {
        name: "gemCostResetRemainingSeconds",
        Name: "GemCostResetRemainingSeconds",
        number: 4,
        protoType: 1,
        protoName: "gem_cost_reset_remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gemCostResetRemainingSeconds;
  }
  get claimedReceipts() {
    if (!this._claimedReceipts) {
      this._claimedReceipts = {
        name: "claimedReceipts",
        Name: "ClaimedReceipts",
        number: 5,
        protoType: 9,
        protoName: "claimed_receipts",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._claimedReceipts;
  }
  get claimedGuildReceipts() {
    if (!this._claimedGuildReceipts) {
      this._claimedGuildReceipts = {
        name: "claimedGuildReceipts",
        Name: "ClaimedGuildReceipts",
        number: 6,
        protoType: 9,
        protoName: "claimed_guild_receipts",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._claimedGuildReceipts;
  }
  get claimedBossRankReceipts() {
    if (!this._claimedBossRankReceipts) {
      this._claimedBossRankReceipts = {
        name: "claimedBossRankReceipts",
        Name: "ClaimedBossRankReceipts",
        number: 7,
        protoType: 9,
        protoName: "claimed_boss_rank_receipts",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._claimedBossRankReceipts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.curGemCost,
        this.curGoldCost,
        this.remainingAds,
        this.nextKeyRemainingSeconds,
        this.gemCostResetRemainingSeconds,
        this.claimedReceipts,
        this.claimedGuildReceipts,
        this.claimedBossRankReceipts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurGemCost",
        Name: "DummyOneofForCurGemCost",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurGoldCost",
        Name: "DummyOneofForCurGoldCost",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRemainingAds",
        Name: "DummyOneofForRemainingAds",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNextKeyRemainingSeconds",
        Name: "DummyOneofForNextKeyRemainingSeconds",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGemCostResetRemainingSeconds",
        Name: "DummyOneofForGemCostResetRemainingSeconds",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_CoopStatus.descriptor = new MapEventStatus_CoopStatus_Descriptor();
class MapEventStatus_EventRewardReceipts {
  get descriptor() {
    return MapEventStatus_EventRewardReceipts.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGuildRankReceipt = false;
    this._guildRankReceipt = null;
    this._hasBossRankReceipt = false;
    this._bossRankReceipt = null;
  }
  isEmpty() {
    if (this._hasGuildRankReceipt) return false;
    if (this._hasBossRankReceipt) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_EventRewardReceipts) {
      return value;
    }
    return MapEventStatus_EventRewardReceipts.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_EventRewardReceipts();
    if (json.guildRankReceipt != null) {
      result._hasGuildRankReceipt = true;
      result._guildRankReceipt = JsonToString.fromJson(json.guildRankReceipt);
    }
    if (json.bossRankReceipt != null) {
      result._hasBossRankReceipt = true;
      result._bossRankReceipt = JsonToString.fromJson(json.bossRankReceipt);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGuildRankReceipt) {
      result.guildRankReceipt = JsonToString.toJson(this._guildRankReceipt);
    }
    if (this._hasBossRankReceipt) {
      result.bossRankReceipt = JsonToString.toJson(this._bossRankReceipt);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get guildRankReceipt() {
    return this._hasGuildRankReceipt ? this._guildRankReceipt : JsonToString.default;
  }
  get hasGuildRankReceipt() {
    return this._hasGuildRankReceipt;
  }
  setGuildRankReceipt(path, value) {
    return {type: 'SET', path: path.concat(['guildRankReceipt']), value};
  }
  deleteGuildRankReceipt(path) {
    return {type: 'DELETE', path: path.concat(['guildRankReceipt'])};
  }
  /**
   * @returns {string}
   */
  get bossRankReceipt() {
    return this._hasBossRankReceipt ? this._bossRankReceipt : JsonToString.default;
  }
  get hasBossRankReceipt() {
    return this._hasBossRankReceipt;
  }
  setBossRankReceipt(path, value) {
    return {type: 'SET', path: path.concat(['bossRankReceipt']), value};
  }
  deleteBossRankReceipt(path) {
    return {type: 'DELETE', path: path.concat(['bossRankReceipt'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "guildRankReceipt": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_EventRewardReceipts(this);
              copy._hasGuildRankReceipt = true;
              copy._guildRankReceipt = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildRankReceipt) {
                return this;
              }
              const copy = new MapEventStatus_EventRewardReceipts(this);
              copy._hasGuildRankReceipt = false;
              copy._guildRankReceipt = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bossRankReceipt": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_EventRewardReceipts(this);
              copy._hasBossRankReceipt = true;
              copy._bossRankReceipt = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBossRankReceipt) {
                return this;
              }
              const copy = new MapEventStatus_EventRewardReceipts(this);
              copy._hasBossRankReceipt = false;
              copy._bossRankReceipt = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_EventRewardReceipts} other
   * @returns {MapEventStatus_EventRewardReceipts}
   */
  merge(other) {
    const copy = new MapEventStatus_EventRewardReceipts(this);
    if (other._hasGuildRankReceipt) {
      copy._hasGuildRankReceipt = true;
      copy._guildRankReceipt = other._guildRankReceipt;
    }
    if (other._hasBossRankReceipt) {
      copy._hasBossRankReceipt = true;
      copy._bossRankReceipt = other._bossRankReceipt;
    }
    return copy;
  }
}
MapEventStatus_EventRewardReceipts.default = new MapEventStatus_EventRewardReceipts();
class MapEventStatus_EventRewardReceipts_Builder {
  constructor(value) {
    this._value = new MapEventStatus_EventRewardReceipts(value);
  }
  build() {
    return new MapEventStatus_EventRewardReceipts(this._value);
  }
  setGuildRankReceipt(value) {
    this._value._hasGuildRankReceipt = true;
    this._value._guildRankReceipt = value;
    return this;
  }
  deleteGuildRankReceipt() {
    this._value._hasGuildRankReceipt = false;
    this._value._guildRankReceipt = null;
    return this;
  }
  setBossRankReceipt(value) {
    this._value._hasBossRankReceipt = true;
    this._value._bossRankReceipt = value;
    return this;
  }
  deleteBossRankReceipt() {
    this._value._hasBossRankReceipt = false;
    this._value._bossRankReceipt = null;
    return this;
  }
}
MapEventStatus_EventRewardReceipts.Builder = MapEventStatus_EventRewardReceipts_Builder;
class MapEventStatus_EventRewardReceipts_WithParent {
  /**
   * @param {MapEventStatus_EventRewardReceipts} value
   * @param {MapEventStatus_EventRewardReceipts_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_EventRewardReceipts.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGuildRankReceipt() {
    if (this._cachedHasGuildRankReceipt === undefined) {
      if (this._value.hasGuildRankReceipt) {
        this._cachedHasGuildRankReceipt = true;
      } else {
        this._cachedHasGuildRankReceipt = this._parent ? this._parent.hasGuildRankReceipt : false;
      }
    }
    return this._cachedHasGuildRankReceipt;
  }
  get guildRankReceipt() {
    if (this._cachedGuildRankReceipt === undefined) {
      if (this._value.hasGuildRankReceipt) {
        this._cachedGuildRankReceipt = this._value.guildRankReceipt;
      } else {
        this._cachedGuildRankReceipt = this._parent ? this._parent.guildRankReceipt : this._value.guildRankReceipt;
      }
    }
    return this._cachedGuildRankReceipt;
  }
  get hasBossRankReceipt() {
    if (this._cachedHasBossRankReceipt === undefined) {
      if (this._value.hasBossRankReceipt) {
        this._cachedHasBossRankReceipt = true;
      } else {
        this._cachedHasBossRankReceipt = this._parent ? this._parent.hasBossRankReceipt : false;
      }
    }
    return this._cachedHasBossRankReceipt;
  }
  get bossRankReceipt() {
    if (this._cachedBossRankReceipt === undefined) {
      if (this._value.hasBossRankReceipt) {
        this._cachedBossRankReceipt = this._value.bossRankReceipt;
      } else {
        this._cachedBossRankReceipt = this._parent ? this._parent.bossRankReceipt : this._value.bossRankReceipt;
      }
    }
    return this._cachedBossRankReceipt;
  }
  update(current, parent) {
    const result = new MapEventStatus_EventRewardReceipts_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_EventRewardReceipts_WithParent.default = new MapEventStatus_EventRewardReceipts_WithParent(MapEventStatus_EventRewardReceipts.default, null);
MapEventStatus_EventRewardReceipts.WithParent = MapEventStatus_EventRewardReceipts_WithParent;
class MapEventStatus_EventRewardReceipts_Descriptor {
  get guildRankReceipt() {
    if (!this._guildRankReceipt) {
      this._guildRankReceipt = {
        name: "guildRankReceipt",
        Name: "GuildRankReceipt",
        number: 1,
        protoType: 9,
        protoName: "guild_rank_receipt",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildRankReceipt;
  }
  get bossRankReceipt() {
    if (!this._bossRankReceipt) {
      this._bossRankReceipt = {
        name: "bossRankReceipt",
        Name: "BossRankReceipt",
        number: 2,
        protoType: 9,
        protoName: "boss_rank_receipt",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossRankReceipt;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.guildRankReceipt,
        this.bossRankReceipt,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGuildRankReceipt",
        Name: "DummyOneofForGuildRankReceipt",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBossRankReceipt",
        Name: "DummyOneofForBossRankReceipt",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_EventRewardReceipts.descriptor = new MapEventStatus_EventRewardReceipts_Descriptor();
class MapEventStatus_EventChestGroupStatus {
  get descriptor() {
    return MapEventStatus_EventChestGroupStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGroupKey = false;
    this._groupKey = null;
    this._hasCurTier = false;
    this._curTier = null;
    this._hasCumulativeTenDraw = false;
    this._cumulativeTenDraw = null;
  }
  isEmpty() {
    if (this._hasGroupKey) return false;
    if (this._hasCurTier) return false;
    if (this._hasCumulativeTenDraw) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus_EventChestGroupStatus) {
      return value;
    }
    return MapEventStatus_EventChestGroupStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus_EventChestGroupStatus();
    if (json.groupKey != null) {
      result._hasGroupKey = true;
      result._groupKey = JsonToString.fromJson(json.groupKey);
    }
    if (json.curTier != null) {
      result._hasCurTier = true;
      result._curTier = JsonToInt32.fromJson(json.curTier);
    }
    if (json.cumulativeTenDraw != null) {
      result._hasCumulativeTenDraw = true;
      result._cumulativeTenDraw = JsonToInt32.fromJson(json.cumulativeTenDraw);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGroupKey) {
      result.groupKey = JsonToString.toJson(this._groupKey);
    }
    if (this._hasCurTier) {
      result.curTier = JsonToInt32.toJson(this._curTier);
    }
    if (this._hasCumulativeTenDraw) {
      result.cumulativeTenDraw = JsonToInt32.toJson(this._cumulativeTenDraw);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get groupKey() {
    return this._hasGroupKey ? this._groupKey : JsonToString.default;
  }
  get hasGroupKey() {
    return this._hasGroupKey;
  }
  setGroupKey(path, value) {
    return {type: 'SET', path: path.concat(['groupKey']), value};
  }
  deleteGroupKey(path) {
    return {type: 'DELETE', path: path.concat(['groupKey'])};
  }
  /**
   * @returns {number}
   */
  get curTier() {
    return this._hasCurTier ? this._curTier : JsonToInt32.default;
  }
  get hasCurTier() {
    return this._hasCurTier;
  }
  setCurTier(path, value) {
    return {type: 'SET', path: path.concat(['curTier']), value};
  }
  deleteCurTier(path) {
    return {type: 'DELETE', path: path.concat(['curTier'])};
  }
  /**
   * @returns {number}
   */
  get cumulativeTenDraw() {
    return this._hasCumulativeTenDraw ? this._cumulativeTenDraw : JsonToInt32.default;
  }
  get hasCumulativeTenDraw() {
    return this._hasCumulativeTenDraw;
  }
  setCumulativeTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeTenDraw']), value};
  }
  deleteCumulativeTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeTenDraw'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "groupKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasGroupKey = true;
              copy._groupKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupKey) {
                return this;
              }
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasGroupKey = false;
              copy._groupKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "curTier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasCurTier = true;
              copy._curTier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurTier) {
                return this;
              }
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasCurTier = false;
              copy._curTier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cumulativeTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasCumulativeTenDraw = true;
              copy._cumulativeTenDraw = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeTenDraw) {
                return this;
              }
              const copy = new MapEventStatus_EventChestGroupStatus(this);
              copy._hasCumulativeTenDraw = false;
              copy._cumulativeTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus_EventChestGroupStatus} other
   * @returns {MapEventStatus_EventChestGroupStatus}
   */
  merge(other) {
    const copy = new MapEventStatus_EventChestGroupStatus(this);
    if (other._hasGroupKey) {
      copy._hasGroupKey = true;
      copy._groupKey = other._groupKey;
    }
    if (other._hasCurTier) {
      copy._hasCurTier = true;
      copy._curTier = other._curTier;
    }
    if (other._hasCumulativeTenDraw) {
      copy._hasCumulativeTenDraw = true;
      copy._cumulativeTenDraw = other._cumulativeTenDraw;
    }
    return copy;
  }
}
MapEventStatus_EventChestGroupStatus.default = new MapEventStatus_EventChestGroupStatus();
class MapEventStatus_EventChestGroupStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus_EventChestGroupStatus(value);
  }
  build() {
    return new MapEventStatus_EventChestGroupStatus(this._value);
  }
  setGroupKey(value) {
    this._value._hasGroupKey = true;
    this._value._groupKey = value;
    return this;
  }
  deleteGroupKey() {
    this._value._hasGroupKey = false;
    this._value._groupKey = null;
    return this;
  }
  setCurTier(value) {
    this._value._hasCurTier = true;
    this._value._curTier = value;
    return this;
  }
  deleteCurTier() {
    this._value._hasCurTier = false;
    this._value._curTier = null;
    return this;
  }
  setCumulativeTenDraw(value) {
    this._value._hasCumulativeTenDraw = true;
    this._value._cumulativeTenDraw = value;
    return this;
  }
  deleteCumulativeTenDraw() {
    this._value._hasCumulativeTenDraw = false;
    this._value._cumulativeTenDraw = null;
    return this;
  }
}
MapEventStatus_EventChestGroupStatus.Builder = MapEventStatus_EventChestGroupStatus_Builder;
class MapEventStatus_EventChestGroupStatus_WithParent {
  /**
   * @param {MapEventStatus_EventChestGroupStatus} value
   * @param {MapEventStatus_EventChestGroupStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus_EventChestGroupStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGroupKey() {
    if (this._cachedHasGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedHasGroupKey = true;
      } else {
        this._cachedHasGroupKey = this._parent ? this._parent.hasGroupKey : false;
      }
    }
    return this._cachedHasGroupKey;
  }
  get groupKey() {
    if (this._cachedGroupKey === undefined) {
      if (this._value.hasGroupKey) {
        this._cachedGroupKey = this._value.groupKey;
      } else {
        this._cachedGroupKey = this._parent ? this._parent.groupKey : this._value.groupKey;
      }
    }
    return this._cachedGroupKey;
  }
  get hasCurTier() {
    if (this._cachedHasCurTier === undefined) {
      if (this._value.hasCurTier) {
        this._cachedHasCurTier = true;
      } else {
        this._cachedHasCurTier = this._parent ? this._parent.hasCurTier : false;
      }
    }
    return this._cachedHasCurTier;
  }
  get curTier() {
    if (this._cachedCurTier === undefined) {
      if (this._value.hasCurTier) {
        this._cachedCurTier = this._value.curTier;
      } else {
        this._cachedCurTier = this._parent ? this._parent.curTier : this._value.curTier;
      }
    }
    return this._cachedCurTier;
  }
  get hasCumulativeTenDraw() {
    if (this._cachedHasCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedHasCumulativeTenDraw = true;
      } else {
        this._cachedHasCumulativeTenDraw = this._parent ? this._parent.hasCumulativeTenDraw : false;
      }
    }
    return this._cachedHasCumulativeTenDraw;
  }
  get cumulativeTenDraw() {
    if (this._cachedCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedCumulativeTenDraw = this._value.cumulativeTenDraw;
      } else {
        this._cachedCumulativeTenDraw = this._parent ? this._parent.cumulativeTenDraw : this._value.cumulativeTenDraw;
      }
    }
    return this._cachedCumulativeTenDraw;
  }
  update(current, parent) {
    const result = new MapEventStatus_EventChestGroupStatus_WithParent(current, parent);
    return result;
  }
}
MapEventStatus_EventChestGroupStatus_WithParent.default = new MapEventStatus_EventChestGroupStatus_WithParent(MapEventStatus_EventChestGroupStatus.default, null);
MapEventStatus_EventChestGroupStatus.WithParent = MapEventStatus_EventChestGroupStatus_WithParent;
class MapEventStatus_EventChestGroupStatus_Descriptor {
  get groupKey() {
    if (!this._groupKey) {
      this._groupKey = {
        name: "groupKey",
        Name: "GroupKey",
        number: 1,
        protoType: 9,
        protoName: "group_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupKey;
  }
  get curTier() {
    if (!this._curTier) {
      this._curTier = {
        name: "curTier",
        Name: "CurTier",
        number: 2,
        protoType: 5,
        protoName: "cur_tier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curTier;
  }
  get cumulativeTenDraw() {
    if (!this._cumulativeTenDraw) {
      this._cumulativeTenDraw = {
        name: "cumulativeTenDraw",
        Name: "CumulativeTenDraw",
        number: 3,
        protoType: 5,
        protoName: "cumulative_ten_draw",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeTenDraw;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.groupKey,
        this.curTier,
        this.cumulativeTenDraw,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGroupKey",
        Name: "DummyOneofForGroupKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurTier",
        Name: "DummyOneofForCurTier",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCumulativeTenDraw",
        Name: "DummyOneofForCumulativeTenDraw",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus_EventChestGroupStatus.descriptor = new MapEventStatus_EventChestGroupStatus_Descriptor();
class MapEventStatus_EventState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "EXPIRED": return 0;
        case "INACTIVATED": return 1;
        case "ACTIVE": return 2;
        case "COMPLETED": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapEventStatus_EventState.fromJson(value);
  }
  static fromReact(e) {
    return MapEventStatus_EventState.fromJson(e);
  }
}
MapEventStatus_EventState.EXPIRED = 0;
MapEventStatus_EventState.INACTIVATED = 1;
MapEventStatus_EventState.ACTIVE = 2;
MapEventStatus_EventState.COMPLETED = 3;
MapEventStatus_EventState.default = 0;
MapEventStatus_EventState.values = {
  EXPIRED: 0,
  INACTIVATED: 1,
  ACTIVE: 2,
  COMPLETED: 3,
};
MapEventStatus_EventState.names = {
  0: "EXPIRED",
  1: "INACTIVATED",
  2: "ACTIVE",
  3: "COMPLETED",
};
export class MapEventStatus {
  get descriptor() {
    return MapEventStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapEventKey = false;
    this._mapEventKey = null;
    this._hasEventState = false;
    this._eventState = null;
    this._hasRemainingSeconds = false;
    this._remainingSeconds = null;
    this._questStatuses = [];
    this._milestoneStatuses = [];
    this._levelStatuses = [];
    this._hasAccessKeyStatus = false;
    this._accessKeyStatus = null;
    this._chestStatuses = [];
    this._hasTokenStatus = false;
    this._tokenStatus = null;
    this._hasCoopStatus = false;
    this._coopStatus = null;
    this._hasBossKeyStatus = false;
    this._bossKeyStatus = null;
    this._hasCoopKeyStatus = false;
    this._coopKeyStatus = null;
    this._hasBossRaidTicketStatus = false;
    this._bossRaidTicketStatus = null;
    this._hasChestOpenCount = false;
    this._chestOpenCount = null;
    this._soloLevelStatuses = [];
  }
  isEmpty() {
    if (this._hasMapEventKey) return false;
    if (this._hasEventState) return false;
    if (this._hasRemainingSeconds) return false;
    if (this._questStatuses.length > 0) return false;
    if (this._milestoneStatuses.length > 0) return false;
    if (this._levelStatuses.length > 0) return false;
    if (this._hasAccessKeyStatus && !this._accessKeyStatus.isEmpty()) return false;
    if (this._chestStatuses.length > 0) return false;
    if (this._hasTokenStatus && !this._tokenStatus.isEmpty()) return false;
    if (this._hasCoopStatus && !this._coopStatus.isEmpty()) return false;
    if (this._hasBossKeyStatus && !this._bossKeyStatus.isEmpty()) return false;
    if (this._hasCoopKeyStatus && !this._coopKeyStatus.isEmpty()) return false;
    if (this._hasBossRaidTicketStatus && !this._bossRaidTicketStatus.isEmpty()) return false;
    if (this._hasChestOpenCount) return false;
    if (this._soloLevelStatuses.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapEventStatus) {
      return value;
    }
    return MapEventStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapEventStatus();
    if (json.mapEventKey != null) {
      result._hasMapEventKey = true;
      result._mapEventKey = JsonToString.fromJson(json.mapEventKey);
    }
    if (json.eventState != null) {
      result._hasEventState = true;
      result._eventState = MapEventStatus_EventState.fromJson(json.eventState);
    }
    if (json.remainingSeconds != null) {
      result._hasRemainingSeconds = true;
      result._remainingSeconds = JsonToDouble.fromJson(json.remainingSeconds);
    }
    result._questStatuses = JsonToList(json.questStatuses, MapEventStatus_QuestStatus);
    result._milestoneStatuses = JsonToList(json.milestoneStatuses, MapEventStatus_MilestoneStatus);
    result._levelStatuses = JsonToList(json.levelStatuses, MapEventStatus_LevelStatus);
    if (json.accessKeyStatus != null) {
      result._hasAccessKeyStatus = true;
      result._accessKeyStatus = MapEventStatus_AccessKeyStatus.fromJson(json.accessKeyStatus);
    }
    result._chestStatuses = JsonToList(json.chestStatuses, MapEventStatus_EventChestGroupStatus);
    if (json.tokenStatus != null) {
      result._hasTokenStatus = true;
      result._tokenStatus = MapEventStatus_TokenStatus.fromJson(json.tokenStatus);
    }
    if (json.coopStatus != null) {
      result._hasCoopStatus = true;
      result._coopStatus = MapEventStatus_CoopStatus.fromJson(json.coopStatus);
    }
    if (json.bossKeyStatus != null) {
      result._hasBossKeyStatus = true;
      result._bossKeyStatus = MapEventStatus_BossKeyStatus.fromJson(json.bossKeyStatus);
    }
    if (json.coopKeyStatus != null) {
      result._hasCoopKeyStatus = true;
      result._coopKeyStatus = MapEventStatus_CoopKeyStatus.fromJson(json.coopKeyStatus);
    }
    if (json.bossRaidTicketStatus != null) {
      result._hasBossRaidTicketStatus = true;
      result._bossRaidTicketStatus = MapEventStatus_BossRaidTicketStatus.fromJson(json.bossRaidTicketStatus);
    }
    if (json.chestOpenCount != null) {
      result._hasChestOpenCount = true;
      result._chestOpenCount = JsonToInt32.fromJson(json.chestOpenCount);
    }
    result._soloLevelStatuses = JsonToList(json.soloLevelStatuses, MapEventStatus_SoloLevelStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapEventKey) {
      result.mapEventKey = JsonToString.toJson(this._mapEventKey);
    }
    if (this._hasEventState) {
      result.eventState = MapEventStatus_EventState.toJson(this._eventState);
    }
    if (this._hasRemainingSeconds) {
      result.remainingSeconds = JsonToDouble.toJson(this._remainingSeconds);
    }
    if (this._questStatuses.length > 0) {
      result.questStatuses = ArrayToJson(this._questStatuses, MapEventStatus_QuestStatus);
    }
    if (this._milestoneStatuses.length > 0) {
      result.milestoneStatuses = ArrayToJson(this._milestoneStatuses, MapEventStatus_MilestoneStatus);
    }
    if (this._levelStatuses.length > 0) {
      result.levelStatuses = ArrayToJson(this._levelStatuses, MapEventStatus_LevelStatus);
    }
    if (this._hasAccessKeyStatus && !this._accessKeyStatus.isEmpty()) {
      result.accessKeyStatus = MapEventStatus_AccessKeyStatus.toJson(this._accessKeyStatus);
    }
    if (this._chestStatuses.length > 0) {
      result.chestStatuses = ArrayToJson(this._chestStatuses, MapEventStatus_EventChestGroupStatus);
    }
    if (this._hasTokenStatus && !this._tokenStatus.isEmpty()) {
      result.tokenStatus = MapEventStatus_TokenStatus.toJson(this._tokenStatus);
    }
    if (this._hasCoopStatus && !this._coopStatus.isEmpty()) {
      result.coopStatus = MapEventStatus_CoopStatus.toJson(this._coopStatus);
    }
    if (this._hasBossKeyStatus && !this._bossKeyStatus.isEmpty()) {
      result.bossKeyStatus = MapEventStatus_BossKeyStatus.toJson(this._bossKeyStatus);
    }
    if (this._hasCoopKeyStatus && !this._coopKeyStatus.isEmpty()) {
      result.coopKeyStatus = MapEventStatus_CoopKeyStatus.toJson(this._coopKeyStatus);
    }
    if (this._hasBossRaidTicketStatus && !this._bossRaidTicketStatus.isEmpty()) {
      result.bossRaidTicketStatus = MapEventStatus_BossRaidTicketStatus.toJson(this._bossRaidTicketStatus);
    }
    if (this._hasChestOpenCount) {
      result.chestOpenCount = JsonToInt32.toJson(this._chestOpenCount);
    }
    if (this._soloLevelStatuses.length > 0) {
      result.soloLevelStatuses = ArrayToJson(this._soloLevelStatuses, MapEventStatus_SoloLevelStatus);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapEventKey() {
    return this._hasMapEventKey ? this._mapEventKey : JsonToString.default;
  }
  get hasMapEventKey() {
    return this._hasMapEventKey;
  }
  setMapEventKey(path, value) {
    return {type: 'SET', path: path.concat(['mapEventKey']), value};
  }
  deleteMapEventKey(path) {
    return {type: 'DELETE', path: path.concat(['mapEventKey'])};
  }
  /**
   * @returns {number}
   */
  get eventState() {
    return this._hasEventState ? this._eventState : MapEventStatus_EventState.default;
  }
  get hasEventState() {
    return this._hasEventState;
  }
  setEventState(path, value) {
    return {type: 'SET', path: path.concat(['eventState']), value};
  }
  deleteEventState(path) {
    return {type: 'DELETE', path: path.concat(['eventState'])};
  }
  /**
   * @returns {number}
   */
  get remainingSeconds() {
    return this._hasRemainingSeconds ? this._remainingSeconds : JsonToDouble.default;
  }
  get hasRemainingSeconds() {
    return this._hasRemainingSeconds;
  }
  setRemainingSeconds(path, value) {
    return {type: 'SET', path: path.concat(['remainingSeconds']), value};
  }
  deleteRemainingSeconds(path) {
    return {type: 'DELETE', path: path.concat(['remainingSeconds'])};
  }
  /**
   * @returns {MapEventStatus_QuestStatus[]}
   */
  get questStatuses() {
    return this._questStatuses;
  }
  addQuestStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['questStatuses']), value: value.toJson()};
  }
  setQuestStatuses(path, value) {
    return {type: 'SET', path: path.concat(['questStatuses']), value: ArrayToJson(value, MapEventStatus_QuestStatus)};
  }
  setQuestStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questStatuses', key]), value: value.toJson()};
  }
  deleteQuestStatuses(path) {
    return {type: 'DELETE', path: path.concat(['questStatuses'])};
  }
  deleteQuestStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questStatuses', key])};
  }
  /**
   * @returns {MapEventStatus_MilestoneStatus[]}
   */
  get milestoneStatuses() {
    return this._milestoneStatuses;
  }
  addMilestoneStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['milestoneStatuses']), value: value.toJson()};
  }
  setMilestoneStatuses(path, value) {
    return {type: 'SET', path: path.concat(['milestoneStatuses']), value: ArrayToJson(value, MapEventStatus_MilestoneStatus)};
  }
  setMilestoneStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['milestoneStatuses', key]), value: value.toJson()};
  }
  deleteMilestoneStatuses(path) {
    return {type: 'DELETE', path: path.concat(['milestoneStatuses'])};
  }
  deleteMilestoneStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['milestoneStatuses', key])};
  }
  /**
   * @returns {MapEventStatus_LevelStatus[]}
   */
  get levelStatuses() {
    return this._levelStatuses;
  }
  addLevelStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['levelStatuses']), value: value.toJson()};
  }
  setLevelStatuses(path, value) {
    return {type: 'SET', path: path.concat(['levelStatuses']), value: ArrayToJson(value, MapEventStatus_LevelStatus)};
  }
  setLevelStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levelStatuses', key]), value: value.toJson()};
  }
  deleteLevelStatuses(path) {
    return {type: 'DELETE', path: path.concat(['levelStatuses'])};
  }
  deleteLevelStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levelStatuses', key])};
  }
  /**
   * @returns {MapEventStatus_AccessKeyStatus}
   */
  get accessKeyStatus() {
    return this._hasAccessKeyStatus ? this._accessKeyStatus : MapEventStatus_AccessKeyStatus.default;
  }
  get hasAccessKeyStatus() {
    return this._hasAccessKeyStatus;
  }
  setAccessKeyStatus(path, value) {
    return {type: 'SET', path: path.concat(['accessKeyStatus']), value: value.toJson()};
  }
  deleteAccessKeyStatus(path) {
    return {type: 'DELETE', path: path.concat(['accessKeyStatus'])};
  }
  /**
   * @returns {MapEventStatus_EventChestGroupStatus[]}
   */
  get chestStatuses() {
    return this._chestStatuses;
  }
  addChestStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['chestStatuses']), value: value.toJson()};
  }
  setChestStatuses(path, value) {
    return {type: 'SET', path: path.concat(['chestStatuses']), value: ArrayToJson(value, MapEventStatus_EventChestGroupStatus)};
  }
  setChestStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chestStatuses', key]), value: value.toJson()};
  }
  deleteChestStatuses(path) {
    return {type: 'DELETE', path: path.concat(['chestStatuses'])};
  }
  deleteChestStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chestStatuses', key])};
  }
  /**
   * @returns {MapEventStatus_TokenStatus}
   */
  get tokenStatus() {
    return this._hasTokenStatus ? this._tokenStatus : MapEventStatus_TokenStatus.default;
  }
  get hasTokenStatus() {
    return this._hasTokenStatus;
  }
  setTokenStatus(path, value) {
    return {type: 'SET', path: path.concat(['tokenStatus']), value: value.toJson()};
  }
  deleteTokenStatus(path) {
    return {type: 'DELETE', path: path.concat(['tokenStatus'])};
  }
  /**
   * @returns {MapEventStatus_CoopStatus}
   */
  get coopStatus() {
    return this._hasCoopStatus ? this._coopStatus : MapEventStatus_CoopStatus.default;
  }
  get hasCoopStatus() {
    return this._hasCoopStatus;
  }
  setCoopStatus(path, value) {
    return {type: 'SET', path: path.concat(['coopStatus']), value: value.toJson()};
  }
  deleteCoopStatus(path) {
    return {type: 'DELETE', path: path.concat(['coopStatus'])};
  }
  /**
   * @returns {MapEventStatus_BossKeyStatus}
   */
  get bossKeyStatus() {
    return this._hasBossKeyStatus ? this._bossKeyStatus : MapEventStatus_BossKeyStatus.default;
  }
  get hasBossKeyStatus() {
    return this._hasBossKeyStatus;
  }
  setBossKeyStatus(path, value) {
    return {type: 'SET', path: path.concat(['bossKeyStatus']), value: value.toJson()};
  }
  deleteBossKeyStatus(path) {
    return {type: 'DELETE', path: path.concat(['bossKeyStatus'])};
  }
  /**
   * @returns {MapEventStatus_CoopKeyStatus}
   */
  get coopKeyStatus() {
    return this._hasCoopKeyStatus ? this._coopKeyStatus : MapEventStatus_CoopKeyStatus.default;
  }
  get hasCoopKeyStatus() {
    return this._hasCoopKeyStatus;
  }
  setCoopKeyStatus(path, value) {
    return {type: 'SET', path: path.concat(['coopKeyStatus']), value: value.toJson()};
  }
  deleteCoopKeyStatus(path) {
    return {type: 'DELETE', path: path.concat(['coopKeyStatus'])};
  }
  /**
   * @returns {MapEventStatus_BossRaidTicketStatus}
   */
  get bossRaidTicketStatus() {
    return this._hasBossRaidTicketStatus ? this._bossRaidTicketStatus : MapEventStatus_BossRaidTicketStatus.default;
  }
  get hasBossRaidTicketStatus() {
    return this._hasBossRaidTicketStatus;
  }
  setBossRaidTicketStatus(path, value) {
    return {type: 'SET', path: path.concat(['bossRaidTicketStatus']), value: value.toJson()};
  }
  deleteBossRaidTicketStatus(path) {
    return {type: 'DELETE', path: path.concat(['bossRaidTicketStatus'])};
  }
  /**
   * @returns {number}
   */
  get chestOpenCount() {
    return this._hasChestOpenCount ? this._chestOpenCount : JsonToInt32.default;
  }
  get hasChestOpenCount() {
    return this._hasChestOpenCount;
  }
  setChestOpenCount(path, value) {
    return {type: 'SET', path: path.concat(['chestOpenCount']), value};
  }
  deleteChestOpenCount(path) {
    return {type: 'DELETE', path: path.concat(['chestOpenCount'])};
  }
  /**
   * @returns {MapEventStatus_SoloLevelStatus[]}
   */
  get soloLevelStatuses() {
    return this._soloLevelStatuses;
  }
  addSoloLevelStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['soloLevelStatuses']), value: value.toJson()};
  }
  setSoloLevelStatuses(path, value) {
    return {type: 'SET', path: path.concat(['soloLevelStatuses']), value: ArrayToJson(value, MapEventStatus_SoloLevelStatus)};
  }
  setSoloLevelStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['soloLevelStatuses', key]), value: value.toJson()};
  }
  deleteSoloLevelStatuses(path) {
    return {type: 'DELETE', path: path.concat(['soloLevelStatuses'])};
  }
  deleteSoloLevelStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['soloLevelStatuses', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapEventKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasMapEventKey = true;
              copy._mapEventKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapEventKey) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasMapEventKey = false;
              copy._mapEventKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventState": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasEventState = true;
              copy._eventState = MapEventStatus_EventState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventState) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasEventState = false;
              copy._eventState = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "remainingSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasRemainingSeconds = true;
              copy._remainingSeconds = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRemainingSeconds) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasRemainingSeconds = false;
              copy._remainingSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "questStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._questStatuses = [];        for (let i of value) {
                copy._questStatuses.push(MapEventStatus_QuestStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus(this);
              copy._questStatuses = copy._questStatuses.concat([MapEventStatus_QuestStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questStatuses.length === 0) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._questStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._questStatuses = copy._questStatuses.slice();
              copy._questStatuses[path[1]] = MapEventStatus_QuestStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus(this);
              copy._questStatuses = copy._questStatuses.slice(0, path[1]).concat(copy._questStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questStatuses.length) {
            return this;
          }
          const oldValue = this._questStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._questStatuses = copy._questStatuses.slice();
          copy._questStatuses[key] = newValue;
          return copy;
        }
      }
      case "milestoneStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._milestoneStatuses = [];        for (let i of value) {
                copy._milestoneStatuses.push(MapEventStatus_MilestoneStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus(this);
              copy._milestoneStatuses = copy._milestoneStatuses.concat([MapEventStatus_MilestoneStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._milestoneStatuses.length === 0) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._milestoneStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._milestoneStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._milestoneStatuses = copy._milestoneStatuses.slice();
              copy._milestoneStatuses[path[1]] = MapEventStatus_MilestoneStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus(this);
              copy._milestoneStatuses = copy._milestoneStatuses.slice(0, path[1]).concat(copy._milestoneStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._milestoneStatuses.length) {
            return this;
          }
          const oldValue = this._milestoneStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._milestoneStatuses = copy._milestoneStatuses.slice();
          copy._milestoneStatuses[key] = newValue;
          return copy;
        }
      }
      case "levelStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._levelStatuses = [];        for (let i of value) {
                copy._levelStatuses.push(MapEventStatus_LevelStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus(this);
              copy._levelStatuses = copy._levelStatuses.concat([MapEventStatus_LevelStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levelStatuses.length === 0) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._levelStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levelStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._levelStatuses = copy._levelStatuses.slice();
              copy._levelStatuses[path[1]] = MapEventStatus_LevelStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus(this);
              copy._levelStatuses = copy._levelStatuses.slice(0, path[1]).concat(copy._levelStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levelStatuses.length) {
            return this;
          }
          const oldValue = this._levelStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._levelStatuses = copy._levelStatuses.slice();
          copy._levelStatuses[key] = newValue;
          return copy;
        }
      }
      case "accessKeyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasAccessKeyStatus = true;
              copy._accessKeyStatus = MapEventStatus_AccessKeyStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAccessKeyStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasAccessKeyStatus = false;
              copy._accessKeyStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAccessKeyStatus) {
            const copy = new MapEventStatus(this);
            copy._hasAccessKeyStatus = true;
            copy._accessKeyStatus = MapEventStatus_AccessKeyStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._accessKeyStatus.apply(type, path.slice(1), value);
          if (newValue === this._accessKeyStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._accessKeyStatus = copy._accessKeyStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chestStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._chestStatuses = [];        for (let i of value) {
                copy._chestStatuses.push(MapEventStatus_EventChestGroupStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus(this);
              copy._chestStatuses = copy._chestStatuses.concat([MapEventStatus_EventChestGroupStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chestStatuses.length === 0) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._chestStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chestStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._chestStatuses = copy._chestStatuses.slice();
              copy._chestStatuses[path[1]] = MapEventStatus_EventChestGroupStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus(this);
              copy._chestStatuses = copy._chestStatuses.slice(0, path[1]).concat(copy._chestStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chestStatuses.length) {
            return this;
          }
          const oldValue = this._chestStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._chestStatuses = copy._chestStatuses.slice();
          copy._chestStatuses[key] = newValue;
          return copy;
        }
      }
      case "tokenStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasTokenStatus = true;
              copy._tokenStatus = MapEventStatus_TokenStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTokenStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasTokenStatus = false;
              copy._tokenStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTokenStatus) {
            const copy = new MapEventStatus(this);
            copy._hasTokenStatus = true;
            copy._tokenStatus = MapEventStatus_TokenStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tokenStatus.apply(type, path.slice(1), value);
          if (newValue === this._tokenStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._tokenStatus = copy._tokenStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "coopStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasCoopStatus = true;
              copy._coopStatus = MapEventStatus_CoopStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCoopStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasCoopStatus = false;
              copy._coopStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCoopStatus) {
            const copy = new MapEventStatus(this);
            copy._hasCoopStatus = true;
            copy._coopStatus = MapEventStatus_CoopStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._coopStatus.apply(type, path.slice(1), value);
          if (newValue === this._coopStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._coopStatus = copy._coopStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "bossKeyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasBossKeyStatus = true;
              copy._bossKeyStatus = MapEventStatus_BossKeyStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBossKeyStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasBossKeyStatus = false;
              copy._bossKeyStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBossKeyStatus) {
            const copy = new MapEventStatus(this);
            copy._hasBossKeyStatus = true;
            copy._bossKeyStatus = MapEventStatus_BossKeyStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._bossKeyStatus.apply(type, path.slice(1), value);
          if (newValue === this._bossKeyStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._bossKeyStatus = copy._bossKeyStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "coopKeyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasCoopKeyStatus = true;
              copy._coopKeyStatus = MapEventStatus_CoopKeyStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCoopKeyStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasCoopKeyStatus = false;
              copy._coopKeyStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCoopKeyStatus) {
            const copy = new MapEventStatus(this);
            copy._hasCoopKeyStatus = true;
            copy._coopKeyStatus = MapEventStatus_CoopKeyStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._coopKeyStatus.apply(type, path.slice(1), value);
          if (newValue === this._coopKeyStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._coopKeyStatus = copy._coopKeyStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "bossRaidTicketStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasBossRaidTicketStatus = true;
              copy._bossRaidTicketStatus = MapEventStatus_BossRaidTicketStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBossRaidTicketStatus) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasBossRaidTicketStatus = false;
              copy._bossRaidTicketStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBossRaidTicketStatus) {
            const copy = new MapEventStatus(this);
            copy._hasBossRaidTicketStatus = true;
            copy._bossRaidTicketStatus = MapEventStatus_BossRaidTicketStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._bossRaidTicketStatus.apply(type, path.slice(1), value);
          if (newValue === this._bossRaidTicketStatus) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._bossRaidTicketStatus = copy._bossRaidTicketStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chestOpenCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._hasChestOpenCount = true;
              copy._chestOpenCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestOpenCount) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._hasChestOpenCount = false;
              copy._chestOpenCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "soloLevelStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._soloLevelStatuses = [];        for (let i of value) {
                copy._soloLevelStatuses.push(MapEventStatus_SoloLevelStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.concat([MapEventStatus_SoloLevelStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._soloLevelStatuses.length === 0) {
                return this;
              }
              const copy = new MapEventStatus(this);
              copy._soloLevelStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._soloLevelStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.slice();
              copy._soloLevelStatuses[path[1]] = MapEventStatus_SoloLevelStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.slice(0, path[1]).concat(copy._soloLevelStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._soloLevelStatuses.length) {
            return this;
          }
          const oldValue = this._soloLevelStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapEventStatus(this);
          copy._soloLevelStatuses = copy._soloLevelStatuses.slice();
          copy._soloLevelStatuses[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapEventStatus} other
   * @returns {MapEventStatus}
   */
  merge(other) {
    const copy = new MapEventStatus(this);
    if (other._hasMapEventKey) {
      copy._hasMapEventKey = true;
      copy._mapEventKey = other._mapEventKey;
    }
    if (other._hasEventState) {
      copy._hasEventState = true;
      copy._eventState = other._eventState;
    }
    if (other._hasRemainingSeconds) {
      copy._hasRemainingSeconds = true;
      copy._remainingSeconds = other._remainingSeconds;
    }
    copy._questStatuses = this._questStatuses.concat(other._questStatuses);
    copy._milestoneStatuses = this._milestoneStatuses.concat(other._milestoneStatuses);
    copy._levelStatuses = this._levelStatuses.concat(other._levelStatuses);
    if (other._hasAccessKeyStatus) {
      if (copy._hasAccessKeyStatus) {
        copy._accessKeyStatus = copy.accessKeyStatus.merge(other.accessKeyStatus);
      } else {
        copy._accessKeyStatus = other._accessKeyStatus;
      }
      copy._hasAccessKeyStatus = true;
    }
    copy._chestStatuses = this._chestStatuses.concat(other._chestStatuses);
    if (other._hasTokenStatus) {
      if (copy._hasTokenStatus) {
        copy._tokenStatus = copy.tokenStatus.merge(other.tokenStatus);
      } else {
        copy._tokenStatus = other._tokenStatus;
      }
      copy._hasTokenStatus = true;
    }
    if (other._hasCoopStatus) {
      if (copy._hasCoopStatus) {
        copy._coopStatus = copy.coopStatus.merge(other.coopStatus);
      } else {
        copy._coopStatus = other._coopStatus;
      }
      copy._hasCoopStatus = true;
    }
    if (other._hasBossKeyStatus) {
      if (copy._hasBossKeyStatus) {
        copy._bossKeyStatus = copy.bossKeyStatus.merge(other.bossKeyStatus);
      } else {
        copy._bossKeyStatus = other._bossKeyStatus;
      }
      copy._hasBossKeyStatus = true;
    }
    if (other._hasCoopKeyStatus) {
      if (copy._hasCoopKeyStatus) {
        copy._coopKeyStatus = copy.coopKeyStatus.merge(other.coopKeyStatus);
      } else {
        copy._coopKeyStatus = other._coopKeyStatus;
      }
      copy._hasCoopKeyStatus = true;
    }
    if (other._hasBossRaidTicketStatus) {
      if (copy._hasBossRaidTicketStatus) {
        copy._bossRaidTicketStatus = copy.bossRaidTicketStatus.merge(other.bossRaidTicketStatus);
      } else {
        copy._bossRaidTicketStatus = other._bossRaidTicketStatus;
      }
      copy._hasBossRaidTicketStatus = true;
    }
    if (other._hasChestOpenCount) {
      copy._hasChestOpenCount = true;
      copy._chestOpenCount = other._chestOpenCount;
    }
    copy._soloLevelStatuses = this._soloLevelStatuses.concat(other._soloLevelStatuses);
    return copy;
  }
}
MapEventStatus.default = new MapEventStatus();
MapEventStatus.QuestStatus = MapEventStatus_QuestStatus;
MapEventStatus.MilestoneStatus = MapEventStatus_MilestoneStatus;
MapEventStatus.LevelStatus = MapEventStatus_LevelStatus;
MapEventStatus.SoloLevelStatus = MapEventStatus_SoloLevelStatus;
MapEventStatus.AccessKeyStatus = MapEventStatus_AccessKeyStatus;
MapEventStatus.TokenStatus = MapEventStatus_TokenStatus;
MapEventStatus.BossKeyStatus = MapEventStatus_BossKeyStatus;
MapEventStatus.CoopKeyStatus = MapEventStatus_CoopKeyStatus;
MapEventStatus.BossRaidTicketStatus = MapEventStatus_BossRaidTicketStatus;
MapEventStatus.CoopStatus = MapEventStatus_CoopStatus;
MapEventStatus.EventRewardReceipts = MapEventStatus_EventRewardReceipts;
MapEventStatus.EventChestGroupStatus = MapEventStatus_EventChestGroupStatus;
MapEventStatus.EventState = MapEventStatus_EventState;
class MapEventStatus_Builder {
  constructor(value) {
    this._value = new MapEventStatus(value);
  }
  build() {
    return new MapEventStatus(this._value);
  }
  setMapEventKey(value) {
    this._value._hasMapEventKey = true;
    this._value._mapEventKey = value;
    return this;
  }
  deleteMapEventKey() {
    this._value._hasMapEventKey = false;
    this._value._mapEventKey = null;
    return this;
  }
  setEventState(value) {
    this._value._hasEventState = true;
    this._value._eventState = value;
    return this;
  }
  deleteEventState() {
    this._value._hasEventState = false;
    this._value._eventState = null;
    return this;
  }
  setRemainingSeconds(value) {
    this._value._hasRemainingSeconds = true;
    this._value._remainingSeconds = value;
    return this;
  }
  deleteRemainingSeconds() {
    this._value._hasRemainingSeconds = false;
    this._value._remainingSeconds = null;
    return this;
  }
  addAllQuestStatuses(values) {
    this._value._questStatuses = this._value._questStatuses.concat(values);
    return this;
  }
  addQuestStatuses(value) {
    this._value._questStatuses = this._value._questStatuses.concat([value]);
    return this;
  }
  setQuestStatuses(index, value) {
    this._value._questStatuses = this._value._questStatuses.concat();
    this._value._questStatuses[index] = value;
    return this;
  }
  clearQuestStatuses() {
    this._value._questStatuses = [];
    return this;
  }
  addAllMilestoneStatuses(values) {
    this._value._milestoneStatuses = this._value._milestoneStatuses.concat(values);
    return this;
  }
  addMilestoneStatuses(value) {
    this._value._milestoneStatuses = this._value._milestoneStatuses.concat([value]);
    return this;
  }
  setMilestoneStatuses(index, value) {
    this._value._milestoneStatuses = this._value._milestoneStatuses.concat();
    this._value._milestoneStatuses[index] = value;
    return this;
  }
  clearMilestoneStatuses() {
    this._value._milestoneStatuses = [];
    return this;
  }
  addAllLevelStatuses(values) {
    this._value._levelStatuses = this._value._levelStatuses.concat(values);
    return this;
  }
  addLevelStatuses(value) {
    this._value._levelStatuses = this._value._levelStatuses.concat([value]);
    return this;
  }
  setLevelStatuses(index, value) {
    this._value._levelStatuses = this._value._levelStatuses.concat();
    this._value._levelStatuses[index] = value;
    return this;
  }
  clearLevelStatuses() {
    this._value._levelStatuses = [];
    return this;
  }
  setAccessKeyStatus(value) {
    this._value._hasAccessKeyStatus = true;
    this._value._accessKeyStatus = value;
    return this;
  }
  deleteAccessKeyStatus() {
    this._value._hasAccessKeyStatus = false;
    this._value._accessKeyStatus = null;
    return this;
  }
  addAllChestStatuses(values) {
    this._value._chestStatuses = this._value._chestStatuses.concat(values);
    return this;
  }
  addChestStatuses(value) {
    this._value._chestStatuses = this._value._chestStatuses.concat([value]);
    return this;
  }
  setChestStatuses(index, value) {
    this._value._chestStatuses = this._value._chestStatuses.concat();
    this._value._chestStatuses[index] = value;
    return this;
  }
  clearChestStatuses() {
    this._value._chestStatuses = [];
    return this;
  }
  setTokenStatus(value) {
    this._value._hasTokenStatus = true;
    this._value._tokenStatus = value;
    return this;
  }
  deleteTokenStatus() {
    this._value._hasTokenStatus = false;
    this._value._tokenStatus = null;
    return this;
  }
  setCoopStatus(value) {
    this._value._hasCoopStatus = true;
    this._value._coopStatus = value;
    return this;
  }
  deleteCoopStatus() {
    this._value._hasCoopStatus = false;
    this._value._coopStatus = null;
    return this;
  }
  setBossKeyStatus(value) {
    this._value._hasBossKeyStatus = true;
    this._value._bossKeyStatus = value;
    return this;
  }
  deleteBossKeyStatus() {
    this._value._hasBossKeyStatus = false;
    this._value._bossKeyStatus = null;
    return this;
  }
  setCoopKeyStatus(value) {
    this._value._hasCoopKeyStatus = true;
    this._value._coopKeyStatus = value;
    return this;
  }
  deleteCoopKeyStatus() {
    this._value._hasCoopKeyStatus = false;
    this._value._coopKeyStatus = null;
    return this;
  }
  setBossRaidTicketStatus(value) {
    this._value._hasBossRaidTicketStatus = true;
    this._value._bossRaidTicketStatus = value;
    return this;
  }
  deleteBossRaidTicketStatus() {
    this._value._hasBossRaidTicketStatus = false;
    this._value._bossRaidTicketStatus = null;
    return this;
  }
  setChestOpenCount(value) {
    this._value._hasChestOpenCount = true;
    this._value._chestOpenCount = value;
    return this;
  }
  deleteChestOpenCount() {
    this._value._hasChestOpenCount = false;
    this._value._chestOpenCount = null;
    return this;
  }
  addAllSoloLevelStatuses(values) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat(values);
    return this;
  }
  addSoloLevelStatuses(value) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat([value]);
    return this;
  }
  setSoloLevelStatuses(index, value) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat();
    this._value._soloLevelStatuses[index] = value;
    return this;
  }
  clearSoloLevelStatuses() {
    this._value._soloLevelStatuses = [];
    return this;
  }
}
MapEventStatus.Builder = MapEventStatus_Builder;
class MapEventStatus_WithParent {
  /**
   * @param {MapEventStatus} value
   * @param {MapEventStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapEventStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapEventKey() {
    if (this._cachedHasMapEventKey === undefined) {
      if (this._value.hasMapEventKey) {
        this._cachedHasMapEventKey = true;
      } else {
        this._cachedHasMapEventKey = this._parent ? this._parent.hasMapEventKey : false;
      }
    }
    return this._cachedHasMapEventKey;
  }
  get mapEventKey() {
    if (this._cachedMapEventKey === undefined) {
      if (this._value.hasMapEventKey) {
        this._cachedMapEventKey = this._value.mapEventKey;
      } else {
        this._cachedMapEventKey = this._parent ? this._parent.mapEventKey : this._value.mapEventKey;
      }
    }
    return this._cachedMapEventKey;
  }
  get hasEventState() {
    if (this._cachedHasEventState === undefined) {
      if (this._value.hasEventState) {
        this._cachedHasEventState = true;
      } else {
        this._cachedHasEventState = this._parent ? this._parent.hasEventState : false;
      }
    }
    return this._cachedHasEventState;
  }
  get eventState() {
    if (this._cachedEventState === undefined) {
      if (this._value.hasEventState) {
        this._cachedEventState = this._value.eventState;
      } else {
        this._cachedEventState = this._parent ? this._parent.eventState : this._value.eventState;
      }
    }
    return this._cachedEventState;
  }
  get hasRemainingSeconds() {
    if (this._cachedHasRemainingSeconds === undefined) {
      if (this._value.hasRemainingSeconds) {
        this._cachedHasRemainingSeconds = true;
      } else {
        this._cachedHasRemainingSeconds = this._parent ? this._parent.hasRemainingSeconds : false;
      }
    }
    return this._cachedHasRemainingSeconds;
  }
  get remainingSeconds() {
    if (this._cachedRemainingSeconds === undefined) {
      if (this._value.hasRemainingSeconds) {
        this._cachedRemainingSeconds = this._value.remainingSeconds;
      } else {
        this._cachedRemainingSeconds = this._parent ? this._parent.remainingSeconds : this._value.remainingSeconds;
      }
    }
    return this._cachedRemainingSeconds;
  }
  get selfQuestStatuses() {
    if (!this._selfQuestStatuses) {
      this._selfQuestStatuses = [];
      for (let i of this._value.questStatuses) {
        this._selfQuestStatuses.push(new MapEventStatus_QuestStatus.WithParent(i, null));
      }
    }
    return this._selfQuestStatuses;
  }
  get inherentQuestStatuses() {
    if (!this._inherentQuestStatuses) {
      this._inherentQuestStatuses = this._parent ? this._parent.questStatuses : [];
    }
    return this._inherentQuestStatuses;
  }
  get questStatuses() {
    if (!this._allQuestStatuses) {
      this._allQuestStatuses = this._parent ? this._parent.questStatuses.concat(this.selfQuestStatuses) : this.selfQuestStatuses;
    }
    return this._allQuestStatuses;
  }
  get selfMilestoneStatuses() {
    if (!this._selfMilestoneStatuses) {
      this._selfMilestoneStatuses = [];
      for (let i of this._value.milestoneStatuses) {
        this._selfMilestoneStatuses.push(new MapEventStatus_MilestoneStatus.WithParent(i, null));
      }
    }
    return this._selfMilestoneStatuses;
  }
  get inherentMilestoneStatuses() {
    if (!this._inherentMilestoneStatuses) {
      this._inherentMilestoneStatuses = this._parent ? this._parent.milestoneStatuses : [];
    }
    return this._inherentMilestoneStatuses;
  }
  get milestoneStatuses() {
    if (!this._allMilestoneStatuses) {
      this._allMilestoneStatuses = this._parent ? this._parent.milestoneStatuses.concat(this.selfMilestoneStatuses) : this.selfMilestoneStatuses;
    }
    return this._allMilestoneStatuses;
  }
  get selfLevelStatuses() {
    if (!this._selfLevelStatuses) {
      this._selfLevelStatuses = [];
      for (let i of this._value.levelStatuses) {
        this._selfLevelStatuses.push(new MapEventStatus_LevelStatus.WithParent(i, null));
      }
    }
    return this._selfLevelStatuses;
  }
  get inherentLevelStatuses() {
    if (!this._inherentLevelStatuses) {
      this._inherentLevelStatuses = this._parent ? this._parent.levelStatuses : [];
    }
    return this._inherentLevelStatuses;
  }
  get levelStatuses() {
    if (!this._allLevelStatuses) {
      this._allLevelStatuses = this._parent ? this._parent.levelStatuses.concat(this.selfLevelStatuses) : this.selfLevelStatuses;
    }
    return this._allLevelStatuses;
  }
  get hasAccessKeyStatus() {
    if (this._cachedHasAccessKeyStatus === undefined) {
      if (this._value.hasAccessKeyStatus) {
        this._cachedHasAccessKeyStatus = true;
      } else {
        this._cachedHasAccessKeyStatus = this._parent ? this._parent.hasAccessKeyStatus : false;
      }
    }
    return this._cachedHasAccessKeyStatus;
  }
  get accessKeyStatus() {
    if (!this._cachedAccessKeyStatus) {
      if (this._value.hasAccessKeyStatus) {
        this._cachedAccessKeyStatus = new MapEventStatus_AccessKeyStatus.WithParent(this._value.accessKeyStatus, this._parent && this._parent.hasAccessKeyStatus ? this._parent.accessKeyStatus : null);
      } else {
        this._cachedAccessKeyStatus = this._parent ? new MapEventStatus_AccessKeyStatus.WithParent(MapEventStatus_AccessKeyStatus.default, this._parent.accessKeyStatus) : MapEventStatus_AccessKeyStatus.WithParent.default;
      }
    }
    return this._cachedAccessKeyStatus;
  }
  get selfChestStatuses() {
    if (!this._selfChestStatuses) {
      this._selfChestStatuses = [];
      for (let i of this._value.chestStatuses) {
        this._selfChestStatuses.push(new MapEventStatus_EventChestGroupStatus.WithParent(i, null));
      }
    }
    return this._selfChestStatuses;
  }
  get inherentChestStatuses() {
    if (!this._inherentChestStatuses) {
      this._inherentChestStatuses = this._parent ? this._parent.chestStatuses : [];
    }
    return this._inherentChestStatuses;
  }
  get chestStatuses() {
    if (!this._allChestStatuses) {
      this._allChestStatuses = this._parent ? this._parent.chestStatuses.concat(this.selfChestStatuses) : this.selfChestStatuses;
    }
    return this._allChestStatuses;
  }
  get hasTokenStatus() {
    if (this._cachedHasTokenStatus === undefined) {
      if (this._value.hasTokenStatus) {
        this._cachedHasTokenStatus = true;
      } else {
        this._cachedHasTokenStatus = this._parent ? this._parent.hasTokenStatus : false;
      }
    }
    return this._cachedHasTokenStatus;
  }
  get tokenStatus() {
    if (!this._cachedTokenStatus) {
      if (this._value.hasTokenStatus) {
        this._cachedTokenStatus = new MapEventStatus_TokenStatus.WithParent(this._value.tokenStatus, this._parent && this._parent.hasTokenStatus ? this._parent.tokenStatus : null);
      } else {
        this._cachedTokenStatus = this._parent ? new MapEventStatus_TokenStatus.WithParent(MapEventStatus_TokenStatus.default, this._parent.tokenStatus) : MapEventStatus_TokenStatus.WithParent.default;
      }
    }
    return this._cachedTokenStatus;
  }
  get hasCoopStatus() {
    if (this._cachedHasCoopStatus === undefined) {
      if (this._value.hasCoopStatus) {
        this._cachedHasCoopStatus = true;
      } else {
        this._cachedHasCoopStatus = this._parent ? this._parent.hasCoopStatus : false;
      }
    }
    return this._cachedHasCoopStatus;
  }
  get coopStatus() {
    if (!this._cachedCoopStatus) {
      if (this._value.hasCoopStatus) {
        this._cachedCoopStatus = new MapEventStatus_CoopStatus.WithParent(this._value.coopStatus, this._parent && this._parent.hasCoopStatus ? this._parent.coopStatus : null);
      } else {
        this._cachedCoopStatus = this._parent ? new MapEventStatus_CoopStatus.WithParent(MapEventStatus_CoopStatus.default, this._parent.coopStatus) : MapEventStatus_CoopStatus.WithParent.default;
      }
    }
    return this._cachedCoopStatus;
  }
  get hasBossKeyStatus() {
    if (this._cachedHasBossKeyStatus === undefined) {
      if (this._value.hasBossKeyStatus) {
        this._cachedHasBossKeyStatus = true;
      } else {
        this._cachedHasBossKeyStatus = this._parent ? this._parent.hasBossKeyStatus : false;
      }
    }
    return this._cachedHasBossKeyStatus;
  }
  get bossKeyStatus() {
    if (!this._cachedBossKeyStatus) {
      if (this._value.hasBossKeyStatus) {
        this._cachedBossKeyStatus = new MapEventStatus_BossKeyStatus.WithParent(this._value.bossKeyStatus, this._parent && this._parent.hasBossKeyStatus ? this._parent.bossKeyStatus : null);
      } else {
        this._cachedBossKeyStatus = this._parent ? new MapEventStatus_BossKeyStatus.WithParent(MapEventStatus_BossKeyStatus.default, this._parent.bossKeyStatus) : MapEventStatus_BossKeyStatus.WithParent.default;
      }
    }
    return this._cachedBossKeyStatus;
  }
  get hasCoopKeyStatus() {
    if (this._cachedHasCoopKeyStatus === undefined) {
      if (this._value.hasCoopKeyStatus) {
        this._cachedHasCoopKeyStatus = true;
      } else {
        this._cachedHasCoopKeyStatus = this._parent ? this._parent.hasCoopKeyStatus : false;
      }
    }
    return this._cachedHasCoopKeyStatus;
  }
  get coopKeyStatus() {
    if (!this._cachedCoopKeyStatus) {
      if (this._value.hasCoopKeyStatus) {
        this._cachedCoopKeyStatus = new MapEventStatus_CoopKeyStatus.WithParent(this._value.coopKeyStatus, this._parent && this._parent.hasCoopKeyStatus ? this._parent.coopKeyStatus : null);
      } else {
        this._cachedCoopKeyStatus = this._parent ? new MapEventStatus_CoopKeyStatus.WithParent(MapEventStatus_CoopKeyStatus.default, this._parent.coopKeyStatus) : MapEventStatus_CoopKeyStatus.WithParent.default;
      }
    }
    return this._cachedCoopKeyStatus;
  }
  get hasBossRaidTicketStatus() {
    if (this._cachedHasBossRaidTicketStatus === undefined) {
      if (this._value.hasBossRaidTicketStatus) {
        this._cachedHasBossRaidTicketStatus = true;
      } else {
        this._cachedHasBossRaidTicketStatus = this._parent ? this._parent.hasBossRaidTicketStatus : false;
      }
    }
    return this._cachedHasBossRaidTicketStatus;
  }
  get bossRaidTicketStatus() {
    if (!this._cachedBossRaidTicketStatus) {
      if (this._value.hasBossRaidTicketStatus) {
        this._cachedBossRaidTicketStatus = new MapEventStatus_BossRaidTicketStatus.WithParent(this._value.bossRaidTicketStatus, this._parent && this._parent.hasBossRaidTicketStatus ? this._parent.bossRaidTicketStatus : null);
      } else {
        this._cachedBossRaidTicketStatus = this._parent ? new MapEventStatus_BossRaidTicketStatus.WithParent(MapEventStatus_BossRaidTicketStatus.default, this._parent.bossRaidTicketStatus) : MapEventStatus_BossRaidTicketStatus.WithParent.default;
      }
    }
    return this._cachedBossRaidTicketStatus;
  }
  get hasChestOpenCount() {
    if (this._cachedHasChestOpenCount === undefined) {
      if (this._value.hasChestOpenCount) {
        this._cachedHasChestOpenCount = true;
      } else {
        this._cachedHasChestOpenCount = this._parent ? this._parent.hasChestOpenCount : false;
      }
    }
    return this._cachedHasChestOpenCount;
  }
  get chestOpenCount() {
    if (this._cachedChestOpenCount === undefined) {
      if (this._value.hasChestOpenCount) {
        this._cachedChestOpenCount = this._value.chestOpenCount;
      } else {
        this._cachedChestOpenCount = this._parent ? this._parent.chestOpenCount : this._value.chestOpenCount;
      }
    }
    return this._cachedChestOpenCount;
  }
  get selfSoloLevelStatuses() {
    if (!this._selfSoloLevelStatuses) {
      this._selfSoloLevelStatuses = [];
      for (let i of this._value.soloLevelStatuses) {
        this._selfSoloLevelStatuses.push(new MapEventStatus_SoloLevelStatus.WithParent(i, null));
      }
    }
    return this._selfSoloLevelStatuses;
  }
  get inherentSoloLevelStatuses() {
    if (!this._inherentSoloLevelStatuses) {
      this._inherentSoloLevelStatuses = this._parent ? this._parent.soloLevelStatuses : [];
    }
    return this._inherentSoloLevelStatuses;
  }
  get soloLevelStatuses() {
    if (!this._allSoloLevelStatuses) {
      this._allSoloLevelStatuses = this._parent ? this._parent.soloLevelStatuses.concat(this.selfSoloLevelStatuses) : this.selfSoloLevelStatuses;
    }
    return this._allSoloLevelStatuses;
  }
  update(current, parent) {
    const result = new MapEventStatus_WithParent(current, parent);
    if (this._selfQuestStatuses) {
      if (this._value.questStatuses === current.questStatuses) {
        result._selfQuestStatuses = this._selfQuestStatuses;
      } else {
        result._selfQuestStatuses = [];
        for (let i = 0; i < current.questStatuses.length; i++) {
          const oldValue = this._value.questStatuses[i];
          if (oldValue) {
            const oldCache = this._selfQuestStatuses[i];
            if (oldValue === current.questStatuses[i]) {
              result._selfQuestStatuses[i] = oldCache;
            } else {
              result._selfQuestStatuses[i] = oldCache.update(current.questStatuses[i], null);
            }
          } else {
            result._selfQuestStatuses[i] = new MapEventStatus_QuestStatus.WithParent(current.questStatuses[i], null);
          }
        }
      }
    }
    if (this._selfMilestoneStatuses) {
      if (this._value.milestoneStatuses === current.milestoneStatuses) {
        result._selfMilestoneStatuses = this._selfMilestoneStatuses;
      } else {
        result._selfMilestoneStatuses = [];
        for (let i = 0; i < current.milestoneStatuses.length; i++) {
          const oldValue = this._value.milestoneStatuses[i];
          if (oldValue) {
            const oldCache = this._selfMilestoneStatuses[i];
            if (oldValue === current.milestoneStatuses[i]) {
              result._selfMilestoneStatuses[i] = oldCache;
            } else {
              result._selfMilestoneStatuses[i] = oldCache.update(current.milestoneStatuses[i], null);
            }
          } else {
            result._selfMilestoneStatuses[i] = new MapEventStatus_MilestoneStatus.WithParent(current.milestoneStatuses[i], null);
          }
        }
      }
    }
    if (this._selfLevelStatuses) {
      if (this._value.levelStatuses === current.levelStatuses) {
        result._selfLevelStatuses = this._selfLevelStatuses;
      } else {
        result._selfLevelStatuses = [];
        for (let i = 0; i < current.levelStatuses.length; i++) {
          const oldValue = this._value.levelStatuses[i];
          if (oldValue) {
            const oldCache = this._selfLevelStatuses[i];
            if (oldValue === current.levelStatuses[i]) {
              result._selfLevelStatuses[i] = oldCache;
            } else {
              result._selfLevelStatuses[i] = oldCache.update(current.levelStatuses[i], null);
            }
          } else {
            result._selfLevelStatuses[i] = new MapEventStatus_LevelStatus.WithParent(current.levelStatuses[i], null);
          }
        }
      }
    }
    if (this._cachedAccessKeyStatus && this._value.hasAccessKeyStatus && current.hasAccessKeyStatus) {
      if (this._value.accessKeyStatus === current.accessKeyStatus && this._parent === parent) {
        result._cachedAccessKeyStatus = this._cachedAccessKeyStatus;
      } else {
        result._cachedAccessKeyStatus = this._cachedAccessKeyStatus.update(current.accessKeyStatus, parent && parent.hasAccessKeyStatus ? parent.accessKeyStatus : null);
      }
    }
    if (this._selfChestStatuses) {
      if (this._value.chestStatuses === current.chestStatuses) {
        result._selfChestStatuses = this._selfChestStatuses;
      } else {
        result._selfChestStatuses = [];
        for (let i = 0; i < current.chestStatuses.length; i++) {
          const oldValue = this._value.chestStatuses[i];
          if (oldValue) {
            const oldCache = this._selfChestStatuses[i];
            if (oldValue === current.chestStatuses[i]) {
              result._selfChestStatuses[i] = oldCache;
            } else {
              result._selfChestStatuses[i] = oldCache.update(current.chestStatuses[i], null);
            }
          } else {
            result._selfChestStatuses[i] = new MapEventStatus_EventChestGroupStatus.WithParent(current.chestStatuses[i], null);
          }
        }
      }
    }
    if (this._cachedTokenStatus && this._value.hasTokenStatus && current.hasTokenStatus) {
      if (this._value.tokenStatus === current.tokenStatus && this._parent === parent) {
        result._cachedTokenStatus = this._cachedTokenStatus;
      } else {
        result._cachedTokenStatus = this._cachedTokenStatus.update(current.tokenStatus, parent && parent.hasTokenStatus ? parent.tokenStatus : null);
      }
    }
    if (this._cachedCoopStatus && this._value.hasCoopStatus && current.hasCoopStatus) {
      if (this._value.coopStatus === current.coopStatus && this._parent === parent) {
        result._cachedCoopStatus = this._cachedCoopStatus;
      } else {
        result._cachedCoopStatus = this._cachedCoopStatus.update(current.coopStatus, parent && parent.hasCoopStatus ? parent.coopStatus : null);
      }
    }
    if (this._cachedBossKeyStatus && this._value.hasBossKeyStatus && current.hasBossKeyStatus) {
      if (this._value.bossKeyStatus === current.bossKeyStatus && this._parent === parent) {
        result._cachedBossKeyStatus = this._cachedBossKeyStatus;
      } else {
        result._cachedBossKeyStatus = this._cachedBossKeyStatus.update(current.bossKeyStatus, parent && parent.hasBossKeyStatus ? parent.bossKeyStatus : null);
      }
    }
    if (this._cachedCoopKeyStatus && this._value.hasCoopKeyStatus && current.hasCoopKeyStatus) {
      if (this._value.coopKeyStatus === current.coopKeyStatus && this._parent === parent) {
        result._cachedCoopKeyStatus = this._cachedCoopKeyStatus;
      } else {
        result._cachedCoopKeyStatus = this._cachedCoopKeyStatus.update(current.coopKeyStatus, parent && parent.hasCoopKeyStatus ? parent.coopKeyStatus : null);
      }
    }
    if (this._cachedBossRaidTicketStatus && this._value.hasBossRaidTicketStatus && current.hasBossRaidTicketStatus) {
      if (this._value.bossRaidTicketStatus === current.bossRaidTicketStatus && this._parent === parent) {
        result._cachedBossRaidTicketStatus = this._cachedBossRaidTicketStatus;
      } else {
        result._cachedBossRaidTicketStatus = this._cachedBossRaidTicketStatus.update(current.bossRaidTicketStatus, parent && parent.hasBossRaidTicketStatus ? parent.bossRaidTicketStatus : null);
      }
    }
    if (this._selfSoloLevelStatuses) {
      if (this._value.soloLevelStatuses === current.soloLevelStatuses) {
        result._selfSoloLevelStatuses = this._selfSoloLevelStatuses;
      } else {
        result._selfSoloLevelStatuses = [];
        for (let i = 0; i < current.soloLevelStatuses.length; i++) {
          const oldValue = this._value.soloLevelStatuses[i];
          if (oldValue) {
            const oldCache = this._selfSoloLevelStatuses[i];
            if (oldValue === current.soloLevelStatuses[i]) {
              result._selfSoloLevelStatuses[i] = oldCache;
            } else {
              result._selfSoloLevelStatuses[i] = oldCache.update(current.soloLevelStatuses[i], null);
            }
          } else {
            result._selfSoloLevelStatuses[i] = new MapEventStatus_SoloLevelStatus.WithParent(current.soloLevelStatuses[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapEventStatus_WithParent.default = new MapEventStatus_WithParent(MapEventStatus.default, null);
MapEventStatus.WithParent = MapEventStatus_WithParent;
class MapEventStatus_Descriptor {
  get mapEventKey() {
    if (!this._mapEventKey) {
      this._mapEventKey = {
        name: "mapEventKey",
        Name: "MapEventKey",
        number: 1,
        protoType: 9,
        protoName: "map_event_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapEventKey;
  }
  get eventState() {
    if (!this._eventState) {
      this._eventState = {
        name: "eventState",
        Name: "EventState",
        number: 2,
        protoType: 14,
        protoName: "event_state",
        type: MapEventStatus_EventState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventState;
  }
  get remainingSeconds() {
    if (!this._remainingSeconds) {
      this._remainingSeconds = {
        name: "remainingSeconds",
        Name: "RemainingSeconds",
        number: 8,
        protoType: 1,
        protoName: "remaining_seconds",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingSeconds;
  }
  get questStatuses() {
    if (!this._questStatuses) {
      this._questStatuses = {
        name: "questStatuses",
        Name: "QuestStatuses",
        number: 4,
        protoType: 11,
        protoName: "quest_statuses",
        type: MapEventStatus_QuestStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questStatuses;
  }
  get milestoneStatuses() {
    if (!this._milestoneStatuses) {
      this._milestoneStatuses = {
        name: "milestoneStatuses",
        Name: "MilestoneStatuses",
        number: 5,
        protoType: 11,
        protoName: "milestone_statuses",
        type: MapEventStatus_MilestoneStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._milestoneStatuses;
  }
  get levelStatuses() {
    if (!this._levelStatuses) {
      this._levelStatuses = {
        name: "levelStatuses",
        Name: "LevelStatuses",
        number: 6,
        protoType: 11,
        protoName: "level_statuses",
        type: MapEventStatus_LevelStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelStatuses;
  }
  get accessKeyStatus() {
    if (!this._accessKeyStatus) {
      this._accessKeyStatus = {
        name: "accessKeyStatus",
        Name: "AccessKeyStatus",
        number: 7,
        protoType: 11,
        protoName: "access_key_status",
        type: MapEventStatus_AccessKeyStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._accessKeyStatus;
  }
  get chestStatuses() {
    if (!this._chestStatuses) {
      this._chestStatuses = {
        name: "chestStatuses",
        Name: "ChestStatuses",
        number: 13,
        protoType: 11,
        protoName: "chest_statuses",
        type: MapEventStatus_EventChestGroupStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestStatuses;
  }
  get tokenStatus() {
    if (!this._tokenStatus) {
      this._tokenStatus = {
        name: "tokenStatus",
        Name: "TokenStatus",
        number: 12,
        protoType: 11,
        protoName: "token_status",
        type: MapEventStatus_TokenStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokenStatus;
  }
  get coopStatus() {
    if (!this._coopStatus) {
      this._coopStatus = {
        name: "coopStatus",
        Name: "CoopStatus",
        number: 9,
        protoType: 11,
        protoName: "coop_status",
        type: MapEventStatus_CoopStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopStatus;
  }
  get bossKeyStatus() {
    if (!this._bossKeyStatus) {
      this._bossKeyStatus = {
        name: "bossKeyStatus",
        Name: "BossKeyStatus",
        number: 14,
        protoType: 11,
        protoName: "boss_key_status",
        type: MapEventStatus_BossKeyStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossKeyStatus;
  }
  get coopKeyStatus() {
    if (!this._coopKeyStatus) {
      this._coopKeyStatus = {
        name: "coopKeyStatus",
        Name: "CoopKeyStatus",
        number: 15,
        protoType: 11,
        protoName: "coop_key_status",
        type: MapEventStatus_CoopKeyStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coopKeyStatus;
  }
  get bossRaidTicketStatus() {
    if (!this._bossRaidTicketStatus) {
      this._bossRaidTicketStatus = {
        name: "bossRaidTicketStatus",
        Name: "BossRaidTicketStatus",
        number: 16,
        protoType: 11,
        protoName: "boss_raid_ticket_status",
        type: MapEventStatus_BossRaidTicketStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bossRaidTicketStatus;
  }
  get chestOpenCount() {
    if (!this._chestOpenCount) {
      this._chestOpenCount = {
        name: "chestOpenCount",
        Name: "ChestOpenCount",
        number: 11,
        protoType: 5,
        protoName: "chest_open_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestOpenCount;
  }
  get soloLevelStatuses() {
    if (!this._soloLevelStatuses) {
      this._soloLevelStatuses = {
        name: "soloLevelStatuses",
        Name: "SoloLevelStatuses",
        number: 21,
        protoType: 11,
        protoName: "solo_level_statuses",
        type: MapEventStatus_SoloLevelStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soloLevelStatuses;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapEventKey,
        this.eventState,
        this.remainingSeconds,
        this.questStatuses,
        this.milestoneStatuses,
        this.levelStatuses,
        this.accessKeyStatus,
        this.chestStatuses,
        this.tokenStatus,
        this.coopStatus,
        this.bossKeyStatus,
        this.coopKeyStatus,
        this.bossRaidTicketStatus,
        this.chestOpenCount,
        this.soloLevelStatuses,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapEventKey",
        Name: "DummyOneofForMapEventKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventState",
        Name: "DummyOneofForEventState",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRemainingSeconds",
        Name: "DummyOneofForRemainingSeconds",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAccessKeyStatus",
        Name: "DummyOneofForAccessKeyStatus",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTokenStatus",
        Name: "DummyOneofForTokenStatus",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCoopStatus",
        Name: "DummyOneofForCoopStatus",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBossKeyStatus",
        Name: "DummyOneofForBossKeyStatus",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCoopKeyStatus",
        Name: "DummyOneofForCoopKeyStatus",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBossRaidTicketStatus",
        Name: "DummyOneofForBossRaidTicketStatus",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestOpenCount",
        Name: "DummyOneofForChestOpenCount",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
MapEventStatus.descriptor = new MapEventStatus_Descriptor();
export class PlayerMapEventStatus {
  get descriptor() {
    return PlayerMapEventStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._mapEventStatuses = [];
    this._hasPreviousEventReceipts = false;
    this._previousEventReceipts = null;
  }
  isEmpty() {
    if (this._mapEventStatuses.length > 0) return false;
    if (this._hasPreviousEventReceipts && !this._previousEventReceipts.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerMapEventStatus) {
      return value;
    }
    return PlayerMapEventStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerMapEventStatus();
    result._mapEventStatuses = JsonToList(json.mapEventStatuses, MapEventStatus);
    if (json.previousEventReceipts != null) {
      result._hasPreviousEventReceipts = true;
      result._previousEventReceipts = MapEventStatus_EventRewardReceipts.fromJson(json.previousEventReceipts);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._mapEventStatuses.length > 0) {
      result.mapEventStatuses = ArrayToJson(this._mapEventStatuses, MapEventStatus);
    }
    if (this._hasPreviousEventReceipts && !this._previousEventReceipts.isEmpty()) {
      result.previousEventReceipts = MapEventStatus_EventRewardReceipts.toJson(this._previousEventReceipts);
    }
    return result;
  }
  /**
   * @returns {MapEventStatus[]}
   */
  get mapEventStatuses() {
    return this._mapEventStatuses;
  }
  addMapEventStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['mapEventStatuses']), value: value.toJson()};
  }
  setMapEventStatuses(path, value) {
    return {type: 'SET', path: path.concat(['mapEventStatuses']), value: ArrayToJson(value, MapEventStatus)};
  }
  setMapEventStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapEventStatuses', key]), value: value.toJson()};
  }
  deleteMapEventStatuses(path) {
    return {type: 'DELETE', path: path.concat(['mapEventStatuses'])};
  }
  deleteMapEventStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapEventStatuses', key])};
  }
  /**
   * @returns {MapEventStatus_EventRewardReceipts}
   */
  get previousEventReceipts() {
    return this._hasPreviousEventReceipts ? this._previousEventReceipts : MapEventStatus_EventRewardReceipts.default;
  }
  get hasPreviousEventReceipts() {
    return this._hasPreviousEventReceipts;
  }
  setPreviousEventReceipts(path, value) {
    return {type: 'SET', path: path.concat(['previousEventReceipts']), value: value.toJson()};
  }
  deletePreviousEventReceipts(path) {
    return {type: 'DELETE', path: path.concat(['previousEventReceipts'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapEventStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerMapEventStatus(this);
              copy._mapEventStatuses = [];        for (let i of value) {
                copy._mapEventStatuses.push(MapEventStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerMapEventStatus(this);
              copy._mapEventStatuses = copy._mapEventStatuses.concat([MapEventStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapEventStatuses.length === 0) {
                return this;
              }
              const copy = new PlayerMapEventStatus(this);
              copy._mapEventStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapEventStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerMapEventStatus(this);
              copy._mapEventStatuses = copy._mapEventStatuses.slice();
              copy._mapEventStatuses[path[1]] = MapEventStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerMapEventStatus(this);
              copy._mapEventStatuses = copy._mapEventStatuses.slice(0, path[1]).concat(copy._mapEventStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapEventStatuses.length) {
            return this;
          }
          const oldValue = this._mapEventStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerMapEventStatus(this);
          copy._mapEventStatuses = copy._mapEventStatuses.slice();
          copy._mapEventStatuses[key] = newValue;
          return copy;
        }
      }
      case "previousEventReceipts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerMapEventStatus(this);
              copy._hasPreviousEventReceipts = true;
              copy._previousEventReceipts = MapEventStatus_EventRewardReceipts.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreviousEventReceipts) {
                return this;
              }
              const copy = new PlayerMapEventStatus(this);
              copy._hasPreviousEventReceipts = false;
              copy._previousEventReceipts = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPreviousEventReceipts) {
            const copy = new PlayerMapEventStatus(this);
            copy._hasPreviousEventReceipts = true;
            copy._previousEventReceipts = MapEventStatus_EventRewardReceipts.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._previousEventReceipts.apply(type, path.slice(1), value);
          if (newValue === this._previousEventReceipts) {
            return this;
          }
          const copy = new PlayerMapEventStatus(this);
          copy._previousEventReceipts = copy._previousEventReceipts.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerMapEventStatus} other
   * @returns {PlayerMapEventStatus}
   */
  merge(other) {
    const copy = new PlayerMapEventStatus(this);
    copy._mapEventStatuses = this._mapEventStatuses.concat(other._mapEventStatuses);
    if (other._hasPreviousEventReceipts) {
      if (copy._hasPreviousEventReceipts) {
        copy._previousEventReceipts = copy.previousEventReceipts.merge(other.previousEventReceipts);
      } else {
        copy._previousEventReceipts = other._previousEventReceipts;
      }
      copy._hasPreviousEventReceipts = true;
    }
    return copy;
  }
}
PlayerMapEventStatus.default = new PlayerMapEventStatus();
class PlayerMapEventStatus_Builder {
  constructor(value) {
    this._value = new PlayerMapEventStatus(value);
  }
  build() {
    return new PlayerMapEventStatus(this._value);
  }
  addAllMapEventStatuses(values) {
    this._value._mapEventStatuses = this._value._mapEventStatuses.concat(values);
    return this;
  }
  addMapEventStatuses(value) {
    this._value._mapEventStatuses = this._value._mapEventStatuses.concat([value]);
    return this;
  }
  setMapEventStatuses(index, value) {
    this._value._mapEventStatuses = this._value._mapEventStatuses.concat();
    this._value._mapEventStatuses[index] = value;
    return this;
  }
  clearMapEventStatuses() {
    this._value._mapEventStatuses = [];
    return this;
  }
  setPreviousEventReceipts(value) {
    this._value._hasPreviousEventReceipts = true;
    this._value._previousEventReceipts = value;
    return this;
  }
  deletePreviousEventReceipts() {
    this._value._hasPreviousEventReceipts = false;
    this._value._previousEventReceipts = null;
    return this;
  }
}
PlayerMapEventStatus.Builder = PlayerMapEventStatus_Builder;
class PlayerMapEventStatus_WithParent {
  /**
   * @param {PlayerMapEventStatus} value
   * @param {PlayerMapEventStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerMapEventStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMapEventStatuses() {
    if (!this._selfMapEventStatuses) {
      this._selfMapEventStatuses = [];
      for (let i of this._value.mapEventStatuses) {
        this._selfMapEventStatuses.push(new MapEventStatus.WithParent(i, null));
      }
    }
    return this._selfMapEventStatuses;
  }
  get inherentMapEventStatuses() {
    if (!this._inherentMapEventStatuses) {
      this._inherentMapEventStatuses = this._parent ? this._parent.mapEventStatuses : [];
    }
    return this._inherentMapEventStatuses;
  }
  get mapEventStatuses() {
    if (!this._allMapEventStatuses) {
      this._allMapEventStatuses = this._parent ? this._parent.mapEventStatuses.concat(this.selfMapEventStatuses) : this.selfMapEventStatuses;
    }
    return this._allMapEventStatuses;
  }
  get hasPreviousEventReceipts() {
    if (this._cachedHasPreviousEventReceipts === undefined) {
      if (this._value.hasPreviousEventReceipts) {
        this._cachedHasPreviousEventReceipts = true;
      } else {
        this._cachedHasPreviousEventReceipts = this._parent ? this._parent.hasPreviousEventReceipts : false;
      }
    }
    return this._cachedHasPreviousEventReceipts;
  }
  get previousEventReceipts() {
    if (!this._cachedPreviousEventReceipts) {
      if (this._value.hasPreviousEventReceipts) {
        this._cachedPreviousEventReceipts = new MapEventStatus_EventRewardReceipts.WithParent(this._value.previousEventReceipts, this._parent && this._parent.hasPreviousEventReceipts ? this._parent.previousEventReceipts : null);
      } else {
        this._cachedPreviousEventReceipts = this._parent ? new MapEventStatus_EventRewardReceipts.WithParent(MapEventStatus_EventRewardReceipts.default, this._parent.previousEventReceipts) : MapEventStatus_EventRewardReceipts.WithParent.default;
      }
    }
    return this._cachedPreviousEventReceipts;
  }
  update(current, parent) {
    const result = new PlayerMapEventStatus_WithParent(current, parent);
    if (this._selfMapEventStatuses) {
      if (this._value.mapEventStatuses === current.mapEventStatuses) {
        result._selfMapEventStatuses = this._selfMapEventStatuses;
      } else {
        result._selfMapEventStatuses = [];
        for (let i = 0; i < current.mapEventStatuses.length; i++) {
          const oldValue = this._value.mapEventStatuses[i];
          if (oldValue) {
            const oldCache = this._selfMapEventStatuses[i];
            if (oldValue === current.mapEventStatuses[i]) {
              result._selfMapEventStatuses[i] = oldCache;
            } else {
              result._selfMapEventStatuses[i] = oldCache.update(current.mapEventStatuses[i], null);
            }
          } else {
            result._selfMapEventStatuses[i] = new MapEventStatus.WithParent(current.mapEventStatuses[i], null);
          }
        }
      }
    }
    if (this._cachedPreviousEventReceipts && this._value.hasPreviousEventReceipts && current.hasPreviousEventReceipts) {
      if (this._value.previousEventReceipts === current.previousEventReceipts && this._parent === parent) {
        result._cachedPreviousEventReceipts = this._cachedPreviousEventReceipts;
      } else {
        result._cachedPreviousEventReceipts = this._cachedPreviousEventReceipts.update(current.previousEventReceipts, parent && parent.hasPreviousEventReceipts ? parent.previousEventReceipts : null);
      }
    }
    return result;
  }
}
PlayerMapEventStatus_WithParent.default = new PlayerMapEventStatus_WithParent(PlayerMapEventStatus.default, null);
PlayerMapEventStatus.WithParent = PlayerMapEventStatus_WithParent;
class PlayerMapEventStatus_Descriptor {
  get mapEventStatuses() {
    if (!this._mapEventStatuses) {
      this._mapEventStatuses = {
        name: "mapEventStatuses",
        Name: "MapEventStatuses",
        number: 1,
        protoType: 11,
        protoName: "map_event_statuses",
        type: MapEventStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapEventStatuses;
  }
  get previousEventReceipts() {
    if (!this._previousEventReceipts) {
      this._previousEventReceipts = {
        name: "previousEventReceipts",
        Name: "PreviousEventReceipts",
        number: 2,
        protoType: 11,
        protoName: "previous_event_receipts",
        type: MapEventStatus_EventRewardReceipts,
        options: {
          comments: "We use this to check if we need to mail any reward from previous event",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._previousEventReceipts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapEventStatuses,
        this.previousEventReceipts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPreviousEventReceipts",
        Name: "DummyOneofForPreviousEventReceipts",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerMapEventStatus.descriptor = new PlayerMapEventStatus_Descriptor();
